(function () {  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired4ea"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired4ea"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("271MM", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $853dc053370b4dd4$export$e506a1d27d1eaa20; });
class $853dc053370b4dd4$export$e506a1d27d1eaa20 {
    static import(product) {
        this.product = product;
    }
}
$853dc053370b4dd4$export$e506a1d27d1eaa20.websiteUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.domain = undefined !== null && undefined !== void 0 ? undefined : window.location.origin;
$853dc053370b4dd4$export$e506a1d27d1eaa20.version = "af0afcea";
$853dc053370b4dd4$export$e506a1d27d1eaa20.environment = "prod";
$853dc053370b4dd4$export$e506a1d27d1eaa20.isDev = false;
$853dc053370b4dd4$export$e506a1d27d1eaa20.isProd = $853dc053370b4dd4$export$e506a1d27d1eaa20.environment == "prod";
$853dc053370b4dd4$export$e506a1d27d1eaa20.httpPanelUrl = "https://panel.sedestral.com/panel";
$853dc053370b4dd4$export$e506a1d27d1eaa20.httpCommunityUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.websocketPanelUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.websocketCommunityUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.editorCollaborationUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.rumEnabled = false;
$853dc053370b4dd4$export$e506a1d27d1eaa20.helpCenterSubDomain = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.blogSubDomain = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.tenorKey = "1HFPKNKBSCVT";
$853dc053370b4dd4$export$e506a1d27d1eaa20.tenorHost = "https://g.tenor.com/v1/";
$853dc053370b4dd4$export$e506a1d27d1eaa20.tenorMediaHost = "https://media.tenor.com/";
$853dc053370b4dd4$export$e506a1d27d1eaa20.domainParent = "sedestral.com";
$853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopModuleVersion = "1.0.14";
$853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopFileName = "sedestral_v" + $853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopModuleVersion + ".zip";
$853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopModuleLink = "/module/" + $853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopFileName;
$853dc053370b4dd4$export$e506a1d27d1eaa20.hotjarId = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.hotjarPanelId = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.livechatStyleUrl = ()=>"undefined/livechat.css?";
$853dc053370b4dd4$export$e506a1d27d1eaa20.livechatJsUrl = ()=>"undefined/livechat.js?";
class $853dc053370b4dd4$export$fcc0626890c55730 {
}
$853dc053370b4dd4$export$fcc0626890c55730.config = {
    apiKey: "AIzaSyCc15ypn8pO3y-ypDbSegb_Bk5bPSIAu9U",
    authDomain: "sedestral-86c7f.firebaseapp.com",
    projectId: "sedestral-86c7f",
    storageBucket: "sedestral-86c7f.appspot.com",
    messagingSenderId: "627959172196",
    appId: "1:627959172196:web:e093c1d3bdea0e96cf6371"
};
$853dc053370b4dd4$export$fcc0626890c55730.vapidKey = "BBmq-zPIaRUHlvMcz-hSyQ_k04tfvM8CUshZDQ012j4j28SmvVoaxD4n7qYmUnMaH98zOnR-DDRnIx6UElUrnUc";

});

parcelRegister("kOkc5", function(module, exports) {

var $7iilT = parcelRequire("7iilT");
module.exports = $7iilT("4x9pe").then(()=>parcelRequire("luYOo"));

});
parcelRegister("7iilT", function(module, exports) {
"use strict";

function $54f8732b7a3aad4a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("jZ94Y")).resolve(id));
}
module.exports = $54f8732b7a3aad4a$var$load;

});


parcelRegister("68Z0d", function(module, exports) {

$parcel$export(module.exports, "EntityService", function () { return $9b2c4bfdf11e2b41$export$714c657d7d597c58; });

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $7Aqrk = parcelRequire("7Aqrk");

var $dH00N = parcelRequire("dH00N");

var $l8ea0 = parcelRequire("l8ea0");

var $2Y8XI = parcelRequire("2Y8XI");

var $2eT6g = parcelRequire("2eT6g");

var $5pJMm = parcelRequire("5pJMm");

var $bKmye = parcelRequire("bKmye");

var $j8ebN = parcelRequire("j8ebN");

var $4in9X = parcelRequire("4in9X");

var $fdmdr = parcelRequire("fdmdr");

var $kfkzw = parcelRequire("kfkzw");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $dEtAh = parcelRequire("dEtAh");

var $9DuXN = parcelRequire("9DuXN");
class $9b2c4bfdf11e2b41$export$714c657d7d597c58 {
    /**
     * get and set
     */ static get activeNotifications() {
        var _EntityService_activeNotificationsList_find;
        this.initActives();
        return (_EntityService_activeNotificationsList_find = $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeNotificationsList.find((value)=>value.product == (0, $271MM.config).product)) === null || _EntityService_activeNotificationsList_find === void 0 ? void 0 : _EntityService_activeNotificationsList_find.notifications;
    }
    static set activeNotifications(notifications) {
        $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeNotificationsList.push({
            product: (0, $271MM.config).product,
            notifications: notifications
        });
    }
    static get activeEntity() {
        var _EntityService_activeEntities_find;
        this.initActives();
        return (_EntityService_activeEntities_find = $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities.find((value)=>value.product == (0, $271MM.config).product)) === null || _EntityService_activeEntities_find === void 0 ? void 0 : _EntityService_activeEntities_find.entity;
    }
    static set activeEntity(entity) {
        $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities.push({
            product: (0, $271MM.config).product,
            entity: entity
        });
    }
    static get activeSite() {
        var _EntityService_activeSites_find;
        this.initActives();
        return (_EntityService_activeSites_find = $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites.find((value)=>value.product == (0, $271MM.config).product)) === null || _EntityService_activeSites_find === void 0 ? void 0 : _EntityService_activeSites_find.site;
    }
    static set activeSite(entity) {
        $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites.push({
            product: (0, $271MM.config).product,
            site: entity
        });
    }
    static get activeWebPushToken() {
        return this._activeWebPushTokenValue;
    }
    static set activeWebPushToken(token) {
        this._activeWebPushTokenValue = token;
        (0, $dEtAh.SedestralStorage).setItem(this._activeWebPushToken, this._activeWebPushTokenValue);
    }
    static get activeToken() {
        return (0, $dEtAh.SedestralStorage).getItem(`_activeToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static set activeToken(token) {
        (0, $dEtAh.SedestralStorage).setItem(`_activeToken` + (0, $271MM.config).product + (0, $271MM.config).environment, token);
    }
    static clearActiveToken() {
        (0, $dEtAh.SedestralStorage).removeItem(`_activeToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static get saveActiveToken() {
        return (0, $9DuXN.SedestralMemory).getItem(`_saveActiveToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static set saveActiveToken(token) {
        (0, $9DuXN.SedestralMemory).setItem(`_saveActiveToken` + (0, $271MM.config).product + (0, $271MM.config).environment, token);
    }
    static clearSaveActiveToken() {
        (0, $9DuXN.SedestralMemory).removeItem(`_saveActiveToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static get activeTokenCookie() {
        this.initActives();
        return (0, $dEtAh.SedestralStorage).getCookie(`_activeTokenCookie` + (0, $271MM.config).environment + (0, $271MM.config).product);
    }
    static set activeTokenCookie(token) {
        this.initActives();
        (0, $dEtAh.SedestralStorage).setCookie(`_activeTokenCookie` + (0, $271MM.config).environment + (0, $271MM.config).product, token, "." + (0, $271MM.config).domainParent);
    }
    static clearTokenCookie() {
        (0, $dEtAh.SedestralStorage).deleteCookie(`_activeTokenCookie` + (0, $271MM.config).environment + (0, $271MM.config).product);
    }
    static dispose() {
        this.typingEvents = [];
    }
    static initActives() {
        if (!$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities = [];
        if (!$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites = [];
        if (!$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeNotificationsList) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeNotificationsList = [];
    }
    static init() {
        this.initActives();
        (0, $2Y8XI.Services).beforeInit(this);
        this._activeWebPushTokenValue = (0, $dEtAh.SedestralStorage).getItem(this._activeWebPushToken);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ENTITY_UPDATE, (data)=>{
            let entity = data;
            if ((0, $dH00N.Models).isAccountModel(entity)) (0, $7Aqrk.AccountService).store(entity);
            else if ((0, $dH00N.Models).isContactModel(entity)) (0, $l8ea0.ContactService).store(entity);
        });
        //TODO remove typing only if typing is active
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ENTITY_TYPING, (data)=>{
            // console.log(data)
            let entity = this.store(data.entity, data.entityType);
            data.files = (0, $bKmye.FileService).storeAll(data.files);
            data.previews = (0, $j8ebN.PreviewService).storeAll(data.previews);
            this.typingEvents.forEach((value)=>value(entity, data.content, data.files, data.previews));
        });
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["EntityService"] = this;
    }
    /**
     * http
     */ static async updateAvatar(accountId, files, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).PANEL, `/account/avatar/update`, {
            files: files,
            accountId: accountId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * get
     */ static getEntity(type, id) {
        if (type == (0, $5pJMm.EntityType).ACCOUNT) return (0, $7Aqrk.AccountService).accounts.filter((value)=>value.id == id)[0];
        else return (0, $l8ea0.ContactService).contacts.filter((value)=>value.id == id)[0];
    }
    static getType(entity) {
        return (0, $dH00N.Models).isContactModel(entity) ? (0, $5pJMm.EntityType).CONTACT : (0, $5pJMm.EntityType).ACCOUNT;
    }
    /**
     * websocket
     */ static typing(conversationId, typing, content, files, previews) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ENTITY_TYPING, {
            conversationId: conversationId,
            typing: typing,
            content: content,
            filesIds: files ? files.map((value)=>value.id) : undefined,
            previewsIds: previews ? previews.map((value)=>value.id) : undefined
        });
    }
    /**
     * headers
     */ static headersToken(headers, saveCookie = true) {
        if (headers !== undefined && headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER] != undefined) {
            $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeToken = headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER];
            if (saveCookie) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeTokenCookie = headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER];
        }
    }
    /**
     * virtual
     */ static virtualGenerate(avatar) {
        return {
            work: "",
            avatar: avatar,
            siteId: "virtualId",
            name: "name",
            id: "virtualId",
            email: "email",
            active: true,
            avatarId: avatar.id,
            twoFactor: false
        };
    }
    /**
     * events
     */ static onTyping(func, component) {
        this.typingEvents.push(func);
        component.onRemove(()=>this.typingEvents.splice(this.typingEvents.indexOf(func), 1));
    }
    /**
     * store
     */ static storeContext(entity, site) {
        this.activeEntity = this.store(entity, entity.type);
        this.activeSite = (0, $fdmdr.SiteService).store(site);
    }
    static storeAll(entities, type) {
        for(let key in entities)entities[key] = this.store(entities[key], type);
        return (0, $2Y8XI.Services).storeAll(entities);
    }
    static store(entity, type) {
        if (type == undefined) {
            if ((0, $dH00N.Models).isContactModel(entity)) entity = (0, $l8ea0.ContactService).store(entity);
            else if ((0, $dH00N.Models).isAccountModel(entity)) entity = (0, $7Aqrk.AccountService).store(entity);
        } else if (type == (0, $5pJMm.EntityType).ACCOUNT) // @ts-ignore
        entity = (0, $7Aqrk.AccountService).store(entity);
        else // @ts-ignore
        entity = (0, $l8ea0.ContactService).store(entity);
        return entity;
    }
}
$9b2c4bfdf11e2b41$export$714c657d7d597c58.typingEvents = [];
$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeOfferProducts = {};
$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeOfferIsFailureToPay = false;
$9b2c4bfdf11e2b41$export$714c657d7d597c58._activeWebPushToken = "_activeWebPushToken";

});
parcelRegister("7AbeR", function(module, exports) {

$parcel$export(module.exports, "Network", function () { return $027898bf994f2033$export$95be4ae94445245a; });
parcelRequire("amWqg");
var $daxY8 = parcelRequire("daxY8");

var $271MM = parcelRequire("271MM");

var $68Z0d = parcelRequire("68Z0d");

var $8J94x = parcelRequire("8J94x");

var $4in9X = parcelRequire("4in9X");

var $bTARt = parcelRequire("bTARt");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $5FliW = parcelRequire("5FliW");

var $bi5k0 = parcelRequire("bi5k0");

var $dEtAh = parcelRequire("dEtAh");

var $btxlx = parcelRequire("btxlx");

var $i00Q1 = parcelRequire("i00Q1");

var $c1R3d = parcelRequire("c1R3d");

var $kSokW = parcelRequire("kSokW");

var $bIule = parcelRequire("bIule");

var $afj2S = parcelRequire("afj2S");

var $esq0i = parcelRequire("esq0i");
class $027898bf994f2033$export$95be4ae94445245a {
    /**
     * logged
     */ static get logged() {
        return this._logged;
    }
    static set logged(value) {
        this._logged = value;
        (0, $dEtAh.SedestralStorage).setItem(`${this.productName}-online`, this._logged + "");
    }
    /**
     * init
     */ static async init(productName) {
        this.productName = productName;
        this._logged = (0, $dEtAh.SedestralStorage).getItem(`${this.productName}-online`) == undefined ? false : (0, $dEtAh.SedestralStorage).getItem(`${this.productName}-online`) == "true";
        this.vendor = (0, $esq0i.generateVendor)((0, $271MM.config).domain);
        this.tenor = (0, $daxY8.default).create({
            baseURL: (0, $271MM.config).tenorHost,
            timeout: this.timeoutTenor
        });
        this.tenor.defaults.params = {
            key: (0, $271MM.config).tenorKey
        };
        this.httpResources = (0, $daxY8.default).create({
            baseURL: (0, $271MM.config).httpPanelUrl,
            withCredentials: false,
            timeout: this.timeoutApi
        });
        this.registerAxios((0, $kfkzw.ProductType).PANEL, (0, $271MM.config).httpPanelUrl);
        var _config_httpCommunityUrl;
        this.registerAxios((0, $kfkzw.ProductType).COMMUNITY, (_config_httpCommunityUrl = (0, $271MM.config).httpCommunityUrl) !== null && _config_httpCommunityUrl !== void 0 ? _config_httpCommunityUrl : (0, $271MM.config).domain);
        this.registerSocket((0, $kfkzw.ProductType).PANEL, (0, $271MM.config).websocketPanelUrl);
        this.registerSocket((0, $kfkzw.ProductType).COMMUNITY, (0, $271MM.config).websocketCommunityUrl);
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["NetworkService"] = this;
    }
    static initErrors() {
        this.commonErrors = [
            {
                errorCode: (0, $bTARt.ErrorCode).SITE_CHANNEL_NO_FOUND,
                message: (0, $5FliW.Resources).t("words.errorSITE_CHANNEL_NO_FOUND")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NO_RECIPIENT,
                message: (0, $5FliW.Resources).t("words.errorNO_RECIPIENT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NO_SITE_CHANEl,
                message: (0, $5FliW.Resources).t("words.errorNO_SITE_CHANNEL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_TECHNICAL,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_TECHNICAL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).CAPTCHA_INCORRECT,
                message: (0, $5FliW.Resources).t("words.errorCAPTCHA_INCORRECT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_CODE_INCORRECT,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_CODE_INCORRECT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_TRANSACTION_NO_FOUND,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_TRANSACTION_NO_FOUND")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_EXPIRE_CODE,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_EXPIRE_CODE")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_ATTEMPT,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_ATTEMPT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_BAND_WIDTH_LIMIT,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_BAND_WIDTH_LIMIT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_METHOD_UNAUTHORIZED,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_METHOD_UNAUTHORIZED")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_CREATE_INVALID_CODE,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_CREATE_INVALID_CODE")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SITE_CHANNEL_PERMISSION,
                message: (0, $5FliW.Resources).t("words.errorSITE_CHANNEL_PERMISSION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PERMISSION,
                message: (0, $5FliW.Resources).t("words.errorPERMISSION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).VERIFICATION,
                message: (0, $5FliW.Resources).t("words.errorVERIFICATION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.errorSIZE_MAX")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NULLITY,
                message: (0, $5FliW.Resources).t("words.errorNULLITY")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EXCEPTION,
                message: (0, $5FliW.Resources).t("words.errorEXCEPTION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).CACHE,
                message: (0, $5FliW.Resources).t("words.errorCACHE")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).K8S_DOMAIN_ERROR,
                message: (0, $5FliW.Resources).t("words.errorK8S_DOMAIN_ERROR")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).DOMAIN_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorDOMAIN_FORMAT"),
                displayValue: true
            },
            {
                errorCode: (0, $bTARt.ErrorCode).DOMAIN_FULL,
                message: (0, $5FliW.Resources).t("words.errorDOMAIN_FULL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).HOST_INCORRECT,
                message: (0, $5FliW.Resources).t("words.errorHOST_INCORRECT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST,
                message: (0, $5FliW.Resources).t("words.errorHOST_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NAME_EXIST,
                message: (0, $5FliW.Resources).t("words.errorNAME_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).WINDOW_EXPIRED,
                message: (0, $5FliW.Resources).t("words.errorWINDOW_EXPIRED")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_ALIAS_EXIST,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_ALIAS_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_ALIAS,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_ALIAS")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_EXIST,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_BLACKLIST,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_BLACKLIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAIL_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorMAIL_FORMAT"),
                displayValue: true
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PHONE_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorPHONE_FORMAT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAIL_DOMAIN,
                message: (0, $5FliW.Resources).t("words.errorMAIL_DOMAIN")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).RECIPIENT_FULL,
                message: (0, $5FliW.Resources).t("words.errorRECIPIENT_FULL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).IMAGE_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorIMAGE_FORMAT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NO_CONTACT,
                message: (0, $5FliW.Resources).t("words.errorNO_CONTACT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TAX_COUNTRY,
                message: (0, $5FliW.Resources).t("words.postalCountryTaxCountry")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TAX_TYPE,
                message: (0, $5FliW.Resources).t("words.taxTypeNotAvailable")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TAX_VALUE_INVALID,
                message: (0, $5FliW.Resources).t("words.taxValueInvalid")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).LOCATION_INVALID,
                message: (0, $5FliW.Resources).t("words.locationInvalid")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TOKEN_INVALID,
                message: (0, $5FliW.Resources).t("words.tokenInvalidMessage")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PAYMENT_PROVIDER_CREATE_SUBSCRIPTION,
                message: (0, $5FliW.Resources).t("words.paymentProviderCreateSubscriptionMessage")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).OFFER_QUOTE_EXISTS,
                message: (0, $5FliW.Resources).t("words.quoteExistsErrorMessage")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).CREATE_ARTICLE_IA_FORM_EMPTY,
                message: (0, $5FliW.Resources).t("words.errorcreateArticleFormEmpty")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TASK_IN_PROGRESS,
                message: (0, $5FliW.Resources).t("words.taskInProgress")
            },
            {
                status: (0, $7ZaxO.HttpStatus).UNAUTHORIZED,
                message: (0, $5FliW.Resources).t("words.errorUNAUTHORIZED")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.errorNOT_FOUND")
            },
            {
                status: (0, $7ZaxO.HttpStatus).PRECONDITION_FAILED,
                message: (0, $5FliW.Resources).t("words.errorPRECONDITION_FAILED")
            },
            {
                status: (0, $7ZaxO.HttpStatus).BAD_GATEWAY,
                message: (0, $5FliW.Resources).t("words.errorSERVICE_UNAVAILABLE")
            },
            {
                status: (0, $7ZaxO.HttpStatus).SERVICE_UNAVAILABLE,
                message: (0, $5FliW.Resources).t("words.errorSERVICE_UNAVAILABLE")
            },
            {
                status: (0, $7ZaxO.HttpStatus).INTERNAL_SERVER_ERROR,
                message: (0, $5FliW.Resources).t("words.errorINTERNAL_SERVER_ERROR")
            },
            {
                status: (0, $7ZaxO.HttpStatus).TOO_MANY_REQUESTS,
                message: (0, $5FliW.Resources).t("words.errorTOO_MANY_REQUESTS")
            }
        ];
    }
    /**
     * starting
     */ static async start(router) {
        if (router != undefined) {
            this.router = router;
            this.router.onStarted = ()=>this.startedFunctions.forEach((value)=>value());
        }
        if (await this.onToken()) {
            if ($027898bf994f2033$export$95be4ae94445245a.logged) await this.startLogin();
        } else {
            this.executeNetworkLost();
            return false;
        }
        return true;
    }
    static async startLogin() {
        if (!await this.onLogin()) {
            this.executeNetworkLost();
            return false;
        }
        return true;
    }
    static async startWebSocket(type, onDisconnect) {
        var _EntityService_activeSite;
        let socket = this.getSocket(type);
        socket.onDisconnect = ()=>{
            if (type == (0, $kfkzw.ProductType).PANEL) this.executeNetworkLost();
            if (onDisconnect) onDisconnect();
        };
        if (await socket.start({
            siteId: (_EntityService_activeSite = (0, $68Z0d.EntityService).activeSite) === null || _EntityService_activeSite === void 0 ? void 0 : _EntityService_activeSite.id,
            entityType: (0, $68Z0d.EntityService).activeEntity.type,
            activeToken: (0, $68Z0d.EntityService).activeToken
        })) return socket;
    }
    /**
     * websocket
     */ static async disconnect(type, logout) {
        this.getSocket(type).disconnect(logout);
    }
    static emit(type, event, value) {
        $027898bf994f2033$export$95be4ae94445245a.getSocket(type).emit(event, value);
    }
    static async emitSync(type, event, value) {
        return await $027898bf994f2033$export$95be4ae94445245a.getSocket(type).emitSync(event, value);
    }
    static on(type, event, func) {
        var _Network_getSocket;
        (_Network_getSocket = $027898bf994f2033$export$95be4ae94445245a.getSocket(type)) === null || _Network_getSocket === void 0 ? void 0 : _Network_getSocket.on(event, func);
    }
    static async join(type, data, route) {
        if (data != null) return await $027898bf994f2033$export$95be4ae94445245a.emitSync(type, route, data);
    }
    static getSocket(type) {
        var _this_sockets_find, _this_sockets_find1;
        if (type) return (_this_sockets_find = this.sockets.find((value)=>value.type == type)) === null || _this_sockets_find === void 0 ? void 0 : _this_sockets_find.socket;
        return (_this_sockets_find1 = this.sockets.find((value)=>value.type == (0, $kfkzw.ProductType).PANEL)) === null || _this_sockets_find1 === void 0 ? void 0 : _this_sockets_find1.socket;
    }
    static removeSocket(type) {
        let socket = this.sockets.find((value)=>value.type == type);
        if (socket) this.sockets.splice(this.sockets.indexOf(socket), 1);
    }
    static registerSocket(type, host) {
        this.removeSocket(type);
        this.sockets.push({
            type: type,
            socket: new (0, $i00Q1.NetworkSocket)(host)
        });
    }
    /**
     * axios
     */ static registerAxios(type, host) {
        let instance = this.axios.find((value)=>value.type == type);
        if (instance) this.axios.splice(this.axios.indexOf(instance), 1);
        let http = (0, $daxY8.default).create({
            baseURL: host,
            withCredentials: false,
            timeout: this.timeoutApi
        });
        http.interceptors.request.use(function(config) {
            if ((0, $68Z0d.EntityService).activeToken) config.headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER] = (0, $68Z0d.EntityService).activeToken;
            if ((0, $68Z0d.EntityService).activeSite) config.headers[(0, $4in9X.NetworkHeaders).SITE_HEADER] = (0, $68Z0d.EntityService).activeSite.id;
            return config;
        });
        this.axios.push({
            type: type,
            http: http
        });
    }
    static getAxios(type) {
        var _this_axios_find, _this_axios_find1;
        if (type) return (_this_axios_find = this.axios.find((value)=>value.type == type)) === null || _this_axios_find === void 0 ? void 0 : _this_axios_find.http;
        return (_this_axios_find1 = this.axios.find((value)=>value.type == (0, $kfkzw.ProductType).PANEL)) === null || _this_axios_find1 === void 0 ? void 0 : _this_axios_find1.http;
    }
    /**
     * http
     */ static async request(type, request, component, config) {
        let tokenSource = (0, $daxY8.default).CancelToken.source();
        if (config === null || config === void 0 ? void 0 : config.cancelableCallback) config.cancelableCallback(tokenSource);
        if (component && component.onRemove) component.onRemove(()=>{
            tokenSource.cancel();
        });
        return (0, $8J94x.SedestralMachine).promise((resolve)=>{
            let axiosRequest = request(tokenSource.token);
            axiosRequest.then((response)=>{
                var _Network_router_static_components_twoFactor, _Network_router_static_components, _Network_router_static, _Network_router, _Network_router_static_components_twoFactor1, _Network_router_static_components1, _Network_router_static1, _Network_router1;
                resolve(response);
                if ((_Network_router = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router === void 0 ? void 0 : (_Network_router_static = _Network_router.static) === null || _Network_router_static === void 0 ? void 0 : (_Network_router_static_components = _Network_router_static.components) === null || _Network_router_static_components === void 0 ? void 0 : (_Network_router_static_components_twoFactor = _Network_router_static_components.twoFactor) === null || _Network_router_static_components_twoFactor === void 0 ? void 0 : _Network_router_static_components_twoFactor.onSuccess) (_Network_router1 = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router1 === void 0 ? void 0 : (_Network_router_static1 = _Network_router1.static) === null || _Network_router_static1 === void 0 ? void 0 : (_Network_router_static_components1 = _Network_router_static1.components) === null || _Network_router_static_components1 === void 0 ? void 0 : (_Network_router_static_components_twoFactor1 = _Network_router_static_components1.twoFactor) === null || _Network_router_static_components_twoFactor1 === void 0 ? void 0 : _Network_router_static_components_twoFactor1.onSuccess(response);
                if (response && response.headers) this.requestAlert(response.headers);
            }).catch((response)=>{
                //Si pas de réponse, on en simule une
                if (!response.response && (response === null || response === void 0 ? void 0 : response.code) !== "ERR_CANCELED") response = {
                    response: {
                        status: (0, $7ZaxO.HttpStatus).SERVICE_UNAVAILABLE,
                        data: ""
                    }
                };
                if (response.response && response.response.data && (response.response.data.status || response.response.data.errorCode) && response.response.status) {
                    var _Network_router_static_components_twoFactor, _Network_router_static_components, _Network_router_static, _Network_router;
                    this.requestTwoFactor(component, {
                        ...response,
                        productType: type
                    });
                    this.requestError(component, response.response.data);
                    if (response.response.status !== (0, $7ZaxO.HttpStatus).LOCKED) (_Network_router = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router === void 0 ? void 0 : (_Network_router_static = _Network_router.static) === null || _Network_router_static === void 0 ? void 0 : (_Network_router_static_components = _Network_router_static.components) === null || _Network_router_static_components === void 0 ? void 0 : (_Network_router_static_components_twoFactor = _Network_router_static_components.twoFactor) === null || _Network_router_static_components_twoFactor === void 0 ? void 0 : _Network_router_static_components_twoFactor.clear();
                } else {
                    var _Network_router_static_components_twoFactor1, _Network_router_static_components1, _Network_router_static1, _Network_router1;
                    if (response.response && response.response.status != (0, $7ZaxO.HttpStatus).OK) this.requestError(component, {
                        status: response.response.status
                    });
                    (_Network_router1 = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router1 === void 0 ? void 0 : (_Network_router_static1 = _Network_router1.static) === null || _Network_router_static1 === void 0 ? void 0 : (_Network_router_static_components1 = _Network_router_static1.components) === null || _Network_router_static_components1 === void 0 ? void 0 : (_Network_router_static_components_twoFactor1 = _Network_router_static_components1.twoFactor) === null || _Network_router_static_components_twoFactor1 === void 0 ? void 0 : _Network_router_static_components_twoFactor1.clear();
                }
                resolve(response.response);
            });
        });
    }
    static async requestAlert(headers) {
        let alertCode = headers[(0, $4in9X.NetworkHeaders).ALERT_HEADER];
        if (alertCode) $027898bf994f2033$export$95be4ae94445245a.router.static.components.notifications.notify((0, $5FliW.Resources).t("words.alert." + alertCode), undefined, 8000, "success");
    }
    static async requestError(component, data) {
        if (data) {
            if (data.status == (0, $7ZaxO.HttpStatus).PAYMENT_REQUIRED) this.onPaymentRequired(data.currentQuantity, data.limitQuantity, data.solutionType, data.productType);
            else if (data.errorCode != (0, $bTARt.ErrorCode)[(0, $bTARt.ErrorCode).TWO_FACTOR_REQUIRED]) {
                if (data.errorCode == (0, $bTARt.ErrorCode)[(0, $bTARt.ErrorCode).SURFACE_CONTROL]) {
                    if (data.subErrors) data.subErrors.forEach((subError)=>{
                        this.onError((0, $5FliW.Resources).r("words.error.fieldErrorMessage", {
                            field: subError.field,
                            message: subError.message
                        }));
                    });
                    else if (data.message && data.message.includes("parameter is missing")) this.onError((0, $5FliW.Resources).t("words.errorfillEmptyFieldsError"));
                    else {
                        var _SedestralDebugger_rum;
                        this.onError((0, $5FliW.Resources).t("words.errorgenericErrorMessage"));
                        (_SedestralDebugger_rum = (0, $c1R3d.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.unHandledError(data.errorCode);
                    }
                } else if (data.status === (0, $7ZaxO.HttpStatus).NETWORK_AUTHENTICATION_REQUIRED) await this.createLogout();
                else {
                    let resultCheckError = $027898bf994f2033$export$95be4ae94445245a.checkError(component === null || component === void 0 ? void 0 : component.networkErrorsHandler, data) || $027898bf994f2033$export$95be4ae94445245a.checkError(this.commonErrors, data);
                    if (!resultCheckError) {
                        var _SedestralDebugger_rum1;
                        let message = data.error + ": " + data.message + " | code: " + data.errorCode + " | type: " + data.errorType + " | status: " + data.status;
                        (_SedestralDebugger_rum1 = (0, $c1R3d.SedestralDebugger).rum) === null || _SedestralDebugger_rum1 === void 0 ? void 0 : _SedestralDebugger_rum1.unHandledError(data.errorCode);
                        this.onError(message);
                    }
                }
            }
        }
    }
    static requestTwoFactor(component, response) {
        if (response.response.data.errorCode == (0, $bTARt.ErrorCode)[(0, $bTARt.ErrorCode).TWO_FACTOR_REQUIRED]) {
            if ($027898bf994f2033$export$95be4ae94445245a.router.static.components.twoFactor.onSuccess) try {
                let data = response.response.headers[(0, $4in9X.NetworkHeaders).TF_TRANSACTION_DATA_HEADER];
                let method = +parseInt(response.response.headers[(0, $4in9X.NetworkHeaders).TF_TRANSACTION_METHOD_HEADER]);
                if (method !== undefined && (method == (0, $btxlx.IAccountTwoFactorMethod).TOTP || method == (0, $btxlx.IAccountTwoFactorMethod).EMAIL && data != undefined)) $027898bf994f2033$export$95be4ae94445245a.router.static.components.twoFactor.create(data, response);
                else this.onError("TWO_FACTOR_REQUIRED not data.");
            } catch (e) {
                this.onError("TWO_FACTOR_REQUIRED not data.");
            }
            else this.onError("TWO_FACTOR_REQUIRED not active.");
        }
    }
    static async postJson(type, url, data, component, config) {
        let jsonHeaders = {
            "Content-Type": "application/json"
        };
        if (!config) config = {};
        config.headers = (0, $kSokW.jsonConcat)(jsonHeaders, config.headers);
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).post(url, JSON.stringify(data), (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async postFormData(type, url, data, component, config) {
        let jsonHeaders = {
            "Content-Type": "multipart/form-data"
        };
        if (!config) config = {};
        config.headers = (0, $kSokW.jsonConcat)(jsonHeaders, config.headers);
        let formData = new FormData();
        Object.keys(data).forEach(function(key) {
            if (key != "files") formData.append(key, data[key]);
        });
        if (data.files) data.files.forEach((file)=>formData.append("files", file));
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).post(url, formData, (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component);
    }
    static async post(type, url, data, component, config, parseQuery = true) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).post(url, data ? parseQuery ? (0, $afj2S.queryString)(data) : data : undefined, (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async put(type, url, data, component, config) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).put(url, data ? (0, $afj2S.queryString)(data) : undefined, (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async putJson(type, url, data, component, config) {
        let jsonHeaders = {
            "Content-Type": "application/json"
        };
        if (!config) config = {};
        config.headers = (0, $kSokW.jsonConcat)(jsonHeaders, config.headers);
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).put(url, JSON.stringify(data), (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async get(type, url, component, config) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).get(url, (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async delete(type, url, component, config) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).delete(url, (0, $kSokW.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async retry(response, component, config) {
        var _response_productType;
        const type = (_response_productType = response.productType) !== null && _response_productType !== void 0 ? _response_productType : (0, $kfkzw.ProductType).PANEL;
        switch(response.config.method){
            case "post":
                try {
                    let jsonData = JSON.parse(response.config.data);
                    return await $027898bf994f2033$export$95be4ae94445245a.postJson(type, response.config.url, jsonData, component, config);
                } catch (e) {
                    return await $027898bf994f2033$export$95be4ae94445245a.post(type, response.config.url, response.config.data, component, config, false);
                }
            case "put":
                try {
                    let jsonData = JSON.parse(response.config.data);
                    return await $027898bf994f2033$export$95be4ae94445245a.putJson(type, response.config.url, jsonData, component, config);
                } catch (e) {
                    return await $027898bf994f2033$export$95be4ae94445245a.put(type, response.config.url, response.config.data, component, config);
                }
            case "get":
                return await $027898bf994f2033$export$95be4ae94445245a.get(type, response.config.url, component, config);
            case "delete":
                return await $027898bf994f2033$export$95be4ae94445245a.delete(type, response.config.url, component, config);
        }
    }
    static async createLogout() {
        $027898bf994f2033$export$95be4ae94445245a.router.onLogout();
        await $027898bf994f2033$export$95be4ae94445245a.onLogout();
    }
    /**
     * to override
     */ static async onToken() {
        return false;
    }
    static async onLogin() {
        return false;
    }
    static async onLogout() {
        return false;
    }
    static onError(message) {}
    static onPaymentRequired(currentQuantity, limitQuantity, solutionType, productType) {}
    /**
     * network error
     */ static onNetworkLost(func) {
        this.lostFunctions.push(func);
    }
    static onNetworkLostSolved(func) {
        this.lostSolvedFunctions.push(func);
    }
    static executeNetworkLost() {
        if (!this.lostConnection) {
            this.lostConnection = true;
            this.lostFunctions.forEach((value)=>value());
            this.lostConnectionInterval = setInterval(async ()=>{
                if (await this.start()) {
                    this.lostConnection = false;
                    clearInterval(this.lostConnectionInterval);
                    this.lostSolvedFunctions.forEach((value)=>value());
                }
            }, this.getSecondsRetry());
        }
    }
    static getSecondsRetry() {
        return (0, $bIule.randomInteger)(3000, 6000);
    }
    /**
     * initialized
     */ static onStarted(func) {
        this.startedFunctions.push(func);
    }
    /**
     * SSR
     */ static ssrRegisterDomain(context) {
        (0, $271MM.config).domain = context;
        this.vendor = (0, $esq0i.generateVendor)((0, $271MM.config).domain);
        return context;
    }
    static checkError(errors, data) {
        let error = undefined;
        if (errors !== undefined) {
            if (data.errorCode != undefined) error = errors.find((value)=>(0, $bTARt.ErrorCode)[value.errorCode] === data.errorCode);
            if (data.status != undefined && error === undefined) error = errors.find((value)=>value.status === data.status);
            if (error === undefined) error = errors.find((value)=>(value === null || value === void 0 ? void 0 : value.defaultError) === true);
            if (error !== undefined) {
                if (error.message && error.message !== "none") this.onError(error.message + (error.displayValue ? " (" + data.message + ")" : ""));
                else if (error.handle) error.handle();
            }
        }
        return error !== undefined;
    }
}
$027898bf994f2033$export$95be4ae94445245a.sockets = [];
$027898bf994f2033$export$95be4ae94445245a.axios = [];
$027898bf994f2033$export$95be4ae94445245a.timeoutApi = 60000;
$027898bf994f2033$export$95be4ae94445245a.timeoutTenor = 10000;
$027898bf994f2033$export$95be4ae94445245a.lostConnectionInterval = 0;
$027898bf994f2033$export$95be4ae94445245a.lostConnection = false;
$027898bf994f2033$export$95be4ae94445245a.lostFunctions = [];
$027898bf994f2033$export$95be4ae94445245a.lostSolvedFunctions = [];
$027898bf994f2033$export$95be4ae94445245a.startedFunctions = [];

});
parcelRegister("amWqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("daxY8")).default; });

var $daxY8 = parcelRequire("daxY8");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $78c946fdaa590200$export$1c00760e9e5a4e95, AxiosError: $78c946fdaa590200$export$c1fbed17c2f6a328, CanceledError: $78c946fdaa590200$export$1ab0c6b20d94fa14, isCancel: $78c946fdaa590200$export$3b22524397b493c6, CancelToken: $78c946fdaa590200$export$fd08e3cb425f0d61, VERSION: $78c946fdaa590200$export$a4ad2735b021c132, all: $78c946fdaa590200$export$84bf76cd7afc7469, Cancel: $78c946fdaa590200$export$848c9b7ead0df967, isAxiosError: $78c946fdaa590200$export$fbafdbe06a5b5a9a, spread: $78c946fdaa590200$export$3ae0fd4797ed47c8, toFormData: $78c946fdaa590200$export$10ae0d317ea97f8b, AxiosHeaders: $78c946fdaa590200$export$4e7d6ff0f3e6520, HttpStatusCode: $78c946fdaa590200$export$a972f69c851492b3, formToJSON: $78c946fdaa590200$export$86d7c59254d6a2c9, getAdapter: $78c946fdaa590200$export$17ddc20a97d669e2, mergeConfig: $78c946fdaa590200$export$7ec1ebcfa9d8bd6a } = (0, $daxY8.default);

});
parcelRegister("daxY8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99668f139e6d27a1$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $jSUas = parcelRequire("jSUas");

var $lT31C = parcelRequire("lT31C");

var $4mJfT = parcelRequire("4mJfT");

var $gGIev = parcelRequire("gGIev");

var $e4j5G = parcelRequire("e4j5G");

var $82h0N = parcelRequire("82h0N");

var $4ar6q = parcelRequire("4ar6q");

var $2v382 = parcelRequire("2v382");

var $iro9b = parcelRequire("iro9b");

var $i2rBs = parcelRequire("i2rBs");

var $jdUqi = parcelRequire("jdUqi");

var $hImvc = parcelRequire("hImvc");

var $fn32J = parcelRequire("fn32J");

var $3V9hT = parcelRequire("3V9hT");

var $ekUJE = parcelRequire("ekUJE");

var $jLDDr = parcelRequire("jLDDr");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $99668f139e6d27a1$var$createInstance(defaultConfig) {
    const context = new (0, $lT31C.default)(defaultConfig);
    const instance = (0, $jSUas.default)((0, $lT31C.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $pci3K.default).extend(instance, (0, $lT31C.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $pci3K.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $99668f139e6d27a1$var$createInstance((0, $4mJfT.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $99668f139e6d27a1$var$axios = $99668f139e6d27a1$var$createInstance((0, $gGIev.default));
// Expose Axios class to allow class inheritance
$99668f139e6d27a1$var$axios.Axios = (0, $lT31C.default);
// Expose Cancel & CancelToken
$99668f139e6d27a1$var$axios.CanceledError = (0, $82h0N.default);
$99668f139e6d27a1$var$axios.CancelToken = (0, $4ar6q.default);
$99668f139e6d27a1$var$axios.isCancel = (0, $2v382.default);
$99668f139e6d27a1$var$axios.VERSION = (0, $iro9b.VERSION);
$99668f139e6d27a1$var$axios.toFormData = (0, $i2rBs.default);
// Expose AxiosError class
$99668f139e6d27a1$var$axios.AxiosError = (0, $jdUqi.default);
// alias for CanceledError for backward compatibility
$99668f139e6d27a1$var$axios.Cancel = $99668f139e6d27a1$var$axios.CanceledError;
// Expose all/spread
$99668f139e6d27a1$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$99668f139e6d27a1$var$axios.spread = (0, $hImvc.default);
// Expose isAxiosError
$99668f139e6d27a1$var$axios.isAxiosError = (0, $fn32J.default);
// Expose mergeConfig
$99668f139e6d27a1$var$axios.mergeConfig = (0, $4mJfT.default);
$99668f139e6d27a1$var$axios.AxiosHeaders = (0, $3V9hT.default);
$99668f139e6d27a1$var$axios.formToJSON = (thing)=>(0, $e4j5G.default)((0, $pci3K.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$99668f139e6d27a1$var$axios.getAdapter = (0, $ekUJE.default).getAdapter;
$99668f139e6d27a1$var$axios.HttpStatusCode = (0, $jLDDr.default);
$99668f139e6d27a1$var$axios.default = $99668f139e6d27a1$var$axios;
var // this module should only have a default export
$99668f139e6d27a1$export$2e2bcd8739ae039 = $99668f139e6d27a1$var$axios;

});
parcelRegister("pci3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04bbde81f62a5b57$export$2e2bcd8739ae039; });

var $jSUas = parcelRequire("jSUas");

var $f8ZNS = parcelRequire("f8ZNS");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $04bbde81f62a5b57$var$toString } = Object.prototype;
const { getPrototypeOf: $04bbde81f62a5b57$var$getPrototypeOf } = Object;
const $04bbde81f62a5b57$var$kindOf = ((cache)=>(thing)=>{
        const str = $04bbde81f62a5b57$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $04bbde81f62a5b57$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$04bbde81f62a5b57$var$kindOf(thing) === type;
};
const $04bbde81f62a5b57$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $04bbde81f62a5b57$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $04bbde81f62a5b57$var$isUndefined = $04bbde81f62a5b57$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $04bbde81f62a5b57$var$isBuffer(val) {
    return val !== null && !$04bbde81f62a5b57$var$isUndefined(val) && val.constructor !== null && !$04bbde81f62a5b57$var$isUndefined(val.constructor) && $04bbde81f62a5b57$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $04bbde81f62a5b57$var$isArrayBuffer = $04bbde81f62a5b57$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $04bbde81f62a5b57$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $04bbde81f62a5b57$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $04bbde81f62a5b57$var$isString = $04bbde81f62a5b57$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $04bbde81f62a5b57$var$isFunction = $04bbde81f62a5b57$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $04bbde81f62a5b57$var$isNumber = $04bbde81f62a5b57$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $04bbde81f62a5b57$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $04bbde81f62a5b57$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $04bbde81f62a5b57$var$isPlainObject = (val)=>{
    if ($04bbde81f62a5b57$var$kindOf(val) !== "object") return false;
    const prototype = $04bbde81f62a5b57$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $04bbde81f62a5b57$var$isDate = $04bbde81f62a5b57$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $04bbde81f62a5b57$var$isFile = $04bbde81f62a5b57$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $04bbde81f62a5b57$var$isBlob = $04bbde81f62a5b57$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $04bbde81f62a5b57$var$isFileList = $04bbde81f62a5b57$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $04bbde81f62a5b57$var$isStream = (val)=>$04bbde81f62a5b57$var$isObject(val) && $04bbde81f62a5b57$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $04bbde81f62a5b57$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $04bbde81f62a5b57$var$isFunction(thing.append) && ((kind = $04bbde81f62a5b57$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $04bbde81f62a5b57$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $04bbde81f62a5b57$var$isURLSearchParams = $04bbde81f62a5b57$var$kindOfTest("URLSearchParams");
const [$04bbde81f62a5b57$var$isReadableStream, $04bbde81f62a5b57$var$isRequest, $04bbde81f62a5b57$var$isResponse, $04bbde81f62a5b57$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($04bbde81f62a5b57$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $04bbde81f62a5b57$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $04bbde81f62a5b57$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($04bbde81f62a5b57$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $04bbde81f62a5b57$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $04bbde81f62a5b57$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $04bbde81f62a5b57$var$isContextDefined = (context)=>!$04bbde81f62a5b57$var$isUndefined(context) && context !== $04bbde81f62a5b57$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $04bbde81f62a5b57$var$merge() {
    const { caseless: caseless } = $04bbde81f62a5b57$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $04bbde81f62a5b57$var$findKey(result, key) || key;
        if ($04bbde81f62a5b57$var$isPlainObject(result[targetKey]) && $04bbde81f62a5b57$var$isPlainObject(val)) result[targetKey] = $04bbde81f62a5b57$var$merge(result[targetKey], val);
        else if ($04bbde81f62a5b57$var$isPlainObject(val)) result[targetKey] = $04bbde81f62a5b57$var$merge({}, val);
        else if ($04bbde81f62a5b57$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $04bbde81f62a5b57$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $04bbde81f62a5b57$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $04bbde81f62a5b57$var$forEach(b, (val, key)=>{
        if (thisArg && $04bbde81f62a5b57$var$isFunction(val)) a[key] = (0, $jSUas.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $04bbde81f62a5b57$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $04bbde81f62a5b57$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $04bbde81f62a5b57$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $04bbde81f62a5b57$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $04bbde81f62a5b57$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $04bbde81f62a5b57$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($04bbde81f62a5b57$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$04bbde81f62a5b57$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $04bbde81f62a5b57$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $04bbde81f62a5b57$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $04bbde81f62a5b57$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $04bbde81f62a5b57$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $04bbde81f62a5b57$var$isHTMLForm = $04bbde81f62a5b57$var$kindOfTest("HTMLFormElement");
const $04bbde81f62a5b57$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $04bbde81f62a5b57$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $04bbde81f62a5b57$var$isRegExp = $04bbde81f62a5b57$var$kindOfTest("RegExp");
const $04bbde81f62a5b57$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $04bbde81f62a5b57$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $04bbde81f62a5b57$var$freezeMethods = (obj)=>{
    $04bbde81f62a5b57$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($04bbde81f62a5b57$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$04bbde81f62a5b57$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $04bbde81f62a5b57$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $04bbde81f62a5b57$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $04bbde81f62a5b57$var$noop = ()=>{};
const $04bbde81f62a5b57$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $04bbde81f62a5b57$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $04bbde81f62a5b57$var$DIGIT = "0123456789";
const $04bbde81f62a5b57$var$ALPHABET = {
    DIGIT: $04bbde81f62a5b57$var$DIGIT,
    ALPHA: $04bbde81f62a5b57$var$ALPHA,
    ALPHA_DIGIT: $04bbde81f62a5b57$var$ALPHA + $04bbde81f62a5b57$var$ALPHA.toUpperCase() + $04bbde81f62a5b57$var$DIGIT
};
const $04bbde81f62a5b57$var$generateString = (size = 16, alphabet = $04bbde81f62a5b57$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $04bbde81f62a5b57$var$isSpecCompliantForm(thing) {
    return !!(thing && $04bbde81f62a5b57$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $04bbde81f62a5b57$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($04bbde81f62a5b57$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $04bbde81f62a5b57$var$isArray(source) ? [] : {};
                $04bbde81f62a5b57$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$04bbde81f62a5b57$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $04bbde81f62a5b57$var$isAsyncFn = $04bbde81f62a5b57$var$kindOfTest("AsyncFunction");
const $04bbde81f62a5b57$var$isThenable = (thing)=>thing && ($04bbde81f62a5b57$var$isObject(thing) || $04bbde81f62a5b57$var$isFunction(thing)) && $04bbde81f62a5b57$var$isFunction(thing.then) && $04bbde81f62a5b57$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $04bbde81f62a5b57$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $04bbde81f62a5b57$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $04bbde81f62a5b57$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $04bbde81f62a5b57$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $04bbde81f62a5b57$var$isFunction($04bbde81f62a5b57$var$_global.postMessage));
const $04bbde81f62a5b57$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($04bbde81f62a5b57$var$_global) : typeof $f8ZNS !== "undefined" && $f8ZNS.nextTick || $04bbde81f62a5b57$var$_setImmediate;
var // *********************
$04bbde81f62a5b57$export$2e2bcd8739ae039 = {
    isArray: $04bbde81f62a5b57$var$isArray,
    isArrayBuffer: $04bbde81f62a5b57$var$isArrayBuffer,
    isBuffer: $04bbde81f62a5b57$var$isBuffer,
    isFormData: $04bbde81f62a5b57$var$isFormData,
    isArrayBufferView: $04bbde81f62a5b57$var$isArrayBufferView,
    isString: $04bbde81f62a5b57$var$isString,
    isNumber: $04bbde81f62a5b57$var$isNumber,
    isBoolean: $04bbde81f62a5b57$var$isBoolean,
    isObject: $04bbde81f62a5b57$var$isObject,
    isPlainObject: $04bbde81f62a5b57$var$isPlainObject,
    isReadableStream: $04bbde81f62a5b57$var$isReadableStream,
    isRequest: $04bbde81f62a5b57$var$isRequest,
    isResponse: $04bbde81f62a5b57$var$isResponse,
    isHeaders: $04bbde81f62a5b57$var$isHeaders,
    isUndefined: $04bbde81f62a5b57$var$isUndefined,
    isDate: $04bbde81f62a5b57$var$isDate,
    isFile: $04bbde81f62a5b57$var$isFile,
    isBlob: $04bbde81f62a5b57$var$isBlob,
    isRegExp: $04bbde81f62a5b57$var$isRegExp,
    isFunction: $04bbde81f62a5b57$var$isFunction,
    isStream: $04bbde81f62a5b57$var$isStream,
    isURLSearchParams: $04bbde81f62a5b57$var$isURLSearchParams,
    isTypedArray: $04bbde81f62a5b57$var$isTypedArray,
    isFileList: $04bbde81f62a5b57$var$isFileList,
    forEach: $04bbde81f62a5b57$var$forEach,
    merge: $04bbde81f62a5b57$var$merge,
    extend: $04bbde81f62a5b57$var$extend,
    trim: $04bbde81f62a5b57$var$trim,
    stripBOM: $04bbde81f62a5b57$var$stripBOM,
    inherits: $04bbde81f62a5b57$var$inherits,
    toFlatObject: $04bbde81f62a5b57$var$toFlatObject,
    kindOf: $04bbde81f62a5b57$var$kindOf,
    kindOfTest: $04bbde81f62a5b57$var$kindOfTest,
    endsWith: $04bbde81f62a5b57$var$endsWith,
    toArray: $04bbde81f62a5b57$var$toArray,
    forEachEntry: $04bbde81f62a5b57$var$forEachEntry,
    matchAll: $04bbde81f62a5b57$var$matchAll,
    isHTMLForm: $04bbde81f62a5b57$var$isHTMLForm,
    hasOwnProperty: $04bbde81f62a5b57$var$hasOwnProperty,
    hasOwnProp: $04bbde81f62a5b57$var$hasOwnProperty,
    reduceDescriptors: $04bbde81f62a5b57$var$reduceDescriptors,
    freezeMethods: $04bbde81f62a5b57$var$freezeMethods,
    toObjectSet: $04bbde81f62a5b57$var$toObjectSet,
    toCamelCase: $04bbde81f62a5b57$var$toCamelCase,
    noop: $04bbde81f62a5b57$var$noop,
    toFiniteNumber: $04bbde81f62a5b57$var$toFiniteNumber,
    findKey: $04bbde81f62a5b57$var$findKey,
    global: $04bbde81f62a5b57$var$_global,
    isContextDefined: $04bbde81f62a5b57$var$isContextDefined,
    ALPHABET: $04bbde81f62a5b57$var$ALPHABET,
    generateString: $04bbde81f62a5b57$var$generateString,
    isSpecCompliantForm: $04bbde81f62a5b57$var$isSpecCompliantForm,
    toJSONObject: $04bbde81f62a5b57$var$toJSONObject,
    isAsyncFn: $04bbde81f62a5b57$var$isAsyncFn,
    isThenable: $04bbde81f62a5b57$var$isThenable,
    setImmediate: $04bbde81f62a5b57$var$_setImmediate,
    asap: $04bbde81f62a5b57$var$asap
};

});
parcelRegister("jSUas", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e79ea136caa62a21$export$2e2bcd8739ae039; });
"use strict";
function $e79ea136caa62a21$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("f8ZNS", function(module, exports) {
// shim for using process in browser
var $b0678b3df8cce278$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b0678b3df8cce278$var$cachedSetTimeout;
var $b0678b3df8cce278$var$cachedClearTimeout;
function $b0678b3df8cce278$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b0678b3df8cce278$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b0678b3df8cce278$var$cachedSetTimeout = setTimeout;
        else $b0678b3df8cce278$var$cachedSetTimeout = $b0678b3df8cce278$var$defaultSetTimout;
    } catch (e) {
        $b0678b3df8cce278$var$cachedSetTimeout = $b0678b3df8cce278$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b0678b3df8cce278$var$cachedClearTimeout = clearTimeout;
        else $b0678b3df8cce278$var$cachedClearTimeout = $b0678b3df8cce278$var$defaultClearTimeout;
    } catch (e) {
        $b0678b3df8cce278$var$cachedClearTimeout = $b0678b3df8cce278$var$defaultClearTimeout;
    }
})();
function $b0678b3df8cce278$var$runTimeout(fun) {
    if ($b0678b3df8cce278$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b0678b3df8cce278$var$cachedSetTimeout === $b0678b3df8cce278$var$defaultSetTimout || !$b0678b3df8cce278$var$cachedSetTimeout) && setTimeout) {
        $b0678b3df8cce278$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b0678b3df8cce278$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b0678b3df8cce278$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b0678b3df8cce278$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b0678b3df8cce278$var$runClearTimeout(marker) {
    if ($b0678b3df8cce278$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b0678b3df8cce278$var$cachedClearTimeout === $b0678b3df8cce278$var$defaultClearTimeout || !$b0678b3df8cce278$var$cachedClearTimeout) && clearTimeout) {
        $b0678b3df8cce278$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b0678b3df8cce278$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b0678b3df8cce278$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b0678b3df8cce278$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b0678b3df8cce278$var$queue = [];
var $b0678b3df8cce278$var$draining = false;
var $b0678b3df8cce278$var$currentQueue;
var $b0678b3df8cce278$var$queueIndex = -1;
function $b0678b3df8cce278$var$cleanUpNextTick() {
    if (!$b0678b3df8cce278$var$draining || !$b0678b3df8cce278$var$currentQueue) return;
    $b0678b3df8cce278$var$draining = false;
    if ($b0678b3df8cce278$var$currentQueue.length) $b0678b3df8cce278$var$queue = $b0678b3df8cce278$var$currentQueue.concat($b0678b3df8cce278$var$queue);
    else $b0678b3df8cce278$var$queueIndex = -1;
    if ($b0678b3df8cce278$var$queue.length) $b0678b3df8cce278$var$drainQueue();
}
function $b0678b3df8cce278$var$drainQueue() {
    if ($b0678b3df8cce278$var$draining) return;
    var timeout = $b0678b3df8cce278$var$runTimeout($b0678b3df8cce278$var$cleanUpNextTick);
    $b0678b3df8cce278$var$draining = true;
    var len = $b0678b3df8cce278$var$queue.length;
    while(len){
        $b0678b3df8cce278$var$currentQueue = $b0678b3df8cce278$var$queue;
        $b0678b3df8cce278$var$queue = [];
        while(++$b0678b3df8cce278$var$queueIndex < len)if ($b0678b3df8cce278$var$currentQueue) $b0678b3df8cce278$var$currentQueue[$b0678b3df8cce278$var$queueIndex].run();
        $b0678b3df8cce278$var$queueIndex = -1;
        len = $b0678b3df8cce278$var$queue.length;
    }
    $b0678b3df8cce278$var$currentQueue = null;
    $b0678b3df8cce278$var$draining = false;
    $b0678b3df8cce278$var$runClearTimeout(timeout);
}
$b0678b3df8cce278$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b0678b3df8cce278$var$queue.push(new $b0678b3df8cce278$var$Item(fun, args));
    if ($b0678b3df8cce278$var$queue.length === 1 && !$b0678b3df8cce278$var$draining) $b0678b3df8cce278$var$runTimeout($b0678b3df8cce278$var$drainQueue);
};
// v8 likes predictible objects
function $b0678b3df8cce278$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b0678b3df8cce278$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b0678b3df8cce278$var$process.title = "browser";
$b0678b3df8cce278$var$process.browser = true;
$b0678b3df8cce278$var$process.env = {};
$b0678b3df8cce278$var$process.argv = [];
$b0678b3df8cce278$var$process.version = ""; // empty string to avoid regexp issues
$b0678b3df8cce278$var$process.versions = {};
function $b0678b3df8cce278$var$noop() {}
$b0678b3df8cce278$var$process.on = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.addListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.once = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.off = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.removeListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.removeAllListeners = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.emit = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.prependListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.prependOnceListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.listeners = function(name) {
    return [];
};
$b0678b3df8cce278$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b0678b3df8cce278$var$process.cwd = function() {
    return "/";
};
$b0678b3df8cce278$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b0678b3df8cce278$var$process.umask = function() {
    return 0;
};

});


parcelRegister("lT31C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef114c15b6f67d7$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $9EAAy = parcelRequire("9EAAy");

var $j4USS = parcelRequire("j4USS");

var $1dKS6 = parcelRequire("1dKS6");

var $4mJfT = parcelRequire("4mJfT");

var $lJkMI = parcelRequire("lJkMI");

var $121Mm = parcelRequire("121Mm");

var $3V9hT = parcelRequire("3V9hT");
"use strict";
const $fef114c15b6f67d7$var$validators = (0, $121Mm.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $fef114c15b6f67d7$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $4mJfT.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $121Mm.default).assertOptions(transitional, {
            silentJSONParsing: $fef114c15b6f67d7$var$validators.transitional($fef114c15b6f67d7$var$validators.boolean),
            forcedJSONParsing: $fef114c15b6f67d7$var$validators.transitional($fef114c15b6f67d7$var$validators.boolean),
            clarifyTimeoutError: $fef114c15b6f67d7$var$validators.transitional($fef114c15b6f67d7$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $pci3K.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $121Mm.default).assertOptions(paramsSerializer, {
                encode: $fef114c15b6f67d7$var$validators.function,
                serialize: $fef114c15b6f67d7$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $pci3K.default).merge(headers.common, headers[config.method]);
        headers && (0, $pci3K.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $3V9hT.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1dKS6.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1dKS6.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $4mJfT.default)(this.defaults, config);
        const fullPath = (0, $lJkMI.default)(config.baseURL, config.url);
        return (0, $9EAAy.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $j4USS.default)(),
            response: new (0, $j4USS.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $pci3K.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $fef114c15b6f67d7$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $4mJfT.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $pci3K.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $4mJfT.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $fef114c15b6f67d7$var$Axios.prototype[method] = generateHTTPMethod();
    $fef114c15b6f67d7$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $fef114c15b6f67d7$export$2e2bcd8739ae039 = $fef114c15b6f67d7$var$Axios;

});
parcelRegister("9EAAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70743b323e147633$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $kskWj = parcelRequire("kskWj");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $70743b323e147633$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $70743b323e147633$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $70743b323e147633$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $pci3K.default).isURLSearchParams(params) ? params.toString() : new (0, $kskWj.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("kskWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee46aa53bf55783d$export$2e2bcd8739ae039; });

var $i2rBs = parcelRequire("i2rBs");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $ee46aa53bf55783d$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $ee46aa53bf55783d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $i2rBs.default)(params, this, options);
}
const $ee46aa53bf55783d$var$prototype = $ee46aa53bf55783d$var$AxiosURLSearchParams.prototype;
$ee46aa53bf55783d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$ee46aa53bf55783d$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $ee46aa53bf55783d$var$encode);
    } : $ee46aa53bf55783d$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $ee46aa53bf55783d$export$2e2bcd8739ae039 = $ee46aa53bf55783d$var$AxiosURLSearchParams;

});
parcelRegister("i2rBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d21dd3491a3fc4ae$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $jdUqi = parcelRequire("jdUqi");

var $gJraw = parcelRequire("gJraw");

var $a94H4 = parcelRequire("a94H4");
var $d21dd3491a3fc4ae$require$Buffer = $a94H4.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d21dd3491a3fc4ae$var$isVisitable(thing) {
    return (0, $pci3K.default).isPlainObject(thing) || (0, $pci3K.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d21dd3491a3fc4ae$var$removeBrackets(key) {
    return (0, $pci3K.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d21dd3491a3fc4ae$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d21dd3491a3fc4ae$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d21dd3491a3fc4ae$var$isFlatArray(arr) {
    return (0, $pci3K.default).isArray(arr) && !arr.some($d21dd3491a3fc4ae$var$isVisitable);
}
const $d21dd3491a3fc4ae$var$predicates = (0, $pci3K.default).toFlatObject((0, $pci3K.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d21dd3491a3fc4ae$var$toFormData(obj, formData, options) {
    if (!(0, $pci3K.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $gJraw.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $pci3K.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $pci3K.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $pci3K.default).isSpecCompliantForm(formData);
    if (!(0, $pci3K.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $pci3K.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $pci3K.default).isBlob(value)) throw new (0, $jdUqi.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $pci3K.default).isArrayBuffer(value) || (0, $pci3K.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $d21dd3491a3fc4ae$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $pci3K.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $pci3K.default).isArray(value) && $d21dd3491a3fc4ae$var$isFlatArray(value) || ((0, $pci3K.default).isFileList(value) || (0, $pci3K.default).endsWith(key, "[]")) && (arr = (0, $pci3K.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d21dd3491a3fc4ae$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $pci3K.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d21dd3491a3fc4ae$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($d21dd3491a3fc4ae$var$isVisitable(value)) return true;
        formData.append($d21dd3491a3fc4ae$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($d21dd3491a3fc4ae$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d21dd3491a3fc4ae$var$isVisitable
    });
    function build(value, path) {
        if ((0, $pci3K.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $pci3K.default).forEach(value, function each(el, key) {
            const result = !((0, $pci3K.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $pci3K.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $pci3K.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $d21dd3491a3fc4ae$export$2e2bcd8739ae039 = $d21dd3491a3fc4ae$var$toFormData;

});
parcelRegister("jdUqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfeaffaadb19a284$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $dfeaffaadb19a284$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $pci3K.default).inherits($dfeaffaadb19a284$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $pci3K.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $dfeaffaadb19a284$var$prototype = $dfeaffaadb19a284$var$AxiosError.prototype;
const $dfeaffaadb19a284$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $dfeaffaadb19a284$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($dfeaffaadb19a284$var$AxiosError, $dfeaffaadb19a284$var$descriptors);
Object.defineProperty($dfeaffaadb19a284$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$dfeaffaadb19a284$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($dfeaffaadb19a284$var$prototype);
    (0, $pci3K.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $dfeaffaadb19a284$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $dfeaffaadb19a284$export$2e2bcd8739ae039 = $dfeaffaadb19a284$var$AxiosError;

});

parcelRegister("gJraw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e5ec71ec6e794f$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $c2e5ec71ec6e794f$export$2e2bcd8739ae039 = null;

});

parcelRegister("a94H4", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $762e62bc52707674$export$a143d493d941bafc; }, function (v) { return $762e62bc52707674$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $762e62bc52707674$export$f99ded8fe4b79145; }, function (v) { return $762e62bc52707674$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $762e62bc52707674$export$a143d493d941bafc;
var $762e62bc52707674$export$e4cf37d7f6fb9e0a;
var $762e62bc52707674$export$f99ded8fe4b79145;
var $762e62bc52707674$export$599f31c3813fae4d;
"use strict";

var $82Ig9 = parcelRequire("82Ig9");

var $awgx0 = parcelRequire("awgx0");
const $762e62bc52707674$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$762e62bc52707674$export$a143d493d941bafc = $762e62bc52707674$var$Buffer;
$762e62bc52707674$export$e4cf37d7f6fb9e0a = $762e62bc52707674$var$SlowBuffer;
$762e62bc52707674$export$f99ded8fe4b79145 = 50;
const $762e62bc52707674$var$K_MAX_LENGTH = 0x7fffffff;
$762e62bc52707674$export$599f31c3813fae4d = $762e62bc52707674$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $762e62bc52707674$var$Buffer.TYPED_ARRAY_SUPPORT = $762e62bc52707674$var$typedArraySupport();
if (!$762e62bc52707674$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $762e62bc52707674$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($762e62bc52707674$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$762e62bc52707674$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($762e62bc52707674$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$762e62bc52707674$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $762e62bc52707674$var$createBuffer(length) {
    if (length > $762e62bc52707674$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $762e62bc52707674$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $762e62bc52707674$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $762e62bc52707674$var$allocUnsafe(arg);
    }
    return $762e62bc52707674$var$from(arg, encodingOrOffset, length);
}
$762e62bc52707674$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $762e62bc52707674$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $762e62bc52707674$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $762e62bc52707674$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($762e62bc52707674$var$isInstance(value, ArrayBuffer) || value && $762e62bc52707674$var$isInstance(value.buffer, ArrayBuffer)) return $762e62bc52707674$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($762e62bc52707674$var$isInstance(value, SharedArrayBuffer) || value && $762e62bc52707674$var$isInstance(value.buffer, SharedArrayBuffer))) return $762e62bc52707674$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $762e62bc52707674$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $762e62bc52707674$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $762e62bc52707674$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $762e62bc52707674$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $762e62bc52707674$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($762e62bc52707674$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($762e62bc52707674$var$Buffer, Uint8Array);
function $762e62bc52707674$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $762e62bc52707674$var$alloc(size, fill, encoding) {
    $762e62bc52707674$var$assertSize(size);
    if (size <= 0) return $762e62bc52707674$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $762e62bc52707674$var$createBuffer(size).fill(fill, encoding) : $762e62bc52707674$var$createBuffer(size).fill(fill);
    return $762e62bc52707674$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $762e62bc52707674$var$Buffer.alloc = function(size, fill, encoding) {
    return $762e62bc52707674$var$alloc(size, fill, encoding);
};
function $762e62bc52707674$var$allocUnsafe(size) {
    $762e62bc52707674$var$assertSize(size);
    return $762e62bc52707674$var$createBuffer(size < 0 ? 0 : $762e62bc52707674$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $762e62bc52707674$var$Buffer.allocUnsafe = function(size) {
    return $762e62bc52707674$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $762e62bc52707674$var$Buffer.allocUnsafeSlow = function(size) {
    return $762e62bc52707674$var$allocUnsafe(size);
};
function $762e62bc52707674$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$762e62bc52707674$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $762e62bc52707674$var$byteLength(string, encoding) | 0;
    let buf = $762e62bc52707674$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $762e62bc52707674$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $762e62bc52707674$var$checked(array.length) | 0;
    const buf = $762e62bc52707674$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $762e62bc52707674$var$fromArrayView(arrayView) {
    if ($762e62bc52707674$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $762e62bc52707674$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $762e62bc52707674$var$fromArrayLike(arrayView);
}
function $762e62bc52707674$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $762e62bc52707674$var$Buffer.prototype);
    return buf;
}
function $762e62bc52707674$var$fromObject(obj) {
    if ($762e62bc52707674$var$Buffer.isBuffer(obj)) {
        const len = $762e62bc52707674$var$checked(obj.length) | 0;
        const buf = $762e62bc52707674$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $762e62bc52707674$var$numberIsNaN(obj.length)) return $762e62bc52707674$var$createBuffer(0);
        return $762e62bc52707674$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $762e62bc52707674$var$fromArrayLike(obj.data);
}
function $762e62bc52707674$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $762e62bc52707674$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $762e62bc52707674$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $762e62bc52707674$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $762e62bc52707674$var$Buffer.alloc(+length);
}
$762e62bc52707674$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $762e62bc52707674$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$762e62bc52707674$var$Buffer.compare = function compare(a, b) {
    if ($762e62bc52707674$var$isInstance(a, Uint8Array)) a = $762e62bc52707674$var$Buffer.from(a, a.offset, a.byteLength);
    if ($762e62bc52707674$var$isInstance(b, Uint8Array)) b = $762e62bc52707674$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$762e62bc52707674$var$Buffer.isBuffer(a) || !$762e62bc52707674$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$762e62bc52707674$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$762e62bc52707674$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $762e62bc52707674$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $762e62bc52707674$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($762e62bc52707674$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$762e62bc52707674$var$Buffer.isBuffer(buf)) buf = $762e62bc52707674$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$762e62bc52707674$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $762e62bc52707674$var$byteLength(string, encoding) {
    if ($762e62bc52707674$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $762e62bc52707674$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $762e62bc52707674$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $762e62bc52707674$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $762e62bc52707674$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$762e62bc52707674$var$Buffer.byteLength = $762e62bc52707674$var$byteLength;
function $762e62bc52707674$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $762e62bc52707674$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $762e62bc52707674$var$utf8Slice(this, start, end);
        case "ascii":
            return $762e62bc52707674$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $762e62bc52707674$var$latin1Slice(this, start, end);
        case "base64":
            return $762e62bc52707674$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $762e62bc52707674$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$762e62bc52707674$var$Buffer.prototype._isBuffer = true;
function $762e62bc52707674$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$762e62bc52707674$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$762e62bc52707674$var$swap(this, i, i + 1);
    return this;
};
$762e62bc52707674$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $762e62bc52707674$var$swap(this, i, i + 3);
        $762e62bc52707674$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$762e62bc52707674$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $762e62bc52707674$var$swap(this, i, i + 7);
        $762e62bc52707674$var$swap(this, i + 1, i + 6);
        $762e62bc52707674$var$swap(this, i + 2, i + 5);
        $762e62bc52707674$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$762e62bc52707674$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $762e62bc52707674$var$utf8Slice(this, 0, length);
    return $762e62bc52707674$var$slowToString.apply(this, arguments);
};
$762e62bc52707674$var$Buffer.prototype.toLocaleString = $762e62bc52707674$var$Buffer.prototype.toString;
$762e62bc52707674$var$Buffer.prototype.equals = function equals(b) {
    if (!$762e62bc52707674$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $762e62bc52707674$var$Buffer.compare(this, b) === 0;
};
$762e62bc52707674$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $762e62bc52707674$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($762e62bc52707674$var$customInspectSymbol) $762e62bc52707674$var$Buffer.prototype[$762e62bc52707674$var$customInspectSymbol] = $762e62bc52707674$var$Buffer.prototype.inspect;
$762e62bc52707674$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($762e62bc52707674$var$isInstance(target, Uint8Array)) target = $762e62bc52707674$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$762e62bc52707674$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $762e62bc52707674$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($762e62bc52707674$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $762e62bc52707674$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($762e62bc52707674$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $762e62bc52707674$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $762e62bc52707674$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $762e62bc52707674$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$762e62bc52707674$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$762e62bc52707674$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $762e62bc52707674$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$762e62bc52707674$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $762e62bc52707674$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $762e62bc52707674$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($762e62bc52707674$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $762e62bc52707674$var$utf8Write(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $762e62bc52707674$var$asciiWrite(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$asciiToBytes(string), buf, offset, length);
}
function $762e62bc52707674$var$base64Write(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$base64ToBytes(string), buf, offset, length);
}
function $762e62bc52707674$var$ucs2Write(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$762e62bc52707674$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $762e62bc52707674$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $762e62bc52707674$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $762e62bc52707674$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $762e62bc52707674$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $762e62bc52707674$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$762e62bc52707674$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $762e62bc52707674$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $82Ig9.fromByteArray(buf);
    else return $82Ig9.fromByteArray(buf.slice(start, end));
}
function $762e62bc52707674$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $762e62bc52707674$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $762e62bc52707674$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $762e62bc52707674$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $762e62bc52707674$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $762e62bc52707674$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $762e62bc52707674$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $762e62bc52707674$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $762e62bc52707674$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $762e62bc52707674$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $762e62bc52707674$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$762e62bc52707674$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $762e62bc52707674$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $762e62bc52707674$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$762e62bc52707674$var$Buffer.prototype.readUintLE = $762e62bc52707674$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readUintBE = $762e62bc52707674$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readUint8 = $762e62bc52707674$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$762e62bc52707674$var$Buffer.prototype.readUint16LE = $762e62bc52707674$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$762e62bc52707674$var$Buffer.prototype.readUint16BE = $762e62bc52707674$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$762e62bc52707674$var$Buffer.prototype.readUint32LE = $762e62bc52707674$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$762e62bc52707674$var$Buffer.prototype.readUint32BE = $762e62bc52707674$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$762e62bc52707674$var$Buffer.prototype.readBigUInt64LE = $762e62bc52707674$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$762e62bc52707674$var$Buffer.prototype.readBigUInt64BE = $762e62bc52707674$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$762e62bc52707674$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$762e62bc52707674$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$762e62bc52707674$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$762e62bc52707674$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$762e62bc52707674$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$762e62bc52707674$var$Buffer.prototype.readBigInt64LE = $762e62bc52707674$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$762e62bc52707674$var$Buffer.prototype.readBigInt64BE = $762e62bc52707674$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$762e62bc52707674$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return $awgx0.read(this, offset, true, 23, 4);
};
$762e62bc52707674$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return $awgx0.read(this, offset, false, 23, 4);
};
$762e62bc52707674$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 8, this.length);
    return $awgx0.read(this, offset, true, 52, 8);
};
$762e62bc52707674$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 8, this.length);
    return $awgx0.read(this, offset, false, 52, 8);
};
function $762e62bc52707674$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$762e62bc52707674$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$762e62bc52707674$var$Buffer.prototype.writeUintLE = $762e62bc52707674$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeUintBE = $762e62bc52707674$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeUint8 = $762e62bc52707674$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$762e62bc52707674$var$Buffer.prototype.writeUint16LE = $762e62bc52707674$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeUint16BE = $762e62bc52707674$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeUint32LE = $762e62bc52707674$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$762e62bc52707674$var$Buffer.prototype.writeUint32BE = $762e62bc52707674$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $762e62bc52707674$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $762e62bc52707674$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $762e62bc52707674$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $762e62bc52707674$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$762e62bc52707674$var$Buffer.prototype.writeBigUInt64LE = $762e62bc52707674$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$762e62bc52707674$var$Buffer.prototype.writeBigUInt64BE = $762e62bc52707674$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$762e62bc52707674$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$762e62bc52707674$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$762e62bc52707674$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$762e62bc52707674$var$Buffer.prototype.writeBigInt64LE = $762e62bc52707674$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$762e62bc52707674$var$Buffer.prototype.writeBigInt64BE = $762e62bc52707674$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $762e62bc52707674$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $762e62bc52707674$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $awgx0.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$762e62bc52707674$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeFloat(this, value, offset, true, noAssert);
};
$762e62bc52707674$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeFloat(this, value, offset, false, noAssert);
};
function $762e62bc52707674$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $awgx0.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$762e62bc52707674$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeDouble(this, value, offset, true, noAssert);
};
$762e62bc52707674$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$762e62bc52707674$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$762e62bc52707674$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$762e62bc52707674$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$762e62bc52707674$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $762e62bc52707674$var$Buffer.isBuffer(val) ? val : $762e62bc52707674$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $762e62bc52707674$var$errors = {};
function $762e62bc52707674$var$E(sym, getMessage, Base) {
    $762e62bc52707674$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$762e62bc52707674$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$762e62bc52707674$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$762e62bc52707674$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $762e62bc52707674$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $762e62bc52707674$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $762e62bc52707674$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $762e62bc52707674$var$checkBounds(buf, offset, byteLength) {
    $762e62bc52707674$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $762e62bc52707674$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $762e62bc52707674$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $762e62bc52707674$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $762e62bc52707674$var$checkBounds(buf, offset, byteLength);
}
function $762e62bc52707674$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $762e62bc52707674$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $762e62bc52707674$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $762e62bc52707674$var$validateNumber(value, type);
        throw new $762e62bc52707674$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $762e62bc52707674$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $762e62bc52707674$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $762e62bc52707674$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $762e62bc52707674$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($762e62bc52707674$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $762e62bc52707674$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $762e62bc52707674$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $762e62bc52707674$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $762e62bc52707674$var$base64ToBytes(str) {
    return $82Ig9.toByteArray($762e62bc52707674$var$base64clean(str));
}
function $762e62bc52707674$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $762e62bc52707674$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $762e62bc52707674$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $762e62bc52707674$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $762e62bc52707674$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $762e62bc52707674$var$BufferBigIntNotDefined : fn;
}
function $762e62bc52707674$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("82Ig9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5db0d7a96cab63b5$export$d622b2ad8d90c771; }, function (v) { return $5db0d7a96cab63b5$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5db0d7a96cab63b5$export$6100ba28696e12de; }, function (v) { return $5db0d7a96cab63b5$export$6100ba28696e12de = v; });
var $5db0d7a96cab63b5$export$a48f0734ac7c2329;
var $5db0d7a96cab63b5$export$d622b2ad8d90c771;
var $5db0d7a96cab63b5$export$6100ba28696e12de;
"use strict";
$5db0d7a96cab63b5$export$a48f0734ac7c2329 = $5db0d7a96cab63b5$var$byteLength;
$5db0d7a96cab63b5$export$d622b2ad8d90c771 = $5db0d7a96cab63b5$var$toByteArray;
$5db0d7a96cab63b5$export$6100ba28696e12de = $5db0d7a96cab63b5$var$fromByteArray;
var $5db0d7a96cab63b5$var$lookup = [];
var $5db0d7a96cab63b5$var$revLookup = [];
var $5db0d7a96cab63b5$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5db0d7a96cab63b5$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5db0d7a96cab63b5$var$i = 0, $5db0d7a96cab63b5$var$len = $5db0d7a96cab63b5$var$code.length; $5db0d7a96cab63b5$var$i < $5db0d7a96cab63b5$var$len; ++$5db0d7a96cab63b5$var$i){
    $5db0d7a96cab63b5$var$lookup[$5db0d7a96cab63b5$var$i] = $5db0d7a96cab63b5$var$code[$5db0d7a96cab63b5$var$i];
    $5db0d7a96cab63b5$var$revLookup[$5db0d7a96cab63b5$var$code.charCodeAt($5db0d7a96cab63b5$var$i)] = $5db0d7a96cab63b5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5db0d7a96cab63b5$var$revLookup["-".charCodeAt(0)] = 62;
$5db0d7a96cab63b5$var$revLookup["_".charCodeAt(0)] = 63;
function $5db0d7a96cab63b5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5db0d7a96cab63b5$var$byteLength(b64) {
    var lens = $5db0d7a96cab63b5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5db0d7a96cab63b5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5db0d7a96cab63b5$var$toByteArray(b64) {
    var tmp;
    var lens = $5db0d7a96cab63b5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5db0d7a96cab63b5$var$Arr($5db0d7a96cab63b5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i)] << 18 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i)] << 2 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i)] << 10 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5db0d7a96cab63b5$var$tripletToBase64(num) {
    return $5db0d7a96cab63b5$var$lookup[num >> 18 & 0x3F] + $5db0d7a96cab63b5$var$lookup[num >> 12 & 0x3F] + $5db0d7a96cab63b5$var$lookup[num >> 6 & 0x3F] + $5db0d7a96cab63b5$var$lookup[num & 0x3F];
}
function $5db0d7a96cab63b5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5db0d7a96cab63b5$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5db0d7a96cab63b5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5db0d7a96cab63b5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5db0d7a96cab63b5$var$lookup[tmp >> 2] + $5db0d7a96cab63b5$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5db0d7a96cab63b5$var$lookup[tmp >> 10] + $5db0d7a96cab63b5$var$lookup[tmp >> 4 & 0x3F] + $5db0d7a96cab63b5$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("awgx0", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $7a89b7596093d253$export$aafa59e2e03f2942; }, function (v) { return $7a89b7596093d253$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $7a89b7596093d253$export$68d8715fc104d294; }, function (v) { return $7a89b7596093d253$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7a89b7596093d253$export$aafa59e2e03f2942;
var $7a89b7596093d253$export$68d8715fc104d294;
$7a89b7596093d253$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7a89b7596093d253$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("j4USS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3a840601a5769e$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
"use strict";
class $de3a840601a5769e$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $pci3K.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $de3a840601a5769e$export$2e2bcd8739ae039 = $de3a840601a5769e$var$InterceptorManager;

});

parcelRegister("1dKS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e3b5d0ffe790033$export$2e2bcd8739ae039; });

var $9IlbM = parcelRequire("9IlbM");

var $2v382 = parcelRequire("2v382");

var $gGIev = parcelRequire("gGIev");

var $82h0N = parcelRequire("82h0N");

var $3V9hT = parcelRequire("3V9hT");

var $ekUJE = parcelRequire("ekUJE");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $0e3b5d0ffe790033$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $82h0N.default)(null, config);
}
function $0e3b5d0ffe790033$export$2e2bcd8739ae039(config) {
    $0e3b5d0ffe790033$var$throwIfCancellationRequested(config);
    config.headers = (0, $3V9hT.default).from(config.headers);
    // Transform request data
    config.data = (0, $9IlbM.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $ekUJE.default).getAdapter(config.adapter || (0, $gGIev.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $0e3b5d0ffe790033$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $9IlbM.default).call(config, config.transformResponse, response);
        response.headers = (0, $3V9hT.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $2v382.default)(reason)) {
            $0e3b5d0ffe790033$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $9IlbM.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $3V9hT.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("9IlbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7128a8cf059b6df6$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $gGIev = parcelRequire("gGIev");

var $3V9hT = parcelRequire("3V9hT");
"use strict";
function $7128a8cf059b6df6$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $gGIev.default);
    const context = response || config;
    const headers = (0, $3V9hT.default).from(context.headers);
    let data = context.data;
    (0, $pci3K.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("gGIev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c262e1575c2b2818$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $jdUqi = parcelRequire("jdUqi");

var $jriIr = parcelRequire("jriIr");

var $i2rBs = parcelRequire("i2rBs");

var $1TxvX = parcelRequire("1TxvX");

var $66BHH = parcelRequire("66BHH");

var $e4j5G = parcelRequire("e4j5G");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c262e1575c2b2818$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $pci3K.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $pci3K.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c262e1575c2b2818$var$defaults = {
    transitional: (0, $jriIr.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $pci3K.default).isObject(data);
            if (isObjectPayload && (0, $pci3K.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $pci3K.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $e4j5G.default)(data)) : data;
            if ((0, $pci3K.default).isArrayBuffer(data) || (0, $pci3K.default).isBuffer(data) || (0, $pci3K.default).isStream(data) || (0, $pci3K.default).isFile(data) || (0, $pci3K.default).isBlob(data) || (0, $pci3K.default).isReadableStream(data)) return data;
            if ((0, $pci3K.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $pci3K.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $1TxvX.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $pci3K.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $i2rBs.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $c262e1575c2b2818$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $c262e1575c2b2818$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $pci3K.default).isResponse(data) || (0, $pci3K.default).isReadableStream(data)) return data;
            if (data && (0, $pci3K.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $jdUqi.default).from(e, (0, $jdUqi.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $66BHH.default).classes.FormData,
        Blob: (0, $66BHH.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $pci3K.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $c262e1575c2b2818$var$defaults.headers[method] = {};
});
var $c262e1575c2b2818$export$2e2bcd8739ae039 = $c262e1575c2b2818$var$defaults;

});
parcelRegister("jriIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e26f0e841b32bf7f$export$2e2bcd8739ae039; });
"use strict";
var $e26f0e841b32bf7f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("1TxvX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1614ecc4ad5f1e47$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $i2rBs = parcelRequire("i2rBs");

var $66BHH = parcelRequire("66BHH");
"use strict";
function $1614ecc4ad5f1e47$export$2e2bcd8739ae039(data, options) {
    return (0, $i2rBs.default)(data, new (0, $66BHH.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $66BHH.default).isNode && (0, $pci3K.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("66BHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47208ccc9dfa862e$export$2e2bcd8739ae039; });

var $aqRTH = parcelRequire("aqRTH");

var $7iFsh = parcelRequire("7iFsh");
var $47208ccc9dfa862e$export$2e2bcd8739ae039 = {
    ...$7iFsh,
    ...(0, $aqRTH.default)
};

});
parcelRegister("aqRTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $798623f976f1919b$export$2e2bcd8739ae039; });

var $2AvpN = parcelRequire("2AvpN");

var $cgjvw = parcelRequire("cgjvw");

var $hqwKZ = parcelRequire("hqwKZ");
var $798623f976f1919b$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $2AvpN.default,
        FormData: $cgjvw.default,
        Blob: $hqwKZ.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("2AvpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e274fee22f2affa$export$2e2bcd8739ae039; });

var $kskWj = parcelRequire("kskWj");
"use strict";
var $1e274fee22f2affa$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $kskWj.default);

});

parcelRegister("cgjvw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ed61c72a76d48f8$export$2e2bcd8739ae039; });
"use strict";
var $8ed61c72a76d48f8$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("hqwKZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafe463d1ead3ee5$export$2e2bcd8739ae039; });
"use strict";
var $cafe463d1ead3ee5$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("7iFsh", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $550a5efe63dbf3a9$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $550a5efe63dbf3a9$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $550a5efe63dbf3a9$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $550a5efe63dbf3a9$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $550a5efe63dbf3a9$export$f710a83a91838a36; });
const $550a5efe63dbf3a9$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $550a5efe63dbf3a9$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $550a5efe63dbf3a9$export$c0bcc9250309d66 = $550a5efe63dbf3a9$export$c4996c4b7b93b0bf && (!$550a5efe63dbf3a9$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($550a5efe63dbf3a9$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $550a5efe63dbf3a9$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $550a5efe63dbf3a9$export$f710a83a91838a36 = $550a5efe63dbf3a9$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("e4j5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3e03f6a4d69f3ca$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a3e03f6a4d69f3ca$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $pci3K.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a3e03f6a4d69f3ca$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a3e03f6a4d69f3ca$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $pci3K.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $pci3K.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $pci3K.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $pci3K.default).isArray(target[name])) target[name] = $a3e03f6a4d69f3ca$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $pci3K.default).isFormData(formData) && (0, $pci3K.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $pci3K.default).forEachEntry(formData, (name, value)=>{
            buildPath($a3e03f6a4d69f3ca$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a3e03f6a4d69f3ca$export$2e2bcd8739ae039 = $a3e03f6a4d69f3ca$var$formDataToJSON;

});


parcelRegister("3V9hT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dade64a2caaec98$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $20sPJ = parcelRequire("20sPJ");
"use strict";
const $2dade64a2caaec98$var$$internals = Symbol("internals");
function $2dade64a2caaec98$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2dade64a2caaec98$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $pci3K.default).isArray(value) ? value.map($2dade64a2caaec98$var$normalizeValue) : String(value);
}
function $2dade64a2caaec98$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2dade64a2caaec98$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2dade64a2caaec98$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $pci3K.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $pci3K.default).isString(value)) return;
    if ((0, $pci3K.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $pci3K.default).isRegExp(filter)) return filter.test(value);
}
function $2dade64a2caaec98$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2dade64a2caaec98$var$buildAccessors(obj, header) {
    const accessorName = (0, $pci3K.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2dade64a2caaec98$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2dade64a2caaec98$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $pci3K.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2dade64a2caaec98$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $pci3K.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $pci3K.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $pci3K.default).isString(header) && (header = header.trim()) && !$2dade64a2caaec98$var$isValidHeaderName(header)) setHeaders((0, $20sPJ.default)(header), valueOrRewrite);
        else if ((0, $pci3K.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2dade64a2caaec98$var$normalizeHeader(header);
        if (header) {
            const key = (0, $pci3K.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2dade64a2caaec98$var$parseTokens(value);
                if ((0, $pci3K.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $pci3K.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $2dade64a2caaec98$var$normalizeHeader(header);
        if (header) {
            const key = (0, $pci3K.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2dade64a2caaec98$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2dade64a2caaec98$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $pci3K.default).findKey(self, _header);
                if (key && (!matcher || $2dade64a2caaec98$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $pci3K.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2dade64a2caaec98$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $pci3K.default).forEach(this, (value, header)=>{
            const key = (0, $pci3K.default).findKey(headers, header);
            if (key) {
                self[key] = $2dade64a2caaec98$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2dade64a2caaec98$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2dade64a2caaec98$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $pci3K.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $pci3K.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2dade64a2caaec98$var$$internals] = this[$2dade64a2caaec98$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2dade64a2caaec98$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2dade64a2caaec98$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $pci3K.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$2dade64a2caaec98$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $pci3K.default).reduceDescriptors($2dade64a2caaec98$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $pci3K.default).freezeMethods($2dade64a2caaec98$var$AxiosHeaders);
var $2dade64a2caaec98$export$2e2bcd8739ae039 = $2dade64a2caaec98$var$AxiosHeaders;

});
parcelRegister("20sPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1761f28f3d84bf08$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $1761f28f3d84bf08$var$ignoreDuplicateOf = (0, $pci3K.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $1761f28f3d84bf08$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $1761f28f3d84bf08$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("2v382", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d20e7516bc422d6$export$2e2bcd8739ae039; });
"use strict";
function $1d20e7516bc422d6$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("82h0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d9bb4d7f700c43f$export$2e2bcd8739ae039; });

var $jdUqi = parcelRequire("jdUqi");

var $pci3K = parcelRequire("pci3K");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $5d9bb4d7f700c43f$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $jdUqi.default).call(this, message == null ? "canceled" : message, (0, $jdUqi.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $pci3K.default).inherits($5d9bb4d7f700c43f$var$CanceledError, (0, $jdUqi.default), {
    __CANCEL__: true
});
var $5d9bb4d7f700c43f$export$2e2bcd8739ae039 = $5d9bb4d7f700c43f$var$CanceledError;

});

parcelRegister("ekUJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fef15eee491476$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $gJraw = parcelRequire("gJraw");

var $e19rN = parcelRequire("e19rN");

var $223Mb = parcelRequire("223Mb");

var $jdUqi = parcelRequire("jdUqi");
const $a6fef15eee491476$var$knownAdapters = {
    http: (0, $gJraw.default),
    xhr: (0, $e19rN.default),
    fetch: (0, $223Mb.default)
};
(0, $pci3K.default).forEach($a6fef15eee491476$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $a6fef15eee491476$var$renderReason = (reason)=>`- ${reason}`;
const $a6fef15eee491476$var$isResolvedHandle = (adapter)=>(0, $pci3K.default).isFunction(adapter) || adapter === null || adapter === false;
var $a6fef15eee491476$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $pci3K.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$a6fef15eee491476$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $a6fef15eee491476$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $jdUqi.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($a6fef15eee491476$var$renderReason).join("\n") : " " + $a6fef15eee491476$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $jdUqi.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $a6fef15eee491476$var$knownAdapters
};

});
parcelRegister("e19rN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3487cbc89bd0978$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $6DPL7 = parcelRequire("6DPL7");

var $jriIr = parcelRequire("jriIr");

var $jdUqi = parcelRequire("jdUqi");

var $82h0N = parcelRequire("82h0N");

var $3lsUt = parcelRequire("3lsUt");

var $66BHH = parcelRequire("66BHH");

var $3V9hT = parcelRequire("3V9hT");

var $kGLeM = parcelRequire("kGLeM");

var $kXlMv = parcelRequire("kXlMv");
const $a3487cbc89bd0978$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $a3487cbc89bd0978$export$2e2bcd8739ae039 = $a3487cbc89bd0978$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $kXlMv.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $3V9hT.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $3V9hT.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $6DPL7.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $jdUqi.default)("Request aborted", (0, $jdUqi.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $jdUqi.default)("Network Error", (0, $jdUqi.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $jriIr.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $jdUqi.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $jdUqi.default).ETIMEDOUT : (0, $jdUqi.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $pci3K.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $pci3K.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $kGLeM.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $kGLeM.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $82h0N.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $3lsUt.default)(_config.url);
        if (protocol && (0, $66BHH.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $jdUqi.default)("Unsupported protocol " + protocol + ":", (0, $jdUqi.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("6DPL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d5e88df11592ed8$export$2e2bcd8739ae039; });

var $jdUqi = parcelRequire("jdUqi");
"use strict";
function $4d5e88df11592ed8$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $jdUqi.default)("Request failed with status code " + response.status, [
        (0, $jdUqi.default).ERR_BAD_REQUEST,
        (0, $jdUqi.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("3lsUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f9c226a90c9425$export$2e2bcd8739ae039; });
"use strict";
function $26f9c226a90c9425$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("kGLeM", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $f0fc5f4288818cb0$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $f0fc5f4288818cb0$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $f0fc5f4288818cb0$export$5d35863c355a22a9; });

var $dTgiS = parcelRequire("dTgiS");

var $3Emrv = parcelRequire("3Emrv");

var $pci3K = parcelRequire("pci3K");
const $f0fc5f4288818cb0$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $dTgiS.default)(50, 250);
    return (0, $3Emrv.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $f0fc5f4288818cb0$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $f0fc5f4288818cb0$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $pci3K.default).asap(()=>fn(...args));

});
parcelRegister("dTgiS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1cd0ef492c22059$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a1cd0ef492c22059$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a1cd0ef492c22059$export$2e2bcd8739ae039 = $a1cd0ef492c22059$var$speedometer;

});

parcelRegister("3Emrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a868430fff916ba$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2a868430fff916ba$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2a868430fff916ba$export$2e2bcd8739ae039 = $2a868430fff916ba$var$throttle;

});


parcelRegister("kXlMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41a36a8254ee805$export$2e2bcd8739ae039; });

var $66BHH = parcelRequire("66BHH");

var $pci3K = parcelRequire("pci3K");

var $kCPPq = parcelRequire("kCPPq");

var $jxWsx = parcelRequire("jxWsx");

var $lJkMI = parcelRequire("lJkMI");

var $4mJfT = parcelRequire("4mJfT");

var $3V9hT = parcelRequire("3V9hT");

var $9EAAy = parcelRequire("9EAAy");
var $f41a36a8254ee805$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $4mJfT.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $3V9hT.default).from(headers);
    newConfig.url = (0, $9EAAy.default)((0, $lJkMI.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $pci3K.default).isFormData(data)) {
        if ((0, $66BHH.default).hasStandardBrowserEnv || (0, $66BHH.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $66BHH.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $pci3K.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $kCPPq.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $jxWsx.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("kCPPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f03f8f4d92ae9bdf$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $66BHH = parcelRequire("66BHH");
"use strict";
var $f03f8f4d92ae9bdf$export$2e2bcd8739ae039 = (0, $66BHH.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $66BHH.default).navigator && /(msie|trident)/i.test((0, $66BHH.default).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $pci3K.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("jxWsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3ae722d856af038$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $66BHH = parcelRequire("66BHH");
var $e3ae722d856af038$export$2e2bcd8739ae039 = (0, $66BHH.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $pci3K.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $pci3K.default).isString(path) && cookie.push("path=" + path);
        (0, $pci3K.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("lJkMI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd1dec58a8c6c17d$export$2e2bcd8739ae039; });

var $pvQE7 = parcelRequire("pvQE7");

var $kSJaN = parcelRequire("kSJaN");
"use strict";
function $fd1dec58a8c6c17d$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $pvQE7.default)(requestedURL)) return (0, $kSJaN.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("pvQE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04cb0a4a1ff44deb$export$2e2bcd8739ae039; });
"use strict";
function $04cb0a4a1ff44deb$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("kSJaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33be43c2be54ac7$export$2e2bcd8739ae039; });
"use strict";
function $f33be43c2be54ac7$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("4mJfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32dc523f48a8a3ad$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $3V9hT = parcelRequire("3V9hT");
"use strict";
const $32dc523f48a8a3ad$var$headersToObject = (thing)=>thing instanceof (0, $3V9hT.default) ? {
        ...thing
    } : thing;
function $32dc523f48a8a3ad$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $pci3K.default).isPlainObject(target) && (0, $pci3K.default).isPlainObject(source)) return (0, $pci3K.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $pci3K.default).isPlainObject(source)) return (0, $pci3K.default).merge({}, source);
        else if ((0, $pci3K.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $pci3K.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $pci3K.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $pci3K.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $pci3K.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $pci3K.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($32dc523f48a8a3ad$var$headersToObject(a), $32dc523f48a8a3ad$var$headersToObject(b), true)
    };
    (0, $pci3K.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $pci3K.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("223Mb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17aeb28412910353$export$2e2bcd8739ae039; });

var $66BHH = parcelRequire("66BHH");

var $pci3K = parcelRequire("pci3K");

var $jdUqi = parcelRequire("jdUqi");

var $fdt1W = parcelRequire("fdt1W");

var $dWNSC = parcelRequire("dWNSC");

var $3V9hT = parcelRequire("3V9hT");

var $kGLeM = parcelRequire("kGLeM");

var $kXlMv = parcelRequire("kXlMv");

var $6DPL7 = parcelRequire("6DPL7");
const $17aeb28412910353$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $17aeb28412910353$var$isReadableStreamSupported = $17aeb28412910353$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $17aeb28412910353$var$encodeText = $17aeb28412910353$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $17aeb28412910353$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $17aeb28412910353$var$supportsRequestStream = $17aeb28412910353$var$isReadableStreamSupported && $17aeb28412910353$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $66BHH.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $17aeb28412910353$var$DEFAULT_CHUNK_SIZE = 65536;
const $17aeb28412910353$var$supportsResponseStream = $17aeb28412910353$var$isReadableStreamSupported && $17aeb28412910353$var$test(()=>(0, $pci3K.default).isReadableStream(new Response("").body));
const $17aeb28412910353$var$resolvers = {
    stream: $17aeb28412910353$var$supportsResponseStream && ((res)=>res.body)
};
$17aeb28412910353$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$17aeb28412910353$var$resolvers[type] && ($17aeb28412910353$var$resolvers[type] = (0, $pci3K.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $jdUqi.default)(`Response type '${type}' is not supported`, (0, $jdUqi.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $17aeb28412910353$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $pci3K.default).isBlob(body)) return body.size;
    if ((0, $pci3K.default).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $pci3K.default).isArrayBufferView(body) || (0, $pci3K.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $pci3K.default).isURLSearchParams(body)) body = body + "";
    if ((0, $pci3K.default).isString(body)) return (await $17aeb28412910353$var$encodeText(body)).byteLength;
};
const $17aeb28412910353$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $pci3K.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $17aeb28412910353$var$getBodyLength(body) : length;
};
var $17aeb28412910353$export$2e2bcd8739ae039 = $17aeb28412910353$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $kXlMv.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $fdt1W.default)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $17aeb28412910353$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $17aeb28412910353$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $pci3K.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $kGLeM.progressEventDecorator)(requestContentLength, (0, $kGLeM.progressEventReducer)((0, $kGLeM.asyncDecorator)(onUploadProgress)));
                data = (0, $dWNSC.trackStream)(_request.body, $17aeb28412910353$var$DEFAULT_CHUNK_SIZE, onProgress, flush, $17aeb28412910353$var$encodeText);
            }
        }
        if (!(0, $pci3K.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $17aeb28412910353$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($17aeb28412910353$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $pci3K.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $kGLeM.progressEventDecorator)(responseContentLength, (0, $kGLeM.progressEventReducer)((0, $kGLeM.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $dWNSC.trackStream)(response.body, $17aeb28412910353$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                isStreamResponse && onFinish();
            }, $17aeb28412910353$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $17aeb28412910353$var$resolvers[(0, $pci3K.default).findKey($17aeb28412910353$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $6DPL7.default)(resolve, reject, {
                data: responseData,
                headers: (0, $3V9hT.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $jdUqi.default)("Network Error", (0, $jdUqi.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $jdUqi.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("fdt1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13e96be51450e73$export$2e2bcd8739ae039; });

var $82h0N = parcelRequire("82h0N");

var $jdUqi = parcelRequire("jdUqi");
const $b13e96be51450e73$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $jdUqi.default) ? err : new (0, $82h0N.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $jdUqi.default)(`timeout ${timeout} of ms exceeded`, (0, $jdUqi.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $b13e96be51450e73$export$2e2bcd8739ae039 = $b13e96be51450e73$var$composeSignals;

});

parcelRegister("dWNSC", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $a277623eac33c0de$export$b0119225647bd83; });
const $a277623eac33c0de$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $a277623eac33c0de$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $a277623eac33c0de$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $a277623eac33c0de$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $a277623eac33c0de$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("121Mm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c075b9e77890a56$export$2e2bcd8739ae039; });

var $iro9b = parcelRequire("iro9b");

var $jdUqi = parcelRequire("jdUqi");
"use strict";
const $0c075b9e77890a56$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $0c075b9e77890a56$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $0c075b9e77890a56$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $0c075b9e77890a56$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $iro9b.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $jdUqi.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $jdUqi.default).ERR_DEPRECATED);
        if (version && !$0c075b9e77890a56$var$deprecatedWarnings[opt]) {
            $0c075b9e77890a56$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $0c075b9e77890a56$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $jdUqi.default)("options must be an object", (0, $jdUqi.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $jdUqi.default)("option " + opt + " must be " + result, (0, $jdUqi.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $jdUqi.default)("Unknown option " + opt, (0, $jdUqi.default).ERR_BAD_OPTION);
    }
}
var $0c075b9e77890a56$export$2e2bcd8739ae039 = {
    assertOptions: $0c075b9e77890a56$var$assertOptions,
    validators: $0c075b9e77890a56$var$validators
};

});
parcelRegister("iro9b", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $d6cd7ab6ae29eb1f$export$a4ad2735b021c132; });
const $d6cd7ab6ae29eb1f$export$a4ad2735b021c132 = "1.7.5";

});



parcelRegister("4ar6q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308d1ea1794f5d49$export$2e2bcd8739ae039; });

var $82h0N = parcelRequire("82h0N");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $308d1ea1794f5d49$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $308d1ea1794f5d49$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $82h0N.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $308d1ea1794f5d49$export$2e2bcd8739ae039 = $308d1ea1794f5d49$var$CancelToken;

});

parcelRegister("hImvc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce580039593d0787$export$2e2bcd8739ae039; });
"use strict";
function $ce580039593d0787$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("fn32J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30b5d498c872f1f$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
"use strict";
function $b30b5d498c872f1f$export$2e2bcd8739ae039(payload) {
    return (0, $pci3K.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("jLDDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e64126d4def41443$export$2e2bcd8739ae039; });
const $e64126d4def41443$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($e64126d4def41443$var$HttpStatusCode).forEach(([key, value])=>{
    $e64126d4def41443$var$HttpStatusCode[value] = key;
});
var $e64126d4def41443$export$2e2bcd8739ae039 = $e64126d4def41443$var$HttpStatusCode;

});



parcelRegister("8J94x", function(module, exports) {

$parcel$export(module.exports, "SedestralMachine", function () { return $9e5d45fdb4a9d0a0$export$3241e4b560eb63f6; });

var $gMGgG = parcelRequire("gMGgG");

var $gRinL = parcelRequire("gRinL");
class $9e5d45fdb4a9d0a0$export$3241e4b560eb63f6 {
    static dispose() {
        this.listeners.forEach((value)=>{
            this.removeListener(value);
        });
        this.resizeObserver.disconnect();
    }
    static async init() {
        this.listeners = [];
        this.outsideClickListeners = [];
        if (this.log) this.setInterval(()=>{
            console.log("listeners " + this.listeners.length);
        }, 3000);
        this.resizeObserver = new ResizeObserver((entries)=>{
            window.requestAnimationFrame(()=>{
                if (!Array.isArray(entries) || !entries.length) return;
                for (let entry of entries)for (let f of entry.target["resizeFunctions"])f(entry.contentRect);
            });
        });
        this.addListener(window, "keydown", (e)=>{
            let nextIndex = e.code == "ArrowDown" ? 1 : e.code == "ArrowUp" ? -1 : 0;
            if (nextIndex != 0) {
                let focusedInput = this.inputs.find((value)=>value.isFocus());
                if (focusedInput) {
                    let nextInput = this.inputs[this.inputs.indexOf(focusedInput) + nextIndex];
                    if (nextInput) nextInput.focus();
                }
            }
        });
    }
    /**
     * timeout/interval
     */ static setTimeout(func, time) {
        return setTimeout(()=>{
            func();
        }, time);
    }
    static setInterval(func, time) {
        return setInterval(()=>{
            func();
        }, time);
    }
    /**
     * listeners
     */ static removeListener(listener) {
        if (listener == undefined) return;
        listener.element.removeEventListener(listener.name, listener.callback, listener.options);
        let index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
        let outsideClickIndex = this.outsideClickListeners.indexOf(listener);
        if (outsideClickIndex >= 0) this.outsideClickListeners.splice(outsideClickIndex, 1);
    }
    static addListener(element, name, callback, options) {
        element.addEventListener(name, callback, options);
        let listener = new (0, $gMGgG.MachineListener)(element, name, callback, options);
        this.listeners.push(listener);
        return listener;
    }
    static addHotKeyListener(component, keys, func) {
        let existingKey = this.hotkeyListeners.find((value)=>value.hotkeys == keys && value.element == component.getHTMLElement());
        if (!existingKey) {
            existingKey = {
                hotkeys: keys,
                element: component.getHTMLElement(),
                entries: []
            };
            this.hotkeyListeners.push(existingKey);
            let map = {};
            map[keys] = (event)=>{
                existingKey.entries.forEach((value)=>value.function(event));
            };
            let handler = (0, $gRinL.createKeybindingsHandler)(map);
            component.getHTMLElement().addEventListener("keydown", handler);
        }
        existingKey.entries.push({
            function: (e)=>func(e)
        });
        return existingKey;
    }
    static deleteHotKeyListener(component, keys) {
        let existingKey = this.hotkeyListeners.find((value)=>value.hotkeys == keys && value.element == component.getHTMLElement());
        if (existingKey) this.hotkeyListeners.splice(this.hotkeyListeners.indexOf(existingKey), 1);
    }
    static addOutsideClickListener(listener, component) {
        listener["component"] = component;
        this.outsideClickListeners.push(listener);
    }
    /**
     * delay
     */ static async wait(func, time) {
        return $9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.promise((end)=>{
            let promise = $9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.promise(async (resolve)=>{
                setTimeout(()=>{
                    resolve(-1);
                }, time);
                let result = await func();
                resolve(result);
            });
            promise.then((data)=>{
                end(data);
            });
        });
    }
    static async delay(asyncFunc, minimumTime) {
        let result = undefined;
        let run = async ()=>result = await asyncFunc();
        await Promise.all([
            run(),
            this.sleep(minimumTime)
        ]);
        return result;
    }
    static async sleep(ms) {
        await $9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.promise((resolve)=>{
            setTimeout(()=>{
                resolve();
            }, ms);
        });
    }
    /**
     * promise
     */ static promiseCancelable(executor) {
        let rejectFn;
        const wrappedPromise = new Promise((resolve, reject)=>{
            rejectFn = reject;
            Promise.resolve(new Promise(executor)).then(resolve).catch(reject);
        });
        wrappedPromise["cancel"] = ()=>{
            rejectFn({
                canceled: true
            });
        };
        return wrappedPromise;
    }
    static async promise(executor, displayRequired, component) {
        let promise = this.promiseCancelable(executor);
        let savedPromise = {
            component: component,
            promise: promise,
            displayRequired: displayRequired
        };
        this.promises.push(savedPromise);
        promise.then(()=>{
            this.promises.splice(this.promises.indexOf(savedPromise), 1);
        });
        if (component) component.onRemove(()=>{
            $9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.requestFrame()(()=>{
                if (this.promises.indexOf(savedPromise) >= 0) {
                    savedPromise.promise["cancel"]();
                    this.promises.splice(this.promises.indexOf(savedPromise), 1);
                }
            });
        });
        return promise;
    }
    /**
     * frame
     */ static requestFrame() {
        // @ts-ignore
        let raf = window.requestAnimationFrame || window["mozRequestAnimationFrame"] || window.webkitRequestAnimationFrame || function(fn) {
            return window.setTimeout(fn, 20);
        };
        return function(fn) {
            return raf(fn);
        };
    }
    static cancelFrame() {
        // @ts-ignore
        let cancel = window.cancelAnimationFrame || window["mozCancelAnimationFrame"] || window.webkitCancelAnimationFrame || window.clearTimeout;
        return function(id) {
            return cancel(id);
        };
    }
}
$9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.log = false;
$9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.listeners = [];
$9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.inputs = [];
$9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.hotkeyListeners = [];
$9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.outsideClickListeners = [];
$9e5d45fdb4a9d0a0$export$3241e4b560eb63f6.promises = [];

});
parcelRegister("gMGgG", function(module, exports) {

$parcel$export(module.exports, "MachineListener", function () { return $33e594805da8f73f$export$884d1a73c2ef5109; });
class $33e594805da8f73f$export$884d1a73c2ef5109 {
    get element() {
        return this._element;
    }
    set element(value) {
        this._element = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get callback() {
        return this._callback;
    }
    set callback(value) {
        this._callback = value;
    }
    get options() {
        return this._options;
    }
    set options(value) {
        this._options = value;
    }
    constructor(element, name, callback, options){
        this._element = element;
        this._name = name;
        this._callback = callback;
        this._options = options;
    }
}

});

parcelRegister("gRinL", function(module, exports) {

$parcel$export(module.exports, "createKeybindingsHandler", function () { return $032ad61ca0c9753b$export$a3db0ee43d16bb47; });
var $032ad61ca0c9753b$var$t = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
], $032ad61ca0c9753b$var$e = "object" == typeof navigator ? navigator.platform : "", $032ad61ca0c9753b$var$n = /Mac|iPod|iPhone|iPad/.test($032ad61ca0c9753b$var$e), $032ad61ca0c9753b$var$o = $032ad61ca0c9753b$var$n ? "Meta" : "Control", $032ad61ca0c9753b$var$r = "Win32" === $032ad61ca0c9753b$var$e ? [
    "Control",
    "Alt"
] : $032ad61ca0c9753b$var$n ? [
    "Alt"
] : [];
function $032ad61ca0c9753b$var$i(t, e) {
    return "function" == typeof t.getModifierState && (t.getModifierState(e) || $032ad61ca0c9753b$var$r.includes(e) && t.getModifierState("AltGraph"));
}
function $032ad61ca0c9753b$export$d0b30d424c95c5e9(t) {
    return t.trim().split(" ").map(function(t) {
        var e = t.split(/\b\+/), n = e.pop(), r = n.match(/^\((.+)\)$/);
        return r && (n = new RegExp("^" + r[1] + "$")), [
            e = e.map(function(t) {
                return "$mod" === t ? $032ad61ca0c9753b$var$o : t;
            }),
            n
        ];
    });
}
function $032ad61ca0c9753b$export$5eab49042bbaa75(e, n) {
    var o = n[0], r = n[1];
    return !((r instanceof RegExp ? !r.test(e.key) && !r.test(e.code) : r.toUpperCase() !== e.key.toUpperCase() && r !== e.code) || o.find(function(t) {
        return !$032ad61ca0c9753b$var$i(e, t);
    }) || $032ad61ca0c9753b$var$t.find(function(t) {
        return !o.includes(t) && r !== t && $032ad61ca0c9753b$var$i(e, t);
    }));
}
function $032ad61ca0c9753b$export$a3db0ee43d16bb47(t, e) {
    var n;
    void 0 === e && (e = {});
    var o = null != (n = e.timeout) ? n : 1e3, r = Object.keys(t).map(function(e) {
        return [
            $032ad61ca0c9753b$export$d0b30d424c95c5e9(e),
            t[e]
        ];
    }), c = new Map, f = null;
    return function(t) {
        t instanceof KeyboardEvent && (r.forEach(function(e) {
            var n = e[0], o = e[1], r = c.get(n) || n;
            $032ad61ca0c9753b$export$5eab49042bbaa75(t, r[0]) ? r.length > 1 ? c.set(n, r.slice(1)) : (c.delete(n), o(t)) : $032ad61ca0c9753b$var$i(t, t.key) || c.delete(n);
        }), f && clearTimeout(f), f = setTimeout(c.clear.bind(c), o));
    };
}
function $032ad61ca0c9753b$export$6fc42dca60e28416(t, e, n) {
    var o = void 0 === n ? {} : n, r = o.event, i = void 0 === r ? "keydown" : r, a = o.capture, u = $032ad61ca0c9753b$export$a3db0ee43d16bb47(e, {
        timeout: o.timeout
    });
    return t.addEventListener(i, u, a), function() {
        t.removeEventListener(i, u, a);
    };
}

});


parcelRegister("4in9X", function(module, exports) {

$parcel$export(module.exports, "NetworkHeaders", function () { return $97febb0327db6720$export$6c0c30308e42bb4b; });
var $97febb0327db6720$export$6c0c30308e42bb4b;
(function(NetworkHeaders) {
    NetworkHeaders["SESSION_HEADER"] = "x-sedestral-session";
    NetworkHeaders["SITE_HEADER"] = "site";
    NetworkHeaders["TF_TRANSACTION_ID_HEADER"] = "tf-transaction-id";
    NetworkHeaders["TF_TRANSACTION_CODE_HEADER"] = "tf-transaction-code";
    NetworkHeaders["TF_TRANSACTION_METHOD_HEADER"] = "tf-transaction-method";
    NetworkHeaders["TF_TRANSACTION_DATA_HEADER"] = "tf-transaction-data";
    NetworkHeaders["ALERT_HEADER"] = "alert";
})($97febb0327db6720$export$6c0c30308e42bb4b || ($97febb0327db6720$export$6c0c30308e42bb4b = {}));

});

parcelRegister("bTARt", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $735f6b1fdc93c9a6$export$d4e71bc0b80dc0fb; });
var $735f6b1fdc93c9a6$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_RECIPIENT"] = 0] = "NO_RECIPIENT";
    ErrorCode[ErrorCode["NO_SITE_CHANEl"] = 1] = "NO_SITE_CHANEl";
    ErrorCode[ErrorCode["NO_SITE"] = 2] = "NO_SITE";
    ErrorCode[ErrorCode["RECIPIENT_FULL"] = 3] = "RECIPIENT_FULL";
    ErrorCode[ErrorCode["MAIL_FORMAT"] = 4] = "MAIL_FORMAT";
    ErrorCode[ErrorCode["MAIL_RECEIVE"] = 5] = "MAIL_RECEIVE";
    ErrorCode[ErrorCode["MAIL_DOMAIN"] = 6] = "MAIL_DOMAIN";
    ErrorCode[ErrorCode["MAIL"] = 7] = "MAIL";
    ErrorCode[ErrorCode["EMAIL_EXIST"] = 8] = "EMAIL_EXIST";
    ErrorCode[ErrorCode["EMAIL_BLACKLIST"] = 9] = "EMAIL_BLACKLIST";
    ErrorCode[ErrorCode["EMAIL_FULL"] = 10] = "EMAIL_FULL";
    ErrorCode[ErrorCode["EMAIL_ALIAS_EXIST"] = 11] = "EMAIL_ALIAS_EXIST";
    ErrorCode[ErrorCode["EMAIL_ALIAS"] = 12] = "EMAIL_ALIAS";
    ErrorCode[ErrorCode["URL_FORMAT"] = 13] = "URL_FORMAT";
    ErrorCode[ErrorCode["IMAGE_FORMAT"] = 14] = "IMAGE_FORMAT";
    ErrorCode[ErrorCode["DOMAIN_FORMAT"] = 15] = "DOMAIN_FORMAT";
    ErrorCode[ErrorCode["DOMAIN_FULL"] = 16] = "DOMAIN_FULL";
    ErrorCode[ErrorCode["WINDOW_EXPIRED"] = 17] = "WINDOW_EXPIRED";
    ErrorCode[ErrorCode["SITE_CHANNEL_NO_FOUND"] = 18] = "SITE_CHANNEL_NO_FOUND";
    ErrorCode[ErrorCode["CHANEl_TYPE_NO_FOUND"] = 19] = "CHANEl_TYPE_NO_FOUND";
    ErrorCode[ErrorCode["CONTACT_NO_FOUND"] = 20] = "CONTACT_NO_FOUND";
    ErrorCode[ErrorCode["SITE_CHANNEL_PERMISSION"] = 21] = "SITE_CHANNEL_PERMISSION";
    ErrorCode[ErrorCode["NAME_EXIST"] = 22] = "NAME_EXIST";
    ErrorCode[ErrorCode["PERMISSION"] = 23] = "PERMISSION";
    ErrorCode[ErrorCode["NULLITY"] = 24] = "NULLITY";
    ErrorCode[ErrorCode["SIZE_MAX"] = 25] = "SIZE_MAX";
    ErrorCode[ErrorCode["SIZE_MIN"] = 26] = "SIZE_MIN";
    ErrorCode[ErrorCode["VERIFICATION"] = 27] = "VERIFICATION";
    ErrorCode[ErrorCode["EXCEPTION"] = 28] = "EXCEPTION";
    ErrorCode[ErrorCode["CACHE"] = 29] = "CACHE";
    ErrorCode[ErrorCode["SURFACE_CONTROL"] = 30] = "SURFACE_CONTROL";
    /*
    {"errorCode":"SURFACE_CONTROL","errorType":"FUNCTIONAL","subErrors":[{"field":"email","rejectedValue":"frrfrffrrfrfrf","message":"doit être une adresse électronique syntaxiquement correcte"},{"field":"password","rejectedValue":"uy","message":"la longueur doit être comprise entre 4 et 2147483647"},{"field":"name","rejectedValue":"  ","message":"ne doit pas être vide"}]}
     */ ErrorCode[ErrorCode["TWO_FACTOR_TECHNICAL"] = 31] = "TWO_FACTOR_TECHNICAL";
    ErrorCode[ErrorCode["TWO_FACTOR_REQUIRED"] = 32] = "TWO_FACTOR_REQUIRED";
    ErrorCode[ErrorCode["TWO_FACTOR_TRANSACTION_NO_FOUND"] = 33] = "TWO_FACTOR_TRANSACTION_NO_FOUND";
    ErrorCode[ErrorCode["TWO_FACTOR_EXPIRE_CODE"] = 34] = "TWO_FACTOR_EXPIRE_CODE";
    ErrorCode[ErrorCode["TWO_FACTOR_ATTEMPT"] = 35] = "TWO_FACTOR_ATTEMPT";
    ErrorCode[ErrorCode["TWO_FACTOR_BAND_WIDTH_LIMIT"] = 36] = "TWO_FACTOR_BAND_WIDTH_LIMIT";
    ErrorCode[ErrorCode["TWO_FACTOR_CODE_INCORRECT"] = 37] = "TWO_FACTOR_CODE_INCORRECT";
    ErrorCode[ErrorCode["TWO_FACTOR_METHOD_UNAUTHORIZED"] = 38] = "TWO_FACTOR_METHOD_UNAUTHORIZED";
    ErrorCode[ErrorCode["TWO_FACTOR_CREATE_INVALID_CODE"] = 39] = "TWO_FACTOR_CREATE_INVALID_CODE";
    ErrorCode[ErrorCode["CAPTCHA_INCORRECT"] = 40] = "CAPTCHA_INCORRECT";
    ErrorCode[ErrorCode["HOST_INCORRECT"] = 41] = "HOST_INCORRECT";
    ErrorCode[ErrorCode["HOST_EXIST"] = 42] = "HOST_EXIST";
    ErrorCode[ErrorCode["K8S_DOMAIN_ERROR"] = 43] = "K8S_DOMAIN_ERROR";
    ErrorCode[ErrorCode["PARTNER_NO_FOUND"] = 44] = "PARTNER_NO_FOUND";
    ErrorCode[ErrorCode["INVALID_LANGUAGE"] = 45] = "INVALID_LANGUAGE";
    ErrorCode[ErrorCode["ROUTE_EXIST"] = 46] = "ROUTE_EXIST";
    ErrorCode[ErrorCode["DATE_RANGE"] = 47] = "DATE_RANGE";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_COMBINATION"] = 48] = "PUBLISHER_ATTACHMENT_COMBINATION";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_COUNT"] = 49] = "PUBLISHER_ATTACHMENT_COUNT";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_LINK"] = 50] = "PUBLISHER_ATTACHMENT_LINK";
    ErrorCode[ErrorCode["PASSWORD"] = 51] = "PASSWORD";
    ErrorCode[ErrorCode["PARTICIPANTS_EMPTY"] = 52] = "PARTICIPANTS_EMPTY";
    ErrorCode[ErrorCode["ATTACHMENT_MANDATORY"] = 53] = "ATTACHMENT_MANDATORY";
    ErrorCode[ErrorCode["PUBLISHER_POST_EMPTY"] = 54] = "PUBLISHER_POST_EMPTY";
    ErrorCode[ErrorCode["NO_CONTACT"] = 55] = "NO_CONTACT";
    ErrorCode[ErrorCode["GPT_RETRY_LIMIT"] = 56] = "GPT_RETRY_LIMIT";
    ErrorCode[ErrorCode["PAYMENT_REQUIRED"] = 57] = "PAYMENT_REQUIRED";
    ErrorCode[ErrorCode["BUNDLES_SIZE"] = 58] = "BUNDLES_SIZE";
    ErrorCode[ErrorCode["BUNDLE_OPTION_SIZE"] = 59] = "BUNDLE_OPTION_SIZE";
    ErrorCode[ErrorCode["OFFER_ALREADY_EXISTS"] = 60] = "OFFER_ALREADY_EXISTS";
    ErrorCode[ErrorCode["SITE_COUNT_MAX"] = 61] = "SITE_COUNT_MAX";
    ErrorCode[ErrorCode["PROMOTION_CODE_INVALID"] = 62] = "PROMOTION_CODE_INVALID";
    ErrorCode[ErrorCode["ACTIVE_OFFER_IS_FAILURE_TO_PAY"] = 63] = "ACTIVE_OFFER_IS_FAILURE_TO_PAY";
    ErrorCode[ErrorCode["OFFER_PRODUCTS_EMPTY"] = 64] = "OFFER_PRODUCTS_EMPTY";
    ErrorCode[ErrorCode["OFFER_SAME_OFFER_ACTIVE"] = 65] = "OFFER_SAME_OFFER_ACTIVE";
    ErrorCode[ErrorCode["TASK_IN_PROGRESS"] = 66] = "TASK_IN_PROGRESS";
    ErrorCode[ErrorCode["OFFER_ACTIVE_EXISTS"] = 67] = "OFFER_ACTIVE_EXISTS";
    ErrorCode[ErrorCode["OFFER_CANCELLED_EXPIRED"] = 68] = "OFFER_CANCELLED_EXPIRED";
    ErrorCode[ErrorCode["SUSPENDED"] = 69] = "SUSPENDED";
    ErrorCode[ErrorCode["PHONE_FORMAT"] = 70] = "PHONE_FORMAT";
    ErrorCode[ErrorCode["PARTNER_CONFING_INVALID"] = 71] = "PARTNER_CONFING_INVALID";
    ErrorCode[ErrorCode["PARTNER_CONFING_PERMISSIONS"] = 72] = "PARTNER_CONFING_PERMISSIONS";
    ErrorCode[ErrorCode["COMMUNITY_AUTOPILOT_DAYS_MAX"] = 73] = "COMMUNITY_AUTOPILOT_DAYS_MAX";
    ErrorCode[ErrorCode["TAX_COUNTRY"] = 74] = "TAX_COUNTRY";
    ErrorCode[ErrorCode["TAX_TYPE"] = 75] = "TAX_TYPE";
    ErrorCode[ErrorCode["TAX_VALUE_INVALID"] = 76] = "TAX_VALUE_INVALID";
    ErrorCode[ErrorCode["LOCATION_INVALID"] = 77] = "LOCATION_INVALID";
    ErrorCode[ErrorCode["TOKEN_INVALID"] = 78] = "TOKEN_INVALID";
    ErrorCode[ErrorCode["PAYMENT_PROVIDER_CREATE_SUBSCRIPTION"] = 79] = "PAYMENT_PROVIDER_CREATE_SUBSCRIPTION";
    ErrorCode[ErrorCode["OFFER_QUOTE_EXISTS"] = 80] = "OFFER_QUOTE_EXISTS";
    ErrorCode[ErrorCode["CREATE_ARTICLE_IA_FORM_EMPTY"] = 81] = "CREATE_ARTICLE_IA_FORM_EMPTY";
    ErrorCode[ErrorCode["MAX_LIMIT"] = 82] = "MAX_LIMIT";
    ErrorCode[ErrorCode["FORMAT"] = 83] = "FORMAT";
})($735f6b1fdc93c9a6$export$d4e71bc0b80dc0fb || ($735f6b1fdc93c9a6$export$d4e71bc0b80dc0fb = {}));

});

parcelRegister("7ZaxO", function(module, exports) {

$parcel$export(module.exports, "HttpStatus", function () { return $6f3d3ee98d6e2b63$export$2b71909294c66558; });
var $6f3d3ee98d6e2b63$export$2b71909294c66558;
(function(HttpStatus) {
    HttpStatus[HttpStatus["CONTINUE"] = 100] = "CONTINUE";
    HttpStatus[HttpStatus["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    HttpStatus[HttpStatus["PROCESSING"] = 102] = "PROCESSING";
    HttpStatus[HttpStatus["OK"] = 200] = "OK";
    HttpStatus[HttpStatus["CREATED"] = 201] = "CREATED";
    HttpStatus[HttpStatus["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatus[HttpStatus["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    HttpStatus[HttpStatus["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatus[HttpStatus["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    HttpStatus[HttpStatus["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    HttpStatus[HttpStatus["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    HttpStatus[HttpStatus["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    HttpStatus[HttpStatus["IM_USED"] = 226] = "IM_USED";
    HttpStatus[HttpStatus["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpStatus[HttpStatus["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpStatus[HttpStatus["FOUND"] = 302] = "FOUND";
    HttpStatus[HttpStatus["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpStatus[HttpStatus["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpStatus[HttpStatus["USE_PROXY"] = 305] = "USE_PROXY";
    HttpStatus[HttpStatus["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    HttpStatus[HttpStatus["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpStatus[HttpStatus["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatus[HttpStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatus[HttpStatus["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HttpStatus[HttpStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatus[HttpStatus["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpStatus[HttpStatus["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpStatus[HttpStatus["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpStatus[HttpStatus["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HttpStatus[HttpStatus["CONFLICT"] = 409] = "CONFLICT";
    HttpStatus[HttpStatus["GONE"] = 410] = "GONE";
    HttpStatus[HttpStatus["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HttpStatus[HttpStatus["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpStatus[HttpStatus["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    HttpStatus[HttpStatus["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    HttpStatus[HttpStatus["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HttpStatus[HttpStatus["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    HttpStatus[HttpStatus["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HttpStatus[HttpStatus["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    HttpStatus[HttpStatus["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    HttpStatus[HttpStatus["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HttpStatus[HttpStatus["LOCKED"] = 423] = "LOCKED";
    HttpStatus[HttpStatus["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    HttpStatus[HttpStatus["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HttpStatus[HttpStatus["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    HttpStatus[HttpStatus["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpStatus[HttpStatus["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HttpStatus[HttpStatus["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HttpStatus[HttpStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpStatus[HttpStatus["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HttpStatus[HttpStatus["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HttpStatus[HttpStatus["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpStatus[HttpStatus["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HttpStatus[HttpStatus["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    HttpStatus[HttpStatus["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    HttpStatus[HttpStatus["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    HttpStatus[HttpStatus["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    HttpStatus[HttpStatus["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    HttpStatus[HttpStatus["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
    HttpStatus[HttpStatus["BANDWIDTH_LIMIT"] = 509] = "BANDWIDTH_LIMIT";
})($6f3d3ee98d6e2b63$export$2b71909294c66558 || ($6f3d3ee98d6e2b63$export$2b71909294c66558 = {}));

});

parcelRegister("kfkzw", function(module, exports) {

$parcel$export(module.exports, "ProductType", function () { return $e5cb6c8f7045f949$export$11b099a658b17995; });
var $e5cb6c8f7045f949$export$11b099a658b17995;
(function(ProductType) {
    ProductType[ProductType["SEDESTRAL"] = 1] = "SEDESTRAL";
    ProductType[ProductType["INBOX"] = 2] = "INBOX";
    ProductType[ProductType["PUBLISHER"] = 3] = "PUBLISHER";
    ProductType[ProductType["STATISTICS"] = 4] = "STATISTICS";
    ProductType[ProductType["CONTACTS"] = 5] = "CONTACTS";
    ProductType[ProductType["CHANNELS"] = 6] = "CHANNELS";
    ProductType[ProductType["LIVECHAT"] = 7] = "LIVECHAT";
    ProductType[ProductType["PANEL"] = 8] = "PANEL";
    ProductType[ProductType["GENERAL"] = 9] = "GENERAL";
    ProductType[ProductType["CHAT_BOT"] = 10] = "CHAT_BOT";
    ProductType[ProductType["MAILS"] = 11] = "MAILS";
    ProductType[ProductType["SELL"] = 12] = "SELL";
    ProductType[ProductType["ENGAGEMENT"] = 13] = "ENGAGEMENT";
    ProductType[ProductType["ADVERTISING"] = 14] = "ADVERTISING";
    ProductType[ProductType["MAILLING"] = 15] = "MAILLING";
    ProductType[ProductType["MEDIAS"] = 16] = "MEDIAS";
    ProductType[ProductType["CALENDAR"] = 17] = "CALENDAR";
    ProductType[ProductType["DOCUMENTS"] = 18] = "DOCUMENTS";
    ProductType[ProductType["PRODUCTS"] = 19] = "PRODUCTS";
    ProductType[ProductType["ESTIMATE"] = 20] = "ESTIMATE";
    ProductType[ProductType["CONTACTS_GREY"] = 21] = "CONTACTS_GREY";
    ProductType[ProductType["PUBLISHER_GREY"] = 22] = "PUBLISHER_GREY";
    ProductType[ProductType["INBOX_GREY"] = 23] = "INBOX_GREY";
    ProductType[ProductType["HELPCENTER"] = 24] = "HELPCENTER";
    ProductType[ProductType["WEBSITE"] = 25] = "WEBSITE";
    ProductType[ProductType["CLIENT_SERVICE"] = 26] = "CLIENT_SERVICE";
    ProductType[ProductType["BLOG"] = 27] = "BLOG";
    ProductType[ProductType["MOBILE"] = 28] = "MOBILE";
    ProductType[ProductType["COMMUNITY"] = 29] = "COMMUNITY";
    ProductType[ProductType["ADMIN"] = 30] = "ADMIN";
})($e5cb6c8f7045f949$export$11b099a658b17995 || ($e5cb6c8f7045f949$export$11b099a658b17995 = {}));

});

parcelRegister("5FliW", function(module, exports) {

$parcel$export(module.exports, "Resources", function () { return $2c6b78a6d87e1877$export$e9a269813a6315a4; });

var $7AbeR = parcelRequire("7AbeR");

var $271MM = parcelRequire("271MM");

var $2bZ4d = parcelRequire("2bZ4d");

var $276sx = parcelRequire("276sx");

var $dEtAh = parcelRequire("dEtAh");

var $iSiUq = parcelRequire("iSiUq");

var $3I7TG = parcelRequire("3I7TG");

var $esq0i = parcelRequire("esq0i");

var $kfkzw = parcelRequire("kfkzw");

var $bi5k0 = parcelRequire("bi5k0");
class $2c6b78a6d87e1877$export$e9a269813a6315a4 {
    static getCountryCode() {
        return this.languageToCountryMap[this.language] || "fr";
    }
    static async init(languagesCandidate, languages, defaultLanguage = this.getDefaultLanguage()) {
        this.languages = languages;
        let selectBestLanguageCandidate = this.getBestLanguageCandidate(languages, languagesCandidate);
        this.setLanguage(selectBestLanguageCandidate);
        if (!this.language) this.setLanguage(defaultLanguage);
        if (!this.language) this.setLanguage(this.getDefaultLanguage());
        if ((0, $271MM.config).product == "blog") this.theme((0, $kfkzw.ProductType).BLOG) == (0, $276sx.AppearanceTheme).LIGHT ? (0, $iSiUq.SedestralInterface).html.removeClass("black") : (0, $iSiUq.SedestralInterface).html.addClass("black");
    }
    static async loadI18n(product, vendor = (0, $esq0i.generateVendor)(window.location.origin)) {
        const request = await (0, $7AbeR.Network).httpResources.get(vendor + "languages/" + product + "/" + this.language + ".json?" + (0, $271MM.config).version, {
            timeout: 60000
        });
        if (this.words !== undefined) this.words = this.mergeI18n(this.words, request.data);
        else {
            this.words = request.data;
            (0, $7AbeR.Network).initErrors();
            (0, $2bZ4d.DateIntervalPickerPurposes).init();
        }
    }
    static async loadCountries(vendor = (0, $esq0i.generateVendor)(window.location.origin)) {
        let request = await (0, $7AbeR.Network).httpResources.get(vendor + "countries/" + this.language + ".json?" + (0, $271MM.config).version, {
            timeout: 60000
        });
        this.countries = request.data;
    }
    static async loadEmojis(vendor = (0, $esq0i.generateVendor)(window.location.origin)) {
        if (this.emojis != undefined) return this.emojis;
        let request = await (0, $7AbeR.Network).httpResources.get(vendor + "emojis/emojis.json?" + (0, $271MM.config).version);
        this.emojis = request.data;
        return this.emojis;
    }
    static async loadWorldLanguages(vendor = (0, $esq0i.generateVendor)(window.location.origin)) {
        let request = await (0, $7AbeR.Network).httpResources.get(vendor + "languages/names.json?" + (0, $271MM.config).version, {
            timeout: 60000
        });
        this.worldLanguages = request.data;
    }
    static t(value, words) {
        const values = value.split(".");
        let object = words !== null && words !== void 0 ? words : this.words;
        for (const val of values)if (object) object = object[val];
        return object !== null && object !== void 0 ? object : value;
    }
    static r(value, replacements, words = this.words) {
        const values = value.split(".");
        let object = words;
        for (const val of values)if (typeof object !== "undefined") object = object[val];
        let result = typeof object === "undefined" || typeof object === "object" ? value : object;
        for(const key in replacements)result = result.replace(`\${${key}}`, replacements[key]);
        return result;
    }
    static exist(value, words) {
        const values = value.split(".");
        let object = words !== null && words !== void 0 ? words : this.words;
        for (const val of values)if (object) object = object[val];
        return object !== undefined;
    }
    static country(a2) {
        a2 = a2.toLowerCase();
        return this.countries.filter((value)=>value["a2"] == a2)[0];
    }
    static lang(code) {
        code = (0, $3I7TG.txtSimpleLang)(code);
        for(let key in this.worldLanguages)if (this.worldLanguages.hasOwnProperty(key)) {
            if (this.worldLanguages[key].code == code) return this.worldLanguages[key];
        }
    }
    static getLanguagesCandidate() {
        return [
            ...new Set(navigator.languages.map((language)=>this.removeRegionLanguage(language)))
        ];
    }
    static getLanguagesCandidateWidthDefault(bestLanguageCandidate) {
        return [
            ...new Set([
                $2c6b78a6d87e1877$export$e9a269813a6315a4.removeRegionLanguage(bestLanguageCandidate),
                ...$2c6b78a6d87e1877$export$e9a269813a6315a4.getLanguagesCandidate()
            ].filter((language)=>language !== undefined))
        ];
    }
    static getBestLanguageCandidate(languages, languagesCandidate = this.getLanguagesCandidate()) {
        return languagesCandidate.find((language)=>languages.includes(language));
    }
    static getDefaultLanguage() {
        return "en";
    }
    static setLanguage(language) {
        if (this.languages.includes(language)) this.language = language;
    }
    static removeRegionLanguage(language) {
        if (language == undefined) return undefined;
        const withoutQuality = language.split(";")[0];
        if (withoutQuality.includes("-")) return withoutQuality.split("-")[0];
        if (withoutQuality.includes("_")) return withoutQuality.split("_")[0];
        return withoutQuality;
    }
    static theme(productType) {
        let theme = this.realTheme(productType);
        if (theme == (0, $276sx.AppearanceTheme).AUTO) {
            if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) return (0, $276sx.AppearanceTheme).DARK;
            else return (0, $276sx.AppearanceTheme).LIGHT;
        }
        return theme;
    }
    static realTheme(productType) {
        let theme = (0, $dEtAh.SedestralStorage).getItem(`${(0, $bi5k0.ProductName).toString(productType)}-theme`);
        if (theme == null) return (0, $276sx.AppearanceTheme).AUTO;
        return parseInt(theme);
    }
    static invertTheme(productType, theme) {
        return (theme ? theme : $2c6b78a6d87e1877$export$e9a269813a6315a4.theme(productType)) == (0, $276sx.AppearanceTheme).DARK ? (0, $276sx.AppearanceTheme).LIGHT : (0, $276sx.AppearanceTheme).DARK;
    }
    static setTheme(productType, theme, silent) {
        (0, $dEtAh.SedestralStorage).setItem(`${(0, $bi5k0.ProductName).toString(productType)}-theme`, "" + theme);
        if (!silent) this.theme(productType) == (0, $276sx.AppearanceTheme).LIGHT ? (0, $iSiUq.SedestralInterface).html.removeClass("black") : (0, $iSiUq.SedestralInterface).html.addClass("black");
    }
    static mergeI18n(wordsA, wordsB) {
        return {
            ...wordsA,
            ...wordsB,
            words: {
                ...wordsA.words,
                ...wordsB.words
            },
            network: {
                ...wordsA.network,
                ...wordsB.network
            },
            errors: {
                ...wordsA.errors,
                ...wordsB.errors
            },
            placeholders: {
                ...wordsA.placeholders,
                ...wordsB.placeholders
            },
            sentences: {
                ...wordsA.sentences,
                ...wordsB.sentences
            },
            products: {
                ...wordsA.products,
                ...wordsB.products
            },
            time: {
                ...wordsA.time,
                ...wordsB.time
            }
        };
    }
}
$2c6b78a6d87e1877$export$e9a269813a6315a4.languageToCountryMap = {
    "fr": "fr",
    "en": "en",
    "es": "es",
    "it": "it",
    "pt": "pt",
    "nl": "nl",
    "de": "de",
    "lb": "lu",
    "da": "dk" // Denmark
};

});
parcelRegister("2bZ4d", function(module, exports) {

$parcel$export(module.exports, "DateIntervalPickerPurposes", function () { return $93711a43f91c5f41$export$c965c81194e437f6; });

var $5FliW = parcelRequire("5FliW");

var $cQhFs = parcelRequire("cQhFs");

var $9bHFi = parcelRequire("9bHFi");

var $arzaW = parcelRequire("arzaW");
class $93711a43f91c5f41$export$c965c81194e437f6 {
    static init() {
        $93711a43f91c5f41$export$c965c81194e437f6.basePurposes = [
            {
                value: "today",
                name: (0, $5FliW.Resources).t("words.todayCalendar"),
                show: true
            },
            {
                value: "yesterday",
                name: (0, $5FliW.Resources).t("words.yesterday"),
                show: true
            },
            {
                value: "week",
                name: (0, $5FliW.Resources).r("words.lastDays", {
                    count: 7
                }),
                show: true
            },
            {
                value: "4week",
                name: (0, $5FliW.Resources).r("words.lastWeeks", {
                    count: 4
                }),
                show: true
            },
            {
                value: "3month",
                name: (0, $5FliW.Resources).r("words.lastMonths", {
                    count: 3
                }),
                show: true
            },
            {
                value: "6month",
                name: (0, $5FliW.Resources).r("words.lastMonths", {
                    count: 6
                }),
                show: true
            },
            {
                value: "12month",
                name: (0, $5FliW.Resources).r("words.lastMonths", {
                    count: 12
                }),
                show: true
            }
        ];
        $93711a43f91c5f41$export$c965c81194e437f6.comparatorPurposes = [
            {
                value: "lastPeriod",
                name: (0, $5FliW.Resources).t("words.lastPeriod"),
                show: true
            },
            {
                value: "lastWeek",
                name: (0, $5FliW.Resources).t("words.lastWeek"),
                show: true
            },
            {
                value: "lastMonth",
                name: (0, $5FliW.Resources).t("words.lastMonth"),
                show: true
            },
            {
                value: "lastTrimester",
                name: (0, $5FliW.Resources).t("words.lastTrimester"),
                show: true
            },
            {
                value: "lastSemester",
                name: (0, $5FliW.Resources).t("words.lastSemester"),
                show: true
            },
            {
                value: "lastYear",
                name: (0, $5FliW.Resources).t("words.lastYear"),
                show: true
            },
            {
                value: "undefined",
                name: (0, $5FliW.Resources).t("words.noComparison"),
                show: true
            }
        ];
    }
    /**
     * calcs
     */ static baseCalc(purposeValue) {
        switch(purposeValue){
            case "today":
                return [
                    new Date(),
                    new Date()
                ];
            case "yesterday":
                return [
                    (0, $9bHFi.datePrevious)(1),
                    (0, $9bHFi.datePrevious)(1)
                ];
            case "week":
                return [
                    (0, $9bHFi.datePrevious)(6),
                    new Date()
                ];
            case "4week":
                return [
                    (0, $9bHFi.datePrevious)(28),
                    new Date()
                ];
            case "3month":
                let month3 = new Date();
                month3.setMonth(month3.getMonth() - 3);
                return [
                    month3,
                    new Date()
                ];
            case "6month":
                let month6 = new Date();
                month6.setMonth(month6.getMonth() - 6);
                return [
                    month6,
                    new Date()
                ];
            case "12month":
                let month12 = new Date();
                month12.setMonth(month12.getMonth() - 12);
                return [
                    month12,
                    new Date()
                ];
        }
    }
    static comparatorCalc(purposeValue, firstDate, secondDate) {
        let comparatorDays = (0, $cQhFs.dateCountDaysBetweenDates)(firstDate, secondDate, true);
        let difference = 0;
        firstDate = (0, $arzaW.dateToCompare)(firstDate);
        secondDate = (0, $arzaW.dateToCompare)(secondDate, true);
        switch(purposeValue){
            case "lastPeriod":
                return [
                    (0, $9bHFi.datePrevious)(comparatorDays + 1, firstDate),
                    (0, $9bHFi.datePrevious)(comparatorDays + 1, secondDate)
                ];
            case "undefined":
                return [
                    undefined,
                    undefined
                ];
            case "lastWeek":
                return [
                    (0, $9bHFi.datePrevious)(7, firstDate),
                    (0, $9bHFi.datePrevious)(7, secondDate)
                ];
            case "lastMonth":
                firstDate.setMonth(firstDate.getMonth() - 1);
                secondDate.setMonth(secondDate.getMonth() - 1);
                difference = comparatorDays - (0, $cQhFs.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
            case "lastTrimester":
                firstDate.setMonth(firstDate.getMonth() - 3);
                secondDate.setMonth(secondDate.getMonth() - 3);
                difference = comparatorDays - (0, $cQhFs.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
            case "lastSemester":
                firstDate.setMonth(firstDate.getMonth() - 6);
                secondDate.setMonth(secondDate.getMonth() - 6);
                difference = comparatorDays - (0, $cQhFs.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
            case "lastYear":
                firstDate.setFullYear(firstDate.getFullYear() - 1);
                secondDate.setFullYear(secondDate.getFullYear() - 1);
                difference = comparatorDays - (0, $cQhFs.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
        }
    }
    /**
     * find
     */ static basePurpose(value) {
        return this.basePurposes.filter((v)=>v.value == value)[0];
    }
    static comparatorPurpose(value) {
        return this.comparatorPurposes.filter((v)=>v.value == value)[0];
    }
}

});
parcelRegister("cQhFs", function(module, exports) {

$parcel$export(module.exports, "dateCountDaysBetweenDates", function () { return $f93d8a6f4c05df54$export$4161df2d8c6bdac8; });

var $arzaW = parcelRequire("arzaW");
function $f93d8a6f4c05df54$export$4161df2d8c6bdac8(date, futureDate, noCountToday) {
    date = (0, $arzaW.dateToCompare)(new Date(date));
    futureDate = new Date(futureDate);
    let days = [];
    while(date.getTime() < futureDate.getTime()){
        let key = "" + date.getFullYear() + date.getMonth() + date.getDate();
        if (!days.includes(key)) days.push(key);
        date.setDate(date.getDate() + 1);
    }
    return days.length - (noCountToday != undefined && noCountToday ? 1 : 0);
}

});
parcelRegister("arzaW", function(module, exports) {

$parcel$export(module.exports, "dateToCompare", function () { return $8c118686ea459f5d$export$90108030505d8ba4; });
/**
 * Met les heures, minutes etc à 0 ou les minutes etc à 59
 */ function $8c118686ea459f5d$export$90108030505d8ba4(d, end) {
    d = new Date(d);
    if (d != undefined) {
        if (end) {
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
            d.setMilliseconds(999);
        } else {
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0);
        }
    }
    return d;
}

});


parcelRegister("9bHFi", function(module, exports) {

$parcel$export(module.exports, "datePrevious", function () { return $6cabce52956bd013$export$41249170adb44dba; });
/**
 * Retourne la date - x nombre de jours par rapport à la date actuel
 */ function $6cabce52956bd013$export$41249170adb44dba(previousDays, fromDate) {
    let myDate = new Date(fromDate == undefined ? new Date() : fromDate);
    myDate.setDate(myDate.getDate() - previousDays);
    return myDate;
}

});


parcelRegister("276sx", function(module, exports) {

$parcel$export(module.exports, "AppearanceTheme", function () { return $4ce679db9bfe7ff3$export$81ee01c5982277e7; });
var $4ce679db9bfe7ff3$export$81ee01c5982277e7;
(function(AppearanceTheme) {
    AppearanceTheme[AppearanceTheme["LIGHT"] = 1] = "LIGHT";
    AppearanceTheme[AppearanceTheme["DARK"] = 2] = "DARK";
    AppearanceTheme[AppearanceTheme["AUTO"] = 3] = "AUTO";
})($4ce679db9bfe7ff3$export$81ee01c5982277e7 || ($4ce679db9bfe7ff3$export$81ee01c5982277e7 = {}));

});

parcelRegister("dEtAh", function(module, exports) {

$parcel$export(module.exports, "SedestralStorage", function () { return $8c39eedb04c7a1de$export$c4d24105fc1cd347; });

var $9DuXN = parcelRequire("9DuXN");

var $kWi7n = parcelRequire("kWi7n");
class $8c39eedb04c7a1de$export$c4d24105fc1cd347 {
    static async init() {
        if (!(0, $kWi7n.isLocalStorageAvailable)()) this.isLocalStorageEnabled = false;
    }
    static setItem(key, value) {
        if (this.isLocalStorageEnabled) localStorage.setItem(key, value);
        else (0, $9DuXN.SedestralMemory).setItem(key, value);
    }
    static getItem(key) {
        if (this.isLocalStorageEnabled) return localStorage.getItem(key);
        else return (0, $9DuXN.SedestralMemory).getItem(key);
    }
    static hasItem(key) {
        return this.getItem(key) != null;
    }
    static removeItem(key) {
        if (this.isLocalStorageEnabled) localStorage.removeItem(key);
        else (0, $9DuXN.SedestralMemory).removeItem(key);
    }
    static setCookie(name, value, domain = location.hostname) {
        try {
            let expireDate = new Date();
            expireDate.setFullYear(expireDate.getFullYear() + 1); // Expire après le nombre d'années spécifié
            document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expireDate.toUTCString()}; domain=${domain}; path=/`;
        } catch (e) {
            console.error("Failed to set cookie", e);
        }
    }
    static getCookie(name) {
        const nameEQ = encodeURIComponent(name) + "=";
        const cookies = document.cookie.split(";");
        for(let i = 0; i < cookies.length; i++){
            let cookie = cookies[i];
            while(cookie.charAt(0) === " ")cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
        }
        return null;
    }
    static deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }
}
$8c39eedb04c7a1de$export$c4d24105fc1cd347.isLocalStorageEnabled = true;

});
parcelRegister("9DuXN", function(module, exports) {

$parcel$export(module.exports, "SedestralMemory", function () { return $55ef900314a0f690$export$fa0502262c0fea12; });
class $55ef900314a0f690$export$fa0502262c0fea12 {
    static async init() {
        this._items = [];
    }
    static setItem(key, value) {
        this._items[key] = value;
    }
    static getItem(key) {
        return this._items[key] ? this._items[key] : null;
    }
    static removeItem(key) {
        delete this._items[key];
    }
}

});

parcelRegister("kWi7n", function(module, exports) {

$parcel$export(module.exports, "isLocalStorageAvailable", function () { return $9f2fc4767f0dcc2a$export$117a30df0da2af20; });
/**
 * vérifie si le localstorage est dispo
 */ function $9f2fc4767f0dcc2a$export$117a30df0da2af20() {
    let test = "test";
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("iSiUq", function(module, exports) {

$parcel$export(module.exports, "SedestralInterface", function () { return $0c9568d831ebfd17$export$a48299ae308b6bd7; });

var $iJHeF = parcelRequire("iJHeF");

var $8J94x = parcelRequire("8J94x");
class $0c9568d831ebfd17$export$a48299ae308b6bd7 {
    static async init() {
        this.components = [];
        if (this.log) (0, $8J94x.SedestralMachine).setInterval(()=>{
            let nullComponents = [];
            for (let component of this.components)if (component.element == undefined) // if (component.constructor.name != "PageComponent")
            nullComponents.push(component);
            console.log(nullComponents);
            console.log(this.components);
            console.log("comp: " + (this.components.length - nullComponents.length));
            console.log("comp n: " + nullComponents.length);
        }, 3000);
        this.html = this.ec("html");
        this.body = this.ec("body");
        this.main = this.ec("main");
        let listeners = [
            "dragenter",
            "dragover",
            "dragleave",
            "drop"
        ];
        listeners.forEach((eventName)=>this.body.putListener(window, eventName, (e)=>e.preventDefault()));
    }
    static dispose() {
        this.components.forEach((c)=>{
            c.nullify();
        });
        this.components = [];
        this.body = undefined;
        this.main = undefined;
    }
    static store(element) {
        this.components.push(element);
    }
    static unStore(element) {
        let index = this.components.indexOf(element);
        if (index >= 0) this.components.splice(index, 1);
    }
    static ec(selector) {
        let e = document.querySelector(selector);
        if (e != undefined) return new (0, $iJHeF.Component)(e);
        return undefined;
    }
    static el(element) {
        return new (0, $iJHeF.Component)(element);
    }
}
$0c9568d831ebfd17$export$a48299ae308b6bd7.log = false;

});
parcelRegister("iJHeF", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $e7322875e9c3c3a0$export$16fa2f45be04daa8; });

var $8J94x = parcelRequire("8J94x");

var $iSiUq = parcelRequire("iSiUq");

var $7WRna = parcelRequire("7WRna");

var $i3Hbv = parcelRequire("i3Hbv");

var $1IWI5 = parcelRequire("1IWI5");

var $ecrPc = parcelRequire("ecrPc");

var $c1R3d = parcelRequire("c1R3d");

var $2xlLE = parcelRequire("2xlLE");

var $dIuUJ = parcelRequire("dIuUJ");

var $5EBOf = parcelRequire("5EBOf");

var $gvC7k = parcelRequire("gvC7k");

var $7s7Z1 = parcelRequire("7s7Z1");

var $86gWV = parcelRequire("86gWV");

var $1aMHk = parcelRequire("1aMHk");

var $dZIKC = parcelRequire("dZIKC");

var $fksB7 = parcelRequire("fksB7");
class $e7322875e9c3c3a0$export$16fa2f45be04daa8 {
    /**
     * Logic
     */ property(type) {
        let offsets = this.getParentOffsets();
        let offsetProperty = typeof offsets[type] == "undefined" ? 0 : offsets[type];
        if (type == "height") offsetProperty = this.getHeight();
        return offsetProperty;
    }
    /**
     * Machine
     */ async sleep(ms) {
        await this.promise((resolve)=>{
            this.timeOut(()=>{
                resolve(undefined);
            }, ms);
        });
    }
    runAsCommit(func) {
        if (this.committed) func();
        else this.onCommit(()=>func());
    }
    async wait(animations) {
        await Promise.all(animations);
    }
    async promise(executor, displayRequired) {
        return (0, $8J94x.SedestralMachine).promise(executor, displayRequired, this);
    }
    async simplePromise(executor, displayRequired) {
        return new Promise(executor);
    }
    /**
     * Animations
     */ async translate(params) {
        return this.simplePromise((resolve)=>{
            if (this.element instanceof HTMLElement) {
                let delay = params.delay == undefined ? 100 : params.delay;
                let delayStyle = `transition-duration: ${delay / 1000}s;`;
                /**
                 * transform
                 */ let transformStyle = ``;
                if (params.translateX != undefined) transformStyle += `translateX(${params.translateX}px) `;
                if (params.translateY != undefined) transformStyle += `translateY(${params.translateY}px) `;
                if (params.scale != undefined) transformStyle += `scale(${params.scale}) `;
                if (params.rotate != undefined) transformStyle += `rotate(${params.rotate}) `;
                if (transformStyle != ``) transformStyle = `transform:${transformStyle};`;
                /**
                 * position
                 */ let offsets = this.getParentOffsets();
                if (offsets == undefined) return;
                let positionStyle = ``;
                if (params.left != undefined) {
                    this.element.style.left = `${offsets["left"]}px`;
                    this.element.style.right = "unset";
                    positionStyle += `left:${offsets["left"] + params.left}px;`;
                }
                if (params.top != undefined) {
                    this.element.style.top = `${offsets["top"]}px`;
                    this.element.style.bottom = "unset";
                    positionStyle += `top:${offsets["top"] + params.top}px;`;
                }
                if (params.bottom != undefined) {
                    this.element.style.bottom = `${offsets["bottom"]}px`;
                    this.element.style.top = "unset";
                    positionStyle += `bottom:${offsets["bottom"] + params.bottom}px;`;
                }
                if (params.right != undefined) {
                    this.element.style.right = `${offsets["right"]}px`;
                    this.element.style.left = "unset";
                    positionStyle += `right:${offsets["right"] + params.right}px;`;
                }
                /**
                 * move
                 */ if (params.moveRight != undefined) {
                    this.element.style.right = `${offsets["right"]}px`;
                    this.element.style.left = "unset";
                    positionStyle += `right:${params.moveRight}px;`;
                }
                if (params.moveLeft != undefined) {
                    this.element.style.left = `${offsets["left"]}px`;
                    this.element.style.right = "unset";
                    positionStyle += `left:${params.moveLeft}px;`;
                }
                if (params.moveTop != undefined) {
                    this.element.style.top = `${offsets["top"]}px`;
                    this.element.style.bottom = "unset";
                    positionStyle += `top:${params.moveTop}px;`;
                }
                if (params.moveBottom != undefined) {
                    this.element.style.bottom = `${offsets["bottom"]}px`;
                    this.element.style.top = "unset";
                    positionStyle += `bottom:${params.moveBottom}px;`;
                }
                let propertiesStyle = ``;
                /**
                 * properties
                 */ if (params.opacity != undefined) propertiesStyle += `opacity:${params.opacity};`;
                if (params.padding != undefined) propertiesStyle += `padding:${params.padding}px;`;
                if (params.margin != undefined) propertiesStyle += `margin:${params.margin}px;`;
                if (params.height != undefined) {
                    this.element.style.height = `${this.getHeight()}px`;
                    propertiesStyle += `height:${params.height}px;`;
                }
                if (params.maxHeight != undefined) {
                    this.element.style.maxHeight = `${this.getHeight()}px`;
                    propertiesStyle += `max-height:${params.maxHeight}px;`;
                }
                if (params.maxWidth != undefined) {
                    this.element.style.maxWidth = `${this.getWidth()}px`;
                    propertiesStyle += `max-width:${params.maxWidth}px;`;
                }
                if (params.width != undefined) {
                    this.element.style.width = `${this.getWidth()}px`;
                    propertiesStyle += `width:${params.width}px;`;
                }
                if (params.widthPercent != undefined) propertiesStyle += `width:${params.widthPercent}%;`;
                if (params.borderRadius != undefined) propertiesStyle += `border-radius:${params.borderRadius};`;
                /**
                 * execution
                 */ (0, $8J94x.SedestralMachine).requestFrame()(()=>{
                    setTimeout(()=>{
                        this.setStyle(transformStyle + delayStyle + positionStyle + propertiesStyle);
                    });
                });
                /**
                 * sync
                 */ this.timeOut(()=>{
                    resolve();
                    if (params.remove != undefined && params.remove == true) this.remove();
                }, delay);
            }
        });
    }
    async scale(start, value, speed) {
        if (this.element instanceof HTMLElement) {
            this.element.style.transform = "scale(" + start + ")";
            await this.translate({
                delay: speed,
                scale: value
            });
        }
    }
    async fade(value, speed) {
        if (this.element instanceof HTMLElement) {
            if (value == "in") this.show();
            let start = value == "in" ? 0 : 1;
            let final = value == "in" ? 1 : 0;
            this.setStyle(`opacity:${start}`);
            await this.translate({
                delay: speed,
                opacity: final
            });
        }
    }
    /**
     * toggle
     */ toggle(tog, gle) {
        let toggled = false;
        this.onClick(()=>{
            if (!toggled) {
                tog();
                toggled = true;
            } else {
                gle();
                toggled = false;
            }
        });
    }
    /**
     * Animations advanced
     */ async openUp(delay) {
        if (!(0, $fksB7.isMobile)()) return this.scaleShow(delay);
        else return this.swapUp();
    }
    async closeDown(delay, scale, clear) {
        if (!(0, $fksB7.isMobile)()) return this.scaleHide(delay, scale, clear);
        else return this.swapDown(clear);
    }
    async swapUp() {
        this.displayShow();
        this.setStyle(`transform:translateY(100%) scale(1);opacity:1;`);
        await this.translate({
            translateY: 0,
            delay: 400
        });
    }
    async swapDown(clear) {
        this.setStyle(`transform:scale(1);opacity:1;`);
        await this.translate({
            translateY: window.innerHeight,
            delay: 400
        });
        this.displayHide();
        if (clear == undefined || clear == true) this.clearAll();
    }
    async scaleShow(delay, withoutDisplay) {
        if (!withoutDisplay) this.displayShow();
        this.setStyle(`transform:scale(0.9);opacity:0;`);
        await this.translate({
            delay: delay == undefined ? 80 : delay,
            scale: 1,
            opacity: 1
        });
        this.isHide = false;
    }
    async scaleHide(delay, scale, clear) {
        this.setStyle(`transform:scale(1);opacity:1;`);
        await this.simplePromise((resolve)=>{
            (0, $8J94x.SedestralMachine).requestFrame()(async ()=>{
                await this.translate({
                    delay: delay == undefined ? 80 : delay,
                    scale: scale == undefined ? 0.9 : scale,
                    opacity: 0
                });
                this.displayHide();
                (0, $8J94x.SedestralMachine).requestFrame()(async ()=>{
                    this.timeOut(()=>{
                        if (clear == undefined || clear == true) this.clearAll();
                        resolve(true);
                    }, 100);
                });
            });
        });
        this.isHide = true;
    }
    async scaleShowTranslate(delay) {
        this.show();
        this.setStyle(`transform:scale(0.9) translateY(20px);opacity:0;`);
        await this.translate({
            delay: delay == undefined ? 80 : delay,
            translateY: 0,
            scale: 1,
            opacity: 1
        });
    }
    /**
     * outside click
     */ excludeOutsideClickComponent(component) {
        this.outsideClickExcludedComponents.push(component);
        component.onRemove(()=>this.outsideClickExcludedComponents.splice(this.outsideClickExcludedComponents.indexOf(component), 1));
    }
    /**
     * Scroll
     */ getScrollPercent() {
        if (this.element instanceof HTMLElement) return Math.round(this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight) * 100);
        return 0;
    }
    getScrollTop() {
        if (this.element instanceof HTMLElement) return this.element.scrollTop;
        return 0;
    }
    getScrollLeft() {
        if (this.element instanceof HTMLElement) return this.element.scrollLeft;
        return 0;
    }
    setScrollLeft(value) {
        if (this.element instanceof HTMLElement) this.element.scrollLeft = value;
    }
    setScrollTop(value) {
        if (this.element instanceof HTMLElement) this.element.scrollTop = value;
    }
    getScrollBottom() {
        if (this.element instanceof HTMLElement) return this.element.scrollHeight - Math.round(this.element.scrollTop + this.getHeight());
    }
    scrollTop(value, speed) {
        let easeInOutQuad = function(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };
        let start = this.getScrollTop(), change = value - start, currentTime = 0, increment = 20;
        let animateScroll = ()=>{
            currentTime += increment;
            this.setScrollTop(easeInOutQuad(currentTime, start, change, speed));
            if (currentTime < speed) (0, $8J94x.SedestralMachine).setTimeout(animateScroll, increment);
        };
        animateScroll();
    }
    scrollIntoView(parent, offset, behavior) {
        parent = parent == undefined ? this.element.parentElement : parent;
        if (parent instanceof HTMLElement) {
            let parentRect = parent.getBoundingClientRect();
            let childRect = this.getHTMLElement().getBoundingClientRect();
            parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top + (offset == undefined ? 0 : offset);
        } else {
            let parentRect = parent.getHTMLElement().getBoundingClientRect();
            let childRect = this.getHTMLElement().getBoundingClientRect();
            let scrollTop = Math.round(childRect.top + parent.getHTMLElement().scrollTop - parentRect.top) + (offset == undefined ? 0 : offset);
            parent.getHTMLElement().scrollTo({
                top: scrollTop,
                behavior: behavior ? behavior : "smooth"
            });
        }
    }
    scrollTo(parent, offset) {
        parent.getHTMLElement().scrollTo({
            top: this.getParentOffsets(parent).top + (offset ? offset : 0),
            behavior: "smooth"
        });
    }
    scrollBottom(value, speed) {
        if (this.element instanceof HTMLElement) {
            let startDistance = this.element.scrollTop;
            let endDistance = this.element.scrollHeight - this.getHeight() - value;
            let frame = 0;
            let delta = (endDistance - startDistance) / speed / 0.06;
            let handle = (0, $8J94x.SedestralMachine).setInterval(()=>{
                if (this.element instanceof HTMLElement) {
                    frame++;
                    let value = startDistance + delta * frame;
                    this.element.scrollTo(0, value);
                    if (this.element == undefined) clearInterval(handle);
                    if (value >= endDistance) clearInterval(handle);
                }
            }, 1 / 0.06);
        }
    }
    forceScrollUpdate() {
        this.addClass("scroll-sdt-scr");
        (0, $8J94x.SedestralMachine).requestFrame()(()=>this.removeClass("scroll-sdt-scr"));
    }
    /**
     * Dimensions
     */ getPaddingHeight() {
        let top = this.getHTMLElement().style.paddingTop.length > 0 ? parseInt(this.getHTMLElement().style.paddingTop) : 0;
        let bottom = this.getHTMLElement().style.paddingBottom.length > 0 ? parseInt(this.getHTMLElement().style.paddingBottom) : 0;
        return top + bottom;
    }
    getFullHeight() {
        let height = this.getHTMLElement().clientHeight;
        let style = getComputedStyle(this.getHTMLElement());
        height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
    }
    getHeightCalculated() {
        let getFullHeight = (element)=>{
            let style = window.getComputedStyle(element);
            let hauteur = element.offsetHeight;
            let margeHaut = parseInt(style.marginTop);
            let margeBas = parseInt(style.marginBottom);
            return hauteur + margeHaut + margeBas;
        };
        let height = 0;
        let childs = this.getHTMLElement() ? this.getHTMLElement().children : [];
        let parentStyle = window.getComputedStyle(this.getHTMLElement());
        let gap = parseInt(parentStyle.gap) || 0;
        for(let i = 0; i < childs.length; i++)if (!childs[i].hasAttribute("scrolltrack")) height += getFullHeight(childs[i]);
        height += gap * (childs.length - 1);
        return height;
    }
    getHeight() {
        if (this.element instanceof HTMLElement) return this.getHTMLElement().getBoundingClientRect().height + this.getPaddingHeight();
    }
    getHeightWithoutBorders() {
        return this.getHeight() - (this.getHTMLElement().offsetHeight - this.getHTMLElement().clientHeight);
    }
    getWidth() {
        if (this.element instanceof HTMLElement) return this.element.clientWidth;
    }
    getPaddingWidth() {
        let left = parseInt(this.getHTMLElement().style.paddingLeft);
        let right = parseInt(this.getHTMLElement().style.paddingRight);
        return (Number.isNaN(left) ? 0 : left) + (Number.isNaN(right) ? 0 : right);
    }
    getMarginWidth() {
        let left = parseInt(this.getHTMLElement().style.marginLeft);
        let right = parseInt(this.getHTMLElement().style.marginRight);
        return (Number.isNaN(left) ? 0 : left) + (Number.isNaN(right) ? 0 : right);
    }
    /**
     * Offsets
     */ getParentOffsets(element) {
        let parent = this.element.parentNode;
        if (typeof element != "undefined") parent = element.element;
        if (parent == undefined) return undefined;
        let parentOffsets = (0, $gvC7k.elementOffsets)(parent);
        let eOffsets = (0, $gvC7k.elementOffsets)(this.element);
        return {
            top: eOffsets["top"] - parentOffsets["top"],
            left: eOffsets["left"] - parentOffsets["left"],
            right: eOffsets["right"] - parentOffsets["right"],
            bottom: eOffsets["bottom"] - parentOffsets["bottom"]
        };
    }
    getOffsets() {
        return (0, $gvC7k.elementOffsets)(this.element);
    }
    /**
     * Value and html and text
     */ getValue() {
        if (this.element instanceof HTMLInputElement || this.element instanceof HTMLTextAreaElement) return this.element.value;
        return "";
    }
    getValueTrim() {
        return this.getValue().trim();
    }
    setValue(value) {
        if (this.element instanceof HTMLInputElement || this.element instanceof HTMLTextAreaElement) this.element.value = value;
        return "";
    }
    streamValue(text, delay) {
        let index = 0;
        this.setValue("");
        let interval = this.interval(()=>{
            if (index < text.length) {
                this.setValue(this.getValue() + text[index]);
                index++;
            } else clearInterval(interval);
        }, delay / text.length);
    }
    getHtml() {
        if (this.element instanceof HTMLElement) return this.element.innerHTML;
    }
    setHtml(html) {
        if (this.element instanceof HTMLElement) this.element.innerHTML = "" + html;
    }
    getText() {
        if (this.element instanceof HTMLElement) return this.element.innerText;
    }
    streamText(text, delay) {
        let index = 0;
        this.setHtml(""); // Effacer le contenu initial
        const addHtml = ()=>{
            if (index < text.length) {
                if (text.substring(index, index + 8) === "<strong>") {
                    // On a trouvé le début d'une balise <strong>
                    const endOfStrongTag = text.indexOf("</strong>", index);
                    if (endOfStrongTag !== -1) {
                        // Ajouter la balise <strong>...</strong> entière en une fois
                        this.setHtml(this.getHtml() + text.substring(index, endOfStrongTag + 9));
                        index = endOfStrongTag + 9; // Avancer l'index après la balise </strong>
                    }
                } else {
                    // Ajouter un caractère normal
                    this.setHtml(this.getHtml() + text[index]);
                    index++;
                }
            } else clearInterval(interval); // Arrêter l'insertion lorsque tout le texte est ajouté
        };
        let interval = setInterval(addHtml, delay / text.length);
    }
    setText(text) {
        if (this.element instanceof HTMLElement) this.element.innerText = text;
    }
    /**
     * style
     */ setPlaceHolderStyle(value) {
        this.placeHolderSelector = (0, $1aMHk.randomString)(20, false);
        this.addClass(this.placeHolderSelector);
        if (!this.placeholderStyleElement) {
            this.placeholderStyleElement = document.createElement("style");
            this.placeholderStyleElement = this.getHTMLElement().appendChild(this.placeholderStyleElement);
        }
        this.placeholderStyleElement.innerHTML = `.${this.placeHolderSelector}::placeholder { ${value} }`;
    }
    setStyle(value) {
        if (this.element instanceof HTMLElement || this.element instanceof SVGElement) this.element.style.cssText += value;
    }
    getStyle(strCssRule) {
        let strValue = "";
        if (this.element instanceof HTMLElement) {
            if (document.defaultView && document.defaultView.getComputedStyle) strValue = document.defaultView.getComputedStyle(this.element, "").getPropertyValue(strCssRule);
            else if (this.element["currentStyle"]) {
                strCssRule = strCssRule.replace(/\-(\w)/g, function(strMatch, p1) {
                    return p1.toUpperCase();
                });
                strValue = this.element["currentStyle"][strCssRule];
            }
        }
        return strValue;
    }
    setStyleValue(type, value) {
        if (this.element instanceof HTMLElement) this.element.style[type] = value;
    }
    /**
     * visibility status
     */ hide() {
        this.isHide = true;
        this.setStyle("visibility:hidden;");
    }
    show() {
        this.isHide = false;
        this.setStyle("visibility:visible;");
    }
    displayHide() {
        this.isHide = true;
        this.setStyle("display:none;");
    }
    displayShow() {
        this.isHide = false;
        this.setStyle("display:block;");
    }
    displayFlex() {
        this.isHide = false;
        this.setStyle("display:flex;");
    }
    isDisplayNone() {
        return this.getStyle("display") == "none";
    }
    isVisible() {
        if (this.element instanceof HTMLElement) return this.element.offsetParent !== undefined;
    }
    /**
     * On events
     */ onHotKeys(keys, func) {
        keys.forEach((key)=>{
            this.hotKeyListeners.push(key);
            (0, $8J94x.SedestralMachine).addHotKeyListener(this, key, func);
        });
    }
    onHotKey(keys, func) {
        this.hotKeyListeners.push(keys);
        (0, $8J94x.SedestralMachine).addHotKeyListener(this, keys, func);
        return keys;
    }
    onChange(func) {
        if (this.mutationObserver == undefined) {
            this.mutationFunctions = [];
            this.mutationObserver = new MutationObserver((mutations)=>{
                for (let f of this.mutationFunctions)f(mutations);
            });
            this.mutationObserver.observe(this.getHTMLElement(), {
                subtree: true,
                childList: true,
                characterData: true,
                attributes: true,
                characterDataOldValue: true,
                attributeOldValue: true,
                attributeFilter: [
                    "id",
                    "class"
                ]
            });
        }
        this.mutationFunctions.push(func);
        return func;
    }
    onResize(func) {
        if (this.element instanceof Element) {
            let f = ()=>{
                let offsets = this.getOffsets();
                func({
                    height: this.getHeight(),
                    width: this.getWidth(),
                    x: offsets.left,
                    y: offsets.top
                });
            };
            window.addEventListener("resize", f);
            this.onRemove(()=>window.removeEventListener("resize", f));
            this.onChange(()=>f());
            (0, $8J94x.SedestralMachine).resizeObserver.observe(this.element);
            if (this.element["resizeFunctions"] == undefined) this.element["resizeFunctions"] = [];
            this.element["resizeFunctions"].push(func);
        }
    }
    onInput(func, delay) {
        return this.addListener("input", this.delay(func, typeof delay == "undefined" ? 0 : delay));
    }
    onKey(func, delay) {
        return this.addListener("keydown", this.delay(func, typeof delay == "undefined" ? 0 : delay));
    }
    onKeyUp(func, delay) {
        return this.addListener("keyup", this.delay(func, typeof delay == "undefined" ? 0 : delay));
    }
    onClick(func, stopPropagation, mobileDelay) {
        return this.addListener("click", (e)=>{
            if (stopPropagation) {
                e.stopImmediatePropagation();
                e.stopPropagation();
            }
            if ((0, $fksB7.isMobile)() && mobileDelay) this.timeOut(()=>func(e), 200);
            else func(e);
        });
    }
    onDragEvent(onEnter, onLeave) {
        let entered = false;
        let leave = true;
        let listeners = [];
        listeners.push(this.putListener(window, "dragleave", (e)=>{
            if (!leave) {
                if (!(0, $7s7Z1.elementParents)(e.target).includes(this.getHTMLElement())) {
                    entered = false;
                    leave = true;
                    onLeave(e);
                }
            }
        }));
        listeners.push(this.putListener(window, "dragenter", (e)=>{
            if (!entered) {
                if (e.target == this.getHTMLElement() || (0, $7s7Z1.elementParents)(e.target).includes(this.getHTMLElement())) {
                    this.timeOut(()=>leave = false, 50);
                    entered = true;
                    onEnter(e);
                }
            }
        }));
        this.putListener(window, "focus", (e)=>onLeave(e));
        return listeners;
    }
    onDragDrop(func) {
        return this.addListener("drop", (e)=>func(e));
    }
    onRightClick(func) {
        this.addListener("contextmenu", (e)=>{
            e.preventDefault();
            func(e);
        });
    }
    onWindowResize(func) {
        this.putListener(window, "resize", func);
    }
    onFocus(func) {
        return this.addListener("focus", (e)=>func(e));
    }
    onBlur(func) {
        return this.addListener("blur", (e)=>func(e));
    }
    onScroll(callback) {
        return this.addListener("scroll", callback);
    }
    async onOutsideClick(func, propagation) {
        await (0, $8J94x.SedestralMachine).sleep(50);
        let listener = this.putListener(window, "click", (e)=>{
            if (!(0, $dIuUJ.elementNotChildren)(document, e.target)) {
                if (!this.isNull() && (0, $dIuUJ.elementNotChildren)(this.element, e.target) && this.outsideClickExcludedComponents.filter((value)=>!(0, $dIuUJ.elementNotChildren)(value.element, e.target)).length == 0) {
                    if (typeof propagation != "undefined") e.stopImmediatePropagation();
                    func(e);
                }
            }
        });
        (0, $8J94x.SedestralMachine).addOutsideClickListener(listener, this);
        return listener;
    }
    async onOutsideRightClick(func, propagation) {
        await (0, $8J94x.SedestralMachine).sleep(50);
        return this.putListener(window, "contextmenu", (e)=>{
            if ((0, $dIuUJ.elementNotChildren)(this.element, e.target)) {
                if (typeof propagation != "undefined") e.stopImmediatePropagation();
                func(e);
            }
        });
    }
    onComponentClick(name, func) {
        let globalFunc = function(e) {
            let parentsClasses = [];
            let a = e.target;
            while(a){
                a = a.parentNode;
                if (a != undefined) {
                    if (a.className !== "") parentsClasses.push(a.className);
                }
            }
            let has = false;
            if ((0, $5EBOf.elementHasClass)(e.target.className, name)) has = true;
            for(let i = 0; i < parentsClasses.length; i++)if ((0, $5EBOf.elementHasClass)(parentsClasses[i], name)) has = true;
            if (has) func();
        };
        return this.addListener("click", globalFunc);
    }
    onHover(func, time) {
        return this.addListener("mouseenter", (e)=>{
            if (time == undefined) func(e);
            else {
                let timeOut = this.timeOut(()=>{
                    func(e);
                }, time);
                let leaveListener = this.addListener("mouseleave", (e)=>{
                    clearTimeout(timeOut);
                    this.deleteListener(leaveListener);
                });
            }
        });
    }
    onLeave(func, time) {
        return this.addListener("mouseleave", (e)=>{
            if (time == undefined) func(e);
            else {
                let timeOut = this.timeOut(()=>{
                    func(e);
                }, time);
                let leaveListener = this.addListener("mouseenter", (e)=>{
                    clearTimeout(timeOut);
                    this.deleteListener(leaveListener);
                });
            }
        });
    }
    onSubmit(func) {
        if (this.element instanceof HTMLElement) this.element.onsubmit = (e)=>{
            func(e);
        };
    }
    onCommit(func) {
        this.onCommitFunctions.push(func);
    }
    onRemove(func) {
        this.onRemoveFunctions.push(func);
    }
    onReactiveObserve(func) {
        this.reactives.push((0, $i3Hbv.observe)(()=>func(), {
            lazy: false
        }));
    }
    onBufferReactiveObserve(func) {
        let scheduled;
        this.reactives.push((0, $i3Hbv.observe)(()=>func(), {
            lazy: false,
            scheduler: ()=>{
                clearTimeout(scheduled);
                scheduled = this.timeOut(()=>{
                    if (!this.isNull()) func();
                }, 25);
                return setTimeout(undefined, 0);
            }
        }));
    }
    onVisible(callback) {
        if (!this.isNull()) new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.intersectionRatio > 0) {
                    callback(this.getHTMLElement());
                    observer.disconnect();
                }
            });
        }).observe(this.getHTMLElement());
    }
    onVisibilityChange(callback) {
        if (!this.isNull()) new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                callback(entry.isIntersecting);
            });
        }, {
            threshold: [
                0
            ]
        }).observe(this.getHTMLElement());
    }
    onParentsScroll(callback) {
        return this.putListener(document, "scroll", (e)=>{
            if ((0, $7s7Z1.elementParents)(this.getHTMLElement()).includes(e.target)) callback(e);
        }, true);
    }
    isBelowScroll(callback, mid) {
        function isElementBelowViewportBottom(element, currentScrollTop) {
            const viewportBottom = currentScrollTop + window.innerHeight;
            const elementTop = element.getBoundingClientRect().top + window.scrollY;
            return elementTop > viewportBottom - (mid ? window.innerHeight / 2 - 100 : 0);
        }
        this.putListener(document, "scroll", ()=>{
            const scrollTop = window.scrollY;
            const targetElement = this.getHTMLElement();
            if (isElementBelowViewportBottom(targetElement, scrollTop)) callback(false);
            else callback(true);
        });
        callback(false);
    }
    /**
     * focus
     */ isFocus() {
        return document.activeElement == this.element;
    }
    focus() {
        if (this.element instanceof HTMLElement) this.element.focus();
    }
    focusAtEnd() {
        this.focus();
        let inputElement = this.getHTMLElement();
        if (inputElement) {
            let strLength = this.getValue().length * 2;
            (0, $8J94x.SedestralMachine).requestFrame()(()=>{
                let type = inputElement.type;
                inputElement.type = "text";
                inputElement.focus();
                inputElement.setSelectionRange(strLength, strLength);
                inputElement.type = type;
            });
        }
    }
    /**
     * append and prepend html text inside component
     */ pendTop() {
        let eElement = this.element.parentNode;
        if (eElement.firstChild != this.element) {
            let newFirstElement = this.element;
            eElement.insertBefore(newFirstElement, eElement.firstChild);
        }
    }
    pendBottom() {
        let eElement = this.element.parentNode;
        let newFirstElement = this.element;
        eElement.appendChild(newFirstElement);
    }
    pendAfter(beforeComponent, component) {
        component = component ? component : this;
        beforeComponent.element.parentElement.appendChild(component.element);
        let beforeElement = beforeComponent.element;
        beforeElement = beforeElement.nextSibling == undefined ? beforeElement : beforeElement.nextSibling;
        beforeComponent.element.parentElement.insertBefore(component.element, beforeElement);
    }
    pendBefore(beforeComponent, component) {
        component = component ? component : this;
        beforeComponent.element.parentElement.appendChild(component.element);
        beforeComponent.element.parentElement.insertBefore(component.element, beforeComponent.element);
    }
    prepend(html, tag) {
        let component = this.append(html, tag);
        component.pendTop();
        return component;
    }
    append(html, tag) {
        let buffer = document.createElement(typeof tag == "undefined" ? "div" : typeof this.tagParents[tag] == "undefined" ? tag : this.tagParents[tag]);
        buffer.innerHTML = html.trim();
        let element = buffer.firstChild;
        if (buffer.childNodes.length > 1) {
            var _this_element, _this_element1;
            (_this_element = this.element) === null || _this_element === void 0 ? void 0 : _this_element.appendChild(buffer);
            (_this_element1 = this.element) === null || _this_element1 === void 0 ? void 0 : _this_element1.insertBefore(buffer, this.element.lastChild);
            element = buffer;
        } else {
            var _this_element2, _this_element3;
            (_this_element2 = this.element) === null || _this_element2 === void 0 ? void 0 : _this_element2.appendChild(element);
            (_this_element3 = this.element) === null || _this_element3 === void 0 ? void 0 : _this_element3.insertBefore(element, this.element.lastChild);
        }
        let component = (0, $iSiUq.SedestralInterface).el(element);
        this.childrens.filter((value)=>!value.drawCommitted).forEach((value)=>this.drawCommit(value));
        if (!component.committed) component.tryCommit();
        this.addChildren(component);
        return component;
    }
    /**
     * Reactive
     */ reactive(v) {
        let id = (0, $1aMHk.randomString)(18, true);
        this.onReactiveObserve(()=>{
            try {
                let value = v();
                if (!this.isNull()) {
                    let element = this.getHTMLElement().getElementsByClassName(id)[0];
                    if (element != undefined) element.innerHTML = (0, $86gWV.filterXSS)(value);
                }
            } catch (e) {}
        });
        return `<reactive class="${id}">${(0, $86gWV.filterXSS)(v())}</reactive>`;
    }
    reactiveObservable(obj) {
        return (0, $i3Hbv.observable)(obj);
    }
    reactiveUnObserve(v) {
        (0, $i3Hbv.unobserve)(v);
    }
    reactivesUnObserve() {
        for(let i = 0; i < this.reactives.length; i++)this.reactiveUnObserve(this.reactives[i]);
        this.reactives = [];
    }
    /**
     * Return the template of an component and added to childrens for final commit
     */ drawAll(components) {
        let template = "";
        for(let i = 0; i < components.length; i++){
            let component = components[i];
            template += this.draw(component);
        }
        return template;
    }
    drawCommit(component) {
        component.drawCommitted = true;
        if (!component.committed) {
            let element = document.getElementById(component.componentId);
            if (element != undefined) {
                component.element = element;
                component.removeAttribute("id");
            }
            component.tryCommit();
        }
    }
    draw(component) {
        component.drawCommitted = false;
        let buffer = document.createElement("div");
        buffer.innerHTML = component.getTemplate().trim();
        if (buffer.childNodes.length > 1) {
            buffer.id = component.componentId;
            component.template = buffer["outerHTML"];
        } else {
            buffer.firstChild["id"] = component.componentId;
            component.template = buffer["innerHTML"];
        }
        if (this.committed) (0, $8J94x.SedestralMachine).requestFrame()(()=>this.drawCommit(component));
        else this.onCommit(()=>this.drawCommit(component));
        this.addChildren(component);
        return component.getTemplate();
    }
    drawFly(component) {
        if (this.committed) {
            this.render(component);
            let html = component.getHTMLElement().outerHTML;
            component.remove();
            return html;
        }
    }
    /**
     * Append a component inside other, better performance than draw()
     */ prerender(component) {
        this.render(component, true);
    }
    render(component, prepend, beforeComponent, beforeAfter) {
        var _this_element, _this_element1;
        let buffer = document.createElement(typeof this.tagParents[component.type] == "undefined" ? component.type : this.tagParents[component.type]);
        buffer.innerHTML = component.getTemplate().trim();
        let element = buffer.firstChild;
        if (buffer.childNodes.length > 1) element = buffer;
        (_this_element = this.element) === null || _this_element === void 0 ? void 0 : _this_element.appendChild(element);
        (_this_element1 = this.element) === null || _this_element1 === void 0 ? void 0 : _this_element1.insertBefore(element, !prepend ? this.element.lastChild : this.element.firstChild);
        component.element = element;
        if (!component.committed) component.tryCommit();
        this.addChildren(component);
        if (beforeComponent) beforeAfter ? this.pendAfter(beforeComponent, component) : this.pendBefore(beforeComponent, component);
        return component;
    }
    /**
     * call this function after apend in DOM
     */ tryCommit() {
        try {
            this.commit();
            this.committed = true;
        } catch (e) {
            (0, $c1R3d.SedestralDebugger).addError("SEDESTRAL COMMIT ERROR", e);
            this.committedError = true;
            this.commitFailed();
        }
    }
    commit() {
        this.committed;
        if (!this.committed) {
            this.committed = true;
            for (let commitFunc of this.onCommitFunctions)commitFunc();
        }
    }
    commitFailed() {}
    commitTooltips() {
        let elements = (0, $2xlLE.elementChildrens)(this.getHTMLElement());
        elements.forEach((element)=>{
            if (!element["commitTooltips"]) {
                element["commitTooltips"] = true;
                let tooltipText = element.getAttribute("data-tooltip");
                let tooltipPosition = element.getAttribute("data-tooltip-position");
                if (tooltipText != undefined) {
                    let component = this.ele(element);
                    component.setTooltip(tooltipText, tooltipPosition);
                }
            }
        });
    }
    /**
     * errors
     */ addNetworkErrors(errors) {
        errors.forEach((error)=>this.networkErrorsHandler.push(error));
    }
    /**
     * create an empty element in DOM with className
     */ virtual(name) {
        let buffer = document.createElement("div");
        buffer.className = name;
        this.element = buffer;
        document.body.appendChild(buffer);
        document.body.insertBefore(buffer, this.element.lastChild);
    }
    addChildren(element) {
        if (!this.childrens.includes(element)) this.childrens.push(element);
    }
    removeChildren(element) {
        let index = this.childrens.indexOf(element);
        if (index >= 0) this.childrens.splice(index, 1);
    }
    /**
     * save and restore headers
     */ saveScroll() {
        this.savedScroll = this.getHTMLElement().scrollTop;
        this.savedScrollCalc = this.getHTMLElement().scrollHeight - this.getHTMLElement().clientHeight;
    }
    restoreScroll() {
        this.getHTMLElement().scrollTop = this.savedScroll + (this.getHTMLElement().scrollHeight - this.getHTMLElement().clientHeight - this.savedScrollCalc);
    }
    save() {
        if (this.element instanceof HTMLElement) {
            this.savedStyle = this.element.getAttribute("style");
            this.savedHtml = this.element.innerHTML;
        }
    }
    saveAndClear() {
        this.save();
        this.clear();
    }
    saveForLoading() {
        this.setStyle(`padding:0;height:${this.getHeightWithoutBorders()}px;width:${this.getWidth()}px;`);
        this.saveAndClear();
    }
    restore() {
        if (this.element instanceof HTMLElement) {
            this.element.setAttribute("style", this.savedStyle);
            this.element.innerHTML = this.savedHtml;
        }
    }
    /**
     * Listeners
     */ clearListeners() {
        for(let i = 0; i < this.listeners.length; i++)(0, $8J94x.SedestralMachine).removeListener(this.listeners[i]);
        this.hotKeyListeners.forEach((value)=>(0, $8J94x.SedestralMachine).deleteHotKeyListener(this, value));
        this.listeners = [];
        this.hotKeyListeners = [];
    }
    clearTooltipListeners() {
        for(let i = 0; i < this.tooltipListeners.length; i++)(0, $8J94x.SedestralMachine).removeListener(this.tooltipListeners[i]);
        this.tooltipListeners = [];
        if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) this.tooltip.tooltipComponent.remove();
        this.tooltip = undefined;
    }
    clearTimeouts() {
        for(let i = 0; i < this.timeOuts.length; i++)clearTimeout(this.timeOuts[i]);
        this.timeOuts = [];
    }
    clearIntervals() {
        for(let i = 0; i < this.intervals.length; i++)clearInterval(this.intervals[i]);
        this.intervals = [];
    }
    addListener(name, func) {
        var _SedestralDebugger_rum;
        (0, $c1R3d.SedestralDebugger).eventTarget(this, name);
        let rum = (_SedestralDebugger_rum = (0, $c1R3d.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.eventTarget(name);
        return this.putListener(this.element, name, (e)=>{
            func(e);
            rum === null || rum === void 0 ? void 0 : rum.end();
        });
    }
    putListener(element, name, func, options) {
        let listener = (0, $8J94x.SedestralMachine).addListener(element, name, func, options);
        this.listeners.push(listener);
        return listener;
    }
    deleteListener(data) {
        if (data != undefined) {
            (0, $8J94x.SedestralMachine).removeListener(data);
            let index = this.listeners.indexOf(data);
            if (index >= 0) this.listeners.splice(index, 1);
        }
    }
    deleteListeners(listeners) {
        for (let listener of listeners)this.deleteListener(listener);
    }
    deleteHotKeyListener(hotkeys) {
        (0, $8J94x.SedestralMachine).deleteHotKeyListener(this, hotkeys);
        let index = this.hotKeyListeners.indexOf(hotkeys);
        if (index >= 0) this.hotKeyListeners.splice(index, 1);
    }
    deleteHotKeyListeners(hotkeys) {
        hotkeys.forEach((value)=>this.deleteHotKeyListener(value));
    }
    deleteOnChangeListener(func) {
        this.mutationFunctions.splice(this.mutationFunctions.indexOf(func), 1);
    }
    /**
     * run listeners
     */ runRemoves() {
        if (this.onRemoveFunctions.length > 0) for (let removeFunc of this.onRemoveFunctions)removeFunc();
        this.onRemoveFunctions = [];
    }
    /**
     * Class interaction
     */ hasClass(cls) {
        if (this.element instanceof HTMLElement) return (0, $5EBOf.elementHasClass)(this.element.className, cls);
    }
    addClass(cls) {
        if (this.element instanceof HTMLElement) {
            if (!this.hasClass(cls)) {
                const last = this.element.className.charAt(this.element.className.length - 1);
                this.element.className += (last == " " ? "" : " ") + cls;
            }
        }
    }
    removeClass(cls) {
        if (this.element instanceof HTMLElement) {
            if (this.hasClass(cls)) {
                let reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
                this.element.className = this.element.className.replace(reg, " ");
            }
        }
    }
    /**
     * Attribute interactions
     */ getAttribute(name) {
        if (this.element instanceof HTMLElement) return this.element.getAttribute(name);
    }
    setAttribute(name, content) {
        if (this.element instanceof HTMLElement) this.element.setAttribute(name, content);
    }
    removeAttribute(name) {
        if (this.element instanceof HTMLElement) this.element.removeAttribute(name);
    }
    /**
     * child headers manipulation
     */ els(className) {
        if (this.element instanceof HTMLElement) {
            let elements = [];
            let components = [];
            if (this.hasClass(className)) elements.push(this.element);
            let classes = this.element.getElementsByClassName(className);
            for(let i = 0; i < classes.length; i++)elements.push(classes[i]);
            for (let element of elements){
                let cache = this.childrens.filter((value)=>value.element == element)[0];
                if (cache == undefined) {
                    let e = (0, $iSiUq.SedestralInterface).el(element);
                    e.committed = true;
                    components.push(e);
                    this.addChildren(e);
                } else components.push(cache);
            }
            return components;
        }
    }
    el(className, noCache) {
        if (!noCache) {
            let cache = this.childrens.filter((value)=>value.element != undefined && value.hasClass(className))[0];
            if (cache != undefined) return cache;
        }
        if (this.element instanceof HTMLElement) {
            let e = (0, $iSiUq.SedestralInterface).el(this.hasClass(className) ? this.element : this.element.getElementsByClassName(className)[0]);
            e.committed = true;
            this.addChildren(e);
            return e;
        }
    }
    ele(element) {
        let cache = this.childrens.filter((value)=>value.element == element)[0];
        if (cache == undefined) {
            let e = (0, $iSiUq.SedestralInterface).el(element);
            e.committed = true;
            this.addChildren(e);
            return e;
        }
        return cache;
    }
    has(className) {
        if (this.element instanceof HTMLElement) {
            let elements = this.element.getElementsByClassName(className);
            if (elements.length > 0) return true;
        }
        return false;
    }
    clearChildrens() {
        for(let i = 0; i < this.childrens.length; i++){
            let child = this.childrens[i];
            child.destroy();
        }
        this.childrens = [];
    }
    count(className) {
        if (this.element instanceof HTMLElement) {
            let elements = this.element.getElementsByTagName("*");
            let count = 0;
            for(let i = 0; i < elements.length; i++)if (!!elements[i].className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"))) count++;
            return count;
        }
    }
    /**
     * apply events
     */ delay(callback, ms) {
        if (ms == 0) return callback;
        else {
            let timer = 0;
            return (params)=>{
                clearTimeout(timer);
                timer = (0, $8J94x.SedestralMachine).setTimeout(()=>{
                    callback(params);
                }, ms || 0);
            };
        }
    }
    timeOut(callback, ms) {
        let timeout = (0, $8J94x.SedestralMachine).setTimeout(()=>{
            callback();
        }, ms);
        this.timeOuts.push(timeout);
        return timeout;
    }
    interval(callback, ms, lazy) {
        if (!lazy) callback();
        let timeout = (0, $8J94x.SedestralMachine).setInterval(()=>{
            callback();
        }, ms);
        this.intervals.push(timeout);
        return timeout;
    }
    /**
     * others
     */ isNull() {
        return this.element == undefined;
    }
    /**
     * end
     */ remove() {
        if (this.element != undefined && this.element.parentNode !== undefined) {
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
        this.destroy();
    }
    nullify() {
        if (this.getHTMLElement() != undefined) (0, $8J94x.SedestralMachine).resizeObserver.unobserve(this.getHTMLElement());
        if (this.mutationObserver != undefined) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
            this.mutationFunctions = [];
        }
        this.clearAll();
        this.element = undefined;
        this.timeOuts = [];
        this.intervals = [];
        this.reactives = [];
        this.listeners = [];
        this.hotKeyListeners = [];
        this.childrens = [];
        this.isHide = undefined;
        this.savedHtml = undefined;
        this.savedStyle = undefined;
        this.savedScroll = undefined;
        this.savedScroll = undefined;
        this.savedScrollCalc = undefined;
        this.outsideClickExcludedComponents = [];
        this.template = undefined;
        this.type = undefined;
        this.scrollbar = undefined;
        this.swapBar = undefined;
        this.runRemoves();
        this.onCommitFunctions = [];
        for(let key in this)if (this.hasOwnProperty(key)) {
            let value = this[key];
            let isArray = Array.isArray(value);
            if (isArray && value["length"] != 0 || !isArray && value != undefined) {
                if (isArray) value = [];
                else value = undefined;
            }
        }
    }
    destroy() {
        this.nullify();
        (0, $iSiUq.SedestralInterface).unStore(this);
    }
    destroyChildrens() {
        this.childrens.forEach((value)=>{
            value.destroyChildrens();
            value.destroy();
        });
    }
    clear() {
        if (this.element instanceof HTMLElement) {
            this.element.innerHTML = "";
            this.clearChildrens();
        }
    }
    clearAll() {
        this.scrollbar = undefined;
        this.swapBar = undefined;
        this.clear();
        this.clearListeners();
        this.clearTooltipListeners();
        this.clearIntervals();
        this.clearTimeouts();
        this.reactivesUnObserve();
    }
    /**
     * change element status
     */ scrollable(autoPlace) {
        if (this.scrollbar == undefined) this.scrollbar = new (0, $7WRna.ComponentScrollbar)(this, autoPlace);
        return this.scrollbar;
    }
    swapable(onDispose) {
        if ((0, $fksB7.isMobile)()) {
            if (this.swapBar == undefined) this.swapBar = new (0, $ecrPc.ComponentSwapBar)(this, onDispose);
            return this.swapBar;
        }
    }
    unClickable() {
        this.onClick((e)=>{
            e.preventDefault();
        }, true);
    }
    /**
     * tooltip
     */ showShadowTooltip(template, color) {
        this.setStyle(`box-shadow: 0 0 0 2px ${color};`);
        this.showTooltip(template, 2000, "bottom");
        clearTimeout(this.tooltipShowShadowTimeout);
        this.tooltipShowShadowTimeout = this.timeOut(()=>{
            this.setStyle(`box-shadow: unset;`);
        }, 2000);
    }
    showTooltip(template, delay, position, noAnimation) {
        clearTimeout(this.tooltipShowTimeout);
        if (!this.tooltip) this.tooltip = new (0, $1IWI5.ComponentTooltip)(this, template, position, noAnimation);
        this.tooltipShowTimeout = this.timeOut(()=>{
            if (this.tooltip) this.tooltip.tooltipComponent.remove();
            this.tooltip = undefined;
        }, delay ? delay : 3000);
    }
    setTooltip(template, position, noAnimation, disabled) {
        if ((0, $fksB7.isMobile)()) {
            let showed = false;
            let show = ()=>{
                if (disabled == undefined || !disabled()) {
                    this.tooltip = new (0, $1IWI5.ComponentTooltip)(this, template, position, noAnimation);
                    showed = true;
                }
            };
            let hide = ()=>{
                if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) {
                    this.tooltip.tooltipComponent.remove();
                    this.tooltip = undefined;
                    showed = false;
                }
            };
            this.tooltipListeners.push(this.onClick(()=>{
                if (showed) hide();
                else show();
            }));
            this.onOutsideClick(()=>hide()).then((value)=>this.tooltipListeners.push(value));
        } else {
            this.tooltipListeners.push(this.onHover(()=>{
                if (disabled == undefined || !disabled()) this.tooltip = new (0, $1IWI5.ComponentTooltip)(this, template, position, noAnimation);
            }));
            this.tooltipListeners.push(this.onClick(()=>{
                if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) {
                    this.tooltip.tooltipComponent.remove();
                    this.tooltip = undefined;
                }
            }));
        }
    }
    /**
     * getter and setter
     */ getHTMLElement() {
        if (this.element instanceof HTMLElement) return this.element;
    }
    getTemplate() {
        return this.template;
    }
    constructor(element){
        this.networkErrorsHandler = [];
        this.tagParents = {
            "th": "tr",
            "td": "tr",
            "tr": "tbody"
        };
        this.element = element;
        this.componentId = (0, $dZIKC.randomUUID)();
        this.timeOuts = [];
        this.intervals = [];
        this.reactives = [];
        this.listeners = [];
        this.hotKeyListeners = [];
        this.childrens = [];
        this.isHide = false;
        this.savedHtml = undefined;
        this.savedStyle = undefined;
        this.savedScroll = 0;
        this.savedScrollCalc = 0;
        this.template = `<div></div>`;
        this.type = "DIV";
        this.committedError = false;
        this.committed = false;
        this.drawCommitted = true;
        this.onCommitFunctions = [];
        this.onRemoveFunctions = [];
        this.tooltipListeners = [];
        this.outsideClickExcludedComponents = [];
        (0, $iSiUq.SedestralInterface).store(this);
    }
}

});
parcelRegister("7WRna", function(module, exports) {

$parcel$export(module.exports, "ComponentScrollbar", function () { return $5e47137620251e9e$export$17759cda9c0355fc; });

var $8J94x = parcelRequire("8J94x");

var $gWkRP = parcelRequire("gWkRP");

var $d1ben = parcelRequire("d1ben");
class $5e47137620251e9e$export$17759cda9c0355fc {
    build() {
        if (this.component.element instanceof HTMLElement) {
            let template = `
                <div scrollTrack class="${$gWkRP.scrollVirtualTrack}">
                    <div scrollBar class="${$gWkRP.scrollVirtualBar}"></div>
                </div>`;
            this.component.prepend(template);
            this.track = this.component.el($gWkRP.scrollVirtualTrack);
            this.bar = this.component.el($gWkRP.scrollVirtualBar);
            this.component.addClass($gWkRP.scrollVirtual);
            if (this.autoPlace) {
                this.place();
                this.component.putListener(window, "resize", ()=>this.place());
            }
        }
    }
    binding() {
        this.bar.addListener("mousedown", (e)=>{
            this.onBarMouseDown(e);
        });
        this.track.addListener("click", (e)=>{
            this.onTrackClick(e);
        });
        this.component.onScroll(()=>this.onScrollResize());
        //this.component.onChange(() => this.onScrollResize());
        this.component.onResize(()=>this.onScrollResize());
        this.component.interval(()=>this.onScrollResize(), 500);
    }
    onScrollResize() {
        if (performance.now() - this.now > 1) {
            if (!(0, $d1ben.isTabletNative)() && this.component.element instanceof HTMLElement) {
                let difference = this.component.element.scrollHeight - this.component.element.clientHeight;
                if (difference <= 0) {
                    this.track.setStyle("display:none;");
                    this.component.removeClass($gWkRP.scrollVirtual);
                    (0, $8J94x.SedestralMachine).requestFrame()(()=>{
                        this.component.removeAttribute("scrollVirtual");
                    });
                } else {
                    this.track.setStyle("display:block;");
                    this.component.addClass($gWkRP.scrollVirtual);
                    this.component.setAttribute("scrollVirtual", "");
                }
                this.moveBar();
                this.timeOutResize = this.component.timeOut(()=>this.getTrackBounds(), 200);
            }
            this.now = performance.now();
        }
    }
    onDrag(e) {
        this.isDragging = true;
        let delta = e.pageY - this.lastPageY;
        (0, $8J94x.SedestralMachine).requestFrame()(()=>{
            let sTop = document.documentElement.scrollTop;
            let isDragWithinTrackBounds = e.pageY >= this.trackRect.top + sTop && e.pageY <= this.trackRect.bottom + sTop;
            if (isDragWithinTrackBounds) this.component.setScrollTop(this.dragScrollTop + delta / this.scrollRatio);
            else {
                this.dragScrollTop = this.component.getScrollTop();
                this.lastPageY = e.pageY;
            }
        });
    }
    onStopDrag(e) {
        this.bar.removeClass($gWkRP.scrollVirtualGrabbed);
        this.track.removeClass($gWkRP.scrollVirtualGrabbed);
        this.bar.removeAttribute("scrollGrabbed");
        this.track.removeAttribute("scrollGrabbed");
        document.body.classList.remove($gWkRP.scrollVirtualSelect);
        this.component.deleteListener(this.mouseDragListener);
        this.component.deleteListener(this.mouseStopDragListener);
        this.component.timeOut(()=>{
            this.isDragging = false;
        }, 100);
    }
    onBarMouseDown(e) {
        this.dragScrollTop = this.component.getScrollTop();
        this.lastPageY = e.pageY;
        this.bar.addClass($gWkRP.scrollVirtualGrabbed);
        this.track.addClass($gWkRP.scrollVirtualGrabbed);
        this.bar.setAttribute("scrollGrabbed", "");
        this.track.setAttribute("scrollGrabbed", "");
        document.body.classList.add($gWkRP.scrollVirtualSelect);
        this.mouseDragListener = this.component.putListener(window, "mousemove", (e)=>{
            this.onDrag(e);
        });
        this.mouseStopDragListener = this.component.putListener(window, "mouseup", (e)=>{
            this.onStopDrag(e);
        });
    }
    onTrackClick(e) {
        if (this.isDragging) return;
        if (this.component.element instanceof HTMLElement) {
            let perc = (e.clientY - this.trackRect.top) / (this.trackRect.height - this.trackRect["topPad"] - this.trackRect["bottomPad"]);
            let scrollHeight = this.component.element.scrollHeight;
            let ownHeight = this.component.element.clientHeight;
            let newScrollTop = perc * (scrollHeight - ownHeight);
            this.component.element.style.scrollBehavior = "smooth";
            this.component.timeOut(()=>{
                if (this.component.element instanceof HTMLElement) this.component.element.style.scrollBehavior = "unset";
            }, 500);
            this.component.element.scrollTop = newScrollTop;
        }
    }
    getTrackBounds() {
        if (this.track.element instanceof HTMLElement) {
            this.trackRect = this.track.element.getBoundingClientRect();
            let styles = window.getComputedStyle(this.track.element, undefined);
            this.trackRect["topPad"] = parseInt(styles.paddingTop, 10);
            this.trackRect["bottomPad"] = parseInt(styles.paddingBottom, 10);
        }
    }
    moveBar() {
        if (this.component.element instanceof HTMLElement && this.track.element instanceof HTMLElement) {
            let scrollHeight = this.component.element.scrollHeight;
            let clientHeight = this.component.element.clientHeight;
            this.scrollRatio = this.track.element.clientHeight / scrollHeight;
            (0, $8J94x.SedestralMachine).requestFrame()(()=>{
                if (this.component.element instanceof HTMLElement) {
                    let height = clientHeight / scrollHeight * 100;
                    let top = this.component.element.scrollTop / scrollHeight * 100;
                    this.bar.setStyle(`height:${height.toFixed(1)}%;top:${top.toFixed(1)}%;`);
                }
            });
        }
    }
    place() {
        this.track.setStyle(`position:fixed;transition:0s;right:${this.component.getOffsets().right + 2}px;height:${this.component.getHeight() - 8}px;top: ${this.component.getOffsets().top + 4}px;`);
        (0, $8J94x.SedestralMachine).requestFrame()(()=>this.track.setStyle(`transition: 0.1s`));
    }
    constructor(component, autoPlace){
        this.track = undefined;
        this.bar = undefined;
        this.dragScrollTop = 0;
        this.timeOutResize = 0;
        this.isDragging = false;
        this.trackRect = undefined;
        this.scrollRatio = 1;
        this.component = component;
        this.now = performance.now();
        this.autoPlace = autoPlace;
        this.build();
        this.binding();
    }
}

});
parcelRegister("gWkRP", function(module, exports) {

$parcel$export(module.exports, "scrollVirtual", function () { return $c5523fe4779efc04$export$c05bc4a5d5bdd591; }, function (v) { return $c5523fe4779efc04$export$c05bc4a5d5bdd591 = v; });
$parcel$export(module.exports, "scrollVirtualTrack", function () { return $c5523fe4779efc04$export$f006a8e874a0c0c2; }, function (v) { return $c5523fe4779efc04$export$f006a8e874a0c0c2 = v; });
$parcel$export(module.exports, "scrollVirtualBar", function () { return $c5523fe4779efc04$export$f95b7f37ecd6af3f; }, function (v) { return $c5523fe4779efc04$export$f95b7f37ecd6af3f = v; });
$parcel$export(module.exports, "scrollVirtualSelect", function () { return $c5523fe4779efc04$export$baea668a85f138e4; }, function (v) { return $c5523fe4779efc04$export$baea668a85f138e4 = v; });
$parcel$export(module.exports, "scrollVirtualGrabbed", function () { return $c5523fe4779efc04$export$7fde6f40368c3f64; }, function (v) { return $c5523fe4779efc04$export$7fde6f40368c3f64 = v; });
var $c5523fe4779efc04$export$c05bc4a5d5bdd591;
var $c5523fe4779efc04$export$f006a8e874a0c0c2;
var $c5523fe4779efc04$export$f95b7f37ecd6af3f;
var $c5523fe4779efc04$export$baea668a85f138e4;
var $c5523fe4779efc04$export$7fde6f40368c3f64;
$c5523fe4779efc04$export$c05bc4a5d5bdd591 = "LsB2h";
$c5523fe4779efc04$export$f006a8e874a0c0c2 = "RWcIP";
$c5523fe4779efc04$export$f95b7f37ecd6af3f = "kf3pr";
$c5523fe4779efc04$export$baea668a85f138e4 = "dQA8W";
$c5523fe4779efc04$export$7fde6f40368c3f64 = "nDSm1";

});

parcelRegister("d1ben", function(module, exports) {

$parcel$export(module.exports, "isTabletNative", function () { return $f3ac6f7a3b159ea9$export$3d3a4f4557ce39f9; });
/**
 * Vérifie si la largeur est inférieur à 450px
 */ 
var $hEeUt = parcelRequire("hEeUt");
function $f3ac6f7a3b159ea9$export$3d3a4f4557ce39f9() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= 970 && (0, $hEeUt.IS_NATIVE);
}

});
parcelRegister("hEeUt", function(module, exports) {

$parcel$export(module.exports, "IS_NATIVE", function () { return $d44de88b02d7f6a1$export$b8b535c3ef3eecc4; });
$parcel$export(module.exports, "IMG_EMPTY", function () { return $d44de88b02d7f6a1$export$d43b17a7dbe4169b; });
let $d44de88b02d7f6a1$export$b8b535c3ef3eecc4 = false;
const $d44de88b02d7f6a1$export$e5ab80781acdc6e8 = 16732543783000;
const $d44de88b02d7f6a1$export$fa5433ab32a7595b = 20;
const $d44de88b02d7f6a1$export$d43b17a7dbe4169b = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

});



parcelRegister("i3Hbv", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $d25a015a8f8adc65$export$d1203567a167490e; });
$parcel$export(module.exports, "unobserve", function () { return $d25a015a8f8adc65$export$23a2283368c55ea2; });
$parcel$export(module.exports, "observable", function () { return $d25a015a8f8adc65$export$5ab46cbf6120b33a; });
var $d25a015a8f8adc65$var$connectionStore = new WeakMap();
var $d25a015a8f8adc65$var$ITERATION_KEY = Symbol("iteration key");
function $d25a015a8f8adc65$var$storeObservable(obj) {
    // this will be used to save (obj.key -> reaction) connections later
    $d25a015a8f8adc65$var$connectionStore.set(obj, new Map());
}
function $d25a015a8f8adc65$var$registerReactionForOperation(reaction, ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    if (type === "iterate") key = $d25a015a8f8adc65$var$ITERATION_KEY;
    var reactionsForObj = $d25a015a8f8adc65$var$connectionStore.get(target);
    var reactionsForKey = reactionsForObj.get(key);
    if (!reactionsForKey) {
        reactionsForKey = new Set();
        reactionsForObj.set(key, reactionsForKey);
    }
    // save the fact that the key is used by the reaction during its current run
    if (!reactionsForKey.has(reaction)) {
        reactionsForKey.add(reaction);
        reaction.cleaners.push(reactionsForKey);
    }
}
function $d25a015a8f8adc65$var$getReactionsForOperation(ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    var reactionsForTarget = $d25a015a8f8adc65$var$connectionStore.get(target);
    var reactionsForKey = new Set();
    if (type === "clear") reactionsForTarget.forEach(function(_, key) {
        $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    });
    else $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    if (type === "add" || type === "delete" || type === "clear") {
        var iterationKey = Array.isArray(target) ? "length" : $d25a015a8f8adc65$var$ITERATION_KEY;
        $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, iterationKey);
    }
    return reactionsForKey;
}
function $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key) {
    var reactions = reactionsForTarget.get(key);
    reactions && reactions.forEach(reactionsForKey.add, reactionsForKey);
}
function $d25a015a8f8adc65$var$releaseReaction(reaction) {
    if (reaction.cleaners) reaction.cleaners.forEach($d25a015a8f8adc65$var$releaseReactionKeyConnection, reaction);
    reaction.cleaners = [];
}
function $d25a015a8f8adc65$var$releaseReactionKeyConnection(reactionsForKey) {
    reactionsForKey.delete(this);
}
// reactions can call each other and form a call stack
var $d25a015a8f8adc65$var$reactionStack = [];
var $d25a015a8f8adc65$var$isDebugging = false;
function $d25a015a8f8adc65$var$runAsReaction(reaction, fn, context, args) {
    // do not build reactive relations, if the reaction is unobserved
    if (reaction.unobserved) return Reflect.apply(fn, context, args);
    // only run the reaction if it is not already in the reaction stack
    // TODO: improve this to allow explicitly recursive reactions
    if ($d25a015a8f8adc65$var$reactionStack.indexOf(reaction) === -1) {
        // release the (obj -> key -> reactions) connections
        // and reset the cleaner connections
        $d25a015a8f8adc65$var$releaseReaction(reaction);
        try {
            // set the reaction as the currently running one
            // this is required so that we can create (observable.prop -> reaction) pairs in the get trap
            $d25a015a8f8adc65$var$reactionStack.push(reaction);
            return Reflect.apply(fn, context, args);
        } finally{
            // always remove the currently running flag from the reaction when it stops execution
            $d25a015a8f8adc65$var$reactionStack.pop();
        }
    }
}
// register the currently running reaction to be queued again on obj.key mutations
function $d25a015a8f8adc65$var$registerRunningReactionForOperation(operation) {
    // get the current reaction from the top of the stack
    var runningReaction = $d25a015a8f8adc65$var$reactionStack[$d25a015a8f8adc65$var$reactionStack.length - 1];
    if (runningReaction) {
        $d25a015a8f8adc65$var$debugOperation(runningReaction, operation);
        $d25a015a8f8adc65$var$registerReactionForOperation(runningReaction, operation);
    }
}
function $d25a015a8f8adc65$var$queueReactionsForOperation(operation) {
    // iterate and queue every reaction, which is triggered by obj.key mutation
    $d25a015a8f8adc65$var$getReactionsForOperation(operation).forEach($d25a015a8f8adc65$var$queueReaction, operation);
}
function $d25a015a8f8adc65$var$queueReaction(reaction) {
    $d25a015a8f8adc65$var$debugOperation(reaction, this);
    // queue the reaction for later execution or run it immediately
    if (typeof reaction.scheduler === "function") reaction.scheduler(reaction);
    else if (typeof reaction.scheduler === "object") reaction.scheduler.add(reaction);
    else reaction();
}
function $d25a015a8f8adc65$var$debugOperation(reaction, operation) {
    if (reaction.debugger && !$d25a015a8f8adc65$var$isDebugging) try {
        $d25a015a8f8adc65$var$isDebugging = true;
        reaction.debugger(operation);
    } finally{
        $d25a015a8f8adc65$var$isDebugging = false;
    }
}
function $d25a015a8f8adc65$var$hasRunningReaction() {
    return $d25a015a8f8adc65$var$reactionStack.length > 0;
}
var $d25a015a8f8adc65$var$IS_REACTION = Symbol("is reaction");
function $d25a015a8f8adc65$export$d1203567a167490e(fn, options) {
    if (options === void 0) options = {};
    // wrap the passed function in a reaction, if it is not already one
    var reaction = fn[$d25a015a8f8adc65$var$IS_REACTION] ? fn : function reaction() {
        return $d25a015a8f8adc65$var$runAsReaction(reaction, fn, this, arguments);
    };
    // save the scheduler and debugger on the reaction
    reaction.scheduler = options.scheduler;
    reaction.debugger = options.debugger;
    // save the fact that this is a reaction
    reaction[$d25a015a8f8adc65$var$IS_REACTION] = true;
    // run the reaction once if it is not a lazy one
    if (!options.lazy) reaction();
    return reaction;
}
function $d25a015a8f8adc65$export$23a2283368c55ea2(reaction) {
    // do nothing, if the reaction is already unobserved
    if (!reaction.unobserved) {
        // indicate that the reaction should not be triggered any more
        reaction.unobserved = true;
        // release (obj -> key -> reaction) connections
        $d25a015a8f8adc65$var$releaseReaction(reaction);
    }
    // unschedule the reaction, if it is scheduled
    if (typeof reaction.scheduler === "object") reaction.scheduler.delete(reaction);
}
var $d25a015a8f8adc65$var$proxyToRaw = new WeakMap();
var $d25a015a8f8adc65$var$rawToProxy = new WeakMap();
var $d25a015a8f8adc65$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d25a015a8f8adc65$var$findObservable(obj) {
    var observableObj = $d25a015a8f8adc65$var$rawToProxy.get(obj);
    if ($d25a015a8f8adc65$var$hasRunningReaction() && typeof obj === "object" && obj !== null) {
        if (observableObj) return observableObj;
        return $d25a015a8f8adc65$export$5ab46cbf6120b33a(obj);
    }
    return observableObj || obj;
}
function $d25a015a8f8adc65$var$patchIterator(iterator, isEntries) {
    var originalNext = iterator.next;
    iterator.next = function() {
        var ref = originalNext.call(iterator);
        var done = ref.done;
        var value = ref.value;
        if (!done) {
            if (isEntries) value[1] = $d25a015a8f8adc65$var$findObservable(value[1]);
            else value = $d25a015a8f8adc65$var$findObservable(value);
        }
        return {
            done: done,
            value: value
        };
    };
    return iterator;
}
var $d25a015a8f8adc65$var$instrumentations = {
    has: function has(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: "has"
        });
        return proto.has.apply(target, arguments);
    },
    get: function get(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: "get"
        });
        return $d25a015a8f8adc65$var$findObservable(proto.get.apply(target, arguments));
    },
    add: function add(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.add.apply(target, arguments);
        if (!hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: key,
            type: "add"
        });
        return result;
    },
    set: function set(key, value) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.set.apply(target, arguments);
        if (!hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            type: "add"
        });
        else if (value !== oldValue) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            oldValue: oldValue,
            type: "set"
        });
        return result;
    },
    delete: function delete$1(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get ? proto.get.call(target, key) : undefined;
        // forward the operation before queueing reactions
        var result = proto.delete.apply(target, arguments);
        if (hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            oldValue: oldValue,
            type: "delete"
        });
        return result;
    },
    clear: function clear() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadItems = target.size !== 0;
        var oldTarget = target instanceof Map ? new Map(target) : new Set(target);
        // forward the operation before queueing reactions
        var result = proto.clear.apply(target, arguments);
        if (hadItems) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            oldTarget: oldTarget,
            type: "clear"
        });
        return result;
    },
    forEach: function forEach(cb) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: "iterate"
        });
        // swap out the raw values with their observable pairs
        // before passing them to the callback
        var wrappedCb = function(value) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            return cb.apply(void 0, [
                $d25a015a8f8adc65$var$findObservable(value)
            ].concat(rest));
        };
        var ref;
        return (ref = proto.forEach).call.apply(ref, [
            target,
            wrappedCb
        ].concat(args));
    },
    keys: function keys() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: "iterate"
        });
        return proto.keys.apply(target, arguments);
    },
    values: function values() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: "iterate"
        });
        var iterator = proto.values.apply(target, arguments);
        return $d25a015a8f8adc65$var$patchIterator(iterator, false);
    },
    entries: function entries() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: "iterate"
        });
        var iterator = proto.entries.apply(target, arguments);
        return $d25a015a8f8adc65$var$patchIterator(iterator, true);
    },
    get size () {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: "iterate"
        });
        return Reflect.get(proto, "size", target);
    }
};
$d25a015a8f8adc65$var$instrumentations[Symbol.iterator] = function() {
    var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
    var proto = Reflect.getPrototypeOf(this);
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        type: "iterate"
    });
    var iterator = proto[Symbol.iterator].apply(target, arguments);
    return $d25a015a8f8adc65$var$patchIterator(iterator, target instanceof Map);
};
var $d25a015a8f8adc65$var$collectionHandlers = {
    get: function get(target, key, receiver) {
        // instrument methods and property accessors to be reactive
        target = $d25a015a8f8adc65$var$hasOwnProperty.call($d25a015a8f8adc65$var$instrumentations, key) ? $d25a015a8f8adc65$var$instrumentations : target;
        return Reflect.get(target, key, receiver);
    }
};
// eslint-disable-next-line
var $d25a015a8f8adc65$var$globalObj = typeof window === "object" ? window : Function("return this")();
// built-in object can not be wrapped by Proxies
// their methods expect the object instance as the 'this' instead of the Proxy wrapper
// complex objects are wrapped with a Proxy of instrumented methods
// which switch the proxy to the raw object and to add reactive wiring
var $d25a015a8f8adc65$var$handlers = new Map([
    [
        Map,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        Set,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        WeakMap,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        WeakSet,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        Object,
        false
    ],
    [
        Array,
        false
    ],
    [
        Int8Array,
        false
    ],
    [
        Uint8Array,
        false
    ],
    [
        Uint8ClampedArray,
        false
    ],
    [
        Int16Array,
        false
    ],
    [
        Uint16Array,
        false
    ],
    [
        Int32Array,
        false
    ],
    [
        Uint32Array,
        false
    ],
    [
        Float32Array,
        false
    ],
    [
        Float64Array,
        false
    ]
]);
function $d25a015a8f8adc65$var$shouldInstrument(ref) {
    var constructor = ref.constructor;
    var isBuiltIn = typeof constructor === "function" && constructor.name in $d25a015a8f8adc65$var$globalObj && $d25a015a8f8adc65$var$globalObj[constructor.name] === constructor;
    return !isBuiltIn || $d25a015a8f8adc65$var$handlers.has(constructor);
}
function $d25a015a8f8adc65$var$getHandlers(obj) {
    return $d25a015a8f8adc65$var$handlers.get(obj.constructor);
}
var $d25a015a8f8adc65$var$hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $d25a015a8f8adc65$var$wellKnownSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter(function(value) {
    return typeof value === "symbol";
}));
// intercept get operations on observables to know which reaction uses their properties
function $d25a015a8f8adc65$var$get(target, key, receiver) {
    var result = Reflect.get(target, key, receiver);
    // do not register (observable.prop -> reaction) pairs for well known symbols
    // these symbols are frequently retrieved in low level JavaScript under the hood
    if (typeof key === "symbol" && $d25a015a8f8adc65$var$wellKnownSymbols.has(key)) return result;
    // register and save (observable.prop -> runningReaction)
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        receiver: receiver,
        type: "get"
    });
    // if we are inside a reaction and observable.prop is an object wrap it in an observable too
    // this is needed to intercept property access on that object too (dynamic observable tree)
    var observableResult = $d25a015a8f8adc65$var$rawToProxy.get(result);
    if ($d25a015a8f8adc65$var$hasRunningReaction() && typeof result === "object" && result !== null) {
        if (observableResult) return observableResult;
        // do not violate the none-configurable none-writable prop get handler invariant
        // fall back to none reactive mode in this case, instead of letting the Proxy throw a TypeError
        var descriptor = Reflect.getOwnPropertyDescriptor(target, key);
        if (!descriptor || !(descriptor.writable === false && descriptor.configurable === false)) return $d25a015a8f8adc65$export$5ab46cbf6120b33a(result);
    }
    // otherwise return the observable wrapper if it is already created and cached or the raw object
    return observableResult || result;
}
function $d25a015a8f8adc65$var$has(target, key) {
    var result = Reflect.has(target, key);
    // register and save (observable.prop -> runningReaction)
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        type: "has"
    });
    return result;
}
function $d25a015a8f8adc65$var$ownKeys(target) {
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        type: "iterate"
    });
    return Reflect.ownKeys(target);
}
// intercept set operations on observables to know when to trigger reactions
function $d25a015a8f8adc65$var$set(target, key, value, receiver) {
    // make sure to do not pollute the raw object with observables
    if (typeof value === "object" && value !== null) value = $d25a015a8f8adc65$var$proxyToRaw.get(value) || value;
    // save if the object had a descriptor for this key
    var hadKey = $d25a015a8f8adc65$var$hasOwnProperty$1.call(target, key);
    // save if the value changed because of this set operation
    var oldValue = target[key];
    // execute the set operation before running any reaction
    var result = Reflect.set(target, key, value, receiver);
    // do not queue reactions if the target of the operation is not the raw receiver
    // (possible because of prototypal inheritance)
    if (target !== $d25a015a8f8adc65$var$proxyToRaw.get(receiver)) return result;
    // queue a reaction if it's a new property or its value changed
    if (!hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        receiver: receiver,
        type: "add"
    });
    else if (value !== oldValue) $d25a015a8f8adc65$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        oldValue: oldValue,
        receiver: receiver,
        type: "set"
    });
    return result;
}
function $d25a015a8f8adc65$var$deleteProperty(target, key) {
    // save if the object had the key
    var hadKey = $d25a015a8f8adc65$var$hasOwnProperty$1.call(target, key);
    var oldValue = target[key];
    // execute the delete operation before running any reaction
    var result = Reflect.deleteProperty(target, key);
    // only queue reactions for delete operations which resulted in an actual change
    if (hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
        target: target,
        key: key,
        oldValue: oldValue,
        type: "delete"
    });
    return result;
}
var $d25a015a8f8adc65$var$baseHandlers = {
    get: $d25a015a8f8adc65$var$get,
    has: $d25a015a8f8adc65$var$has,
    ownKeys: $d25a015a8f8adc65$var$ownKeys,
    set: $d25a015a8f8adc65$var$set,
    deleteProperty: $d25a015a8f8adc65$var$deleteProperty
};
function $d25a015a8f8adc65$export$5ab46cbf6120b33a(obj) {
    if (obj === void 0) obj = {};
    // if it is already an observable or it should not be wrapped, return it
    if ($d25a015a8f8adc65$var$proxyToRaw.has(obj) || !$d25a015a8f8adc65$var$shouldInstrument(obj)) return obj;
    // if it already has a cached observable wrapper, return it
    // otherwise create a new observable
    return $d25a015a8f8adc65$var$rawToProxy.get(obj) || $d25a015a8f8adc65$var$createObservable(obj);
}
function $d25a015a8f8adc65$var$createObservable(obj) {
    // if it is a complex built-in object or a normal object, wrap it
    var handlers = $d25a015a8f8adc65$var$getHandlers(obj) || $d25a015a8f8adc65$var$baseHandlers;
    var observable = new Proxy(obj, handlers);
    // save these to switch between the raw object and the wrapped object with ease later
    $d25a015a8f8adc65$var$rawToProxy.set(obj, observable);
    $d25a015a8f8adc65$var$proxyToRaw.set(observable, obj);
    // init basic data structures to save and cleanup later (observable.prop -> reaction) connections
    $d25a015a8f8adc65$var$storeObservable(obj);
    return observable;
}
function $d25a015a8f8adc65$export$5cd057a6046189f9(obj) {
    return $d25a015a8f8adc65$var$proxyToRaw.has(obj);
}
function $d25a015a8f8adc65$export$1776c186c69df29e(obj) {
    return $d25a015a8f8adc65$var$proxyToRaw.get(obj) || obj;
}

});

parcelRegister("1IWI5", function(module, exports) {

$parcel$export(module.exports, "ComponentTooltip", function () { return $6fb1f77b640bab21$export$5e82891434456073; });

var $iJHeF = parcelRequire("iJHeF");

var $iSiUq = parcelRequire("iSiUq");

var $2HHsV = parcelRequire("2HHsV");

var $gvC7k = parcelRequire("gvC7k");
class $6fb1f77b640bab21$export$5e82891434456073 {
    place(replace) {
        switch(this.preference){
            case "left":
                this.placeLeft();
                break;
            case "leftTop":
                this.placeLeftTop();
                break;
            case "rightTop":
                this.placeRightTop();
                break;
            case "right":
                this.placeRight();
                break;
            case "bottom":
                this.placeBottom();
                break;
            default:
                this.placeTop();
                break;
        }
        let tooltipOffsets = (0, $gvC7k.elementOffsets)(this.tooltipComponent.element);
        if (this.isOutside(tooltipOffsets)) {
            let places = [
                "placeTop",
                "placeRight",
                "placeBottom",
                "placeLeft"
            ];
            if (this.preference == "leftTop") places = [
                "placeTop",
                "placeLeft",
                "placeBottom",
                "placeRight"
            ];
            for (let placeFunc of places){
                this[placeFunc]();
                tooltipOffsets = (0, $gvC7k.elementOffsets)(this.tooltipComponent.element);
                if (!this.isOutside(tooltipOffsets)) break;
            }
        }
        if (!this.noAnimation) {
            if (!replace) {
                this.tooltipComponent.setStyle(`opacity:0;transform:scale(0.9);`);
                this.tooltipComponent.translate({
                    delay: 40,
                    opacity: 1,
                    scale: 1
                });
            } else this.tooltipComponent.setStyle(`transition-duration: 0s;`);
        } else this.tooltipComponent.setStyle(`transition-duration: 0s;opacity:1;transform:scale(1);`);
    }
    replace() {
        let timeNow = performance.now();
        if (timeNow - 1 > this.time) {
            this.time = timeNow;
            this.place(true);
        }
    }
    placeTop() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let left = offsets.left + (this.component.getWidth() / 2 - this.tooltipComponent.getWidth() / 2);
        let top = offsets.top - this.tooltipComponent.getHeight() - 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowTop();
    }
    placeBottom() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let left = offsets.left + (this.component.getWidth() / 2 - this.tooltipComponent.getWidth() / 2);
        let top = offsets.top + this.component.getHeight() + 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowBottom();
    }
    placeLeftTop() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let left = offsets.left;
        let top = offsets.top - this.tooltipComponent.getHeight() - 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowLeftTop();
    }
    placeRightTop() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let left = offsets.left + this.component.getWidth() - this.tooltipComponent.getWidth();
        let top = offsets.top - this.tooltipComponent.getHeight() - 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowRightTop();
    }
    placeLeft() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let left = offsets.left - this.tooltipComponent.getWidth() - 8;
        let top = offsets.top + this.component.getHeight() / 2 - this.tooltipComponent.getHeight() / 2;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowLeft();
    }
    placeRight() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let left = offsets.left + this.component.getWidth() + 8;
        let top = offsets.top + this.component.getHeight() / 2 - this.tooltipComponent.getHeight() / 2;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowRight();
    }
    placeArrowLeft() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let tooltipOffsets = (0, $gvC7k.elementOffsets)(this.tooltipComponent.element);
        this.tooltipComponent.el($2HHsV.arrow).setStyle(`right:-5px;left:unset;bottom:unset;top:${offsets.top - tooltipOffsets.top + (this.component.getHeight() / 2 - 5)}px`);
    }
    placeArrowLeftTop() {
        let left = this.tooltipComponent.getWidth() / 2 - 5;
        this.tooltipComponent.el($2HHsV.arrow).setStyle(`bottom:-5px;right:unset;top:unset;left:${left > 15 ? 15 : left}px`);
    }
    placeArrowRightTop() {
        let left = this.tooltipComponent.getWidth() / 2 - 5;
        this.tooltipComponent.el($2HHsV.arrow).setStyle(`bottom:-5px;right:unset;top:unset;right:${left > 15 ? 15 : left}px`);
    }
    placeArrowRight() {
        this.placeArrowLeft();
        this.tooltipComponent.el($2HHsV.arrow).setStyle(`left:-5px;right:unset;`);
    }
    placeArrowTop() {
        let offsets = (0, $gvC7k.elementOffsets)(this.component.element);
        let tooltipOffsets = (0, $gvC7k.elementOffsets)(this.tooltipComponent.element);
        this.tooltipComponent.el($2HHsV.arrow).setStyle(`bottom:-5px;right:unset;top:unset;left:${offsets.left - tooltipOffsets.left + (this.component.getWidth() / 2 - 5)}px`);
    }
    placeArrowBottom() {
        this.placeArrowTop();
        this.tooltipComponent.el($2HHsV.arrow).setStyle(`bottom:unset;top:-5px`);
    }
    isOutside(offsets) {
        return offsets.top < -1 || offsets.left < -1 || offsets.right < -1 || offsets.bottom < -1;
    }
    async dispose() {
        if (!this.noAnimation) await this.tooltipComponent.translate({
            delay: 40,
            opacity: 0,
            scale: 0.9
        });
        if (!this.tooltipComponent.isNull()) this.tooltipComponent.remove();
    }
    constructor(component, template, preference, noAnimation){
        this.component = component;
        this.hoverDelay = 0;
        this.leaveDelay = 0;
        this.time = performance.now();
        this.noAnimation = noAnimation;
        this.preference = preference;
        this.tooltipComponent = new (0, $iJHeF.Component)();
        //language=HTML
        this.tooltipComponent.template = `
            <div class="${$2HHsV.tooltip}">
                <div class="${$2HHsV.content}">
                    ${typeof template == "string" ? template : this.tooltipComponent.draw(template())}
                </div>
                <div class="${$2HHsV.arrow}"></div>
            </div>
        `;
        (0, $iSiUq.SedestralInterface).main.render(this.tooltipComponent);
        (0, $iSiUq.SedestralInterface).main.removeChildren(this.tooltipComponent);
        this.component.onLeave(async ()=>this.dispose());
        this.tooltipComponent.putListener(window, "resize", ()=>this.replace());
        this.tooltipComponent.putListener(window, "scroll", ()=>this.replace(), true);
        this.place();
    }
}

});
parcelRegister("2HHsV", function(module, exports) {

$parcel$export(module.exports, "tooltip", function () { return $1f81504553cf2496$export$4e6f96734dfe12f4; }, function (v) { return $1f81504553cf2496$export$4e6f96734dfe12f4 = v; });
$parcel$export(module.exports, "arrow", function () { return $1f81504553cf2496$export$f2120bbfa5450bd2; }, function (v) { return $1f81504553cf2496$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "content", function () { return $1f81504553cf2496$export$a7db06668cad9adb; }, function (v) { return $1f81504553cf2496$export$a7db06668cad9adb = v; });
var $1f81504553cf2496$export$4e6f96734dfe12f4;
var $1f81504553cf2496$export$f2120bbfa5450bd2;
var $1f81504553cf2496$export$a7db06668cad9adb;
$1f81504553cf2496$export$4e6f96734dfe12f4 = "MifWe";
$1f81504553cf2496$export$f2120bbfa5450bd2 = "ffBJp";
$1f81504553cf2496$export$a7db06668cad9adb = "zELri";

});

parcelRegister("gvC7k", function(module, exports) {

$parcel$export(module.exports, "elementOffsets", function () { return $f05e7cdbf4a272a3$export$ee0dccb429ca5135; });
function $f05e7cdbf4a272a3$export$ee0dccb429ca5135(element) {
    if (element instanceof HTMLElement) {
        let offsets = element.getBoundingClientRect();
        return {
            top: offsets.top,
            left: offsets.left,
            right: window.innerWidth - (offsets.left + element.clientWidth),
            bottom: window.innerHeight - (offsets.top + element.clientHeight)
        };
    }
}

});


parcelRegister("ecrPc", function(module, exports) {

$parcel$export(module.exports, "ComponentSwapBar", function () { return $2d00a843064991a6$export$db3c68524c9422f3; });

var $fhjLo = parcelRequire("fhjLo");

var $4sByH = parcelRequire("4sByH");
class $2d00a843064991a6$export$db3c68524c9422f3 {
    init() {
        this.component.addClass($fhjLo.swap);
        //language=HTML
        let selector = this.component.prepend(`
            <div swapBar class="${$fhjLo.swapBar}">
                <div class="${$fhjLo.bar}"></div>
            </div>
        `);
        let swiper = (0, $4sByH.onSwipe)(selector, this.component);
        swiper.onDown = ()=>this.onDispose();
    }
    constructor(component, onDispose){
        this.component = component;
        this.onDispose = onDispose;
        this.init();
    }
}

});
parcelRegister("fhjLo", function(module, exports) {

$parcel$export(module.exports, "swapBar", function () { return $b1f7c623df416bd5$export$e77117ea01f7e7b4; }, function (v) { return $b1f7c623df416bd5$export$e77117ea01f7e7b4 = v; });
$parcel$export(module.exports, "bar", function () { return $b1f7c623df416bd5$export$d927737047eb3867; }, function (v) { return $b1f7c623df416bd5$export$d927737047eb3867 = v; });
$parcel$export(module.exports, "swap", function () { return $b1f7c623df416bd5$export$b0e76d9850c64156; }, function (v) { return $b1f7c623df416bd5$export$b0e76d9850c64156 = v; });
var $b1f7c623df416bd5$export$e77117ea01f7e7b4;
var $b1f7c623df416bd5$export$d927737047eb3867;
var $b1f7c623df416bd5$export$b0e76d9850c64156;
$b1f7c623df416bd5$export$e77117ea01f7e7b4 = "zuPEc";
$b1f7c623df416bd5$export$d927737047eb3867 = "zHhZo";
$b1f7c623df416bd5$export$b0e76d9850c64156 = "-cgS8";

});

parcelRegister("4sByH", function(module, exports) {

$parcel$export(module.exports, "onSwipe", function () { return $add9e8f96a2eda67$export$84b1cb3e0372354b; });
/**
 * Swippable
 */ 
var $WU7ox = parcelRequire("WU7ox");
function $add9e8f96a2eda67$export$84b1cb3e0372354b(selector, component) {
    return new (0, $WU7ox.Swiper)(selector, component ? component : selector);
}

});
parcelRegister("WU7ox", function(module, exports) {

$parcel$export(module.exports, "Swiper", function () { return $622ce7be79da3151$export$6b3850921bc5a414; });

var $ljJAb = parcelRequire("ljJAb");
class $622ce7be79da3151$export$6b3850921bc5a414 {
    /**
     * override
     */ onLeft() {}
    onRight() {}
    onUp() {}
    onDown() {}
    constructor(selector, component){
        this.yCurrent = 0;
        this.selector = selector;
        component.addListener("touchend", (evt)=>{
            let percent = component.getHeight() / 4;
            if (this.yCurrent > percent) this.onDown();
            else component.setStyle(`bottom:0px !important;transition:0.4s;`);
            this.yCurrent = 0;
        });
        (0, $ljJAb.onDrag)(selector, (left, top)=>{
            if (top > 0) {
                this.yCurrent = top;
                component.setStyle(`bottom:calc(${-top}px - env(safe-area-inset-top)) !important;transition:0s;`);
            }
        });
    }
}

});
parcelRegister("ljJAb", function(module, exports) {

$parcel$export(module.exports, "onDrag", function () { return $d012ff8de3ceffa9$export$11a07b18d6f8f6d2; });

var $iSiUq = parcelRequire("iSiUq");
function $d012ff8de3ceffa9$export$11a07b18d6f8f6d2(component, func, onFinish, selector) {
    let initX, initY, mousePressX, mousePressY;
    let down = false;
    let tDown = false;
    let moveListener = undefined;
    let upListener = undefined;
    let tMoveListener = undefined;
    let tUpListener = undefined;
    let componentListener = selector ? selector : component;
    let touchDown = (e)=>{
        (0, $iSiUq.SedestralInterface).body.setStyle(`user-select:none;`);
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = e.touches[0].pageX;
            mousePressY = e.touches[0].pageY;
            tDown = true;
            tMoveListener = componentListener.putListener(window, "touchmove", move);
            tUpListener = componentListener.putListener(window, "touchend", touchUp);
        }
    };
    let touchUp = (e)=>{
        (0, $iSiUq.SedestralInterface).body.setStyle(`user-select:unset;`);
        if (tDown) {
            tDown = false;
            componentListener.deleteListener(tMoveListener);
            componentListener.deleteListener(tUpListener);
            if (onFinish) onFinish();
        }
    };
    let mouseDown = (event)=>{
        (0, $iSiUq.SedestralInterface).body.setStyle(`user-select:none;`);
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = event.pageX;
            mousePressY = event.pageY;
            down = true;
            moveListener = componentListener.putListener(window, "mousemove", move);
            upListener = componentListener.putListener(window, "mouseup", mouseUp);
        }
    };
    let mouseUp = ()=>{
        (0, $iSiUq.SedestralInterface).body.setStyle(`user-select:unset;`);
        if (down) {
            down = false;
            componentListener.deleteListener(moveListener);
            componentListener.deleteListener(upListener);
            if (onFinish) onFinish();
        }
    };
    componentListener.addListener("touchstart", touchDown);
    componentListener.addListener("mousedown", mouseDown);
    let move = (event)=>{
        if (tDown) {
            let left = initX + event.touches[0].pageX - mousePressX;
            let top = initY + event.touches[0].pageY - mousePressY;
            func(left, top);
        }
        if (down) {
            let left = initX + event.pageX - mousePressX;
            let top = initY + event.pageY - mousePressY;
            func(left, top);
        }
    };
}

});




parcelRegister("c1R3d", function(module, exports) {

$parcel$export(module.exports, "SedestralDebugger", function () { return $044a56e23c6347ec$export$455e2f1284cdadf9; });

var $iSiUq = parcelRequire("iSiUq");

var $271MM = parcelRequire("271MM");

class $044a56e23c6347ec$export$455e2f1284cdadf9 {
    static async init() {
        if ((0, $271MM.config).rumEnabled) try {
            this.rum = new (await (parcelRequire("kOkc5"))).SedestralRum();
        } catch (e) {
            console.error(e);
        }
        window.onerror = (error, url, line, column, e)=>{
            /*
            console.log(error);
            console.log(url);
            console.log(line);
            console.log(column);

             */ this.addError("UNDEFINED", e);
        };
        window.onabort = ()=>{
            console.log("abort");
        };
    }
    static addError(title, error) {
        if (error) {
            var _this_rum;
            let now = performance.now();
            let listeners = this.listenersLogs.filter((value)=>value.time > now - 100);
            let trace = listeners.map((value)=>value.log).join("\n=> ");
            console.log("%c" + title, "color: white;font-size:14px;background:red;padding:3px;");
            if (listeners.length > 0) console.log("=> " + trace);
            console.error(error);
            (_this_rum = this.rum) === null || _this_rum === void 0 ? void 0 : _this_rum.error(error, trace);
        }
    }
    static eventTarget(component, name) {
        let child = (0, $iSiUq.SedestralInterface).components.filter((value)=>value.childrens.find((value)=>value == component) != undefined)[0];
        this.listenersLogs.push({
            log: "[[" + name + " - " + (child == undefined ? "" : child.constructor.name) + " - " + component.constructor.name + " - " + component.element["className"] + "]]",
            time: performance.now()
        });
    }
}
$044a56e23c6347ec$export$455e2f1284cdadf9.listenersLogs = [];

});

parcelRegister("2xlLE", function(module, exports) {

$parcel$export(module.exports, "elementChildrens", function () { return $94f5981ea6f655e9$export$7ee75abb6f48dde2; });
/**
 * retourne tous les enfants d'un élément ainsi que lui même
 */ function $94f5981ea6f655e9$export$7ee75abb6f48dde2(element) {
    let elements = [];
    let childs = element.getElementsByTagName("*");
    for (let child of childs)elements.push(child);
    elements.push(element);
    return elements;
}

});

parcelRegister("dIuUJ", function(module, exports) {

$parcel$export(module.exports, "elementNotChildren", function () { return $915ae8bff9ac79d1$export$81078fe376cc4110; });
/**
 * Vérifie si un élément n'est pas le fils
 */ function $915ae8bff9ac79d1$export$81078fe376cc4110(parent, element) {
    let childrens = Array.from(parent.getElementsByTagName("*"));
    if (element != parent && childrens.indexOf(element) == -1) return true;
}

});

parcelRegister("5EBOf", function(module, exports) {

$parcel$export(module.exports, "elementHasClass", function () { return $4c024f49565e9e6c$export$2122b72d0e83e4af; });
/**
 * Vérifie si un élément a une class
 */ function $4c024f49565e9e6c$export$2122b72d0e83e4af(classes, name) {
    if (typeof classes == "undefined" || classes == "") return false;
    return !!classes.match(new RegExp("(\\s|^)" + name + "(\\s|$)"));
}

});

parcelRegister("7s7Z1", function(module, exports) {

$parcel$export(module.exports, "elementParents", function () { return $4be61371edef6e7c$export$aedc7b608ca8e855; });
/**
 * Retourne la liste des parents des éléments
 */ function $4be61371edef6e7c$export$aedc7b608ca8e855(element) {
    let nodes = [];
    nodes.push(element);
    while(element.parentNode){
        nodes.unshift(element.parentNode);
        element = element.parentNode;
    }
    return nodes;
}

});

parcelRegister("86gWV", function(module, exports) {

$parcel$export(module.exports, "filterXSS", function () { return $908d2ee7fadc9c7e$export$95c1dcf5e40cf598; });

var $2im9I = parcelRequire("2im9I");
function $908d2ee7fadc9c7e$export$95c1dcf5e40cf598(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2im9I))).sanitize(string, {
        USE_PROFILES: {
            html: true
        }
    });
}

});
parcelRegister("2im9I", function(module, exports) {
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== "undefined" && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param {Array} array - The array to be cleaned.
   * @returns {Array} The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT
    });
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "3.1.6";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const remove = lookupGetter(ElementPrototype, "remove");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML("");
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        const HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ const _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ const _isNode = function _isNode(object) {
            return typeof Node === "function" && object instanceof Node;
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, " ");
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === "value" ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, " ");
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, " ");
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("1aMHk", function(module, exports) {

$parcel$export(module.exports, "randomString", function () { return $d27cf0b5f922b536$export$7fa8378418b4411e; });
/**
 * genere une chaine de caractère aléatoire
 */ function $d27cf0b5f922b536$export$7fa8378418b4411e(length, numbers) {
    let result = "";
    let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    if (numbers) characters += "0123456789";
    let charactersLength = characters.length;
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
}

});

parcelRegister("dZIKC", function(module, exports) {

$parcel$export(module.exports, "randomUUID", function () { return $20ecc43da4b6e799$export$f15387b9ab8915bf; });
/**
 * genere un identifiant UUID
 */ function $20ecc43da4b6e799$export$f15387b9ab8915bf() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}

});

parcelRegister("fksB7", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $d5ee3c126539a4a2$export$d0a8044dce8ff2fc; });
function $d5ee3c126539a4a2$export$d0a8044dce8ff2fc() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 600;
}

});



parcelRegister("3I7TG", function(module, exports) {

$parcel$export(module.exports, "txtSimpleLang", function () { return $75c0c595a1abf55d$export$9499e98ac7c1c42; });
/**
 * retourne un code unique de langue "fr-Fr" vers "fr"
 */ function $75c0c595a1abf55d$export$9499e98ac7c1c42(code) {
    return code.includes("-") ? code.split("-")[0] : code;
}

});

parcelRegister("esq0i", function(module, exports) {

$parcel$export(module.exports, "generateVendor", function () { return $d74dbaf1b801d070$export$866fc66270dcd090; });
/**
 * generer l'url vendor
 */ function $d74dbaf1b801d070$export$866fc66270dcd090(domain) {
    return new URL("vendor/", domain).toString();
}

});

parcelRegister("bi5k0", function(module, exports) {

$parcel$export(module.exports, "ProductName", function () { return $1c4f8fbe22f89fbb$export$acdfad52bc8c6626; });

var $kfkzw = parcelRequire("kfkzw");
class $1c4f8fbe22f89fbb$export$acdfad52bc8c6626 {
    static toString(type) {
        switch(type){
            case (0, $kfkzw.ProductType).SEDESTRAL:
                return "sedestral";
            case (0, $kfkzw.ProductType).INBOX:
                return "inbox";
            case (0, $kfkzw.ProductType).PUBLISHER:
                return "publisher";
            case (0, $kfkzw.ProductType).STATISTICS:
                return "statistics";
            case (0, $kfkzw.ProductType).CONTACTS:
                return "contacts";
            case (0, $kfkzw.ProductType).CHANNELS:
                return "channels";
            case (0, $kfkzw.ProductType).LIVECHAT:
                return "livechat";
            case (0, $kfkzw.ProductType).PANEL:
                return "panel";
            case (0, $kfkzw.ProductType).GENERAL:
                return "general";
            case (0, $kfkzw.ProductType).CHAT_BOT:
                return "chatBot";
            case (0, $kfkzw.ProductType).MAILS:
                return "mails";
            case (0, $kfkzw.ProductType).SELL:
                return "sell";
            case (0, $kfkzw.ProductType).ENGAGEMENT:
                return "engagement";
            case (0, $kfkzw.ProductType).ADVERTISING:
                return "advertising";
            case (0, $kfkzw.ProductType).MAILLING:
                return "mailling";
            case (0, $kfkzw.ProductType).MEDIAS:
                return "medias";
            case (0, $kfkzw.ProductType).CALENDAR:
                return "calendar";
            case (0, $kfkzw.ProductType).DOCUMENTS:
                return "documents";
            case (0, $kfkzw.ProductType).PRODUCTS:
                return "products";
            case (0, $kfkzw.ProductType).ESTIMATE:
                return "estimate";
            case (0, $kfkzw.ProductType).CONTACTS_GREY:
                return "contactsGrey";
            case (0, $kfkzw.ProductType).INBOX_GREY:
                return "inboxGrey";
            case (0, $kfkzw.ProductType).PUBLISHER_GREY:
                return "publisherGrey";
            case (0, $kfkzw.ProductType).HELPCENTER:
                return "helpCenter";
            case (0, $kfkzw.ProductType).WEBSITE:
                return "website";
            case (0, $kfkzw.ProductType).CLIENT_SERVICE:
                return "clientService";
            case (0, $kfkzw.ProductType).BLOG:
                return "blog";
            case (0, $kfkzw.ProductType).MOBILE:
                return "mobile";
            case (0, $kfkzw.ProductType).COMMUNITY:
                return "community";
            case (0, $kfkzw.ProductType).ADMIN:
                return "admin";
        }
    }
}

});


parcelRegister("btxlx", function(module, exports) {

$parcel$export(module.exports, "IAccountTwoFactorMethod", function () { return $82d4a3b23976e37d$export$195d311003943aa6; });
var $82d4a3b23976e37d$export$195d311003943aa6;
(function(IAccountTwoFactorMethod) {
    IAccountTwoFactorMethod[IAccountTwoFactorMethod["EMAIL"] = 1] = "EMAIL";
    IAccountTwoFactorMethod[IAccountTwoFactorMethod["TOTP"] = 2] = "TOTP";
})($82d4a3b23976e37d$export$195d311003943aa6 || ($82d4a3b23976e37d$export$195d311003943aa6 = {}));

});

parcelRegister("i00Q1", function(module, exports) {

$parcel$export(module.exports, "NetworkSocket", function () { return $fda1665b58771d3f$export$af02ff68916c531; });

var $k56Hb = parcelRequire("k56Hb");

var $2eT6g = parcelRequire("2eT6g");

var $8J94x = parcelRequire("8J94x");

var $68Z0d = parcelRequire("68Z0d");
class $fda1665b58771d3f$export$af02ff68916c531 {
    async start(options) {
        return (0, $8J94x.SedestralMachine).promise(async (started)=>{
            let success = await this.startConnectionTry(options, 0);
            if (success) this.socket.on("disconnect", ()=>{
                if (!this.logout) this.onDisconnect();
            });
            if (success) this.events.forEach((value)=>this.on(value.event, value.func));
            started(success);
        });
    }
    async startConnection(options) {
        return (0, $8J94x.SedestralMachine).promise((resolve)=>{
            try {
                this.logout = false;
                this.socket = new (0, $k56Hb.NetworkSocketConnection)(options, this.host);
                this.socket.on("connect", ()=>resolve(true));
                this.socket.on("error", ()=>resolve(false));
            } catch (e) {
                resolve(false);
            }
        });
    }
    async startConnectionTry(options, attempts) {
        return (0, $8J94x.SedestralMachine).promise(async (resolve)=>{
            if (attempts < 3) {
                attempts++;
                let connected = await this.startConnection(options);
                if (connected) {
                    this.on((0, $2eT6g.WebSocketPanelEventName).CONNECTION_ERROR, async ()=>{
                        await (0, $8J94x.SedestralMachine).sleep(1000);
                        resolve(this.startConnectionTry(options, attempts));
                    });
                    this.on((0, $2eT6g.WebSocketPanelEventName).CONNECTION_READY, (data)=>{
                        (0, $68Z0d.EntityService).activeEntity.active = data;
                        resolve(true);
                    });
                } else {
                    await (0, $8J94x.SedestralMachine).sleep(1000);
                    resolve(this.startConnectionTry(options, attempts));
                }
            } else resolve(false);
        });
    }
    disconnect(logout) {
        this.socket.disconnect();
        this.socket = undefined;
        this.logout = logout;
    }
    emit(event, value) {
        this.socket.emit(event, value);
    }
    async emitSync(event, value) {
        return await this.socket.emitSync(event, value);
    }
    on(event, func) {
        if (!this.events.find((value)=>value.event == event)) this.events.push({
            event: event,
            func: func
        });
        if (this.socket) this.socket.on(event, func);
    }
    async join(data, route) {
        if (data != null) return await this.emitSync(route, data);
    }
    removeListener(event) {
        this.socket.removeListener(event);
    }
    /**
     * override
     */ onDisconnect() {}
    constructor(host){
        this.host = host;
        this.events = [];
    }
}

});
parcelRegister("k56Hb", function(module, exports) {

$parcel$export(module.exports, "NetworkSocketConnection", function () { return $15a872c8de3bdf0f$export$a82946cdc7ec341d; });

var $8J94x = parcelRequire("8J94x");
class $15a872c8de3bdf0f$export$a82946cdc7ec341d {
    bind() {
        this.ws.onclose = (data)=>{
            this.disconnectEvents.forEach((value)=>value.func(data));
            clearInterval(this.pingInterval);
        };
        this.ws.onopen = (data)=>{
            clearInterval(this.pingInterval);
            this.pingInterval = setInterval(()=>{
                this.ws.send("2");
            }, 14000);
            this.connectEvents.forEach((value)=>value.func(data));
        };
        this.ws.onerror = (data)=>{
            this.errorEvents.forEach((value)=>value.func(data));
            clearInterval(this.pingInterval);
        };
        this.ws.onmessage = (message)=>{
            //Si on reçoit un ping, on retourne un pong
            if (message.data == "2") this.ws.send("3");
            if (message.data.startsWith("42")) {
                let decoded = JSON.parse(message.data.substring(2));
                let events = this.events.filter((value)=>value.id == decoded[0]);
                events.forEach((event)=>{
                    event.func(decoded[1]);
                });
            }
        };
    }
    /**
     * listen
     */ on(id, func) {
        let event = {
            id: id,
            func: func
        };
        switch(id){
            case "disconnect":
                this.disconnectEvents.push(event);
                break;
            case "error":
                this.errorEvents.push(event);
                break;
            case "connect":
                this.connectEvents.push(event);
                break;
            default:
                this.events.push(event);
                break;
        }
        return event;
    }
    /**
     * emit
     */ emit(event, value) {
        let array = [
            event,
            value
        ];
        let content = `42${JSON.stringify(array)}`;
        this.ws.send(content);
    }
    async emitSync(id, value) {
        this.emit(id, value);
        return (0, $8J94x.SedestralMachine).promise(async (resolve)=>{
            let event = this.on(id, (data)=>{
                this.events.splice(this.events.indexOf(event), 1);
                resolve(data);
            });
        });
    }
    /**
     * logic
     */ close() {
        this.ws.close();
    }
    disconnect() {
        this.networkOnLogout = true;
        this.ws.close();
    }
    removeListener(event) {
        this.events = this.events.filter((value)=>value.id != event);
    }
    constructor(options, host){
        this.events = [];
        this.disconnectEvents = [];
        this.connectEvents = [];
        this.errorEvents = [];
        let site = options.siteId ? `&site=${options.siteId}` : ``;
        this.ws = new WebSocket(`${host}/?token=${options.activeToken}&type=${options.entityType}&EIO=3&transport=websocket${site}`);
        this.bind();
    }
}

});

parcelRegister("2eT6g", function(module, exports) {

$parcel$export(module.exports, "WebSocketPanelEventName", function () { return $7b0b33cebe0cb20a$export$379e1fa1a42f4e1e; });
class $7b0b33cebe0cb20a$export$379e1fa1a42f4e1e {
}
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONNECTION_READY = "connection/ready";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONNECTION_ERROR = "connection/error";
//manage room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_JOIN = "inbox/join" // receive join and compose inbox
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_LEAVE = "inbox/leave" // receive leave
;
//inbox room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_JOIN_ACCOUNT = "inbox/join/account" // compose account
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_LEAVE_ACCOUNT = "inbox/leave/account" // compose account
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_UPDATE_COUNTS = "inbox/update/counts" // compose inbox counts
;
//collab editor room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_JOIN = "collaboration/editor/join" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_LEAVE = "collaboration/editor/leave" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_SAVE_ATTACHMENTS = "collaboration/editor/attachments" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_SAVE_METADATA = "collaboration/editor/metadata" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_VIEWER_JOIN = "collaboration/editor/viewer/join" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_VIEWER_LEAVE = "collaboration/editor/viewer/leave" //compose editor
;
//manage room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_JOIN = "site/join" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_LEAVE = "site/leave" // receive leave
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_UPDATE_ACTIVE_CONTACT = "site/active/contact" //compose update active contact
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_UPDATE = "site/update" //compose site
;
//site and livechat room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_JOIN_ACCOUNT = "site/join/account" //compose joined account
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_LEAVE_ACCOUNT = "site/leave/account" //compose account
;
//inbox room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_NEW_CONVERSATION = "site/new/conversation" //compose new conversations
;
//no room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_RELOAD = "site/reload" //compose true
;
//manage room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_JOIN = "livechat/join";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_LEAVE = "livechat/leave";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_DELETE = "livechat/delete";
//livechat room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_ACTIVITY_UPDATE = "livechat/activity/update";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_APPEARANCE_UPDATE = "livechat/appearances/update";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_SECURITY_UPDATE = "livechat/security/update";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_SETTINGS_UPDATE = "livechat/settings/update";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_TEXT_UPDATE = "livechat/texts/update";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.LIVECHAT_FORM_UPDATE = "livechat/form/update";
//manage room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATION_JOIN = "conversation/join" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATION_LEAVE = "conversation/leave" // receive leave
;
// livechat and site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATION_UPDATE = "conversation/update" //compose conversation
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATION_UPDATE_LIST = "conversation/update/list" //compose conversation
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATION_UPDATE_LIGHT = "conversation/update/light" //compose conversation
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATION_UPDATE_LIGHT_LIST = "conversation/update/light/list" //compose conversation
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_CONVERSATIONS_DELETE = "conversations/delete";
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ROLE_UPDATE = "role/update" //compose role
;
//set to roles room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ROLE_CREATE = "role/create" //compose role
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ROLE_DELETE = "role/delete" //compose role
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONTACT_JOIN = "contact/join" //compose contact
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONTACT_LEAVE = "contact/leave" //compose contact
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONTACT_UPDATE = "contact/update" //compose contact
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONTACT_UPDATE_COUNTS = "contact/update/counts" // compose inbox counts
;
//no room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_SOCIAL_LOGIN = "account/social/login" //compose account
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_LOGOUT = "account/logout" //compose true
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_UPDATE = "account/update" //compose account
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_KICK = "account/kick" //compose account
;
// inbox and livechat room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ENTITY_TYPING = "entity/typing" //compose entity typing
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ENTITY_UPDATE = "entity/update" //compose contact or account
;
//site inbox and livechat room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.MESSAGE_NEW = "message/new" //compose new message
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.MESSAGE_UPDATE = "message/update" //compose new message
;
//site channel
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_CHANNEL_UPDATE = "sitechannel/update";
//inbox room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.FILTER_UPDATE = "filter/update" //compose new filter
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.FILTER_DELETE = "filter/delete" //compose new filter
;
//inbox room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CATEGORY_UPDATE = "category/update" //compose new category
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CATEGORY_DELETE = "category/delete" //compose new category
;
//contact room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.NOTE_NEW = "note/new" //compose note
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.NOTE_DELETE = "note/delete" //compose note
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_SHORTCUT_NEW = "shortcut/new" //compose note
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.INBOX_SHORTCUT_DELETE = "shortcut/delete" //compose note
;
//ws entity and inbox
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.NOTIFICATION_ACCOUNT_UPDATE = "notification/account/update" //compose account
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.NOTIFICATION_CONTACT_UPDATE = "notification/contact/update" //compose account
;
//ws publisher
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_JOIN = "publisher/join" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_LEAVE = "publisher/leave" // receive leave
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_JOIN_ACCOUNT = "publisher/join/account" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_LEAVE_ACCOUNT = "publisher/leave/account" // receive leave
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_POST_DELETE = "publisher/post/delete" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_POST_UPDATE = "publisher/post/update" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.PUBLISHER_POST_UPDATES = "publisher/post/updates" // receive join
;
//gpt service
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.GPT_SEGMENT = "gpt/segment" // receive
;

});


parcelRegister("kSokW", function(module, exports) {

$parcel$export(module.exports, "jsonConcat", function () { return $e38ef923f42afac9$export$18a01edb43e2b5d0; });
/**
 * Concat two json
 */ function $e38ef923f42afac9$export$18a01edb43e2b5d0(o1, o2) {
    if (!o2) return o1;
    for(let key in o2)o1[key] = o2[key];
    return o1;
}

});

parcelRegister("bIule", function(module, exports) {

$parcel$export(module.exports, "randomInteger", function () { return $cc3869da56531322$export$3f522a9c938dfb72; });
/**
 * random
 */ /**
 * genere un nombre aléatoire
 */ function $cc3869da56531322$export$3f522a9c938dfb72(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

});

parcelRegister("afj2S", function(module, exports) {

$parcel$export(module.exports, "queryString", function () { return $497f06504bef2c61$export$ded69dcd8ce7e468; });
/**
 * Transforme du JSON en data pour les requêtes ajax
 */ function $497f06504bef2c61$export$ded69dcd8ce7e468(object) {
    let data = "";
    let counter = 1;
    Object.keys(object).forEach((k)=>{
        if (object[k] != undefined) {
            data += k + "=" + encodeURIComponent(object[k]) + (counter >= Object.keys(object).length ? "" : "&");
            counter++;
        }
    });
    return data;
}

});


parcelRegister("7Aqrk", function(module, exports) {

$parcel$export(module.exports, "AccountService", function () { return $f62ac74e8bd8a8cb$export$b662858863b75c61; });

var $7AbeR = parcelRequire("7AbeR");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7ZaxO = parcelRequire("7ZaxO");

var $g0YRJ = parcelRequire("g0YRJ");

var $5pJMm = parcelRequire("5pJMm");

var $2eT6g = parcelRequire("2eT6g");

var $kCcuA = parcelRequire("kCcuA");

var $68Z0d = parcelRequire("68Z0d");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $f62ac74e8bd8a8cb$export$b662858863b75c61 {
    static dispose() {
        this.accounts = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ACCOUNT_UPDATE, (data)=>{
            this.store(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ACCOUNT_LOGOUT, ()=>{
            location.reload();
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ACCOUNT_KICK, (data)=>{
            let account = this.store(data);
            account.siteId = undefined;
            if (account.id == (0, $68Z0d.EntityService).activeEntity.id) location.reload();
        });
    }
    /**
     * rest
     */ static async create(data, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).TOO_MANY_REQUESTS,
                message: (0, $5FliW.Resources).t("words.accountRegisterToManyRequests")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/account`, data, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async update(name, email, work, numberPhone, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/update", {
            name: name,
            language: (0, $5FliW.Resources).language,
            email: email,
            work: work,
            numberPhone: numberPhone
        }, component);
        return request.status;
    }
    static async registerTransaction(transactionId, sessionId, component) {
        return await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/register/transaction", {
            transactionId: transactionId,
            sessionId: sessionId
        }, component);
    }
    static async updatePassword(oldPassword, newPassword, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).PASSWORD,
                message: (0, $5FliW.Resources).t("words.account.currentPasswordUnavailable")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/update/password", {
            oldPassword: oldPassword,
            newPassword: newPassword
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async activity(active, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/account/activity`, {
            active: active
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findBySiteId(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/site/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findRolesBySiteId(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/roles/site/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findById(id, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async twoFactorVerify(id, token, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/2fa/verify/${id}/${token}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async twoFactorDisabled(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/2fa/disable`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async twoFactorEnabled(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/2fa/enable`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getAccountAdmin(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/admin/` + id, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async updateEmailNotifyAccountAdmin(id, state, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/admin/emailNotify/` + id + "/" + state, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async updateDisplayPromoCodeInputAccountAdmin(id, state, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/admin/displayPromoCodeInput/` + id + "/" + state, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async hasEvent(id, event, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/event/${id}/${event}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async addEvent(id, event, component) {
        await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/event", {
            id: id,
            event: event
        }, component);
    }
    /**
     * has
     */ static hasRole(account, role) {
        if (account.rolesAccount != undefined) return account.rolesAccount.filter((roleAccount)=>roleAccount.role.id == role.id).length > 0;
        return false;
    }
    /**
     * logic
     */ static async requestLogin(request) {
        (0, $68Z0d.EntityService).headersToken(request === null || request === void 0 ? void 0 : request.headers);
        await (0, $7AbeR.Network).onToken();
        await (0, $7AbeR.Network).onLogin();
        (0, $7AbeR.Network).router.onLogin();
    }
    /**
     * get
     */ static getAll() {
        return this.accounts;
    }
    /**
     * store
     */ static storeAll(accounts) {
        for(let key in accounts)accounts[key] = this.store(accounts[key]);
        return (0, $2Y8XI.Services).storeAll(accounts);
    }
    static store(account) {
        if (account != undefined) {
            var _EntityService_activeEntity, _EntityService_activeEntity1;
            if (account.avatar != undefined) account.avatar = (0, $g0YRJ.AvatarService).store(account.avatar);
            if (account.rolesAccount != undefined) account.rolesAccount = (0, $kCcuA.RoleAccountService).storeAll(account.rolesAccount);
            account.type = (0, $5pJMm.EntityType).ACCOUNT;
            if (account.id === ((_EntityService_activeEntity = (0, $68Z0d.EntityService).activeEntity) === null || _EntityService_activeEntity === void 0 ? void 0 : _EntityService_activeEntity.id) && account.email === "") account.email = (_EntityService_activeEntity1 = (0, $68Z0d.EntityService).activeEntity) === null || _EntityService_activeEntity1 === void 0 ? void 0 : _EntityService_activeEntity1.email;
            return (0, $2Y8XI.Services).store("id", this.accounts, account);
        }
    }
}
$f62ac74e8bd8a8cb$export$b662858863b75c61.accounts = (0, $i3Hbv.observable)([]);

});
parcelRegister("2Y8XI", function(module, exports) {

$parcel$export(module.exports, "Services", function () { return $0b02b3d6e2a603d1$export$c447b0cdbd1cd184; });

var $i3Hbv = parcelRequire("i3Hbv");

var $7AbeR = parcelRequire("7AbeR");

var $hBfeZ = parcelRequire("hBfeZ");
class $0b02b3d6e2a603d1$export$c447b0cdbd1cd184 {
    static storeAll(list) {
        if (list == undefined) return undefined;
        return (0, $i3Hbv.observable)(list);
    }
    static store(key, array, object) {
        // @ts-ignore
        object = (0, $i3Hbv.observable)(object);
        let cache = array.filter((a)=>a[key] == object[key])[0];
        if (cache != undefined) {
            (0, $hBfeZ.objectUpdate)(cache, object);
            return cache;
        }
        array.push(object);
        return object;
    }
    static unStore(key, array, object) {
        let cache = array.filter((a)=>a[key] == object[key])[0];
        if (cache != undefined) {
            array.splice(array.indexOf(cache), 1);
            return cache;
        }
        return undefined;
    }
    static get(key, array, value) {
        return array.filter((a)=>a[key] == value)[0];
    }
    static on(service, type, event, func) {
        if (!service.socketHandlers) service.socketHandlers = [];
        service.socketHandlers.push({
            event: event,
            func: func
        });
        (0, $7AbeR.Network).on(type, event, func);
    }
    static beforeInit(service) {
        if (service.socketHandlers && (0, $7AbeR.Network).getSocket()) {
            service.socketHandlers.forEach((v)=>(0, $7AbeR.Network).getSocket().removeListener(v.event));
            service.socketHandlers = [];
        }
    }
    static handleErrors(component, errors) {
        if (!component) component = {
            networkErrorsHandler: [],
            addNetworkErrors (errors) {
                errors.forEach((error)=>this.networkErrorsHandler.push(error));
            }
        };
        if (component && component.networkErrorsHandler.length === 0) component.addNetworkErrors(errors);
    }
}

});
parcelRegister("hBfeZ", function(module, exports) {

$parcel$export(module.exports, "objectUpdate", function () { return $075de30f517e1154$export$e20c9e8e0502f2a5; });

var $lQXpd = parcelRequire("lQXpd");
function $075de30f517e1154$export$e20c9e8e0502f2a5(objectBase, newObject) {
    if (newObject) {
        for(let property in objectBase){
            if (objectBase.hasOwnProperty(property)) {
                if (typeof newObject[property] !== "undefined") {
                    if (!Array.isArray(newObject[property])) {
                        if (objectBase[property] != newObject[property]) objectBase[property] = newObject[property];
                    } else if (!(0, $lQXpd.arrayEquals)(objectBase[property], newObject[property])) objectBase[property] = newObject[property];
                }
            }
        }
        for(let property in newObject){
            if (!objectBase.hasOwnProperty(property)) {
                if (typeof newObject[property] !== "undefined") objectBase[property] = newObject[property];
            }
        }
    }
    return objectBase;
}

});
parcelRegister("lQXpd", function(module, exports) {

$parcel$export(module.exports, "arrayEquals", function () { return $a57c8bd8faef97fb$export$22d6d01dd47e89dd; });
/**
 * array
 */ 
var $laeZ5 = parcelRequire("laeZ5");
function $a57c8bd8faef97fb$export$22d6d01dd47e89dd(arr1, arr2) {
    if (arr1 == undefined || arr2 == undefined) return false;
    if (arr1.length != arr2.length) return false;
    if (arr1.length == 0 && arr2.length == 0) return true;
    arr1 = [
        ...arr1
    ];
    arr2 = [
        ...arr2
    ];
    arr1 = arr1.sort(function(a, b) {
        return a > b ? 1 : -1;
    });
    arr2 = arr2.sort(function(a, b) {
        return a > b ? 1 : -1;
    });
    for(let i = 0; i < arr1.length; i++)if (typeof arr1[i] == "object") {
        if (!(0, $laeZ5.objectEquals)(arr1[i], arr2[i])) return false;
    } else {
        if (arr1[i] != arr2[i]) return false;
    }
    return true;
}

});
parcelRegister("laeZ5", function(module, exports) {

$parcel$export(module.exports, "objectEquals", function () { return $f5f98b829328b5d6$export$5b4d20f570fee173; });
/**
 * Vérifie de manière recursif si deux objets sont identique
 */ 
var $lQXpd = parcelRequire("lQXpd");
function $f5f98b829328b5d6$export$5b4d20f570fee173(obj1, obj2) {
    if (obj1 == undefined || obj2 == undefined) return false;
    for(let property in obj1)if (obj1.hasOwnProperty(property)) {
        let value = obj1[property];
        let compareValue = obj2[property];
        if (typeof value == "object") {
            if (!$f5f98b829328b5d6$export$5b4d20f570fee173(value, compareValue)) return false;
        } else if (Array.isArray(value)) {
            if (!(0, $lQXpd.arrayEquals)(value, compareValue)) return false;
        } else {
            if (typeof value === "string") {
                let valueNumber = Number(value);
                if (!Number.isNaN(valueNumber)) value = valueNumber;
            }
            if (typeof compareValue === "string") {
                let valueNumber = Number(value);
                if (!Number.isNaN(valueNumber)) compareValue = valueNumber;
            }
            if (value != compareValue) return false;
        }
    }
    return true;
}

});




parcelRegister("g0YRJ", function(module, exports) {

$parcel$export(module.exports, "AvatarService", function () { return $73823d77789937ac$export$c122ef7a8e25709e; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $bKmye = parcelRequire("bKmye");

var $fYPFR = parcelRequire("fYPFR");

var $68Z0d = parcelRequire("68Z0d");
class $73823d77789937ac$export$c122ef7a8e25709e {
    static init() {}
    static dispose() {
        this.avatars = (0, $i3Hbv.observable)([]);
    }
    static storeAll(avatars) {
        for(let key in avatars)avatars[key] = this.store(avatars[key]);
        return (0, $2Y8XI.Services).storeAll(avatars);
    }
    static store(avatar) {
        let storedAvatar = (0, $2Y8XI.Services).get("id", this.avatars, avatar.id);
        if (storedAvatar != undefined) {
            if (avatar.file == undefined) storedAvatar.file = undefined;
            if (avatar.color == undefined) storedAvatar.color = undefined;
        }
        if (avatar.file != undefined) avatar.file = (0, $bKmye.FileService).store(avatar.file);
        if (avatar.color != undefined) avatar.color = (0, $fYPFR.AvatarColorService).store(avatar.color);
        return (0, $2Y8XI.Services).store("id", this.avatars, avatar);
    }
    static isActive(activeModel) {
        return activeModel["siteId"] != undefined ? activeModel.active && activeModel["siteId"] == (0, $68Z0d.EntityService).activeSite.id : activeModel.active;
    }
}
$73823d77789937ac$export$c122ef7a8e25709e.avatars = (0, $i3Hbv.observable)([]);

});
parcelRegister("bKmye", function(module, exports) {

$parcel$export(module.exports, "FileService", function () { return $dc50932e05ed7fd7$export$4adefade6695ab45; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $271MM = parcelRequire("271MM");
class $dc50932e05ed7fd7$export$4adefade6695ab45 {
    static init() {}
    static dispose() {
        this.files = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async create(siteId, origin, files, progress, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).PANEL, `/files`, {
            files: files,
            siteId: siteId,
            origin: origin
        }, component, {
            onUploadProgress: (progressEvent)=>{
                progress(progressEvent.loaded * 100 / progressEvent.total);
            }
        });
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    /**
     * link
     */ static link(file) {
        return (0, $271MM.config).httpPanelUrl + `/files/${file.id}.${file.extension}`;
    }
    static storeAll(files) {
        for(let key in files)files[key] = this.store(files[key]);
        return (0, $2Y8XI.Services).storeAll(files);
    }
    static store(file) {
        file.link = $dc50932e05ed7fd7$export$4adefade6695ab45.link(file);
        return (0, $2Y8XI.Services).store("id", this.files, file);
    }
}
$dc50932e05ed7fd7$export$4adefade6695ab45.files = (0, $i3Hbv.observable)([]);

});

parcelRegister("fYPFR", function(module, exports) {

$parcel$export(module.exports, "AvatarColorService", function () { return $4a50255f26c705bb$export$8fd88b7de3288064; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $4a50255f26c705bb$export$8fd88b7de3288064 {
    static init() {}
    static dispose() {
        this.colors = (0, $i3Hbv.observable)([]);
    }
    static storeAll(colors) {
        for(let key in colors)colors[key] = this.store(colors[key]);
        return (0, $2Y8XI.Services).storeAll(colors);
    }
    static store(color) {
        return (0, $2Y8XI.Services).store("color", this.colors, color);
    }
}
$4a50255f26c705bb$export$8fd88b7de3288064.colors = (0, $i3Hbv.observable)([]);

});


parcelRegister("5pJMm", function(module, exports) {

$parcel$export(module.exports, "EntityType", function () { return $22639064657c8baf$export$8eda7e02f8f033b2; });
var $22639064657c8baf$export$8eda7e02f8f033b2;
(function(EntityType) {
    EntityType[EntityType["ACCOUNT"] = 1] = "ACCOUNT";
    EntityType[EntityType["CONTACT"] = 2] = "CONTACT";
    EntityType[EntityType["CHATBOT"] = 3] = "CHATBOT";
    EntityType[EntityType["EXTERNAL"] = 4] = "EXTERNAL";
})($22639064657c8baf$export$8eda7e02f8f033b2 || ($22639064657c8baf$export$8eda7e02f8f033b2 = {}));

});

parcelRegister("kCcuA", function(module, exports) {

$parcel$export(module.exports, "RoleAccountService", function () { return $13646c59b2684459$export$776d4b659cbf7495; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $jdUQG = parcelRequire("jdUQG");

var $kfkzw = parcelRequire("kfkzw");
class $13646c59b2684459$export$776d4b659cbf7495 {
    static dispose() {
        this.accounts = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * http
     */ static async delete(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/roles/account/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async create(accountId, roleId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/account", {
            accountId: accountId,
            roleId: roleId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * store
     */ static storeAll(rolesAccount) {
        for(let key in rolesAccount)rolesAccount[key] = this.store(rolesAccount[key]);
        return (0, $2Y8XI.Services).storeAll(rolesAccount);
    }
    static store(roleAccount) {
        roleAccount.role = (0, $jdUQG.RoleService).store(roleAccount.role);
        roleAccount = (0, $2Y8XI.Services).store("id", this.accounts, roleAccount);
        return roleAccount;
    }
}
$13646c59b2684459$export$776d4b659cbf7495.accounts = (0, $i3Hbv.observable)([]);

});
parcelRegister("jdUQG", function(module, exports) {

$parcel$export(module.exports, "RoleService", function () { return $4eb5e681485625fd$export$bb170c807acfe5f; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $2eT6g = parcelRequire("2eT6g");

var $4ymN9 = parcelRequire("4ymN9");

var $68Z0d = parcelRequire("68Z0d");

var $dvTuK = parcelRequire("dvTuK");

var $9jYbZ = parcelRequire("9jYbZ");

var $kfkzw = parcelRequire("kfkzw");
class $4eb5e681485625fd$export$bb170c807acfe5f {
    static dispose() {
        this.roles = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ROLE_UPDATE, (data)=>{
            this.store(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ROLE_CREATE, (data)=>{
            let role = this.store(data);
            this.roleChange(role);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ROLE_DELETE, (data)=>{
            let role = this.store(data);
            this.unStore(role);
            this.roleChange(role);
        });
    }
    /**
     * http
     */ static async findBySite(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/roles/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async updateRanks(siteId, orders, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/roles/update/ranks", {
            siteId: siteId,
            orders: orders
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async updatePermissions(roleId, permissions, siteChannelsIdsInbox, siteChannelsIdsPublisher, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/update/permissions", {
            roleId: roleId,
            permissions: permissions,
            siteChannelsIdsInbox: siteChannelsIdsInbox,
            siteChannelsIdsPublisher: siteChannelsIdsPublisher
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static getAll() {
        return this.roles;
    }
    static async update(roleId, name, color, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/update", {
            roleId: roleId,
            name: name,
            color: color
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async create(siteId, name, color, model, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles", {
            siteId: siteId,
            name: name,
            color: color,
            model: model
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let role = this.store(request.data);
            this.roleChange(role);
            return role;
        }
        return undefined;
    }
    static async delete(roleId, component) {
        let role = this.roles.filter((role)=>role.id == roleId)[0];
        this.unStore(role);
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/roles/${roleId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.roleChange(role);
            return true;
        }
        return false;
    }
    static async duplicate(roleId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/duplicate", {
            roleId: roleId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let role = this.store(request.data);
            this.roleChange(role);
            return role;
        }
        return undefined;
    }
    /**
     * utilities
     */ static maxRank(account) {
        let maxRank = 0;
        for (let role of account.rolesAccount.map((roleAccount)=>roleAccount.role))if (role.rank > maxRank) maxRank = role.rank;
        return maxRank;
    }
    static greater(account) {
        let myAccount = (0, $68Z0d.EntityService).activeEntity;
        let mySite = (0, $68Z0d.EntityService).activeSite;
        if (myAccount.id == mySite.accountId) return true;
        if (account.id == mySite.accountId) return false;
        if (myAccount.rolesAccount == undefined || myAccount.rolesAccount.length == 0) return false;
        if (account.rolesAccount == undefined || account.rolesAccount.length == 0) return true;
        return this.maxRank(myAccount) > this.maxRank(account);
    }
    static can(...permissions) {
        if ((0, $68Z0d.EntityService).activeSite == undefined) return false;
        return this.canAccess((0, $68Z0d.EntityService).activeEntity, ...permissions);
    }
    static updateRole(role) {
        return this.canUpdateRole((0, $68Z0d.EntityService).activeEntity, (0, $68Z0d.EntityService).activeSite, role);
    }
    static hasPermission(rolesAccounts, ...permissions) {
        for (let permission of permissions){
            if (rolesAccounts.filter((roleAccount)=>roleAccount.role.permissions.includes(permission)).length > 0) return true;
        }
        return false;
    }
    static canAccess(account, ...permissions) {
        if (account.rolesAccount == undefined) return false;
        if (this.hasPermission(account.rolesAccount, (0, $4ymN9.RolePermissionsType).ADMINISTRATOR)) return true;
        return this.hasPermission(account.rolesAccount, ...permissions);
    }
    static canUpdateRole(account, site, role) {
        if (role.id == site.superRoleId) return false;
        if (account.id == site.accountId) return true;
        return this.maxRank(account) > role.rank;
    }
    /**
     * avatar
     */ static avatar(role) {
        return {
            type: (0, $dvTuK.AvatarType).ROLE,
            color: {
                color: role.color
            }
        };
    }
    /**
     * events
     */ static roleChange(role) {
        this.rolesChange.forEach((value)=>value(role));
    }
    static onRoleChange(func, component) {
        this.rolesChange.push(func);
        component.onRemove(()=>this.rolesChange.splice(this.rolesChange.indexOf(func), 1));
    }
    /**
     * store
     */ static storeAll(roles) {
        for(let key in roles)roles[key] = this.store(roles[key]);
        return (0, $2Y8XI.Services).storeAll(roles);
    }
    static store(role) {
        role.siteChannelsInbox = (0, $9jYbZ.SiteChannelService).storeAll(role.siteChannelsInbox);
        role.siteChannelsPublisher = (0, $9jYbZ.SiteChannelService).storeAll(role.siteChannelsPublisher);
        role = (0, $2Y8XI.Services).store("id", this.roles, role);
        return role;
    }
    static unStore(role) {
        (0, $2Y8XI.Services).unStore("id", this.roles, role);
    }
}
$4eb5e681485625fd$export$bb170c807acfe5f.roles = (0, $i3Hbv.observable)([]);
$4eb5e681485625fd$export$bb170c807acfe5f.rolesChange = [];

});
parcelRegister("4ymN9", function(module, exports) {

$parcel$export(module.exports, "RolePermissionsType", function () { return $42e5c2c0d98d9329$export$6f6fd11394c3f5db; });
class $42e5c2c0d98d9329$export$6f6fd11394c3f5db {
}
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.ADMINISTRATOR = "a";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_ADMINISTRATOR = "pa";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_PUBLISH = "be";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER = "p";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_FACEBOOK_READ = "ba";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_INSTAGRAM_PAGE_READ = "bb";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_TWITTER_READ = "bc";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_ADMINISTRATOR = "m";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX = "b";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_ASSIGNMENT = "h";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_FILTERS_PUBLIC = "j";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_SHORTCUTS_PUBLIC = "q";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_FILES = "z";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_CATEGORIES_PUBLIC = "ac";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_EDIT_ALL = "af";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_LIVECHAT_READ = "f";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_MAIL_READ = "ak";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_TWITTER_READ = "bd";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_FACEBOOK_READ = "rfb";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_INSTAGRAM_PAGE_READ = "ris";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_LINKEDIN_READ = "bg";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_SHOPIFY_READ = "bo";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.GENERAL = "c";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.ACCOUNT_MANAGE = "g";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INVITATIONS_MANAGE = "k";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_CHANNEL_MANAGE = "l";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_CHANNEL_LIVECHAT_MANAGE = "r";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_CHANNEL_MAILS_MANAGE = "ah";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.ROLES_MANAGE = "n";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_MANAGE = "ad";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_ADMINISTRATOR = "s";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_NOTES = "t";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_NOTES_MANAGE = "v";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_PRIVATE_DATA = "aa";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_ACTIVES = "ad";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_BAN = "ae";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_EDIT_DATA = "ag";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_CREATE = "bh";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_ADMINISTRATOR = "ab";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX = "e";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX_CONVERSATION = "u";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX_MESSAGES = "w";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX_MEMBERS = "x";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_ADMINISTRATOR = "bn";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_READING = "bp";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_WRITING = "bq";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_PUBLISH = "bs";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_DELETE = "br";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_ADMINISTRATOR = "bi";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_READING = "bj";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_WRITING = "bk";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_PUBLISH = "bt";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_DELETE = "bl";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SUBSCRIPTION_ADMINISTRATOR = "bm";

});

parcelRegister("dvTuK", function(module, exports) {

$parcel$export(module.exports, "AvatarType", function () { return $6359b9e3c26ba03a$export$c11c93bc4a4bfefe; });
var $6359b9e3c26ba03a$export$c11c93bc4a4bfefe;
(function(AvatarType) {
    AvatarType[AvatarType["ENTITY"] = 1] = "ENTITY";
    AvatarType[AvatarType["ROLE"] = 2] = "ROLE";
    AvatarType[AvatarType["SITE"] = 3] = "SITE";
    AvatarType[AvatarType["SITE_CHANNEL"] = 4] = "SITE_CHANNEL";
    AvatarType[AvatarType["BOT"] = 5] = "BOT";
    AvatarType[AvatarType["MAIL"] = 6] = "MAIL";
    AvatarType[AvatarType["HELP_CENTER"] = 7] = "HELP_CENTER";
})($6359b9e3c26ba03a$export$c11c93bc4a4bfefe || ($6359b9e3c26ba03a$export$c11c93bc4a4bfefe = {}));

});

parcelRegister("9jYbZ", function(module, exports) {

$parcel$export(module.exports, "SiteChannelService", function () { return $87b88de78b4d8705$export$d235de51709f9b1d; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $nSXuR = parcelRequire("nSXuR");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $g0YRJ = parcelRequire("g0YRJ");

var $bOsdQ = parcelRequire("bOsdQ");

var $1kPHR = parcelRequire("1kPHR");

var $dvTuK = parcelRequire("dvTuK");

var $68Z0d = parcelRequire("68Z0d");

var $1b6Hd = parcelRequire("1b6Hd");

var $dEIDr = parcelRequire("dEIDr");

var $7Aqrk = parcelRequire("7Aqrk");

var $kfkzw = parcelRequire("kfkzw");

var $2eT6g = parcelRequire("2eT6g");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $87b88de78b4d8705$export$d235de51709f9b1d {
    static dispose() {
        this.siteChannels = (0, $i3Hbv.observable)([]);
        this.updates = [];
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_CHANNEL_UPDATE, (data)=>{
            let update = data;
            this.updates.forEach((value)=>value(update));
        });
    }
    static async findUrlConnectPartner(invitationId, isLogin, channelType, communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/oauth/url/${channelType}/${isLogin}`, {
            invitationId: invitationId,
            communityId: communityId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return decodeURIComponent(request.data);
        return undefined;
    }
    static async findBySiteId(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findBySiteIdAndPerms(siteId, product, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/perms/${siteId}/${product}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findByType(channelType, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/type/${channelType}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findReliedAccounts(siteChannelId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/relied/accounts/${siteChannelId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $7Aqrk.AccountService).storeAll(request.data);
        return [];
    }
    static async pickedByPerms(component, channelType) {
        let siteChannels = await this.findBySiteIdAndPerms((0, $68Z0d.EntityService).activeSite.id, (0, $kfkzw.ProductType).INBOX, component);
        siteChannels = siteChannels.filter((value)=>!channelType || value.channel.type == channelType);
        let siteChannel = siteChannels.find((value)=>value.id == (0, $1b6Hd.PreferencesService).siteChannelPickerSelected);
        return siteChannel ? siteChannel : siteChannels[0];
    }
    static async delete(id, component) {
        let siteChannel = this.siteChannels.filter((value)=>value.id == id)[0];
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/site/channel/delete", {
            id: id
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.unStore(siteChannel);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async update(id, component) {
        let request = await (0, $7AbeR.Network).put((0, $kfkzw.ProductType).PANEL, "/site/channel/update", {
            id: id
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.store(request.data);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async register(registerOutgoingModel, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).PARTNER_CONFING_INVALID,
                message: (0, $5FliW.Resources).t("words.partnerConnectionFailed")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PARTNER_CONFING_PERMISSIONS,
                message: registerOutgoingModel.channelType == (0, $bOsdQ.ChannelType).SHOPIFY ? (0, $5FliW.Resources).t("words.shopifyPermissionsMessage") : (0, $5FliW.Resources).t("words.missingPermissions")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/site/channel/register`, registerOutgoingModel, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    /**
     * avatar
     */ static avatar(siteChannel) {
        if (siteChannel.avatar) return siteChannel.avatar;
        if (siteChannel.mail) return (0, $1kPHR.MailService).avatar(siteChannel.mail);
        return {
            type: (0, $dvTuK.AvatarType).SITE_CHANNEL,
            color: {
                color: siteChannel.color
            }
        };
    }
    /**
     * logic
     */ static comType(siteChannel) {
        switch(siteChannel.channel.type){
            case (0, $bOsdQ.ChannelType).MAIL:
                return (0, $dEIDr.ComType).EMAIL;
            default:
                return (0, $dEIDr.ComType).DIRECT_MESSAGE;
        }
    }
    /**
     * ws
     */ static onUpdates(func, component) {
        this.updates.push(func);
        component.onRemove(()=>this.updates.splice(this.updates.indexOf(func), 1));
    }
    /**
     * store
     */ static storeAll(siteChannels) {
        for(let key in siteChannels)siteChannels[key] = this.store(siteChannels[key]);
        return (0, $2Y8XI.Services).storeAll(siteChannels);
    }
    static store(siteChannel) {
        if (siteChannel.avatar != undefined) siteChannel.avatar = (0, $g0YRJ.AvatarService).store(siteChannel.avatar);
        if (siteChannel.mail != undefined) siteChannel.mail = (0, $1kPHR.MailService).store(siteChannel.mail);
        siteChannel.channel = (0, $nSXuR.ChannelService).findById(siteChannel.channelId);
        return siteChannel;
    }
    static unStore(siteChannel) {
        (0, $2Y8XI.Services).unStore("id", this.siteChannels, siteChannel);
    }
}
$87b88de78b4d8705$export$d235de51709f9b1d.siteChannels = (0, $i3Hbv.observable)([]);
$87b88de78b4d8705$export$d235de51709f9b1d.updates = [];

});
parcelRegister("nSXuR", function(module, exports) {

$parcel$export(module.exports, "ChannelService", function () { return $78d27de023919bc7$export$ad877c9653fa6220; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $78d27de023919bc7$export$ad877c9653fa6220 {
    static init() {}
    static dispose() {
        this.channels = (0, $i3Hbv.observable)([]);
    }
    static findById(id) {
        return $78d27de023919bc7$export$ad877c9653fa6220.channels.find((channel)=>channel.id === id);
    }
    static findAllByFiter() {
        return $78d27de023919bc7$export$ad877c9653fa6220.channels.filter((channel)=>channel.inboxProperties);
    }
    static storeAll(channels) {
        return channels.map((value)=>this.store(value));
    }
    static store(channel) {
        return (0, $2Y8XI.Services).store("id", this.channels, channel);
    }
}
$78d27de023919bc7$export$ad877c9653fa6220.channels = (0, $i3Hbv.observable)([]);

});

parcelRegister("bOsdQ", function(module, exports) {

$parcel$export(module.exports, "ChannelType", function () { return $6ec2cf14a5300222$export$36655de2868043ae; });
var $6ec2cf14a5300222$export$36655de2868043ae;
(function(ChannelType) {
    ChannelType["LIVECHAT"] = "2e3b69b2999c4c38b45c5076f98e6946";
    ChannelType["TWITTER"] = "200cfded4cfd4bde977f174bc16bc634";
    ChannelType["FACEBOOK"] = "eebf03447dbc46068dd217fcd62e586d";
    ChannelType["LINKEDIN"] = "d7d61128f27a4af7b4bbd78394d65582";
    ChannelType["INSTAGRAM"] = "8d4446321fa7481cb71ddac1d78cd0ct";
    ChannelType["MAIL"] = "25132600ff214f18b623479258eecf38";
    ChannelType["SHOPIFY"] = "t7d61128f27a4bf7b4bbd78394d65572";
    ChannelType["WIX"] = "w7x61128f27a4b4rd4bbd78394d65512";
    ChannelType["WORDPRESS"] = "wwx61128f27a4b45d4bbd78394d65516";
    ChannelType["WEBFLOW"] = "wfx61128f27a4b45d4bbd78394d65519";
    ChannelType["PRESTASHOP"] = "ppx61128f27a4b4rd4bbd78394d65512";
    ChannelType["GOOGLE"] = "1";
    ChannelType["UNKNOWN"] = "0";
})($6ec2cf14a5300222$export$36655de2868043ae || ($6ec2cf14a5300222$export$36655de2868043ae = {}));
function $6ec2cf14a5300222$export$c91bb9fb1b59614a(type) {
    return Object.keys($6ec2cf14a5300222$export$36655de2868043ae).find((value)=>$6ec2cf14a5300222$export$36655de2868043ae[value] == type);
}

});

parcelRegister("1kPHR", function(module, exports) {

$parcel$export(module.exports, "MailService", function () { return $20c4c3e180d6caf1$export$2e1dbe9af965f3b0; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $304P8 = parcelRequire("304P8");

var $i8I9j = parcelRequire("i8I9j");

var $kAgUX = parcelRequire("kAgUX");

var $byPqo = parcelRequire("byPqo");

var $dvTuK = parcelRequire("dvTuK");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $20c4c3e180d6caf1$export$2e1dbe9af965f3b0 {
    static init() {
        (0, $304P8.MailDomainService).init();
        (0, $i8I9j.MailServerService).init();
        (0, $kAgUX.MailAliasService).init();
        (0, $byPqo.MailRedirectService).init();
    }
    static dispose() {
        this.mails = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async create(name, senderName, domainId, diskSpaceLimit, serverId, assignedId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).INSUFFICIENT_STORAGE,
                message: (0, $5FliW.Resources).t("words.mailDiskError")
            },
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: (0, $5FliW.Resources).t("words.mailDiskAllowError")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAIL_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorMAIL_FORMAT"),
                displayValue: true
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails", {
            name: name,
            senderName: senderName,
            domainId: domainId,
            serverId: serverId,
            assignedId: assignedId,
            diskSpaceLimit: diskSpaceLimit
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async delete(mail, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/mails/${mail.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(mail);
            return true;
        }
        return false;
    }
    static async findByServer(serverId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/${serverId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findBySite(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/site/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    /**
     * values
     */ static senderName(mail) {
        return mail.assigned ? mail.assigned.name : mail.senderName;
    }
    static avatar(mail) {
        if (mail.assigned) return mail.assigned.avatar;
        return {
            type: (0, $dvTuK.AvatarType).MAIL,
            color: {
                color: mail.color
            }
        };
    }
    /**
     * store
     */ static storeAll(mails) {
        for(let key in mails)mails[key] = this.store(mails[key]);
        return (0, $2Y8XI.Services).storeAll(mails);
    }
    static store(mail) {
        return (0, $2Y8XI.Services).store("id", this.mails, mail);
    }
    static unStore(mail) {
        (0, $2Y8XI.Services).unStore("id", this.mails, mail);
    }
}
$20c4c3e180d6caf1$export$2e1dbe9af965f3b0.mails = (0, $i3Hbv.observable)([]);

});
parcelRegister("304P8", function(module, exports) {

$parcel$export(module.exports, "MailDomainService", function () { return $b2eb5a9ff3be9167$export$aa408acb4ffdaa07; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");
class $b2eb5a9ff3be9167$export$aa408acb4ffdaa07 {
    static init() {}
    static dispose() {
        this.domains = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async create(name, serverId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/domains", {
            name: name,
            serverId: serverId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async verify(id, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/domains/verify", {
            id: id
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async delete(domain, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/mails/domains/${domain.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(domain);
            return true;
        }
        return false;
    }
    static async findByServer(serverId, includeDomainPublic, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/domains/${serverId}/${includeDomainPublic}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static storeAll(domains) {
        for(let key in domains)domains[key] = this.store(domains[key]);
        return (0, $2Y8XI.Services).storeAll(domains);
    }
    static store(domain) {
        return (0, $2Y8XI.Services).store("id", this.domains, domain);
    }
    static unStore(domain) {
        (0, $2Y8XI.Services).unStore("id", this.domains, domain);
    }
}
$b2eb5a9ff3be9167$export$aa408acb4ffdaa07.domains = (0, $i3Hbv.observable)([]);

});

parcelRegister("i8I9j", function(module, exports) {

$parcel$export(module.exports, "MailServerService", function () { return $d6cef4e77bff19c4$export$bf5cfa6108e941da; });

var $i3Hbv = parcelRequire("i3Hbv");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $kfkzw = parcelRequire("kfkzw");
class $d6cef4e77bff19c4$export$bf5cfa6108e941da {
    static init() {}
    static dispose() {
        this.servers = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async create(name, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/server", {
            name: name
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async delete(server, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/mails/server/${server.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(server);
            return true;
        }
        return false;
    }
    static async updateSpam(server, spamMode, component) {
        let request = await (0, $7AbeR.Network).put((0, $kfkzw.ProductType).PANEL, `/mails/server/spam/${server.id}`, {
            mailServerSpamModeCode: spamMode
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            server.spamMode = spamMode;
            return true;
        }
        return false;
    }
    static async findDiskSpace(serverId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/server/disk/space/${serverId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findView(serverId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/server/view/${serverId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findStats(serverId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/server/stats/${serverId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findBySite(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/server/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static storeAll(servers) {
        for(let key in servers)servers[key] = this.store(servers[key]);
        return (0, $2Y8XI.Services).storeAll(servers);
    }
    static store(server) {
        return (0, $2Y8XI.Services).store("id", this.servers, server);
    }
    static unStore(server) {
        (0, $2Y8XI.Services).unStore("id", this.servers, server);
    }
}
$d6cef4e77bff19c4$export$bf5cfa6108e941da.servers = (0, $i3Hbv.observable)([]);

});

parcelRegister("kAgUX", function(module, exports) {

$parcel$export(module.exports, "MailAliasService", function () { return $8897ed981158ddc3$export$7d9f62cd426f09f6; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");
class $8897ed981158ddc3$export$7d9f62cd426f09f6 {
    static init() {}
    static dispose() {
        this.aliases = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async findByServer(serverId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/alias/${serverId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async create(names, mailId, errors, component) {
        (0, $2Y8XI.Services).handleErrors(component, errors);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/alias", {
            names: names,
            mailId: mailId
        }, component);
        if (request.status != (0, $7ZaxO.HttpStatus).OK) return {
            alias: undefined,
            status: request.status
        };
        return {
            alias: this.store(request.data),
            status: request.status
        };
    }
    static async update(id, names, errors, component) {
        (0, $2Y8XI.Services).handleErrors(component, errors);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/alias/update", {
            names: names,
            id: id
        }, component);
        if (request.status != (0, $7ZaxO.HttpStatus).OK) return {
            alias: undefined,
            status: request.status
        };
        return {
            alias: this.store(request.data),
            status: request.status
        };
    }
    static async delete(alias, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/mails/alias/${alias.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(alias);
            return true;
        }
        return false;
    }
    static storeAll(aliases) {
        for(let key in aliases)aliases[key] = this.store(aliases[key]);
        return (0, $2Y8XI.Services).storeAll(aliases);
    }
    static store(alias) {
        return (0, $2Y8XI.Services).store("id", this.aliases, alias);
    }
    static unStore(alias) {
        (0, $2Y8XI.Services).unStore("id", this.aliases, alias);
    }
}
$8897ed981158ddc3$export$7d9f62cd426f09f6.aliases = (0, $i3Hbv.observable)([]);

});

parcelRegister("byPqo", function(module, exports) {

$parcel$export(module.exports, "MailRedirectService", function () { return $3a0c3aae00adeeac$export$c4ef83c71ef62b92; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");
class $3a0c3aae00adeeac$export$c4ef83c71ef62b92 {
    static init() {}
    static dispose() {
        this.redirects = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async findByServer(serverId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/mails/redirect/${serverId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async create(mailId, redirectionName, errors, component) {
        (0, $2Y8XI.Services).handleErrors(component, errors);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/redirect", {
            redirectionName: redirectionName,
            mailId: mailId
        }, component);
        if (request.status != (0, $7ZaxO.HttpStatus).OK) return {
            redirect: undefined,
            status: request.status
        };
        return {
            redirect: this.store(request.data),
            status: request.status
        };
    }
    static async update(id, mailId, redirectionName, errors, component) {
        (0, $2Y8XI.Services).handleErrors(component, errors);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/mails/redirect/update", {
            id: id,
            redirectionName: redirectionName,
            mailId: mailId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async delete(redirect, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/mails/redirect/${redirect.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(redirect);
            return true;
        }
        return false;
    }
    /**
     * store
     */ static storeAll(redirects) {
        for(let key in redirects)redirects[key] = this.store(redirects[key]);
        return (0, $2Y8XI.Services).storeAll(redirects);
    }
    static store(redirect) {
        return (0, $2Y8XI.Services).store("id", this.redirects, redirect);
    }
    static unStore(redirect) {
        (0, $2Y8XI.Services).unStore("id", this.redirects, redirect);
    }
}
$3a0c3aae00adeeac$export$c4ef83c71ef62b92.redirects = (0, $i3Hbv.observable)([]);

});


parcelRegister("1b6Hd", function(module, exports) {

$parcel$export(module.exports, "PreferencesService", function () { return $cfeb42a5c4fe0291$export$cc55b2103fd9a32b; });

var $e4AOZ = parcelRequire("e4AOZ");

var $dEtAh = parcelRequire("dEtAh");
class $cfeb42a5c4fe0291$export$cc55b2103fd9a32b {
    static get editorSpellChecker() {
        return this._editorSpellChecker;
    }
    static set editorSpellChecker(value) {
        (0, $dEtAh.SedestralStorage).setItem("_editorSpellChecker", JSON.stringify(value));
        this._editorSpellChecker = value;
    }
    static get editorLineMode() {
        return this._editorLineMode;
    }
    static set editorLineMode(value) {
        (0, $dEtAh.SedestralStorage).setItem("_editorLineMode", value);
        this._editorLineMode = value;
    }
    static get mediaVolume() {
        return this._mediaVolume;
    }
    static set mediaVolume(value) {
        (0, $dEtAh.SedestralStorage).setItem("_mediaVolume", "" + value);
        this._mediaVolume = value;
    }
    static get siteChannelPickerSelected() {
        return this._siteChannelPickerSelected;
    }
    static set siteChannelPickerSelected(value) {
        this._siteChannelPickerSelected = value;
        if (value == undefined) (0, $dEtAh.SedestralStorage).removeItem("_siteChannelPickerSelected");
        else (0, $dEtAh.SedestralStorage).setItem("_siteChannelPickerSelected", value);
    }
    static get inboxBodyDetailsClosed() {
        return this._inboxBodyDetailsClosed;
    }
    static set inboxBodyDetailsClosed(value) {
        (0, $dEtAh.SedestralStorage).setItem("_inboxBodyDetailsClosed", JSON.stringify(value));
        this._inboxBodyDetailsClosed = value;
    }
    static get inboxSearchValue() {
        return this._inboxSearchValue;
    }
    static set inboxSearchValue(value) {
        this._inboxSearchValue = value;
        if (value == undefined) (0, $dEtAh.SedestralStorage).removeItem("_inboxSearchValue");
        else (0, $dEtAh.SedestralStorage).setItem("_inboxSearchValue", value);
    }
    static get inboxSearchFilterData() {
        return this._inboxSearchFilterData;
    }
    static set inboxSearchFilterData(value) {
        this._inboxSearchFilterData = value;
        if (value == undefined) (0, $dEtAh.SedestralStorage).removeItem("_inboxSearchFilterData");
        else (0, $dEtAh.SedestralStorage).setItem("_inboxSearchFilterData", value);
    }
    static get inboxSearchSort() {
        return this._inboxSearchSort;
    }
    static set inboxSearchSort(value) {
        this._inboxSearchSort = value;
        if (value == undefined) (0, $dEtAh.SedestralStorage).removeItem("_inboxSearchSort");
        else (0, $dEtAh.SedestralStorage).setItem("_inboxSearchSort", "" + value);
    }
    static get inboxFilterEntryId() {
        return this._inboxFilterEntryId;
    }
    static set inboxFilterEntryId(value) {
        this._inboxFilterEntryId = value;
        (0, $dEtAh.SedestralStorage).setItem("_inboxFilterEntryId", value);
    }
    static get inboxFilterEntryData() {
        return this._inboxFilterEntryData;
    }
    static set inboxFilterEntryData(value) {
        this._inboxFilterEntryData = value;
        (0, $dEtAh.SedestralStorage).setItem("_inboxFilterEntryData", value);
    }
    static get inboxFilterEntryName() {
        return this._inboxFilterEntryName;
    }
    static set inboxFilterEntryName(value) {
        this._inboxFilterEntryName = value;
        (0, $dEtAh.SedestralStorage).setItem("_inboxFilterEntryName", value);
    }
    static get inboxFilterId() {
        return this._inboxFilterId;
    }
    static set inboxFilterId(value) {
        this._inboxFilterId = value;
        (0, $dEtAh.SedestralStorage).setItem("_inboxFilterId", value);
    }
    static get inboxFilterData() {
        return this._inboxFilterData;
    }
    static set inboxFilterData(value) {
        this._inboxFilterData = value;
        (0, $dEtAh.SedestralStorage).setItem("_inboxFilterData", value);
    }
    static get inboxFilterName() {
        return this._inboxFilterName;
    }
    static set inboxFilterName(value) {
        this._inboxFilterName = value;
        (0, $dEtAh.SedestralStorage).setItem("_inboxFilterName", value);
    }
    static get contactDetailsSort() {
        return this._contactDetailsSort;
    }
    static set contactDetailsSort(value) {
        (0, $dEtAh.SedestralStorage).setItem("_contactDetailsSort", value);
        this._contactDetailsSort = value;
    }
    static get statisticsInboxHomeDays() {
        return this._statisticsInboxHomeDays;
    }
    static set statisticsInboxHomeDays(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxHomeDays", "" + value);
        this._statisticsInboxHomeDays = value;
    }
    static get statisticsInboxConversationFilters() {
        return this._statisticsInboxConversationFilters == "undefined" || this._statisticsInboxConversationFilters == "null" ? undefined : this._statisticsInboxConversationFilters;
    }
    static set statisticsInboxConversationFilters(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxConversationCountFilters", value);
        this._statisticsInboxConversationFilters = value;
    }
    static get statisticsInboxMessagesFilters() {
        return this._statisticsInboxMessagesFilters == "undefined" || this._statisticsInboxMessagesFilters == "null" ? undefined : this._statisticsInboxMessagesFilters;
    }
    static set statisticsInboxMessagesFilters(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxMessagesFilters", value);
        this._statisticsInboxMessagesFilters = value;
    }
    static get statisticsInboxMembersSort() {
        return this._statisticsInboxMembersSort == "undefined" || this._statisticsInboxMembersSort == "null" ? undefined : this._statisticsInboxMembersSort;
    }
    static set statisticsInboxMembersSort(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxMembersSort", value);
        this._statisticsInboxMembersSort = value;
    }
    static get statisticsInboxSplitType() {
        return this._statisticsInboxSplitType;
    }
    static set statisticsInboxSplitType(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxConversationCountSplitType", "" + value);
        this._statisticsInboxSplitType = value;
    }
    static get statisticsInboxFirstInterval() {
        return this._statisticsInboxFirstInterval;
    }
    static set statisticsInboxFirstInterval(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxConversationCountFirstInterval", value);
        this._statisticsInboxFirstInterval = value;
    }
    static get statisticsInboxSecondInterval() {
        return this._statisticsInboxSecondInterval;
    }
    static set statisticsInboxSecondInterval(value) {
        (0, $dEtAh.SedestralStorage).setItem("_statisticsInboxConversationCountSecondInterval", value);
        this._statisticsInboxSecondInterval = value;
    }
    static get timeZoneOffset() {
        return this._timeZoneOffset;
    }
    static set timeZoneOffset(value) {
        (0, $dEtAh.SedestralStorage).setItem("_timeZoneOffset", "" + value);
        this._timeZoneOffset = value;
    }
    static get timeZoneName() {
        return this._timeZoneName;
    }
    static set timeZoneName(value) {
        (0, $dEtAh.SedestralStorage).setItem("_timeZoneName", "" + value);
        this._timeZoneName = value;
    }
    static get hour12() {
        return this._hour12;
    }
    static set hour12(value) {
        (0, $dEtAh.SedestralStorage).setItem("_hour12", JSON.stringify(value));
        this._hour12 = value;
    }
    static get livechatPopupCloseTime() {
        return this._livechatPopupCloseTime;
    }
    static set livechatPopupCloseTime(value) {
        (0, $dEtAh.SedestralStorage).setItem("_livechatPopupCloseTime", "" + value);
        this._livechatPopupCloseTime = value;
    }
    static init() {
        this._editorSpellChecker = JSON.parse((0, $dEtAh.SedestralStorage).getItem("_editorSpellChecker"));
        this._editorLineMode = (0, $dEtAh.SedestralStorage).getItem("_editorLineMode");
        this._contactDetailsSort = (0, $dEtAh.SedestralStorage).getItem("_contactDetailsSort");
        this._mediaVolume = (0, $dEtAh.SedestralStorage).getItem("_mediaVolume") == undefined ? 0.5 : parseFloat((0, $dEtAh.SedestralStorage).getItem("_mediaVolume"));
        this._livechatPopupCloseTime = (0, $dEtAh.SedestralStorage).getItem("_livechatPopupCloseTime") == undefined ? 0 : Number((0, $dEtAh.SedestralStorage).getItem("_livechatPopupCloseTime"));
        this._inboxFilterName = (0, $dEtAh.SedestralStorage).getItem("_inboxFilterName") == undefined ? "Inbox" : (0, $dEtAh.SedestralStorage).getItem("_inboxFilterName");
        this._inboxFilterEntryName = (0, $dEtAh.SedestralStorage).getItem("_inboxFilterEntryName") == undefined ? "G\xe9n\xe9ral" : (0, $dEtAh.SedestralStorage).getItem("_inboxFilterEntryName");
        this._inboxFilterEntryData = (0, $dEtAh.SedestralStorage).getItem("_inboxFilterEntryData") == undefined ? "inbox" : (0, $dEtAh.SedestralStorage).getItem("_inboxFilterEntryData");
        this._inboxFilterEntryId = (0, $dEtAh.SedestralStorage).getItem("_inboxFilterEntryId") == undefined ? "inbox" : (0, $dEtAh.SedestralStorage).getItem("_inboxFilterEntryId");
        this._inboxSearchValue = (0, $dEtAh.SedestralStorage).getItem("_inboxSearchValue");
        this._siteChannelPickerSelected = (0, $dEtAh.SedestralStorage).getItem("_siteChannelPickerSelected");
        this._inboxSearchSort = (0, $dEtAh.SedestralStorage).getItem("_inboxSearchSort") == undefined ? (0, $e4AOZ.OperatorType).ORDER_DESC : parseInt((0, $dEtAh.SedestralStorage).getItem("_inboxSearchSort"));
        this._inboxSearchFilterData = (0, $dEtAh.SedestralStorage).getItem("_inboxSearchFilterData");
        this._inboxFilterId = (0, $dEtAh.SedestralStorage).getItem("_inboxFilterId") == undefined ? "inbox" : (0, $dEtAh.SedestralStorage).getItem("_inboxFilterId");
        this._inboxFilterData = (0, $dEtAh.SedestralStorage).getItem("_inboxFilterData") == undefined ? "inbox" : (0, $dEtAh.SedestralStorage).getItem("_inboxFilterData");
        this._inboxBodyDetailsClosed = JSON.parse((0, $dEtAh.SedestralStorage).getItem("_inboxBodyDetailsClosed"));
        this._statisticsInboxHomeDays = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxHomeDays") == undefined ? 7 : parseInt((0, $dEtAh.SedestralStorage).getItem("_statisticsInboxHomeDays"));
        this._statisticsInboxConversationFilters = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxConversationCountFilters");
        this._statisticsInboxMessagesFilters = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxMessagesFilters");
        this._statisticsInboxMembersSort = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxMembersSort");
        this._statisticsInboxSplitType = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxConversationCountSplitType") == undefined ? -1 : parseInt((0, $dEtAh.SedestralStorage).getItem("_statisticsInboxConversationCountSplitType"));
        this._statisticsInboxFirstInterval = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxConversationCountFirstInterval");
        this._statisticsInboxSecondInterval = (0, $dEtAh.SedestralStorage).getItem("_statisticsInboxConversationCountSecondInterval");
        this._timeZoneOffset = new Date().getTimezoneOffset();
        this._timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this._hour12 = new Intl.DateTimeFormat().resolvedOptions().hour12;
    }
    static dispose() {}
}

});
parcelRegister("e4AOZ", function(module, exports) {

$parcel$export(module.exports, "OperatorType", function () { return $7cf1e0abb5e22052$export$c18bb9d3f9b808b3; });
var $7cf1e0abb5e22052$export$c18bb9d3f9b808b3;
(function(OperatorType) {
    OperatorType[OperatorType["IS"] = 1] = "IS";
    OperatorType[OperatorType["IS_NOT"] = 2] = "IS_NOT";
    OperatorType[OperatorType["CONTAINS_ALL"] = 12] = "CONTAINS_ALL";
    OperatorType[OperatorType["CONTAINS"] = 3] = "CONTAINS";
    OperatorType[OperatorType["NOT_CONTAINS"] = 4] = "NOT_CONTAINS";
    OperatorType[OperatorType["EXIST"] = 5] = "EXIST";
    OperatorType[OperatorType["NOT_EXIST"] = 6] = "NOT_EXIST";
    OperatorType[OperatorType["GREATER"] = 7] = "GREATER";
    OperatorType[OperatorType["AFTER"] = 10] = "AFTER";
    OperatorType[OperatorType["LESS"] = 8] = "LESS";
    OperatorType[OperatorType["BEFORE"] = 9] = "BEFORE";
    OperatorType[OperatorType["STARTS_WITH"] = 16] = "STARTS_WITH";
    OperatorType[OperatorType["ENDS_WITH"] = 17] = "ENDS_WITH";
    OperatorType[OperatorType["ORDER_DESC"] = 14] = "ORDER_DESC";
    OperatorType[OperatorType["ORDER_ASC"] = 15] = "ORDER_ASC";
    OperatorType[OperatorType["INTERVAL"] = 11] = "INTERVAL";
})($7cf1e0abb5e22052$export$c18bb9d3f9b808b3 || ($7cf1e0abb5e22052$export$c18bb9d3f9b808b3 = {}));

});


parcelRegister("dEIDr", function(module, exports) {

$parcel$export(module.exports, "ComType", function () { return $18b60e3a9583c841$export$eb6444840b6d30cf; });
var $18b60e3a9583c841$export$eb6444840b6d30cf;
(function(ComType) {
    ComType[ComType["DIRECT_MESSAGE"] = 1] = "DIRECT_MESSAGE";
    ComType[ComType["EMAIL"] = 2] = "EMAIL";
})($18b60e3a9583c841$export$eb6444840b6d30cf || ($18b60e3a9583c841$export$eb6444840b6d30cf = {}));

});





parcelRegister("dH00N", function(module, exports) {

$parcel$export(module.exports, "Models", function () { return $f1ebd9544e1eb9b6$export$6edbc060ce567afa; });
class $f1ebd9544e1eb9b6$export$6edbc060ce567afa {
    static isPreviewModel(objet) {
        return objet["baseUrl"] != undefined;
    }
    static isContactModel(object) {
        return object["sessionsCount"] != undefined;
    }
    static isMediaModel(object) {
        return object["extension"] != undefined;
    }
    static isAccountModel(object) {
        return object["account"] != undefined;
    }
    static isEntityModel(object) {
        return this.isAccountModel(object) || this.isContactModel(object);
    }
}

});

parcelRegister("l8ea0", function(module, exports) {

$parcel$export(module.exports, "ContactService", function () { return $b116f891c2396ac5$export$7500cbca02a113b2; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $g0YRJ = parcelRequire("g0YRJ");

var $jRVhz = parcelRequire("jRVhz");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $5pJMm = parcelRequire("5pJMm");

var $9qBer = parcelRequire("9qBer");

var $l3pV9 = parcelRequire("l3pV9");

var $2eT6g = parcelRequire("2eT6g");

var $kfkzw = parcelRequire("kfkzw");
class $b116f891c2396ac5$export$7500cbca02a113b2 {
    static dispose() {
        this.contacts = (0, $i3Hbv.observable)([]);
        this.details = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).CONTACT_UPDATE, (data)=>this.store(data));
    }
    /**
     * load
     */ static async findById(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/contact/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findChannelsById(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/contact/channels/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $jRVhz.ContactChannelService).storeAll(request.data);
        return undefined;
    }
    static async findDetailsById(id, component) {
        component.addNetworkErrors([
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            },
            {
                status: (0, $7ZaxO.HttpStatus).UNAUTHORIZED,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/contact/details/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            request.data.contact = this.store(request.data.contact);
            request.data.id = request.data.contact.id;
            if (request.data.notes != undefined) request.data.notes = (0, $l3pV9.NoteService).storeAll(request.data.notes);
            request.data.lastSession = (0, $9qBer.ContactSessionService).store(request.data.lastSession);
            return this.storeDetails(request.data);
        }
        return undefined;
    }
    static async findActivesStats(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/contact/actives`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findCounts(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/contact/counts/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findAll(data, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/contact/find`, data, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let all = request.data;
            all.contacts = this.storeAll(all.contacts);
            return all;
        }
        return undefined;
    }
    static async update(id, name, email, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/contact/update", {
            id: id,
            name: name,
            email: email
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async state(contactId, state, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/contact/state/${contactId}/${state}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async create(contactId, name, email, numberPhone, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/contact/create", {
            contactId: contactId,
            email: email,
            name: name,
            numberPhone: numberPhone
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateAll(contacts, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/contact/update/all", contacts, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    /**
     * logic
     */ static addNote(contactId, note) {
        let details = this.details.find((value)=>value.id == contactId);
        if (details) {
            if (details.notes != undefined && details.notes.filter((value)=>value.id == note.id)[0] == undefined) details.notes.push(note);
        }
    }
    static removeNote(contactId, note) {
        let details = this.details.find((value)=>value.id == contactId);
        if (details) {
            if (details.notes != undefined && details.notes.filter((value)=>value.id == note.id)[0] != undefined) details.notes.splice(details.notes.indexOf(note), 1);
        }
    }
    /**
     * websocket
     */ static async join(id) {
        if (id != null) await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).PANEL, id, (0, $2eT6g.WebSocketPanelEventName).CONTACT_JOIN);
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).CONTACT_LEAVE, id);
    }
    /**
     * store
     */ static storeDetails(details) {
        return (0, $2Y8XI.Services).store("id", this.details, details);
    }
    static storeAll(contacts) {
        for(let key in contacts)contacts[key] = this.store(contacts[key]);
        return (0, $2Y8XI.Services).storeAll(contacts);
    }
    static store(contact) {
        if (contact.avatar != undefined) contact.avatar = (0, $g0YRJ.AvatarService).store(contact.avatar);
        if (contact.channels != undefined) contact.channels = (0, $jRVhz.ContactChannelService).storeAll(contact.channels);
        if (!contact.columnsData) contact.columnsData = {};
        contact.type = (0, $5pJMm.EntityType).CONTACT;
        contact = (0, $2Y8XI.Services).store("id", this.contacts, contact);
        return contact;
    }
    static storeActives(contactsActives) {
        for(let contactId in contactsActives){
            let active = contactsActives[contactId];
            let contact = (0, $2Y8XI.Services).get("id", this.contacts, contactId);
            if (contact !== undefined) {
                contact.active = active;
                (0, $2Y8XI.Services).store("id", this.contacts, contact);
            }
        }
    }
}
$b116f891c2396ac5$export$7500cbca02a113b2.contacts = (0, $i3Hbv.observable)([]);
$b116f891c2396ac5$export$7500cbca02a113b2.details = (0, $i3Hbv.observable)([]);

});
parcelRegister("jRVhz", function(module, exports) {

$parcel$export(module.exports, "ContactChannelService", function () { return $dc80b4dc497966a2$export$3e8bc3e1cb0c867a; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $9jYbZ = parcelRequire("9jYbZ");
class $dc80b4dc497966a2$export$3e8bc3e1cb0c867a {
    static dispose() {
        this.channels = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * store
     */ static storeAll(channels) {
        for(let key in channels)channels[key] = this.store(channels[key]);
        return (0, $2Y8XI.Services).storeAll(channels);
    }
    static store(channel) {
        if (channel.siteChannels) channel.siteChannels = (0, $9jYbZ.SiteChannelService).storeAll(channel.siteChannels);
        channel = (0, $2Y8XI.Services).store("id", this.channels, channel);
        return channel;
    }
}
$dc80b4dc497966a2$export$3e8bc3e1cb0c867a.channels = (0, $i3Hbv.observable)([]);

});

parcelRegister("9qBer", function(module, exports) {

$parcel$export(module.exports, "ContactSessionService", function () { return $f6f826778595f47e$export$9cff05b91414610e; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $f6f826778595f47e$export$9cff05b91414610e {
    static dispose() {
        this.sessions = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * store
     */ static storeAll(sessions) {
        for(let key in sessions)sessions[key] = this.store(sessions[key]);
        return (0, $2Y8XI.Services).storeAll(sessions);
    }
    static store(session) {
        if (session != undefined) {
            session = (0, $2Y8XI.Services).store("id", this.sessions, session);
            return session;
        }
    }
}
$f6f826778595f47e$export$9cff05b91414610e.sessions = (0, $i3Hbv.observable)([]);

});

parcelRegister("l3pV9", function(module, exports) {

$parcel$export(module.exports, "NoteService", function () { return $3b3b0a0ef823868c$export$3fe64b3b1d79393c; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $h0ByL = parcelRequire("h0ByL");

var $68Z0d = parcelRequire("68Z0d");

var $2eT6g = parcelRequire("2eT6g");

var $l8ea0 = parcelRequire("l8ea0");

var $kfkzw = parcelRequire("kfkzw");
class $3b3b0a0ef823868c$export$3fe64b3b1d79393c {
    static dispose() {
        this.notes = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).NOTE_NEW, (data)=>{
            this.store(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).NOTE_DELETE, (data)=>{
            this.unStore(data);
        });
    }
    /**
     * load
     */ static async create(contentId, type, text, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/notes", {
            contentId: contentId,
            type: type,
            text: text
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async delete(noteId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/notes/${noteId}`, component);
    /*
        if (request.status == HttpStatus.OK)
            this.unStore(request.data);

         */ }
    /**
     * store
     */ static storeAll(notes) {
        for(let key in notes)notes[key] = this.store(notes[key]);
        return (0, $2Y8XI.Services).storeAll(notes);
    }
    static store(note) {
        note.author = (0, $68Z0d.EntityService).store(note.author);
        note = (0, $2Y8XI.Services).store("id", this.notes, note);
        this.entityUpdate(note, true);
        return note;
    }
    static unStore(note) {
        note = (0, $2Y8XI.Services).unStore("id", this.notes, note);
        if (note != undefined) this.entityUpdate(note, false);
    }
    static entityUpdate(note, isStore) {
        if (note.type == (0, $h0ByL.NoteType).CONTACT) {
            if (isStore) (0, $l8ea0.ContactService).addNote(note.contentId, note);
            else (0, $l8ea0.ContactService).removeNote(note.contentId, note);
        }
    }
}
$3b3b0a0ef823868c$export$3fe64b3b1d79393c.notes = (0, $i3Hbv.observable)([]);

});
parcelRegister("h0ByL", function(module, exports) {

$parcel$export(module.exports, "NoteType", function () { return $13657c6069028144$export$7725531246cac2b9; });
var $13657c6069028144$export$7725531246cac2b9;
(function(NoteType) {
    NoteType[NoteType["CONTACT"] = 1] = "CONTACT";
})($13657c6069028144$export$7725531246cac2b9 || ($13657c6069028144$export$7725531246cac2b9 = {}));

});



parcelRegister("j8ebN", function(module, exports) {

$parcel$export(module.exports, "PreviewService", function () { return $f03233c3c182bdcd$export$f1f35c887a42c378; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $ayMnG = parcelRequire("ayMnG");

var $271MM = parcelRequire("271MM");

var $kfkzw = parcelRequire("kfkzw");
class $f03233c3c182bdcd$export$f1f35c887a42c378 {
    static dispose() {
        this.previews = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * load
     */ static async findByUrl(url, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/preview/get`, {
            url: url
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static proxyUrl(preview) {
        switch(preview.type){
            case (0, $ayMnG.PreviewType).GIF:
            case (0, $ayMnG.PreviewType).FILE:
            case (0, $ayMnG.PreviewType).AUDIO:
            case (0, $ayMnG.PreviewType).IMAGE:
            case (0, $ayMnG.PreviewType).VIDEO:
                if (preview.baseUrl != undefined && !this.proxyBypass(preview)) return (0, $271MM.config).httpPanelUrl + `/proxy?hash=${preview.id}&url=${encodeURI(preview.baseUrl)}`;
                break;
            case (0, $ayMnG.PreviewType).WEBSITE:
                if (preview.fileUrl != undefined) {
                    console.log(preview.fileUrl);
                    return (0, $271MM.config).httpPanelUrl + `/proxy?hash=${preview.id}&url=${encodeURI(preview.fileUrl)}`;
                }
                break;
        }
        return preview.baseUrl;
    }
    static proxyBypass(preview) {
        return preview.baseUrl.startsWith((0, $271MM.config).tenorMediaHost);
    }
    /**
     * store
     */ static storeAll(previews) {
        for(let key in previews)previews[key] = this.store(previews[key]);
        return (0, $2Y8XI.Services).storeAll(previews);
    }
    static store(preview) {
        preview = (0, $2Y8XI.Services).store("id", this.previews, preview);
        return preview;
    }
}
$f03233c3c182bdcd$export$f1f35c887a42c378.previews = (0, $i3Hbv.observable)([]);

});
parcelRegister("ayMnG", function(module, exports) {

$parcel$export(module.exports, "PreviewType", function () { return $ff97855fee9fb07b$export$ec949ba0ad63fae4; });
var $ff97855fee9fb07b$export$ec949ba0ad63fae4;
(function(PreviewType) {
    PreviewType[PreviewType["WEBSITE"] = 1] = "WEBSITE";
    PreviewType[PreviewType["IMAGE"] = 2] = "IMAGE";
    PreviewType[PreviewType["VIDEO"] = 3] = "VIDEO";
    PreviewType[PreviewType["GIF"] = 4] = "GIF";
    PreviewType[PreviewType["FILE"] = 5] = "FILE";
    PreviewType[PreviewType["AUDIO"] = 6] = "AUDIO";
})($ff97855fee9fb07b$export$ec949ba0ad63fae4 || ($ff97855fee9fb07b$export$ec949ba0ad63fae4 = {}));

});


parcelRegister("fdmdr", function(module, exports) {

$parcel$export(module.exports, "SiteService", function () { return $850cf6f71545fc5e$export$eb480a33ba4bd7a; });

var $7AbeR = parcelRequire("7AbeR");

var $2eT6g = parcelRequire("2eT6g");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $g0YRJ = parcelRequire("g0YRJ");

var $kZE1x = parcelRequire("kZE1x");

var $7Aqrk = parcelRequire("7Aqrk");

var $l8ea0 = parcelRequire("l8ea0");

var $7ZaxO = parcelRequire("7ZaxO");

var $lTF9x = parcelRequire("lTF9x");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");

var $68Z0d = parcelRequire("68Z0d");

var $32rNO = parcelRequire("32rNO");
class $850cf6f71545fc5e$export$eb480a33ba4bd7a {
    static dispose() {
        this.sites = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_JOIN_ACCOUNT, (data)=>(0, $7Aqrk.AccountService).store(data));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_LEAVE_ACCOUNT, (data)=>{
            let account = (0, $7Aqrk.AccountService).store(data);
            account.siteId = undefined;
            account.active = false;
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_UPDATE_ACTIVE_CONTACT, (data)=>(0, $l8ea0.ContactService).storeActives(data));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_UPDATE, (data)=>this.store(data));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_NEW_CONVERSATION, (data)=>{
            data = (0, $kZE1x.InboxConversationService).store(data);
            (0, $kZE1x.InboxConversationService).newConversation(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_RELOAD, ()=>this.onReload());
    }
    /**
     * http
     */ static async findActiveAccounts(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/activeAccounts`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            request.data = (0, $7Aqrk.AccountService).storeAll(request.data);
            return request.data;
        }
        return undefined;
    }
    static async findMind(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/sites/mind`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async findStatistics(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/sites/statistics`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async select(siteId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites/select", {
            siteId: siteId
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async unSelect(siteId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites/unselect", {
            siteId: siteId
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async create(name, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SITE_COUNT_MAX,
                message: (0, $5FliW.Resources).t("words.maxSite")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites", {
            name: name
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateAvatar(files, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).PANEL, `/sites/avatar/update`, {
            files: files
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async update(name, link, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites/update", {
            name: name,
            link: link
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateAddress(address, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/sites/update/address", address, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async orderColumns(columns, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/sites/column/order`, columns, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createColumn(siteColumn, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/sites/column`, siteColumn, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async deleteColumn(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/sites/column/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async getTaxTypes(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/sites/taxTypes`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    /**
     * websocket
     */ static async join(id) {
        if (id != null) await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).PANEL, id, (0, $2eT6g.WebSocketPanelEventName).SITE_JOIN);
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_LEAVE, id);
    }
    /**
     * override
     */ static onReload() {}
    /**
     * store
     */ static storeAll(conversations) {
        for(let key in conversations)conversations[key] = this.store(conversations[key]);
        return (0, $2Y8XI.Services).storeAll(conversations);
    }
    static store(site) {
        if (site != undefined) {
            if (site.columnsContacts) site.columnsContacts = (0, $lTF9x.SiteColumnsContactService).store(site.columnsContacts);
            else site.columnsContacts = (0, $lTF9x.SiteColumnsContactService).standard;
            if ((0, $68Z0d.EntityService).activeSite && (0, $68Z0d.EntityService).activeSite.id == site.id) (0, $68Z0d.EntityService).activeSite = site;
            site.avatar = (0, $g0YRJ.AvatarService).store(site.avatar);
            site.paymentProvider = (0, $32rNO.getPaymentProviderById)(site.paymentProviderType);
            return (0, $2Y8XI.Services).store("id", this.sites, site);
        }
    }
}
$850cf6f71545fc5e$export$eb480a33ba4bd7a.sites = (0, $i3Hbv.observable)([]);

});
parcelRegister("kZE1x", function(module, exports) {

$parcel$export(module.exports, "InboxConversationService", function () { return $c376b46e67e9a7ac$export$c15b46ac94b7bc1a; });

var $7AbeR = parcelRequire("7AbeR");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7ZaxO = parcelRequire("7ZaxO");

var $9jYbZ = parcelRequire("9jYbZ");

var $f0JQp = parcelRequire("f0JQp");

var $2eT6g = parcelRequire("2eT6g");

var $68Z0d = parcelRequire("68Z0d");

var $bns9j = parcelRequire("bns9j");

var $dEIDr = parcelRequire("dEIDr");

var $6bq2D = parcelRequire("6bq2D");

var $4d5jz = parcelRequire("4d5jz");

var $5pJMm = parcelRequire("5pJMm");

var $4uV0z = parcelRequire("4uV0z");

var $fVKoy = parcelRequire("fVKoy");

var $1b6Hd = parcelRequire("1b6Hd");

var $lAwIV = parcelRequire("lAwIV");

var $gRsj9 = parcelRequire("gRsj9");

var $jRVhz = parcelRequire("jRVhz");

var $e4AOZ = parcelRequire("e4AOZ");

var $gbrl3 = parcelRequire("gbrl3");

var $ec2Gs = parcelRequire("ec2Gs");

var $kfkzw = parcelRequire("kfkzw");

var $5FliW = parcelRequire("5FliW");

var $bOsdQ = parcelRequire("bOsdQ");

var $32Z3V = parcelRequire("32Z3V");

var $7q3ie = parcelRequire("7q3ie");

var $lQXpd = parcelRequire("lQXpd");
class $c376b46e67e9a7ac$export$c15b46ac94b7bc1a {
    static dispose() {
        this.conversations = (0, $i3Hbv.observable)([]);
        this.newConversationEvents = [];
        this.messageConversationEvents = [];
        this.conversationUpdatesEvents = [];
        this.conversationUpdateStatusEvents = [];
        this.conversationUpdateDeleteEvents = [];
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATION_UPDATE_LIGHT_LIST, (conversations)=>this.storeAll(conversations));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATION_UPDATE_LIGHT, (conversation)=>this.store(conversation));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATION_UPDATE_LIST, (conversations)=>conversations.forEach((c)=>this.execUpdate(c)));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATION_UPDATE, (conversation)=>this.execUpdate(conversation));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATIONS_DELETE, (conversationsIds)=>{
            conversationsIds.forEach((id)=>{
                let conversation = this.getById(id);
                if (conversation) {
                    conversation.state = (0, $lAwIV.ComState).DELETED;
                    this.execUpdate(conversation);
                    this.unStore(conversation);
                }
            });
            this.deleteConversation(conversationsIds);
        });
    }
    /**
     * Websocket
     */ static join(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATION_JOIN, id);
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).INBOX_CONVERSATION_LEAVE, id);
    }
    /**
     * rest
     */ static async findOnInbox(siteId, count, beforeTime, filterEntryId, filterId, searchFilterData, searchValue, searchSort, component) {
        let request = await (0, $7AbeR.Network).request((0, $kfkzw.ProductType).PANEL, (token)=>(0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/conversations/site", {
                siteId: siteId,
                count: count,
                beforeTime: beforeTime,
                filterEntryId: filterEntryId,
                filterId: filterId,
                searchFilterData: JSON.parse(searchFilterData ? searchFilterData : "{}"),
                searchValue: searchValue,
                searchSort: searchSort
            }), component);
        if (request != undefined && request.status == (0, $7ZaxO.HttpStatus).OK) {
            let conversations = this.storeAll(request.data);
            conversations = this.sort(conversations);
            if (searchSort == (0, $e4AOZ.OperatorType).ORDER_ASC) conversations = conversations.reverse();
            return conversations;
        }
        return [];
    }
    static async findBySiteAndFilter(siteId, count, beforeTime, waste, filterData, component) {
        let request = await (0, $7AbeR.Network).request((0, $kfkzw.ProductType).PANEL, (token)=>(0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/conversations/site/filters/${siteId}/${count}/${beforeTime}/${waste}`, JSON.parse(filterData)), component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findInboxCountsBySite(siteId, filterId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/conversations/site/inboxCounts/${siteId}/${filterId}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return [];
    }
    static async findById(id, component) {
        let conversation = this.getById(id);
        if (conversation != undefined) return conversation;
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).UNAUTHORIZED,
                message: (0, $5FliW.Resources).t("words.conversationsNotAvailableMessage")
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/conversations/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findAttachmentsById(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/conversations/attachments/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $fVKoy.InboxConversationMessageAttachmentService).storeAll(request.data);
        return undefined;
    }
    static async updateStatus(conversationsIds, conversationStatus, categoriesIds, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/status/update", {
            conversationsIds: conversationsIds,
            conversationStatus: conversationStatus,
            categoriesIds: categoriesIds
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async updateCategory(conversationsIds, categoryId, remove, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/categories/update", {
            remove: remove,
            conversationsIds: conversationsIds,
            categoryId: categoryId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async updateRating(id, rating, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/rating/update", {
            id: id,
            rating: rating
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.store(request.data);
            return true;
        }
        return false;
    }
    static async create(siteChannelId, comType, snippet, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations", {
            siteChannelId: siteChannelId,
            comType: comType,
            snippet: snippet
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async start(start, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/conversations/start`, start, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            request.data.conversation = this.store(request.data.conversation);
            if (request.data.message) request.data.message = (0, $ec2Gs.InboxConversationMessageService).store(request.data.message);
            return request.data;
        }
        return undefined;
    }
    static async read(conversationsIds, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/read", {
            conversationsIds: conversationsIds
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async markUnread(conversationsIds, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/markUnread", {
            conversationsIds: conversationsIds
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async mute(conversationsIds, mute, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/mute", {
            conversationsIds: conversationsIds,
            mute: mute
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async state(conversationsIds, state, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/state", {
            conversationsIds: conversationsIds,
            state: state
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async compose(recipients, component) {
        if ((0, $7AbeR.Network).router.static.components.composer.canTab()) {
            let siteChannel = await (0, $9jYbZ.SiteChannelService).pickedByPerms(component, (0, $bOsdQ.ChannelType).MAIL);
            if (siteChannel) {
                let comType = (0, $9jYbZ.SiteChannelService).comType(siteChannel);
                let message = (0, $ec2Gs.InboxConversationMessageService).virtualGenerateDto(comType, undefined);
                message.comState = (0, $lAwIV.ComState).DRAFT;
                message.comType = (0, $dEIDr.ComType).EMAIL;
                if (siteChannel.channel.type == (0, $bOsdQ.ChannelType).MAIL) message.metaData = {
                    mail: {
                        to: recipients
                    }
                };
                let startData = await $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.start({
                    comType: comType,
                    sendMessage: true,
                    comState: (0, $lAwIV.ComState).DRAFT,
                    siteChannelId: siteChannel.id,
                    message: message
                });
                if (startData) {
                    await (0, $32Z3V.AccountComposerService).createTab({
                        type: (0, $7q3ie.ComposerType).CONVERSATION_MESSAGE,
                        contentId: startData.message.id
                    }, component);
                    return true;
                }
            } else (0, $7AbeR.Network).router.static.components.composer.renderTab({
                type: (0, $7q3ie.ComposerType).EMPTY,
                contentId: (0, $5FliW.Resources).t("words.createEmailBeforeConversation")
            }, true);
        }
        return false;
    }
    /**
     * get
     */ static getById(id) {
        return this.conversations.filter((value)=>value.id == id)[0];
    }
    static getAll(count) {
        this.conversations.length;
        let conversations = [
            ...this.conversations
        ];
        if (count == undefined) return this.sort(conversations);
        else return this.sort(conversations).slice(0, count);
    }
    static getUnReadsByEntity(entityType, entityId, conversations) {
        let unReads = 0;
        conversations.map((conversation)=>{
            let participant = $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.getParticipantByEntity(entityType, entityId, conversation);
            if (participant != undefined) unReads += participant.unreadCount;
        });
        return unReads;
    }
    static getParticipantByEntity(entityType, entityId, conversation) {
        return conversation.participants.filter((value)=>value.participantId == entityId && value.participantType == entityType)[0];
    }
    static getMyParticipant(conversation) {
        return $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.getParticipantByEntity((0, $68Z0d.EntityService).activeEntity.type, (0, $68Z0d.EntityService).activeEntity.id, conversation);
    }
    static iamParticipant(conversation) {
        let myParticipant = $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.getMyParticipant(conversation);
        return myParticipant != undefined && myParticipant.state == (0, $gbrl3.AssignableState).JOINED;
    }
    static getParticipantsByType(type, conversation) {
        let participants = conversation.participants.filter((value)=>value.participantType == type);
        participants.sort((a, b)=>a.lastMessageTime > b.lastMessageTime ? 1 : -1);
        participants.reverse();
        return participants.length > 0 ? participants : [
            conversation.owner
        ];
    }
    /**
     * logic
     */ static newMessage(message) {
        let conversation = $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.getById(message.conversationId);
        if (conversation != undefined) {
            conversation.newMessages.push(message);
            this.messageConversationEvents.forEach((value)=>value(conversation, message));
            conversation.isNew = false;
        }
    }
    static newConversation(conversation) {
        conversation.isNew = true;
        this.newConversationEvents.forEach((value)=>value(conversation));
    }
    static updateConversation(conversation) {
        this.conversationUpdatesEvents.forEach((value)=>value(conversation));
    }
    static updateStatusConversation(conversation) {
        this.conversationUpdateStatusEvents.forEach((value)=>value(conversation));
    }
    static deleteConversation(conversationsIds) {
        //conversations.isNew = false;
        this.conversationUpdateDeleteEvents.forEach((value)=>value(conversationsIds));
    }
    static sort(conversations) {
        return conversations.sort((a, b)=>a.updatedTime > b.updatedTime ? 1 : -1).reverse();
    }
    static activeEntityRead(conversation) {
        let participant = $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.getMyParticipant(conversation);
        if (participant != undefined && participant.unreadCount > 0) $c376b46e67e9a7ac$export$c15b46ac94b7bc1a.read([
            conversation.id
        ]);
    }
    static execUpdate(conversation) {
        let updateStatus = false;
        let storedConversation = this.getById(conversation.id);
        if (storedConversation != undefined) {
            if (storedConversation.updatedTime < conversation.updatedTime) updateStatus = true;
            if (!(0, $lQXpd.arrayEquals)(storedConversation.participants.filter((value)=>value.state != (0, $gbrl3.AssignableState).DELETED).map((value)=>value.id), conversation.participants.filter((value)=>value.state != (0, $gbrl3.AssignableState).DELETED).map((value)=>value.id))) updateStatus = true;
        }
        conversation = this.store(conversation);
        this.updateConversation(conversation);
        if (updateStatus) this.updateStatusConversation(conversation);
    }
    /**
     * events
     */ static onNewConversation(func, component) {
        this.newConversationEvents.push(func);
        component.onRemove(()=>this.newConversationEvents.splice(this.newConversationEvents.indexOf(func), 1));
    }
    static onNewMessage(func, component) {
        this.messageConversationEvents.push(func);
        component.onRemove(()=>this.messageConversationEvents.splice(this.messageConversationEvents.indexOf(func), 1));
    }
    static onUpdateConversation(func, component) {
        this.conversationUpdatesEvents.push(func);
        component.onRemove(()=>this.conversationUpdatesEvents.splice(this.conversationUpdatesEvents.indexOf(func), 1));
    }
    static onUpdateStatusConversation(func, component) {
        this.conversationUpdateStatusEvents.push(func);
        component.onRemove(()=>this.conversationUpdateStatusEvents.splice(this.conversationUpdateStatusEvents.indexOf(func), 1));
    }
    static onDeleteConversations(func, component) {
        this.conversationUpdateDeleteEvents.push(func);
        component.onRemove(()=>this.conversationUpdateDeleteEvents.splice(this.conversationUpdateDeleteEvents.indexOf(func), 1));
    }
    /**
     * filter
     */ static filters(conversation, filters) {
        return filters.filter((value)=>value != undefined && value.startsWith("{")).filter((value)=>!this.filter(conversation, value)).length == 0;
    }
    static filter(conversation, filters) {
        let builder = new (0, $4d5jz.FilterBuilderConversation)(filters, conversation);
        if ((0, $1b6Hd.PreferencesService).inboxSearchValue != undefined && (0, $1b6Hd.PreferencesService).inboxSearchValue.length > 0) {
            if (!conversation.owner.participant.name.toLowerCase().startsWith((0, $1b6Hd.PreferencesService).inboxSearchValue.toLowerCase())) return false;
        }
        if (conversation.state == (0, $lAwIV.ComState).DELETED) return false;
        let filter = builder.reader.getEntry((0, $gRsj9.FiltersOperatorIdentifiers).STATE);
        if (filter != undefined) {
            if (!filter.values.includes((0, $lAwIV.ComState).SPAM) && conversation.state == (0, $lAwIV.ComState).SPAM) return false;
            if (!filter.values.includes((0, $lAwIV.ComState).SPAM_ASSASSIN) && conversation.state == (0, $lAwIV.ComState).SPAM_ASSASSIN) return false;
            if (!filter.values.includes((0, $lAwIV.ComState).TRASH) && conversation.state == (0, $lAwIV.ComState).TRASH) return false;
        }
        return builder.build();
    }
    /**
     * generate
     */ static virtualGenerate(avatar, siteChannel) {
        return {
            lastResponseContactTime: 0,
            importance: false,
            contactChannels: [],
            siteChannelId: siteChannel.id,
            siteChannels: [
                siteChannel
            ],
            state: (0, $lAwIV.ComState).NONE,
            remoteId: "remoteId",
            id: "virtualId",
            siteId: "virtualId",
            snippet: "snippet",
            unreadCount: 0,
            status: (0, $bns9j.InboxConversationStatus).SOLVED,
            comType: (0, $dEIDr.ComType).DIRECT_MESSAGE,
            updatedTime: new Date().getTime(),
            time: new Date().getTime(),
            owner: (0, $f0JQp.InboxConversationParticipantService).virtualGenerate(avatar, (0, $5pJMm.EntityType).ACCOUNT),
            entities: [],
            newMessages: [],
            siteChannel: siteChannel,
            participants: [
                (0, $f0JQp.InboxConversationParticipantService).virtualGenerate(avatar, (0, $5pJMm.EntityType).ACCOUNT)
            ],
            categories: [],
            rating: (0, $4uV0z.RatingType).NO_RATING,
            isNew: false
        };
    }
    /**
     * store
     */ static storeAll(conversations) {
        for(let key in conversations)conversations[key] = this.store(conversations[key]);
        return (0, $2Y8XI.Services).storeAll(conversations);
    }
    static store(conversation) {
        if (conversation.participants.length > 0) {
            conversation.owner = (0, $f0JQp.InboxConversationParticipantService).store(conversation.participants.filter((value)=>value.owner)[0]);
            conversation.participants = (0, $f0JQp.InboxConversationParticipantService).storeAll(conversation.participants.filter((value)=>value.participant != undefined));
        }
        conversation.categories = (0, $6bq2D.InboxConversationCategoryService).storeAll(conversation.categories);
        conversation.entities = (0, $68Z0d.EntityService).storeAll(conversation.entities);
        conversation.siteChannels = (0, $9jYbZ.SiteChannelService).storeAll(conversation.siteChannels);
        conversation.contactChannels = (0, $jRVhz.ContactChannelService).storeAll(conversation.contactChannels);
        conversation.siteChannel = (0, $9jYbZ.SiteChannelService).store(conversation.siteChannels.filter((value)=>value.id == conversation.siteChannelId)[0]);
        if (conversation.newMessages == undefined) conversation.newMessages = (0, $i3Hbv.observable)([]);
        conversation = (0, $2Y8XI.Services).store("id", this.conversations, conversation);
        return conversation;
    }
    static unStore(conversation) {
        (0, $2Y8XI.Services).unStore("id", this.conversations, conversation);
    }
}
$c376b46e67e9a7ac$export$c15b46ac94b7bc1a.conversations = (0, $i3Hbv.observable)([]);
$c376b46e67e9a7ac$export$c15b46ac94b7bc1a.newConversationEvents = [];
$c376b46e67e9a7ac$export$c15b46ac94b7bc1a.messageConversationEvents = [];
$c376b46e67e9a7ac$export$c15b46ac94b7bc1a.conversationUpdatesEvents = [];
$c376b46e67e9a7ac$export$c15b46ac94b7bc1a.conversationUpdateStatusEvents = [];
$c376b46e67e9a7ac$export$c15b46ac94b7bc1a.conversationUpdateDeleteEvents = [];

});
parcelRegister("f0JQp", function(module, exports) {

$parcel$export(module.exports, "InboxConversationParticipantService", function () { return $1ce70f7081d99aff$export$1e36082b109c19e3; });

var $i3Hbv = parcelRequire("i3Hbv");

var $7Aqrk = parcelRequire("7Aqrk");

var $l8ea0 = parcelRequire("l8ea0");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $68Z0d = parcelRequire("68Z0d");

var $5pJMm = parcelRequire("5pJMm");

var $gbrl3 = parcelRequire("gbrl3");

var $kfkzw = parcelRequire("kfkzw");
class $1ce70f7081d99aff$export$1e36082b109c19e3 {
    static dispose() {
        this.participants = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * load
     */ static async findByConversationId(conversationId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/conversations/participants/${conversationId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    /**
     * create
     */ static async create(conversationsIds, participantId, message, assignableType, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/participants", {
            conversationsIds: conversationsIds,
            participantId: participantId,
            message: message,
            type: assignableType
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    /**
     * delete
     */ static async delete(participantsIds, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/conversations/participants/delete", {
            participantsIds: participantsIds
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    /**
     * virtual
     */ static virtualGenerate(avatar, type) {
        return {
            lastReadTime: 0,
            conversationMuted: false,
            participant: (0, $68Z0d.EntityService).virtualGenerate(avatar),
            participantId: "virtualId",
            participantType: type,
            lastMessageTime: 0,
            state: (0, $gbrl3.AssignableState).JOINED,
            id: "virtualId",
            message: "message",
            owner: true,
            unreadCount: 0,
            conversationId: "virtualId"
        };
    }
    /**
     * store
     */ static storeAll(participants) {
        for(let key in participants)participants[key] = this.store(participants[key]);
        return (0, $2Y8XI.Services).storeAll(participants);
    }
    static store(participant) {
        if (participant.participantType == (0, $5pJMm.EntityType).ACCOUNT) // @ts-ignore
        participant.participant = (0, $7Aqrk.AccountService).store(participant.participant);
        if (participant.participantType == (0, $5pJMm.EntityType).CONTACT) // @ts-ignore
        participant.participant = (0, $l8ea0.ContactService).store(participant.participant);
        participant = (0, $2Y8XI.Services).store("id", this.participants, participant);
        return participant;
    }
}
$1ce70f7081d99aff$export$1e36082b109c19e3.participants = (0, $i3Hbv.observable)([]);

});
parcelRegister("gbrl3", function(module, exports) {

$parcel$export(module.exports, "AssignableState", function () { return $5ea3db465047602d$export$1028903292e335d8; });
var $5ea3db465047602d$export$1028903292e335d8;
(function(AssignableState) {
    AssignableState[AssignableState["DELETED"] = 0] = "DELETED";
    AssignableState[AssignableState["JOINED"] = 1] = "JOINED";
    AssignableState[AssignableState["INVITED"] = 2] = "INVITED";
    AssignableState[AssignableState["PASSIVE"] = 3] = "PASSIVE";
})($5ea3db465047602d$export$1028903292e335d8 || ($5ea3db465047602d$export$1028903292e335d8 = {}));

});


parcelRegister("bns9j", function(module, exports) {

$parcel$export(module.exports, "InboxConversationStatus", function () { return $c07b8b409f45716a$export$a60b0e7b291b9ff5; });
var $c07b8b409f45716a$export$a60b0e7b291b9ff5;
(function(InboxConversationStatus) {
    InboxConversationStatus[InboxConversationStatus["NOT_SOLVED"] = 1] = "NOT_SOLVED";
    InboxConversationStatus[InboxConversationStatus["SOLVED"] = 2] = "SOLVED";
})($c07b8b409f45716a$export$a60b0e7b291b9ff5 || ($c07b8b409f45716a$export$a60b0e7b291b9ff5 = {}));

});

parcelRegister("6bq2D", function(module, exports) {

$parcel$export(module.exports, "InboxConversationCategoryService", function () { return $217e21eec756d438$export$c70501d5b159f4eb; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $5eSnT = parcelRequire("5eSnT");
class $217e21eec756d438$export$c70501d5b159f4eb {
    static init() {}
    static dispose() {
        this.categories = (0, $i3Hbv.observable)([]);
    }
    static storeAll(categories) {
        for(let key in categories)categories[key] = this.store(categories[key]);
        return (0, $2Y8XI.Services).storeAll(categories);
    }
    static store(category) {
        category.category = (0, $5eSnT.CategoryService).store(category.category);
        return (0, $2Y8XI.Services).store("id", this.categories, category);
    }
}
$217e21eec756d438$export$c70501d5b159f4eb.categories = (0, $i3Hbv.observable)([]);

});
parcelRegister("5eSnT", function(module, exports) {

$parcel$export(module.exports, "CategoryService", function () { return $0a0dd379b481f973$export$f5504725dc934335; });

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $2tQfN = parcelRequire("2tQfN");

var $2eT6g = parcelRequire("2eT6g");

var $kfkzw = parcelRequire("kfkzw");
class $0a0dd379b481f973$export$f5504725dc934335 {
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).CATEGORY_UPDATE, (data)=>{
            this.store(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).CATEGORY_DELETE, (data)=>{
            this.unStore(data);
            this.onDelete(data);
        });
    }
    static dispose() {
        this.categories = (0, $i3Hbv.observable)([]);
    }
    static async findByType(typeId, manage, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/categories/${typeId}/${manage == undefined ? false : manage}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findByTypeAndJoined(typeId, joinedId, categorizableId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/categories/joined/${typeId}/${joinedId}${categorizableId == undefined ? `` : `/${categorizableId}`}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async delete(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/categories/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let c = this.categories.filter((category)=>category.id == id)[0];
            this.unStore(c);
        }
    }
    static async create(name, color, type, joinedIds, personal, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/categories", {
            name: name,
            color: color,
            type: type,
            joinedIds: joinedIds,
            personal: personal
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async update(id, name, color, joinedIds, personal, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/categories/update", {
            id: id,
            name: name,
            color: color,
            joinedIds: joinedIds,
            personal: personal
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * events
     */ static onDelete(category) {}
    static storeAll(categories) {
        for(let key in categories)categories[key] = this.store(categories[key]);
        return (0, $2Y8XI.Services).storeAll(categories);
    }
    static store(category) {
        if (category.filters != undefined) category.filters = (0, $2tQfN.FilterService).storeAll(category.filters);
        return (0, $2Y8XI.Services).store("id", this.categories, category);
    }
    static unStore(category) {
        (0, $2Y8XI.Services).unStore("id", this.categories, category);
    }
}
$0a0dd379b481f973$export$f5504725dc934335.categories = (0, $i3Hbv.observable)([]);

});
parcelRegister("2tQfN", function(module, exports) {

$parcel$export(module.exports, "FilterService", function () { return $1de00e44e549d566$export$f4fb036b8adcc8c8; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $68Z0d = parcelRequire("68Z0d");

var $2eT6g = parcelRequire("2eT6g");

var $kfkzw = parcelRequire("kfkzw");

var $gVIYW = parcelRequire("gVIYW");
class $1de00e44e549d566$export$f4fb036b8adcc8c8 {
    static dispose() {
        this.filters = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).FILTER_UPDATE, (data)=>{
            this.store(data);
            this.onCreate(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).FILTER_DELETE, (data)=>{
            this.unStore(data);
            this.onDelete(data);
        });
    }
    /**
     * load
     */ static async findBySiteIdAndType(siteId, type, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/filters/site/${siteId}/${type}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.filters.filter((filter)=>filter.type == type).forEach((filter)=>(0, $gVIYW.arrayRemove)(this.filters, filter));
            this.filtersLoadedTypes.push(type);
            return this.storeAll(request.data);
        }
        return undefined;
    }
    /**
     * get
     */ static async getAll(type) {
        if (this.filtersLoadedTypes.includes(type)) return this.filters.filter((value)=>value.type == type);
        else return await this.findBySiteIdAndType((0, $68Z0d.EntityService).activeSite.id, type);
    }
    /**
     * create
     */ static async create(name, data, type, isPrivate, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/filters", {
            name: name,
            data: JSON.parse(data),
            type: type,
            isPrivate: isPrivate
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * update
     */ static async update(id, name, data, type, isPrivate, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/filters/update/${id}`, {
            name: name,
            data: JSON.parse(data),
            type: type,
            isPrivate: isPrivate
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * delete
     */ static async delete(filter, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/filters/${filter.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(filter);
            return true;
        }
        return false;
    }
    /**
     * events
     */ static onDelete(filter) {}
    static onCreate(filter) {}
    /**
     * store
     */ static storeAll(filters) {
        for(let key in filters)filters[key] = this.store(filters[key]);
        return (0, $2Y8XI.Services).storeAll(filters);
    }
    static store(filter) {
        return (0, $2Y8XI.Services).store("id", this.filters, filter);
    }
    static unStore(filter) {
        (0, $gVIYW.arrayRemove)(this.filters, this.filters.filter((value)=>value.id == filter.id)[0]);
    }
}
$1de00e44e549d566$export$f4fb036b8adcc8c8.filters = (0, $i3Hbv.observable)([]);
$1de00e44e549d566$export$f4fb036b8adcc8c8.filtersLoadedTypes = [];

});
parcelRegister("gVIYW", function(module, exports) {

$parcel$export(module.exports, "arrayRemove", function () { return $4dded3a4c369cac9$export$30a014203d0d7e4f; });
/**
 * Retire un élément de l'array
 */ function $4dded3a4c369cac9$export$30a014203d0d7e4f(arr, obj) {
    let index = arr.indexOf(obj);
    if (index >= 0) arr.splice(index, 1);
}

});




parcelRegister("4d5jz", function(module, exports) {

$parcel$export(module.exports, "FilterBuilderConversation", function () { return $96546415cf13d8fa$export$b563e3aae78628d2; });

var $33OPo = parcelRequire("33OPo");

var $gRsj9 = parcelRequire("gRsj9");

var $5pJMm = parcelRequire("5pJMm");

var $gbrl3 = parcelRequire("gbrl3");
class $96546415cf13d8fa$export$b563e3aae78628d2 extends (0, $33OPo.FilterBuilder) {
    constructor(filtersData, conversation){
        super(filtersData);
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).CONTACT_NAME, ()=>{
            return [
                conversation.owner.participant.name
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).CONTACT_MAIL, ()=>{
            return [
                conversation.owner.participant.email
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).SITE_CHANNELS, ()=>{
            return [
                conversation.siteChannel.id
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).CHANNELS, ()=>{
            return [
                conversation.siteChannel.channelId
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).ASSIGNED, ()=>{
            return [
                conversation.participants.filter((value)=>value.participantType == (0, $5pJMm.EntityType).ACCOUNT && value.state != (0, $gbrl3.AssignableState).DELETED).length > 0
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).ASSIGNED_TO, ()=>{
            return [
                conversation.participants.filter((value)=>value.state != (0, $gbrl3.AssignableState).DELETED).map((value)=>value.participantId)
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).CONTACT_ID, ()=>{
            return [
                conversation.participants.filter((value)=>value.state != (0, $gbrl3.AssignableState).DELETED && value.participantType == (0, $5pJMm.EntityType).CONTACT).map((value)=>value.participantId)
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).STATUS, ()=>{
            return [
                conversation.status
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).STATE, ()=>{
            return [
                conversation.state
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).CATEGORY, ()=>{
            return [
                conversation.categories.map((value)=>value.category.id)
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).ARCHIVED, ()=>{
            return [
                conversation.categories.length > 0
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).TIME, ()=>{
            return [
                conversation.time
            ];
        });
        this.register((0, $gRsj9.FiltersOperatorIdentifiers).UPDATED_TIME, ()=>{
            return [
                conversation.updatedTime
            ];
        });
    }
}

});
parcelRegister("33OPo", function(module, exports) {

$parcel$export(module.exports, "FilterBuilder", function () { return $db29c322dd682e6f$export$afb49bb3b076029e; });

var $bpnM6 = parcelRequire("bpnM6");

var $c6fT2 = parcelRequire("c6fT2");

var $e4AOZ = parcelRequire("e4AOZ");

var $1Qvx7 = parcelRequire("1Qvx7");

var $gRsj9 = parcelRequire("gRsj9");

var $d4Ri5 = parcelRequire("d4Ri5");
class $db29c322dd682e6f$export$afb49bb3b076029e {
    build() {
        this.reader.filters.forEach((filter)=>{
            this.registers.forEach((register)=>{
                if (register.identifier == filter.identifier) register.func(filter);
            });
        });
        if (this.reader.conditionType == (0, $bpnM6.ConditionType).AND) return this.conditions.filter((value)=>value == false).length == 0;
        else return this.conditions.filter((value)=>value == true).length >= 0;
    }
    sort(objects) {
        let filter = this.reader.getEntry((0, $gRsj9.FiltersOperatorIdentifiers).SORT_COLUMN_NAME) ? this.reader.getEntry((0, $gRsj9.FiltersOperatorIdentifiers).SORT_COLUMN_NAME) : this.reader.getEntry((0, $gRsj9.FiltersOperatorIdentifiers).SORT_JSON_COLUMN_NAME);
        if (filter) {
            let columnId = filter.values[0].split("-")[0];
            columnId = columnId.includes("_") ? (0, $d4Ri5.txtCamelCase)(columnId) : columnId;
            let valueType = parseInt(filter.values[0].split("-")[1]);
            if (filter.identifier == (0, $gRsj9.FiltersOperatorIdentifiers).SORT_COLUMN_NAME) {
                objects.forEach((object)=>object[columnId] = this.parse(valueType, object[columnId]));
                objects = objects.sort((a, b)=>a[columnId] < b[columnId] ? 1 : -1);
            } else {
                objects.forEach((object)=>object.columnsData[columnId] = this.parse(valueType, object.columnsData[columnId]));
                objects = objects.sort((a, b)=>a.columnsData[columnId] < b.columnsData[columnId] ? 1 : -1);
            }
            if (filter.operator == (0, $e4AOZ.OperatorType).ORDER_ASC) objects = objects.reverse();
        }
        return objects;
    }
    register(identifier, func) {
        this.registers.push({
            identifier: identifier,
            func: (filter)=>{
                let values = func(filter);
                this.registerLogic(filter, values);
            }
        });
    }
    registerLogic(filter, currentValues) {
        let localConditions = [];
        if (filter.operator == (0, $e4AOZ.OperatorType).CONTAINS_ALL) localConditions.push(filter.values.filter((value)=>currentValues.filter((cValue)=>cValue.includes(value)).length > 0).length == filter.values.length);
        else if (filter.operator == (0, $e4AOZ.OperatorType).INTERVAL) localConditions.push(currentValues[0] > filter.values[0] && currentValues[0] < filter.values[1]);
        else filter.values.forEach((value)=>{
            value = this.parse(filter.builderEntry.valueType, value);
            switch(filter.operator){
                case (0, $e4AOZ.OperatorType).IS:
                    localConditions.push(currentValues.filter((v)=>this.clean(v) == value)[0] != undefined);
                    break;
                case (0, $e4AOZ.OperatorType).IS_NOT:
                    localConditions.push(!(currentValues.filter((v)=>this.clean(v) == value)[0] != undefined));
                    break;
                case (0, $e4AOZ.OperatorType).CONTAINS:
                    localConditions.push(currentValues.filter((cValue)=>this.clean(cValue).includes(value)).length > 0);
                    break;
                case (0, $e4AOZ.OperatorType).NOT_CONTAINS:
                    localConditions.push(!(currentValues.filter((cValue)=>this.clean(cValue).includes(value)).length > 0));
                    break;
                case (0, $e4AOZ.OperatorType).STARTS_WITH:
                    localConditions.push(currentValues.filter((cValue)=>this.clean(cValue).startsWith(value)).length > 0);
                    break;
                case (0, $e4AOZ.OperatorType).ENDS_WITH:
                    localConditions.push(currentValues.filter((cValue)=>this.clean(cValue).endsWith(value)).length > 0);
                    break;
                case (0, $e4AOZ.OperatorType).EXIST:
                    localConditions.push(currentValues.length > 0);
                    break;
                case (0, $e4AOZ.OperatorType).NOT_EXIST:
                    localConditions.push(currentValues.length == 0);
                    break;
                case (0, $e4AOZ.OperatorType).AFTER:
                case (0, $e4AOZ.OperatorType).GREATER:
                    localConditions.push(currentValues.filter((cValue)=>cValue > value).length > 0);
                    break;
                case (0, $e4AOZ.OperatorType).BEFORE:
                case (0, $e4AOZ.OperatorType).LESS:
                    localConditions.push(currentValues.filter((cValue)=>cValue < value).length > 0);
                    break;
            }
        });
        this.conditions.push(localConditions.filter((value)=>value == true).length >= 1);
    }
    clean(value) {
        if (typeof value == "string") value = value.toLowerCase();
        return value;
    }
    parse(valueType, value) {
        switch(valueType){
            case (0, $1Qvx7.ValueType).INTEGER:
            case (0, $1Qvx7.ValueType).LONG:
                return Number(value);
            case (0, $1Qvx7.ValueType).STRING:
                return this.clean(value);
            case (0, $1Qvx7.ValueType).BOOLEAN:
                return value == "true";
        }
        return value;
    }
    constructor(filtersData){
        this.reader = new (0, $c6fT2.FilterBuilderReader)(filtersData);
        this.registers = [];
        this.conditions = [];
    }
}

});
parcelRegister("bpnM6", function(module, exports) {

$parcel$export(module.exports, "ConditionType", function () { return $b85eb0da49ee80c2$export$748d1c753cdf4bfd; });
var $b85eb0da49ee80c2$export$748d1c753cdf4bfd;
(function(ConditionType) {
    ConditionType[ConditionType["AND"] = 1] = "AND";
    ConditionType[ConditionType["OR"] = 2] = "OR";
})($b85eb0da49ee80c2$export$748d1c753cdf4bfd || ($b85eb0da49ee80c2$export$748d1c753cdf4bfd = {}));

});

parcelRegister("c6fT2", function(module, exports) {

$parcel$export(module.exports, "FilterBuilderReader", function () { return $24fec88af3ddfd5a$export$133f0297641e782d; });

var $djXfs = parcelRequire("djXfs");

var $bpnM6 = parcelRequire("bpnM6");

var $7CICo = parcelRequire("7CICo");

var $gRsj9 = parcelRequire("gRsj9");

var $gVIYW = parcelRequire("gVIYW");
class $24fec88af3ddfd5a$export$133f0297641e782d {
    getEntry(identifier) {
        return this.filters.find((value)=>value.identifier == identifier);
    }
    removeEntry(identifier) {
        (0, $gVIYW.arrayRemove)(this.filters, this.getEntry(identifier));
    }
    addEntry(p) {
        let filter = new (0, $djXfs.Filter)(p.operator, p.identifier, p.values, (0, $7CICo.FilterOperatorIdentifiersEntries).get(p.identifier));
        this.filters.push(filter);
    }
    addSort(sort, columnId, valueType, isJson) {
        this.addEntry({
            operator: sort,
            identifier: isJson ? (0, $gRsj9.FiltersOperatorIdentifiers).SORT_JSON_COLUMN_NAME : (0, $gRsj9.FiltersOperatorIdentifiers).SORT_COLUMN_NAME,
            values: [
                columnId + "-" + valueType
            ]
        });
    }
    export(json) {
        let filters = [];
        this.filters.forEach((value)=>filters.push(value.jsonify()));
        let object = {
            "conditionType": this.conditionType,
            "filters": filters
        };
        return json ? object : JSON.stringify(object);
    }
    constructor(filtersData){
        filtersData = typeof filtersData == "string" ? JSON.parse(filtersData) : filtersData;
        this.filtersData = filtersData ? filtersData : {
            conditionType: (0, $bpnM6.ConditionType).AND,
            filters: []
        };
        this.conditionType = this.filtersData.conditionType;
        this.filters = [];
        for (let filterData of this.filtersData.filters){
            let filter = new (0, $djXfs.Filter)(filterData.operator, filterData.identifier, filterData.values, (0, $7CICo.FilterOperatorIdentifiersEntries).get(filterData.identifier));
            this.filters.push(filter);
        }
    }
}

});
parcelRegister("djXfs", function(module, exports) {

$parcel$export(module.exports, "Filter", function () { return $d8a74f30746e8a81$export$ec91da630f36d5ea; });

var $1Qvx7 = parcelRequire("1Qvx7");
class $d8a74f30746e8a81$export$ec91da630f36d5ea {
    jsonify() {
        let values = [];
        if (this.builderEntry.type == (0, $1Qvx7.ValueType).NULL) values = [
            "null"
        ];
        else this.values.forEach((value)=>values.push(value.value ? value.value : value));
        return {
            operator: this.operator,
            identifier: this.identifier,
            values: values
        };
    }
    constructor(operator, identifier, values, builderEntry){
        this.operator = operator;
        this.identifier = identifier;
        this.values = values;
        this.builderEntry = builderEntry;
    }
}

});
parcelRegister("1Qvx7", function(module, exports) {

$parcel$export(module.exports, "ValueType", function () { return $9ac1834eecd4a192$export$f1921b45c66f982c; });
var $9ac1834eecd4a192$export$f1921b45c66f982c;
(function(ValueType) {
    ValueType[ValueType["UUID"] = 0] = "UUID";
    ValueType[ValueType["STRING"] = 1] = "STRING";
    ValueType[ValueType["BOOLEAN"] = 2] = "BOOLEAN";
    ValueType[ValueType["INTEGER"] = 3] = "INTEGER";
    ValueType[ValueType["DATE"] = 4] = "DATE";
    ValueType[ValueType["LIST"] = 5] = "LIST";
    ValueType[ValueType["LONG"] = 6] = "LONG";
    ValueType[ValueType["NULL"] = 7] = "NULL";
    ValueType[ValueType["PHONE"] = 8] = "PHONE";
    ValueType[ValueType["MAIL"] = 9] = "MAIL";
    ValueType[ValueType["LANG"] = 10] = "LANG";
})($9ac1834eecd4a192$export$f1921b45c66f982c || ($9ac1834eecd4a192$export$f1921b45c66f982c = {}));

});


parcelRegister("7CICo", function(module, exports) {

$parcel$export(module.exports, "FilterOperatorIdentifiersEntries", function () { return $0600e38a669c42f9$export$1830767618bd371e; });

var $gRsj9 = parcelRequire("gRsj9");

var $e4AOZ = parcelRequire("e4AOZ");

var $1Qvx7 = parcelRequire("1Qvx7");
class $0600e38a669c42f9$export$1830767618bd371e {
    static get(identifier) {
        return this.entries.filter((entry)=>entry.identifier == identifier)[0];
    }
}
$0600e38a669c42f9$export$1830767618bd371e.entries = [
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).CONTACT_NAME,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT,
            (0, $e4AOZ.OperatorType).CONTAINS,
            (0, $e4AOZ.OperatorType).NOT_CONTAINS,
            (0, $e4AOZ.OperatorType).STARTS_WITH,
            (0, $e4AOZ.OperatorType).ENDS_WITH
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 2
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).CONTACT_MAIL,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT,
            (0, $e4AOZ.OperatorType).CONTAINS,
            (0, $e4AOZ.OperatorType).NOT_CONTAINS,
            (0, $e4AOZ.OperatorType).STARTS_WITH,
            (0, $e4AOZ.OperatorType).ENDS_WITH
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 2
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).SITE_CHANNELS,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).CHANNELS,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ASSIGNED,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).BOOLEAN,
        valueType: (0, $1Qvx7.ValueType).BOOLEAN,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ASSIGNED_TO,
        operators: [
            (0, $e4AOZ.OperatorType).CONTAINS,
            (0, $e4AOZ.OperatorType).CONTAINS_ALL,
            (0, $e4AOZ.OperatorType).NOT_CONTAINS
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ASSIGNED_TO_HAS_UNREADS,
        operators: [
            (0, $e4AOZ.OperatorType).CONTAINS,
            (0, $e4AOZ.OperatorType).CONTAINS_ALL,
            (0, $e4AOZ.OperatorType).NOT_CONTAINS
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ASSIGNED_INVITED,
        operators: [
            (0, $e4AOZ.OperatorType).CONTAINS,
            (0, $e4AOZ.OperatorType).CONTAINS_ALL,
            (0, $e4AOZ.OperatorType).NOT_CONTAINS
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).STATUS,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).STATE,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).CATEGORY,
        operators: [
            (0, $e4AOZ.OperatorType).CONTAINS,
            (0, $e4AOZ.OperatorType).CONTAINS_ALL,
            (0, $e4AOZ.OperatorType).NOT_CONTAINS
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ARCHIVED,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).BOOLEAN,
        valueType: (0, $1Qvx7.ValueType).BOOLEAN,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).TRANSMITTED_STATUS,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).BEFORE_UPDATED_TIME,
        operators: [
            (0, $e4AOZ.OperatorType).LESS,
            (0, $e4AOZ.OperatorType).GREATER
        ],
        type: (0, $1Qvx7.ValueType).DATE,
        valueType: (0, $1Qvx7.ValueType).LONG,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).SITE_ID,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).TIME,
        operators: [
            (0, $e4AOZ.OperatorType).INTERVAL,
            (0, $e4AOZ.OperatorType).AFTER,
            (0, $e4AOZ.OperatorType).BEFORE
        ],
        type: (0, $1Qvx7.ValueType).DATE,
        valueType: (0, $1Qvx7.ValueType).LONG,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).UPDATED_TIME,
        operators: [
            (0, $e4AOZ.OperatorType).INTERVAL,
            (0, $e4AOZ.OperatorType).AFTER,
            (0, $e4AOZ.OperatorType).BEFORE
        ],
        type: (0, $1Qvx7.ValueType).DATE,
        valueType: (0, $1Qvx7.ValueType).LONG,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).RECEIVED_OFFLINE,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).BOOLEAN,
        valueType: (0, $1Qvx7.ValueType).BOOLEAN,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).HAS_MESSAGE_DRAFT,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ACCOUNT_OWNER,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).MESSAGE_MAIL_SERVER_ID,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).MESSAGE_TYPE,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).SENDER_TYPE,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).NEWSLETTER,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).ORIGIN,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).LIST,
        valueType: (0, $1Qvx7.ValueType).INTEGER,
        maxItems: 3
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).BANNED,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).BOOLEAN,
        valueType: (0, $1Qvx7.ValueType).BOOLEAN,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).BANNED,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).BOOLEAN,
        valueType: (0, $1Qvx7.ValueType).BOOLEAN,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).HAS_CONVERSATIONS,
        operators: [
            (0, $e4AOZ.OperatorType).IS,
            (0, $e4AOZ.OperatorType).IS_NOT
        ],
        type: (0, $1Qvx7.ValueType).BOOLEAN,
        valueType: (0, $1Qvx7.ValueType).BOOLEAN,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).SORT_COLUMN_NAME,
        operators: [
            (0, $e4AOZ.OperatorType).ORDER_ASC,
            (0, $e4AOZ.OperatorType).ORDER_DESC
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 1
    },
    {
        identifier: (0, $gRsj9.FiltersOperatorIdentifiers).SORT_JSON_COLUMN_NAME,
        operators: [
            (0, $e4AOZ.OperatorType).ORDER_ASC,
            (0, $e4AOZ.OperatorType).ORDER_DESC
        ],
        type: (0, $1Qvx7.ValueType).STRING,
        valueType: (0, $1Qvx7.ValueType).STRING,
        maxItems: 1
    }
];

});
parcelRegister("gRsj9", function(module, exports) {

$parcel$export(module.exports, "FiltersOperatorIdentifiers", function () { return $8ce607400f5a51e5$export$5a5eba00d8d99b8d; });
var $8ce607400f5a51e5$export$5a5eba00d8d99b8d;
(function(FiltersOperatorIdentifiers) {
    FiltersOperatorIdentifiers["CONTACT_NAME"] = "CONTACT_NAME";
    FiltersOperatorIdentifiers["CONTACT_MAIL"] = "CONTACT_MAIL";
    FiltersOperatorIdentifiers["MESSAGE_MAIL_SERVER_ID"] = "MESSAGE_MAIL_SERVER_ID";
    FiltersOperatorIdentifiers["MESSAGE_TYPE"] = "MESSAGE_TYPE";
    FiltersOperatorIdentifiers["HAS_CONVERSATIONS"] = "HAS_CONVERSATIONS";
    FiltersOperatorIdentifiers["NEWSLETTER"] = "NEWSLETTER";
    FiltersOperatorIdentifiers["ORIGIN"] = "ORIGIN";
    FiltersOperatorIdentifiers["BANNED"] = "BANNED";
    FiltersOperatorIdentifiers["SITE_CHANNELS"] = "SITE_CHANNELS";
    FiltersOperatorIdentifiers["CHANNELS"] = "CHANNELS";
    FiltersOperatorIdentifiers["ASSIGNED"] = "ASSIGNED";
    FiltersOperatorIdentifiers["ASSIGNED_TO"] = "ASSIGNED_TO";
    FiltersOperatorIdentifiers["ASSIGNED_TO_HAS_UNREADS"] = "ASSIGNED_TO_HAS_UNREADS";
    FiltersOperatorIdentifiers["ASSIGNED_INVITED"] = "ASSIGNED_INVITED";
    FiltersOperatorIdentifiers["CONTACT_ID"] = "CONTACT_ID";
    FiltersOperatorIdentifiers["STATUS"] = "STATUS";
    FiltersOperatorIdentifiers["CATEGORY"] = "CATEGORY";
    FiltersOperatorIdentifiers["ARCHIVED"] = "ARCHIVED";
    FiltersOperatorIdentifiers["BEFORE_UPDATED_TIME"] = "BEFORE_UPDATED_TIME";
    FiltersOperatorIdentifiers["SITE_ID"] = "SITE_ID";
    FiltersOperatorIdentifiers["TIME"] = "TIME";
    FiltersOperatorIdentifiers["UPDATED_TIME"] = "UPDATED_TIME";
    FiltersOperatorIdentifiers["RECEIVED_OFFLINE"] = "RECEIVED_OFFLINE";
    FiltersOperatorIdentifiers["STATE"] = "STATE";
    FiltersOperatorIdentifiers["ACCOUNT_OWNER"] = "ACCOUNT_OWNER";
    FiltersOperatorIdentifiers["HAS_MESSAGE_DRAFT"] = "HAS_MESSAGE_DRAFT";
    FiltersOperatorIdentifiers["SORT_COLUMN_NAME"] = "SORT_COLUMN_NAME";
    FiltersOperatorIdentifiers["SORT_JSON_COLUMN_NAME"] = "SORT_JSON_COLUMN_NAME";
    FiltersOperatorIdentifiers["SENDER_TYPE"] = "SENDER_TYPE";
    FiltersOperatorIdentifiers["TRANSMITTED_STATUS"] = "TRANSMITTED_STATUS";
})($8ce607400f5a51e5$export$5a5eba00d8d99b8d || ($8ce607400f5a51e5$export$5a5eba00d8d99b8d = {}));

});



parcelRegister("d4Ri5", function(module, exports) {

$parcel$export(module.exports, "txtCamelCase", function () { return $286fe925d09b5c6e$export$f78b41a71d175eb8; });
/**
 * convertit une variable "xxx_xx" en xxxXx
 */ function $286fe925d09b5c6e$export$f78b41a71d175eb8(snakeCaseStr) {
    return snakeCaseStr.replace(/_([a-z])/g, function(match, letter) {
        return letter.toUpperCase();
    });
}

});



parcelRegister("4uV0z", function(module, exports) {

$parcel$export(module.exports, "RatingType", function () { return $28991124a14fc695$export$56c6ddffc3d29190; });
var $28991124a14fc695$export$56c6ddffc3d29190;
(function(RatingType) {
    RatingType[RatingType["NO_RATING"] = 0] = "NO_RATING";
    RatingType[RatingType["BAD"] = 1] = "BAD";
    RatingType[RatingType["NOT_GOOD"] = 2] = "NOT_GOOD";
    RatingType[RatingType["GOOD"] = 3] = "GOOD";
    RatingType[RatingType["VERY_GOOD"] = 4] = "VERY_GOOD";
})($28991124a14fc695$export$56c6ddffc3d29190 || ($28991124a14fc695$export$56c6ddffc3d29190 = {}));

});

parcelRegister("fVKoy", function(module, exports) {

$parcel$export(module.exports, "InboxConversationMessageAttachmentService", function () { return $340216e42890f66d$export$e6a3c536bc09ac00; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $19J71 = parcelRequire("19J71");

var $bKmye = parcelRequire("bKmye");

var $j8ebN = parcelRequire("j8ebN");

var $68Z0d = parcelRequire("68Z0d");
class $340216e42890f66d$export$e6a3c536bc09ac00 {
    static dispose() {
        this.attachments = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * virtual
     */ static virtualGenerate(files, previews) {
        let attachments = [];
        if (files != undefined && files.length != undefined) files.forEach((value)=>{
            attachments.push((0, $i3Hbv.observable)({
                id: "virtualId",
                type: (0, $19J71.AttachmentType).FILE,
                content: value
            }));
        });
        if (previews != undefined && previews.length != undefined) previews.forEach((value)=>{
            attachments.push((0, $i3Hbv.observable)({
                id: "virtualId",
                type: (0, $19J71.AttachmentType).PREVIEW,
                content: value
            }));
        });
        return attachments;
    }
    /**
     * store
     */ static storeAll(attachments) {
        for(let key in attachments)attachments[key] = this.store(attachments[key]);
        return (0, $2Y8XI.Services).storeAll(attachments);
    }
    static store(attachment) {
        if (attachment.type == (0, $19J71.AttachmentType).FILE) attachment.content = (0, $bKmye.FileService).store(attachment.content);
        if (attachment.type == (0, $19J71.AttachmentType).PREVIEW) attachment.content = (0, $j8ebN.PreviewService).store(attachment.content);
        if (attachment.owner != undefined) attachment.owner = (0, $68Z0d.EntityService).store(attachment.owner);
        attachment = (0, $2Y8XI.Services).store("id", this.attachments, attachment);
        return attachment;
    }
}
$340216e42890f66d$export$e6a3c536bc09ac00.attachments = (0, $i3Hbv.observable)([]);

});
parcelRegister("19J71", function(module, exports) {

$parcel$export(module.exports, "AttachmentType", function () { return $8eb762a4ca09f34e$export$86cfdc1f02eaf37a; });
var $8eb762a4ca09f34e$export$86cfdc1f02eaf37a;
(function(AttachmentType) {
    AttachmentType[AttachmentType["FILE"] = 1] = "FILE";
    AttachmentType[AttachmentType["FILE_EMBEDDED"] = 3] = "FILE_EMBEDDED";
    AttachmentType[AttachmentType["PREVIEW"] = 2] = "PREVIEW";
})($8eb762a4ca09f34e$export$86cfdc1f02eaf37a || ($8eb762a4ca09f34e$export$86cfdc1f02eaf37a = {}));

});


parcelRegister("lAwIV", function(module, exports) {

$parcel$export(module.exports, "ComState", function () { return $8c380099a9d14b25$export$db3c4d82d8faec4d; });
var $8c380099a9d14b25$export$db3c4d82d8faec4d;
(function(ComState) {
    ComState[ComState["NONE"] = 0] = "NONE";
    ComState[ComState["SPAM"] = 1] = "SPAM";
    ComState[ComState["TRASH"] = 2] = "TRASH";
    ComState[ComState["SPAM_ASSASSIN"] = 3] = "SPAM_ASSASSIN";
    ComState[ComState["DRAFT"] = 4] = "DRAFT";
    ComState[ComState["PUBLISH_DRAFTS"] = 7] = "PUBLISH_DRAFTS";
    ComState[ComState["SCHEDULED"] = 5] = "SCHEDULED";
    ComState[ComState["DELETED"] = 6] = "DELETED";
    ComState[ComState["TRANSFERRED"] = 8] = "TRANSFERRED";
    ComState[ComState["ERROR"] = 10] = "ERROR";
    ComState[ComState["ERROR_RED"] = 12] = "ERROR_RED";
    ComState[ComState["RANK"] = 11] = "RANK";
})($8c380099a9d14b25$export$db3c4d82d8faec4d || ($8c380099a9d14b25$export$db3c4d82d8faec4d = {}));

});

parcelRegister("ec2Gs", function(module, exports) {

$parcel$export(module.exports, "InboxConversationMessageService", function () { return $68ed8faec933c0d7$export$5380a4235b95525b; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $fVKoy = parcelRequire("fVKoy");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $2eT6g = parcelRequire("2eT6g");

var $kZE1x = parcelRequire("kZE1x");

var $a14Rv = parcelRequire("a14Rv");

var $5pJMm = parcelRequire("5pJMm");

var $dEIDr = parcelRequire("dEIDr");

var $lAwIV = parcelRequire("lAwIV");

var $b33nz = parcelRequire("b33nz");

var $68Z0d = parcelRequire("68Z0d");

var $2J4N8 = parcelRequire("2J4N8");

var $RMbsz = parcelRequire("RMbsz");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");

var $laeZ5 = parcelRequire("laeZ5");
class $68ed8faec933c0d7$export$5380a4235b95525b {
    static dispose() {
        this.messages = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).MESSAGE_NEW, (data)=>{
            let message = data;
            message = this.store(message);
            (0, $kZE1x.InboxConversationService).newMessage(message);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).MESSAGE_UPDATE, (data)=>{
            let message = data;
            this.store(message);
        });
    }
    /**
     * HTTP
     */ static async findByConversationId(conversationId, count, beforeTime, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/messages/conversation/${conversationId}/${count}/${beforeTime}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) //TODO récupérer l'état d'importation ici request.data.inProgressImportation
        return this.storeAll(request.data.messages);
        return [];
    }
    static async findCreator(messageId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/messages/creator/${messageId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return {
            message: this.store(request.data.message),
            conversation: (0, $kZE1x.InboxConversationService).store(request.data.conversation)
        };
        return undefined;
    }
    static async create(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).URL_FORMAT,
                message: (0, $5FliW.Resources).t("words.invalidAttachmentUrl")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.messageNoFound")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/messages", p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async retry(messageId, subId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/messages/retry", {
            messageId: messageId,
            subId: subId
        }, component);
        return request.status;
    }
    static async update(messageId, text, files, previews, component) {
        let filesIds = files.map((value)=>value.id);
        let previewsUrls = previews.map((value)=>value.baseUrl);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/messages/update", {
            messageId: messageId,
            text: text,
            filesIds: filesIds,
            previewsUrls: previewsUrls
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async sendDraft(messageId, html, scheduleTime, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).PAYLOAD_TOO_LARGE,
                message: (0, $5FliW.Resources).t("words.emailSizeExceeded")
            },
            {
                status: (0, $7ZaxO.HttpStatus).INSUFFICIENT_STORAGE,
                message: (0, $5FliW.Resources).t("words.storageLimitExceeded")
            },
            {
                status: (0, $7ZaxO.HttpStatus).BANDWIDTH_LIMIT,
                message: (0, $5FliW.Resources).t("words.sendingLimitExceeded")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/messages/send/draft", {
            messageId: messageId,
            scheduleTime: scheduleTime,
            html: html
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return request.status;
    }
    static async delete(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/messages/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            $68ed8faec933c0d7$export$5380a4235b95525b.store(request.data);
            return true;
        }
        return false;
    }
    /**
     * logic
     */ static findingCount(conversation) {
        if (conversation) switch(conversation.comType){
            case (0, $dEIDr.ComType).DIRECT_MESSAGE:
                return 30;
            case (0, $dEIDr.ComType).EMAIL:
                return 25;
        }
        return 25;
    }
    static findingRecipients(conversation, message, type) {
        let finding = [];
        let recipients = message.metaData.mail[type];
        recipients.forEach((recipient)=>{
            if (!finding.find((v)=>(0, $laeZ5.objectEquals)(recipient, v))) finding.push({
                ...recipient
            });
        });
        return finding;
    }
    static findingRecipientFrom(conversation, message) {
        if (message.senderType == (0, $5pJMm.EntityType).ACCOUNT) {
            let siteChannel = conversation.siteChannels.find((value)=>value.id == message.senderSiteChannelId);
            let participant = (0, $kZE1x.InboxConversationService).getParticipantByEntity(message.senderType, message.senderId, conversation);
            return {
                mail: siteChannel.name,
                name: participant.participant.name,
                entityType: message.senderType,
                entityId: message.senderId
            };
        } else if (message.senderType == (0, $5pJMm.EntityType).CONTACT) {
            let contactChannel = conversation.contactChannels.find((value)=>value.id == message.senderContactChannelId);
            return {
                mail: contactChannel.identifier,
                name: contactChannel.identifierName,
                entityType: message.senderType,
                entityId: message.senderId
            };
        }
    }
    static toReplyMetaData(conversation, message, sendType, all) {
        let prefix = "RE: ";
        let subject = message.metaData.mail.subject;
        let metadata = {
            mail: {
                to: [
                    this.findingRecipientFrom(conversation, message)
                ],
                subject: subject.toLowerCase().startsWith(prefix.toLowerCase()) ? subject : prefix + subject,
                sendType: sendType
            }
        };
        if (all) {
            metadata.mail.cc = this.findingRecipients(conversation, message, (0, $2J4N8.MailRecipientsType).TO).concat(this.findingRecipients(conversation, message, (0, $2J4N8.MailRecipientsType).CC));
            metadata.mail.bcc = this.findingRecipients(conversation, message, (0, $2J4N8.MailRecipientsType).BCC);
        }
        return metadata;
    }
    static isMine(message) {
        return message.senderId == (0, $68Z0d.EntityService).activeEntity.id && message.senderType == (0, $68Z0d.EntityService).activeEntity.type;
    }
    static isError(message) {
        return message.transmittedStatus == (0, $RMbsz.ComTransmittedStatus).ERROR || message.transmittedStatus == (0, $RMbsz.ComTransmittedStatus).ERROR_RETRY || message.transmittedStatus == (0, $RMbsz.ComTransmittedStatus).HELD;
    }
    static getSiteChannel(conversation, message) {
        let siteChannelId = message.receiveSiteChannelId != null ? message.receiveSiteChannelId : message.senderSiteChannelId;
        return conversation.siteChannels.find((value)=>value.id == siteChannelId);
    }
    /**
     * virtual
     */ static virtualGenerate(text, entity, files, previews) {
        let message = {
            id: "virtualId",
            conversationId: "virtualId",
            senderContactChannelId: "xx",
            senderSiteChannelId: "xx",
            receiveSiteChannelId: null,
            text: text,
            senderId: entity == undefined ? "virtualId" : entity.id,
            senderType: entity == undefined ? (0, $5pJMm.EntityType).ACCOUNT : entity.type,
            type: (0, $a14Rv.InboxConversationMessageType).NORMAL,
            time: Date.now(),
            transmittedTime: 0,
            deletedTime: 0,
            comType: (0, $dEIDr.ComType).DIRECT_MESSAGE,
            metaData: {},
            attachments: (0, $fVKoy.InboxConversationMessageAttachmentService).virtualGenerate(files, previews),
            replyToId: "replyId",
            reply: "reply",
            state: (0, $lAwIV.ComState).NONE,
            transmittedStatus: 0
        };
        return [
            (0, $i3Hbv.observable)(message)
        ];
    }
    static virtualGenerateDto(comType, text) {
        return {
            type: (0, $a14Rv.InboxConversationMessageType).NORMAL,
            text: text,
            scheduledTime: 0,
            filesIds: [],
            previewsUrls: [],
            comType: comType,
            comState: (0, $lAwIV.ComState).NONE,
            metaData: {},
            sendType: (0, $b33nz.ComSendType).SEND
        };
    }
    /**
     * store
     */ static storeAll(messages) {
        for(let key in messages)messages[key] = this.store(messages[key]);
        return (0, $2Y8XI.Services).storeAll(messages);
    }
    static store(message) {
        message.attachments = (0, $fVKoy.InboxConversationMessageAttachmentService).storeAll(message.attachments);
        message = (0, $2Y8XI.Services).store("id", this.messages, message);
        return message;
    }
}
$68ed8faec933c0d7$export$5380a4235b95525b.messages = (0, $i3Hbv.observable)([]);

});
parcelRegister("a14Rv", function(module, exports) {

$parcel$export(module.exports, "InboxConversationMessageType", function () { return $6ab55c592e2dd825$export$960e9385f3457382; });
var $6ab55c592e2dd825$export$960e9385f3457382;
(function(InboxConversationMessageType) {
    InboxConversationMessageType[InboxConversationMessageType["NORMAL"] = 1] = "NORMAL";
    InboxConversationMessageType[InboxConversationMessageType["PRIVATE"] = 2] = "PRIVATE";
    InboxConversationMessageType[InboxConversationMessageType["CONVERSATION_JOIN"] = 3] = "CONVERSATION_JOIN";
    InboxConversationMessageType[InboxConversationMessageType["CONVERSATION_LEAVE"] = 4] = "CONVERSATION_LEAVE";
    InboxConversationMessageType[InboxConversationMessageType["CONVERSATION_SOLVE"] = 5] = "CONVERSATION_SOLVE";
    InboxConversationMessageType[InboxConversationMessageType["CONVERSATION_NOT_SOLVE"] = 6] = "CONVERSATION_NOT_SOLVE";
    InboxConversationMessageType[InboxConversationMessageType["CREATE_REMINDER"] = 7] = "CREATE_REMINDER";
    InboxConversationMessageType[InboxConversationMessageType["EXECUTE_REMINDER"] = 8] = "EXECUTE_REMINDER";
})($6ab55c592e2dd825$export$960e9385f3457382 || ($6ab55c592e2dd825$export$960e9385f3457382 = {}));

});

parcelRegister("b33nz", function(module, exports) {

$parcel$export(module.exports, "ComSendType", function () { return $a3e20f419dbeaa68$export$26489e8d8e2a770d; });
var $a3e20f419dbeaa68$export$26489e8d8e2a770d;
(function(ComSendType) {
    ComSendType[ComSendType["SEND"] = 1] = "SEND";
    ComSendType[ComSendType["FORWARD"] = 2] = "FORWARD";
})($a3e20f419dbeaa68$export$26489e8d8e2a770d || ($a3e20f419dbeaa68$export$26489e8d8e2a770d = {}));

});

parcelRegister("2J4N8", function(module, exports) {

$parcel$export(module.exports, "MailRecipientsType", function () { return $b8c78d4bc81aa682$export$91b041425e79906c; });
var $b8c78d4bc81aa682$export$91b041425e79906c;
(function(MailRecipientsType) {
    MailRecipientsType["TO"] = "to";
    MailRecipientsType["CC"] = "cc";
    MailRecipientsType["BCC"] = "bcc";
    MailRecipientsType["SUBJECT"] = "subject";
})($b8c78d4bc81aa682$export$91b041425e79906c || ($b8c78d4bc81aa682$export$91b041425e79906c = {}));

});

parcelRegister("RMbsz", function(module, exports) {

$parcel$export(module.exports, "ComTransmittedStatus", function () { return $3926defc4770d7e8$export$6e69249dbb2a9008; });
var $3926defc4770d7e8$export$6e69249dbb2a9008;
(function(ComTransmittedStatus) {
    ComTransmittedStatus[ComTransmittedStatus["DONE"] = 0] = "DONE";
    ComTransmittedStatus[ComTransmittedStatus["WAIT"] = 1] = "WAIT";
    ComTransmittedStatus[ComTransmittedStatus["ERROR"] = 2] = "ERROR";
    ComTransmittedStatus[ComTransmittedStatus["NONE"] = 3] = "NONE";
    ComTransmittedStatus[ComTransmittedStatus["ERROR_RETRY"] = 4] = "ERROR_RETRY";
    ComTransmittedStatus[ComTransmittedStatus["HELD"] = 5] = "HELD"; //Message retenu, on peut retry
})($3926defc4770d7e8$export$6e69249dbb2a9008 || ($3926defc4770d7e8$export$6e69249dbb2a9008 = {}));

});


parcelRegister("32Z3V", function(module, exports) {

$parcel$export(module.exports, "AccountComposerService", function () { return $41e950382d8e55f0$export$17daaa5b015255bb; });

var $i3Hbv = parcelRequire("i3Hbv");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $kfkzw = parcelRequire("kfkzw");
class $41e950382d8e55f0$export$17daaa5b015255bb {
    static dispose() {
        this.composers = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * rest
     */ static async create(type, contentId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/composer", {
            type: type,
            contentId: contentId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return $41e950382d8e55f0$export$17daaa5b015255bb.store(request.data);
        return undefined;
    }
    static async delete(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/account/composer/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.unStore(this.composers.find((value)=>value.id == id));
        return undefined;
    }
    /**
     * tab
     */ static async createTab(composer, component) {
        let accountComposer = await this.create(composer.type, composer.contentId, component);
        (0, $7AbeR.Network).router.static.components.composer.renderTab(accountComposer, true);
    }
    /**
     * store
     */ static unStore(composer) {
        (0, $2Y8XI.Services).unStore("id", this.composers, composer);
    }
    static storeAll(composers) {
        for(let key in composers)composers[key] = this.store(composers[key]);
        return (0, $2Y8XI.Services).storeAll(composers);
    }
    static store(composer) {
        if (composer != undefined) return (0, $2Y8XI.Services).store("id", this.composers, composer);
    }
}
$41e950382d8e55f0$export$17daaa5b015255bb.composers = (0, $i3Hbv.observable)([]);

});

parcelRegister("7q3ie", function(module, exports) {

$parcel$export(module.exports, "ComposerType", function () { return $6015819b28cd5c77$export$89895f1a672d2d82; });
var $6015819b28cd5c77$export$89895f1a672d2d82;
(function(ComposerType) {
    ComposerType[ComposerType["CONVERSATION_MESSAGE"] = 1] = "CONVERSATION_MESSAGE";
    ComposerType[ComposerType["EMPTY"] = 2] = "EMPTY";
})($6015819b28cd5c77$export$89895f1a672d2d82 || ($6015819b28cd5c77$export$89895f1a672d2d82 = {}));

});


parcelRegister("lTF9x", function(module, exports) {

$parcel$export(module.exports, "SiteColumnsContactService", function () { return $62ddc994379d4d6a$export$56c517e2ad94c677; });

var $5FliW = parcelRequire("5FliW");

var $ggBhC = parcelRequire("ggBhC");

var $6GI6j = parcelRequire("6GI6j");

var $iuYSI = parcelRequire("iuYSI");
class $62ddc994379d4d6a$export$56c517e2ad94c677 extends (0, $iuYSI.SiteColumnsService) {
    static dispose() {}
    static init() {}
    /**
     * store
     */ static store(columns) {
        return this.storeAbstract(this.standard, columns);
    }
    static storeStandard(columns) {
        let frontPossibleValues = {
            "gender": [
                {
                    id: "M",
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.male")
                        }
                    ]
                },
                {
                    id: "F",
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.female")
                        }
                    ]
                }
            ],
            "origin": [
                {
                    id: (0, $6GI6j.ContactOrigin).LIVECHAT,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.products.livechat")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).MAIL,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.products.mails")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).BLOG,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.products.blog")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).HELPCENTER,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.products.helpCenter")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).FACEBOOK,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.products.facebookPage")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).INSTAGRAM,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.products.instagram")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).UNKNOWN,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.unknown")
                        }
                    ]
                },
                {
                    id: (0, $6GI6j.ContactOrigin).CUSTOM_CREATE,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.collaborators")
                        }
                    ]
                }
            ],
            "newsletter": [
                {
                    id: "" + (0, $ggBhC.ContactNewsletterState).SUBSCRIBER,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.subscriber")
                        }
                    ]
                },
                {
                    id: "" + (0, $ggBhC.ContactNewsletterState).NONE,
                    labels: [
                        {
                            language: "fr",
                            name: (0, $5FliW.Resources).t("words.nonSubscriber")
                        }
                    ]
                }
            ]
        };
        columns.columns.forEach((column)=>{
            if (frontPossibleValues[column.id]) column.possibleValues = frontPossibleValues[column.id];
        });
        this.standard = columns;
    }
}

});
parcelRegister("ggBhC", function(module, exports) {

$parcel$export(module.exports, "ContactNewsletterState", function () { return $77107b1786f0fb37$export$4cb9cd0ea02cb6c2; });
var $77107b1786f0fb37$export$4cb9cd0ea02cb6c2;
(function(ContactNewsletterState) {
    ContactNewsletterState[ContactNewsletterState["SUBSCRIBER"] = 0] = "SUBSCRIBER";
    ContactNewsletterState[ContactNewsletterState["NONE"] = 1] = "NONE";
})($77107b1786f0fb37$export$4cb9cd0ea02cb6c2 || ($77107b1786f0fb37$export$4cb9cd0ea02cb6c2 = {}));

});

parcelRegister("6GI6j", function(module, exports) {

$parcel$export(module.exports, "ContactOrigin", function () { return $40e1e92061914444$export$c2d5652df87718d6; });
var $40e1e92061914444$export$c2d5652df87718d6;
(function(ContactOrigin) {
    ContactOrigin[ContactOrigin["UNKNOWN"] = -1] = "UNKNOWN";
    ContactOrigin[ContactOrigin["LIVECHAT"] = 0] = "LIVECHAT";
    ContactOrigin[ContactOrigin["MAIL"] = 1] = "MAIL";
    ContactOrigin[ContactOrigin["HELPCENTER"] = 2] = "HELPCENTER";
    ContactOrigin[ContactOrigin["BLOG"] = 3] = "BLOG";
    ContactOrigin[ContactOrigin["FACEBOOK"] = 4] = "FACEBOOK";
    ContactOrigin[ContactOrigin["INSTAGRAM"] = 5] = "INSTAGRAM";
    ContactOrigin[ContactOrigin["CUSTOM_CREATE"] = 6] = "CUSTOM_CREATE";
})($40e1e92061914444$export$c2d5652df87718d6 || ($40e1e92061914444$export$c2d5652df87718d6 = {}));

});

parcelRegister("iuYSI", function(module, exports) {

$parcel$export(module.exports, "SiteColumnsService", function () { return $9933ea83335bdc7c$export$93b30e7a5f4508b6; });

var $271MM = parcelRequire("271MM");

var $5FliW = parcelRequire("5FliW");

var $1Qvx7 = parcelRequire("1Qvx7");

var $kLeAE = parcelRequire("kLeAE");

var $3Szqe = parcelRequire("3Szqe");

var $d4Ri5 = parcelRequire("d4Ri5");

var $1NBjD = parcelRequire("1NBjD");

var $agutJ = parcelRequire("agutJ");
class $9933ea83335bdc7c$export$93b30e7a5f4508b6 {
    static value(object, column) {
        let r;
        if (column.rowColumn) r = object[(0, $d4Ri5.txtCamelCase)(column.id)];
        else r = object.columnsData ? object.columnsData[column.id] : undefined;
        if (column.id == "name" && (0, $271MM.config).product == "livechat" && (0, $3Szqe.txtNameIsVisitor)(r)) return undefined;
        return r;
    }
    static label(column) {
        if (!column.labels || column.labels.length == 0) return (0, $5FliW.Resources).t("words." + column.id);
        let label = this.findLabel(column.labels);
        return label ? label.name : column.id;
    }
    static type(column) {
        let value = (0, $1Qvx7.ValueType)[column.type];
        if (column.type == (0, $1Qvx7.ValueType).LIST) return `List of ${(0, $1Qvx7.ValueType)[column.valueType].toLowerCase()}`;
        return (0, $kLeAE.txtCapitalize)(value.toLowerCase());
    }
    static inputType(value) {
        switch(value){
            case (0, $1Qvx7.ValueType).MAIL:
                return "email";
            case (0, $1Qvx7.ValueType).INTEGER:
            case (0, $1Qvx7.ValueType).LONG:
                return "number";
            case (0, $1Qvx7.ValueType).PHONE:
                return "tel";
            default:
                return "text";
        }
    }
    static filledFields(siteColumns, object, columnsIds) {
        let columns = siteColumns.columns.filter((c)=>columnsIds.includes(c.id));
        return columns.find((column)=>{
            let value = this.value(object, column);
            return value != 0 && (value == undefined || value == "");
        }) == undefined;
    }
    /**
     * verifications
     */ static verifyColumnData(value, column) {
        if (!column.required && (value == undefined || value.length == 0)) return true;
        if (value != undefined) switch(column.valueType){
            case (0, $1Qvx7.ValueType).MAIL:
                return (0, $agutJ.txtIsValidMail)(value);
            case (0, $1Qvx7.ValueType).INTEGER:
                if (value.length > column.maxLength) return false;
                return (0, $1NBjD.txtIsNumber)(value);
            default:
                return value.length <= column.maxLength;
        }
        return false;
    }
    static sort(columns) {
        return {
            columns: columns.columns.sort((a, b)=>a.order < b.order ? 1 : -1).reverse()
        };
    }
    /**
     * store
     */ static storeAbstract(standard, columns) {
        standard.columns.forEach((standardColumn)=>{
            let findColumn = columns.columns.find((v)=>v.id == standardColumn.id);
            if (!findColumn) columns.columns.push(standardColumn);
            else {
                findColumn.possibleValues = standardColumn.possibleValues;
                findColumn.labels = standardColumn.labels;
            }
        });
        return columns;
    }
    static findLabel(labels) {
        return labels.find((label)=>label.language == (0, $5FliW.Resources).language) || labels[0];
    }
}

});
parcelRegister("kLeAE", function(module, exports) {

$parcel$export(module.exports, "txtCapitalize", function () { return $1d2d11c8888d1db9$export$3d76145083528b12; });
/**
 * Met la première lettre du texte en majuscule
 */ function $1d2d11c8888d1db9$export$3d76145083528b12(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

});

parcelRegister("3Szqe", function(module, exports) {

$parcel$export(module.exports, "txtNameIsVisitor", function () { return $894c0177aff75540$export$db67df5717f45cac; });
/**
 * Vérifie si un nom est un visiteur
 */ function $894c0177aff75540$export$db67df5717f45cac(name) {
    if (!name) return false;
    const re = /^Visitor \d{4}$/;
    return re.test(String(name));
}

});

parcelRegister("1NBjD", function(module, exports) {

$parcel$export(module.exports, "txtIsNumber", function () { return $a1ebe9273cabb31b$export$e1acc20410d476e8; });
/**
 * Vérifie si un text est un nombre
 */ function $a1ebe9273cabb31b$export$e1acc20410d476e8(str) {
    if (!str) return false;
    if (typeof str != "string") return true;
    // @ts-ignore
    return !isNaN(str) && !isNaN(parseFloat(str));
}

});

parcelRegister("agutJ", function(module, exports) {

$parcel$export(module.exports, "txtIsValidMail", function () { return $19af1375bd47ef3a$export$6d44f8a76e7fdfef; });
/**
 * Vérifie si un mail est valide
 */ function $19af1375bd47ef3a$export$6d44f8a76e7fdfef(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

});



parcelRegister("32rNO", function(module, exports) {

$parcel$export(module.exports, "getPaymentProviderById", function () { return $44a7722bc63ba98b$export$b030ae93ac7cf1ce; });
var $44a7722bc63ba98b$export$d106de282c1be6c1;
(function(PaymentProviderType) {
    PaymentProviderType[PaymentProviderType["STRIPE"] = 0] = "STRIPE";
    PaymentProviderType[PaymentProviderType["SHOPIFY"] = 1] = "SHOPIFY";
})($44a7722bc63ba98b$export$d106de282c1be6c1 || ($44a7722bc63ba98b$export$d106de282c1be6c1 = {}));
class $44a7722bc63ba98b$export$202bc391a3eb96a {
    constructor(id, invoice, cb, address, directDeleteDefinitiveOffer){
        this.id = id;
        this.invoice = invoice;
        this.cb = cb;
        this.address = address;
        this.directDeleteDefinitiveOffer = directDeleteDefinitiveOffer;
    }
}
const $44a7722bc63ba98b$export$735606310a3da449 = new $44a7722bc63ba98b$export$202bc391a3eb96a(0, true, true, true, false);
const $44a7722bc63ba98b$export$6da9acb12d5139d4 = new $44a7722bc63ba98b$export$202bc391a3eb96a(1, false, false, false, true);
const $44a7722bc63ba98b$var$paymentProvidersMap = {
    [0]: $44a7722bc63ba98b$export$735606310a3da449,
    [1]: $44a7722bc63ba98b$export$6da9acb12d5139d4
};
function $44a7722bc63ba98b$export$b030ae93ac7cf1ce(id) {
    return $44a7722bc63ba98b$var$paymentProvidersMap[id];
}

});



var $a32d25ff06603372$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a32d25ff06603372$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $a32d25ff06603372$exports));
try {
    regeneratorRuntime = $a32d25ff06603372$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a32d25ff06603372$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a32d25ff06603372$var$runtime);
}



var $8J94x = parcelRequire("8J94x");

var $iSiUq = parcelRequire("iSiUq");

var $9DuXN = parcelRequire("9DuXN");

var $c1R3d = parcelRequire("c1R3d");

var $7AbeR = parcelRequire("7AbeR");

var $8J94x = parcelRequire("8J94x");

var $5FliW = parcelRequire("5FliW");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $kfkzw = parcelRequire("kfkzw");
class $04dad054de4b2ddf$export$f650c34b939fcf30 {
    static async init() {
        var _window_location_pathname;
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["ssr"] = this;
        this.ssrPath = (_window_location_pathname = window.location.pathname) === null || _window_location_pathname === void 0 ? void 0 : _window_location_pathname.endsWith("sedestral.ssr");
    }
    static hasSsr() {
        return this.ssrPath;
    }
    static async awaitProcessing() {
        await this.awaitRequests();
        let promises = (0, $8J94x.SedestralMachine).promises.filter((promise)=>promise.displayRequired);
        if (promises.length > 0) await Promise.all(promises.map((promise)=>promise.promise));
    }
    static async awaitRequests() {
        let request = await this.awaitRequest();
        if (request) return await this.awaitRequests();
    }
    static async awaitRequest() {
        return (0, $8J94x.SedestralMachine).promise((resolve)=>{
            let origOpen = XMLHttpRequest.prototype.open;
            let timeOut = setTimeout(()=>{
                resolve(false);
            });
            XMLHttpRequest.prototype.open = function() {
                this.addEventListener("load", function() {
                    resolve(true);
                });
                clearTimeout(timeOut);
                origOpen.apply(this, arguments);
                XMLHttpRequest.prototype.open = origOpen;
            };
        });
    }
    /**
     * SSR
     */ static async renderPageSsr(path) {
        document.body.className = "";
        await (0, $7AbeR.Network).router.pages.reload(path);
        await this.awaitProcessing();
        await (0, $8J94x.SedestralMachine).sleep(1);
        if ((0, $7AbeR.Network).router.static.components.loader) (0, $7AbeR.Network).router.static.components.loader.displayShow();
        document.body.className += "ssrPageReady";
    }
    static getRoutesSsr() {
        if ((0, $7AbeR.Network).productName == (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).BLOG) || (0, $7AbeR.Network).productName === (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).HELPCENTER)) return (0, $5FliW.Resources).languages.flatMap((language)=>[
                "/" + language + "/home"
            ]).join(",");
        return (0, $5FliW.Resources).languages.flatMap((language)=>{
            return Object.keys((0, $7AbeR.Network).router.pages.pages).map((route)=>"/" + language + route);
        }).join(",");
    }
}



var $dEtAh = parcelRequire("dEtAh");
class $ae3682a3319cdf37$export$d1af847c14d84dee {
    static async init() {
        await Promise.all([
            (0, $c1R3d.SedestralDebugger).init(),
            (0, $8J94x.SedestralMachine).init(),
            (0, $iSiUq.SedestralInterface).init(),
            (0, $9DuXN.SedestralMemory).init(),
            (0, $dEtAh.SedestralStorage).init(),
            (0, $04dad054de4b2ddf$export$f650c34b939fcf30).init()
        ]);
    }
    static ready(callback) {
        if (document.readyState !== "loading") callback();
        else if (document.addEventListener) document.addEventListener("DOMContentLoaded", callback);
        else // @ts-ignore
        document.attachEvent("onreadystatechange", ()=>{
            if (document.readyState == "complete") callback();
        });
    }
}



var $271MM = parcelRequire("271MM");

var $7AbeR = parcelRequire("7AbeR");

var $bi5k0 = parcelRequire("bi5k0");

var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $68Z0d = parcelRequire("68Z0d");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");
class $680ec485db5e71e8$export$88eb42c4a6e30051 {
    static dispose() {}
    static init() {}
    /**
     * store
     */ static async update(id, text) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/text/update/" + id, text);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static storeAll(texts) {
        for(let key in texts)texts[key] = this.store(texts[key]);
        return (0, $2Y8XI.Services).storeAll(texts);
    }
    static store(text) {
        return (0, $2Y8XI.Services).store("id", this.texts, text);
    }
}
$680ec485db5e71e8$export$88eb42c4a6e30051.texts = (0, $i3Hbv.observable)([]);



var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7Aqrk = parcelRequire("7Aqrk");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");


var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");


var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");
class $e1536de0087baae2$export$e473f7e46afe97f7 {
}
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_JOIN = "community/join";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_LEAVE = "community/leave";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_UPDATE = "community/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_WRITING_STYLE_UPDATE = "community/writingStyle/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE = "community/seo/cluster/keywords/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_JOIN = "community/article/join";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_LEAVE = "community/article/leave";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_CONTENT_SORT = "community/content/sort";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_CATEGORY_CREATE = "community/category/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_CATEGORY_DELETE = "community/category/delete";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_CATEGORY_UPDATE = "community/category/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_CREATE = "community/article/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_DELETE = "community/article/delete";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_UPDATE = "community/article/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_PROPOSAL_CREATE = "community/article/proposal/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_SECTION_CREATE = "community/article/section/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_GENERATE = "community/article/generate";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_GENERATE_START = "community/article/generate/start";
$e1536de0087baae2$export$e473f7e46afe97f7.GPT_SEGMENT = "gpt/segment";



var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $271MM = parcelRequire("271MM");
class $e76657c0ca80eee3$export$3d1acc6bf13b6cd1 {
    static dispose() {}
    static init() {}
    static async create(communityId, fileType, files, progress, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).COMMUNITY, `/community/files`, {
            communityId: communityId,
            files: files,
            fileType: fileType
        }, component, {
            onUploadProgress: (progressEvent)=>{
                if (progress) progress(progressEvent.loaded * 100 / progressEvent.total);
            }
        });
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async searchImages(communityId, query, page, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/files/search/images", {
            communityId: communityId,
            query: query,
            page: page
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async downloadImage(communityId, imageId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/files/download/image", {
            communityId: communityId,
            imageId: imageId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
    }
    /**
     * link
     */ static link(file) {
        var _config_httpCommunityUrl;
        return ((_config_httpCommunityUrl = (0, $271MM.config).httpCommunityUrl) !== null && _config_httpCommunityUrl !== void 0 ? _config_httpCommunityUrl : (0, $271MM.config).domain) + `/community/files/${file.id}.${file.extension}`;
    }
    /**
     * store
     */ static storeAll(files) {
        for(let key in files)files[key] = this.store(files[key]);
        return (0, $2Y8XI.Services).storeAll(files);
    }
    static store(file) {
        file.link = this.link(file);
        return (0, $2Y8XI.Services).store("id", this.files, file);
    }
}
$e76657c0ca80eee3$export$3d1acc6bf13b6cd1.files = (0, $i3Hbv.observable)([]);



var $gVIYW = parcelRequire("gVIYW");

var $bIule = parcelRequire("bIule");
var $00ecc5127dabc543$export$1f6539ddf1c5815;
(function(CommunityArticleAIState) {
    CommunityArticleAIState[CommunityArticleAIState["NONE"] = 0] = "NONE";
    CommunityArticleAIState[CommunityArticleAIState["WAITING_IA"] = 1] = "WAITING_IA";
    CommunityArticleAIState[CommunityArticleAIState["ERROR"] = 2] = "ERROR";
    CommunityArticleAIState[CommunityArticleAIState["DONE"] = 3] = "DONE";
})($00ecc5127dabc543$export$1f6539ddf1c5815 || ($00ecc5127dabc543$export$1f6539ddf1c5815 = {}));


class $5aab3284ce582eaf$export$439035f52ab89a16 {
    static dispose() {
        this.createEvents = [];
        this.deleteEvents = [];
        this.updateEvents = [];
        this.proposalEvents = [];
        this.sectionEvents = [];
        this.generateEvents = [];
        this.generateStartEvents = [];
    }
    static init() {
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["CommunityArticleService"] = this;
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_CREATE, (data)=>{
            let article = this.store(data);
            this.createEvents.forEach((value)=>value(article));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_UPDATE, (data)=>{
            let article = this.store(data);
            this.updateEvents.forEach((value)=>value(article));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_DELETE, (data)=>{
            let article = this.store(data);
            this.deleteEvents.forEach((value)=>value(article));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_PROPOSAL_CREATE, (proposal)=>{
            this.storeProposal(proposal);
            this.proposalEvents.forEach((value)=>value(proposal));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_SECTION_CREATE, (section)=>{
            this.storeSection(section);
            this.sectionEvents.forEach((value)=>value(section));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_GENERATE, (data)=>{
            this.generateEvents.forEach((value)=>value(data));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_GENERATE_START, (data)=>{
            this.generateStarts.push(data);
            this.generateStartEvents.forEach((value)=>value(data));
        });
    }
    /**
     * websocket
     */ static onCreateEvent(component, func) {
        this.createEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.createEvents, func));
    }
    static onDeleteEvent(component, func) {
        this.deleteEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.deleteEvents, func));
    }
    static onUpdateEvent(component, func) {
        this.updateEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.updateEvents, func));
    }
    static onProposalEvent(component, func) {
        this.proposalEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.proposalEvents, func));
    }
    static onSectionEvent(component, func) {
        this.sectionEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.sectionEvents, func));
    }
    static onGenerateEvent(component, func, id) {
        this.generateEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.generateEvents, func));
    }
    static onGenerateStartEvent(component, articleId, func) {
        let start = this.generateStarts.find((value)=>value.articleId == articleId);
        if (start) {
            func(start);
            (0, $gVIYW.arrayRemove)(this.generateStarts, start);
        }
        this.generateStartEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.generateStartEvents, func));
    }
    /**
     * http
     */ static async aiStepCreate(create, component) {
        if (!create.title) create.title = `${(0, $5FliW.Resources).t("words.untitled")} ${(0, $bIule.randomInteger)(1000, 99999)}`;
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/ai/create", create, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiStepKeyword(keyword, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxProposalsPerItem")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/ai/keyword", keyword, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiStepRules(rules, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/ai/rules", rules, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiProposalsRetry(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/proposals/retry`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiSections(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/sections`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiSectionsRetry(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/sections/retry`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiSectionsUpdate(p, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/sections/update`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiGenerate(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/generate`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async view(communityId, route, component) {
        if ((0, $04dad054de4b2ddf$export$f650c34b939fcf30).hasSsr() && this.ssrArticleViews) return Promise.resolve(this.ssrArticleViews);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/view/${communityId}/${(0, $5FliW.Resources).language}/${route}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeView(request.data);
        return undefined;
    }
    static async lastUserContexts(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/last-user-contexts/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findById(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findAll(communityId, start, limit, categoryRoute, component) {
        if ((0, $04dad054de4b2ddf$export$f650c34b939fcf30).hasSsr() && this.ssrArticlesByCategory) return Promise.resolve(this.ssrArticlesByCategory);
        const queryParams = new URLSearchParams({
            ...categoryRoute ? {
                categoryRoute: categoryRoute
            } : {},
            language: (0, $5FliW.Resources).language,
            communityId: communityId,
            start: start.toString(),
            limit: limit.toString()
        }).toString();
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article?${queryParams}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeArticles(request.data);
        return undefined;
    }
    static async generatedCount(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/generated/count/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async update(update, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).ROUTE_EXIST,
                message: (0, $5FliW.Resources).t("words.routeExist")
            }
        ]);
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article`, update, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.store(request.data);
            return true;
        }
        return false;
    }
    static async delete(articleId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/article/${articleId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.unStore(request.data);
        return undefined;
    }
    static async search(communityId, language, search, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/list/${communityId}/${language}/${search}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeArticles(request.data);
        return undefined;
    }
    static async alternate(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/alternate/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async getArticlesMonitoring(communityId, pagination, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/articles/monitoring/${communityId}`, pagination, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    /**
     * websocket
     */ static async join(id) {
        if (id != null) {
            await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).COMMUNITY, id, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_JOIN);
            this.joinedArticleId = id;
        }
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_LEAVE, id);
        this.joinedArticleId = undefined;
    }
    /**
     * store
     */ static storeView(view) {
        view.article = this.store(view.article);
        view.category = (0, $f48e754c50b84d29$export$dedc23250a387576).store(view.category);
        return view;
    }
    static storeArticles(articles) {
        articles.articles = $5aab3284ce582eaf$export$439035f52ab89a16.storeAll(articles.articles);
        return articles;
    }
    static storeAll(articles) {
        for(let key in articles)articles[key] = this.store(articles[key]);
        return (0, $2Y8XI.Services).storeAll(articles);
    }
    static storeProposal(proposal) {
        let article = this.articles.find((value)=>value.id == proposal.articleId);
        if (article && article.proposals) article.proposals.items[proposal.index].proposals.push(proposal.proposal);
    }
    static storeSection(section) {
        let article = this.articles.find((value)=>value.id == section.articleId);
        if (article && article.sections) article.sections.items[section.indexSection].sections.push(section.section);
    }
    static store(article) {
        let storedArticle = (0, $2Y8XI.Services).get("id", this.articles, article.id);
        if (storedArticle != undefined) {
            if (!article.deltas && storedArticle.deltas) article.deltas = storedArticle.deltas;
            if (article.writersAccounts.length == 0 && storedArticle.writersAccounts.length !== 0) article.writersAccounts = storedArticle.writersAccounts;
            if (article.writersRedactors.length == 0 && storedArticle.writersRedactors.length !== 0) article.writersRedactors = storedArticle.writersRedactors;
        }
        if (article.imageFile) article.imageFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(article.imageFile);
        (0, $7Aqrk.AccountService).storeAll(article.writersAccounts);
        return (0, $2Y8XI.Services).store("id", this.articles, article);
    }
    static unStore(article) {
        (0, $2Y8XI.Services).unStore("id", this.articles, article);
    }
    static storeMetadata(metadata) {
        if (metadata.imageFile) metadata.imageFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(metadata.imageFile);
        (0, $7Aqrk.AccountService).storeAll(metadata.writersAccounts);
    }
    static getMainKeyword(article) {
        var _article_sections, _article_proposals_items_doneSection_index_keywords, _article_proposals_items_doneSection_index, _article_proposals;
        const doneSection = article === null || article === void 0 ? void 0 : (_article_sections = article.sections) === null || _article_sections === void 0 ? void 0 : _article_sections.items.find((section)=>section.state === (0, $00ecc5127dabc543$export$1f6539ddf1c5815).DONE);
        var _article_proposals_items_doneSection_index_keywords_;
        return doneSection ? (_article_proposals_items_doneSection_index_keywords_ = article === null || article === void 0 ? void 0 : (_article_proposals = article.proposals) === null || _article_proposals === void 0 ? void 0 : (_article_proposals_items_doneSection_index = _article_proposals.items[doneSection.index]) === null || _article_proposals_items_doneSection_index === void 0 ? void 0 : (_article_proposals_items_doneSection_index_keywords = _article_proposals_items_doneSection_index.keywords) === null || _article_proposals_items_doneSection_index_keywords === void 0 ? void 0 : _article_proposals_items_doneSection_index_keywords[0]) !== null && _article_proposals_items_doneSection_index_keywords_ !== void 0 ? _article_proposals_items_doneSection_index_keywords_ : "" : "";
    }
    /**
     * SSR
     */ static setContextSsr(context) {
        let object = JSON.parse(context);
        if (object.articles) {
            let articles = this.storeArticles(object);
            this.ssrArticlesByCategory = (0, $i3Hbv.observable)(articles);
        } else {
            let article = this.storeView(object);
            this.ssrArticleViews = (0, $i3Hbv.observable)(article);
        }
    }
}
$5aab3284ce582eaf$export$439035f52ab89a16.NB_MAX_SECTIONS_BY_ITEM = 7;
$5aab3284ce582eaf$export$439035f52ab89a16.articles = (0, $i3Hbv.observable)([]);
$5aab3284ce582eaf$export$439035f52ab89a16.createEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.deleteEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.updateEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.proposalEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.sectionEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.generateEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.generateStartEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.generateStarts = [];
$5aab3284ce582eaf$export$439035f52ab89a16.ssrArticleViews = (0, $i3Hbv.observable)();
$5aab3284ce582eaf$export$439035f52ab89a16.ssrArticlesByCategory = (0, $i3Hbv.observable)();



var $kfkzw = parcelRequire("kfkzw");


var $5FliW = parcelRequire("5FliW");


var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $bTARt = parcelRequire("bTARt");


var $gVIYW = parcelRequire("gVIYW");

var $1aMHk = parcelRequire("1aMHk");
/**
 * transforme un texte au format lien
 */ function $51206b0120f9ac1b$export$85277f0038a080ec(txt) {
    txt = txt.trim().toLowerCase();
    txt = txt.normalize("NFD");
    txt = txt.replace(/[\u0300-\u036f]/g, "");
    txt = txt.replace(/[^a-zA-Z0-9 -]/g, "");
    txt = txt.replace(/[-\s]+/g, "-");
    return txt;
}


class $f48e754c50b84d29$export$dedc23250a387576 {
    static dispose() {
        this.createEvents = [];
        this.deleteEvents = [];
        this.updateEvents = [];
    }
    static init() {
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["CommunityCategoryService"] = this;
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_CATEGORY_CREATE, (data)=>{
            this.createEvents.forEach((value)=>value(this.store(data)));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_CATEGORY_UPDATE, (data)=>{
            this.updateEvents.forEach((value)=>value(this.store(data)));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_CATEGORY_DELETE, (data)=>{
            this.deleteEvents.forEach((value)=>value(this.store(data)));
        });
    }
    /**
     * websocket
     */ static onCreateEvent(component, func) {
        this.createEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.createEvents, func));
    }
    static onDeleteEvent(component, func) {
        this.deleteEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.deleteEvents, func));
    }
    static onUpdateEvent(component, func) {
        this.updateEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.updateEvents, func));
    }
    /**
     * HTTP
     */ static async findCategories(communityId, language, component) {
        if ((0, $04dad054de4b2ddf$export$f650c34b939fcf30).hasSsr() && this.categories) return Promise.resolve(this.categories);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/categories/${communityId}/${language}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async delete(categoryId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MIN,
                message: (0, $5FliW.Resources).t("words.minCategoryError")
            }
        ]);
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/category/${categoryId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let category = this.categories.find((value)=>value.id == categoryId);
            if (category) this.unStore(category);
        }
        return undefined;
    }
    static async create(category, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).ROUTE_EXIST,
                message: (0, $5FliW.Resources).t("words.communityCategoryRouteExist")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/category`, category, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async update(id, category, component) {
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).COMMUNITY, `/community/category/${id}`, category, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async alternates(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/category/alternates/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    /**
     * logic
     */ static async createAlternate(language, category) {
        var _category_imageFile;
        let title = `(${language.toUpperCase()}) ${category.title}`;
        return await $f48e754c50b84d29$export$dedc23250a387576.create({
            communityId: category.communityId,
            language: language,
            title: title,
            route: (0, $1aMHk.randomString)(10, false) + (0, $51206b0120f9ac1b$export$85277f0038a080ec)(title),
            imageFileId: (_category_imageFile = category.imageFile) === null || _category_imageFile === void 0 ? void 0 : _category_imageFile.id,
            description: `(${language.toUpperCase()}) ${category.description}`,
            alternateCategoryId: category.id
        });
    }
    /**
     * store
     */ static storeView(view) {
        view.articles = (0, $5aab3284ce582eaf$export$439035f52ab89a16).storeArticles(view.articles);
        view.category = this.store(view.category);
        return view;
    }
    static storeAll(categories) {
        for(let key in categories)categories[key] = this.store(categories[key]);
        return (0, $2Y8XI.Services).storeAll(categories);
    }
    static store(category) {
        if (category.imageFile) category.imageFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(category.imageFile);
        return (0, $2Y8XI.Services).store("id", this.categories, category);
    }
    static unStore(category) {
        (0, $2Y8XI.Services).unStore("id", this.categories, category);
    }
}
$f48e754c50b84d29$export$dedc23250a387576.categories = (0, $i3Hbv.observable)([]);
$f48e754c50b84d29$export$dedc23250a387576.createEvents = [];
$f48e754c50b84d29$export$dedc23250a387576.deleteEvents = [];
$f48e754c50b84d29$export$dedc23250a387576.updateEvents = [];




var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $5FliW = parcelRequire("5FliW");



var $bTARt = parcelRequire("bTARt");


var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");
var $75961db7d7c0df07$export$27fb916c8cac12c7;
(function(CommunityVisitorActionType) {
    CommunityVisitorActionType[CommunityVisitorActionType["LINK"] = 1] = "LINK";
})($75961db7d7c0df07$export$27fb916c8cac12c7 || ($75961db7d7c0df07$export$27fb916c8cac12c7 = {}));



var $8J94x = parcelRequire("8J94x");
class $57a401ba8ef81077$export$d41076a259927884 {
    static dispose() {}
    static init() {
        (0, $7AbeR.Network).onStarted(()=>{
            (0, $7AbeR.Network).router.pages.stats.onNewPage((stats, page)=>{
                this.queuedPages.push({
                    duration: page.duration,
                    route: page.route,
                    endTime: page.endTime,
                    startTime: page.startTime,
                    viewedPercentage: page.viewedPercentage,
                    actions: page.actions.map((value)=>{
                        return {
                            name: value.name,
                            value: value.value,
                            time: value.time,
                            actionType: value.type == "link" ? (0, $75961db7d7c0df07$export$27fb916c8cac12c7).LINK : (0, $75961db7d7c0df07$export$27fb916c8cac12c7).LINK
                        };
                    })
                });
            });
            (0, $7AbeR.Network).router.pages.stats.onClosePage((stats)=>this.save());
            (0, $8J94x.SedestralMachine).setInterval(()=>this.save(), 15000);
        });
    }
    static save() {
        if (this.queuedPages.length > 0) {
            this.insert({
                frontId: (0, $7AbeR.Network).router.pages.stats.frontId,
                referrer: (0, $7AbeR.Network).router.pages.stats.referrer,
                pages: this.queuedPages
            });
            this.queuedPages = [];
        }
    }
    static async insert(visitor, component) {
        await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/visitor`, visitor, component);
    }
}
$57a401ba8ef81077$export$d41076a259927884.queuedPages = [];



var $gVIYW = parcelRequire("gVIYW");

var $8J94x = parcelRequire("8J94x");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");


var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $ea99dfb6cc838099$export$6368a938bdcd0b2 {
    static dispose() {}
    static init() {}
    static async update(communityId, communityAutopilot, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).COMMUNITY_AUTOPILOT_DAYS_MAX,
                message: (0, $5FliW.Resources).t("words.communityAutopilotDaysMax")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/autopilot/update/${communityId}`, communityAutopilot);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(request.data);
        return undefined;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");



var $gVIYW = parcelRequire("gVIYW");
class $8a2826395ed74d11$export$106b309753d02dc0 {
    static dispose() {
        this.styleEvents = [];
    }
    static init() {
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_WRITING_STYLE_UPDATE, (data)=>{
            (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(data.community);
            this.styleEvents.forEach((value)=>value(data));
        });
    }
    /**
     * websocket
     */ static onWritingStyle(component, func) {
        this.styleEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.styleEvents, func));
    }
    static async create(style, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/writingStyle`, style, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async delete(communityId, writingStyleId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/writingStyle/${communityId}/${writingStyleId}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(request.data);
        return undefined;
    }
}
$8a2826395ed74d11$export$106b309753d02dc0.styleEvents = [];



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $16fe27051c61311b$export$c8c9ba79e1431b49 {
    static dispose() {}
    static init() {}
    static async getKeywordsSite(search, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/keywords/site`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async searchKeywords(name, search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/keywords/search/${name}`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async searchKeywordsHistory(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/keywords/search/history/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async createRankingOverview(communityId, host, owner, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST,
                message: (0, $5FliW.Resources).t("words.domainAlreadyInStats")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/overview/create/${communityId}/${host}/${owner}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getRankingOverview(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/overview/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        if (request.status == (0, $7ZaxO.HttpStatus).NOT_FOUND) return [];
        return undefined;
    }
    static async getIndividualsPositioning(id, search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/individualsPositioning/${id}`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getCannibalization(communityId, pagination, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/cannibalization/${communityId}`, pagination, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getComparativePositioning(search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/comparativePositioning`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async deleteRanking(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/${id}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");
class $4db228f3f242765b$export$b7b630d38b5e9168 {
    static dispose() {}
    static init() {}
    static async getByCommunity(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/${communityId}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return [];
    }
    static async create(communityId, name, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/create/${communityId}/${name}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async update(communityId, knowledgeId, name, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/update/${communityId}/${knowledgeId}/${name}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async delete(communityId, knowledgeId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/delete/${communityId}/${knowledgeId}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async createResource(communityId, knowledgeId, resource, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/create/resource/${communityId}/${knowledgeId}`, resource, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async createResourceFile(communityId, knowledgeId, meshing, file, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/create/resource/file/${communityId}/${meshing}/${knowledgeId}`, {
            file: file
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async deleteResource(communityId, knowledgeId, resourceId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/delete/${communityId}/${knowledgeId}/${resourceId}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");


var $gVIYW = parcelRequire("gVIYW");

var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $39bece87a6f042d1$export$19e8f5eea8d43acd {
    static dispose() {
        this.events = [];
    }
    static init() {
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE, (data)=>{
            this.events.forEach((value)=>value(data));
        });
    }
    static async create(communityId, query, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/create/${communityId}/${query}`, {}, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async update(communityId, clusterId, keywords, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MIN,
                message: (0, $5FliW.Resources).t("words.minKeywords")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxKeywords")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAX_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxClusterModification")
            }
        ]);
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/update/${communityId}/${clusterId}`, keywords, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getPreviewsByCommunityId(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getClusters(communityId, clusterId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/${communityId}/${clusterId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getCompetitors(communityId, clusterId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/competitors/${communityId}/${clusterId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async delete(communityId, id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/${communityId}/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static onClusterCreate(component, func) {
        this.events.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.events, func));
    }
}
$39bece87a6f042d1$export$19e8f5eea8d43acd.events = [];



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $5FliW = parcelRequire("5FliW");
class $cefa0647525faafd$export$d57fb523d3be1724 {
    static dispose() {}
    static init() {}
    static async getGsc(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/${communityId}`, component);
        return request.data;
    }
    static async disconnect(communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/disconnect/${communityId}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async verification(communityId, verificationType, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/verification/${verificationType}/${communityId}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async addSitemapGsc(communityId, url, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: (0, $5FliW.Resources).t("words.sitemapRejectedByGoogle")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/addSitemap/${communityId}`, {
            url: url
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async deleteSitemapGsc(communityId, url, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: (0, $5FliW.Resources).t("words.requestRejectedByGoogle")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/deleteSitemap/${communityId}`, {
            url: url
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
}


class $b1e6fff8c0d9b52f$export$55b7b226f6213252 {
    static dispose() {
        this.contentSortEvents = [];
        (0, $680ec485db5e71e8$export$88eb42c4a6e30051).dispose();
        (0, $f48e754c50b84d29$export$dedc23250a387576).dispose();
        (0, $5aab3284ce582eaf$export$439035f52ab89a16).dispose();
        (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).dispose();
        (0, $ea99dfb6cc838099$export$6368a938bdcd0b2).dispose();
        (0, $16fe27051c61311b$export$c8c9ba79e1431b49).dispose();
        (0, $39bece87a6f042d1$export$19e8f5eea8d43acd).dispose();
        (0, $4db228f3f242765b$export$b7b630d38b5e9168).dispose();
        (0, $57a401ba8ef81077$export$d41076a259927884).dispose();
        (0, $8a2826395ed74d11$export$106b309753d02dc0).dispose();
        (0, $cefa0647525faafd$export$d57fb523d3be1724).dispose();
    }
    static init() {
        (0, $680ec485db5e71e8$export$88eb42c4a6e30051).init();
        (0, $f48e754c50b84d29$export$dedc23250a387576).init();
        (0, $5aab3284ce582eaf$export$439035f52ab89a16).init();
        (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).init();
        (0, $ea99dfb6cc838099$export$6368a938bdcd0b2).init();
        (0, $16fe27051c61311b$export$c8c9ba79e1431b49).init();
        (0, $39bece87a6f042d1$export$19e8f5eea8d43acd).init();
        (0, $4db228f3f242765b$export$b7b630d38b5e9168).init();
        (0, $8a2826395ed74d11$export$106b309753d02dc0).init();
        (0, $cefa0647525faafd$export$d57fb523d3be1724).init();
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["CommunityService"] = this;
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_CONTENT_SORT, (data)=>{
            this.contentSortEvents.forEach((value)=>value(data));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_UPDATE, (data)=>{
            this.store(data);
        });
    }
    /**
     * websocket
     */ static onContentSort(component, func) {
        this.contentSortEvents.push(func);
        component.onRemove(()=>(0, $gVIYW.arrayRemove)(this.contentSortEvents, func));
    }
    /**
     * http
     */ static async token() {
        try {
            let tokenRequest = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/token", {
                languages: (0, $5FliW.Resources).getLanguagesCandidateWidthDefault((0, $7AbeR.Network) === null || (0, $7AbeR.Network) === void 0 ? void 0 : (0, $7AbeR.Network).router.language())
            });
            let live = this.storeLive(tokenRequest.data);
            (0, $68Z0d.EntityService).headersToken(tokenRequest.headers, false);
            return live;
        } catch (e) {
            console.log("erreur token: ");
            console.log(e);
            return undefined;
        }
    }
    static async addLanguage(communityId, language, component) {
        let request = await (0, $7AbeR.Network).put((0, $kfkzw.ProductType).COMMUNITY, "/community/addLanguage", {
            communityId: communityId,
            language: language
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateLogos(id, fileType, files, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).COMMUNITY, `/community/logos/update`, {
            files: files,
            fileType: fileType,
            communityId: id
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateAppearance(id, communityAppearanceModel) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/appearance/update/${id}`, communityAppearanceModel);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateSendEmailNotificationRanking(communityId, sendEmailNotificationRanking) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/sendEmailNotificationRanking/update/${communityId}/${sendEmailNotificationRanking}`);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateContext(communityId, context, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/context/update`, {
            communityId: communityId,
            context: context
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createHost(communityId, host, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/host/create`, {
            communityId: communityId,
            host: host
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateSettings(id, community) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/settings/update/${id}`, community);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async checkRoute(language, categoryRoute, articleRoute, component) {
        if ((0, $04dad054de4b2ddf$export$f650c34b939fcf30).hasSsr()) return true;
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/checkRoute", {
            language: language,
            categoryRoute: categoryRoute,
            articleRoute: articleRoute
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async findBySite(siteId, type, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).SERVICE_UNAVAILABLE,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/site/${siteId}/${type}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async findLimitsBySite(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/site/${siteId}/limits`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async delete(communityId, component) {
        await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/${communityId}`, component);
    }
    static async findById(communityId, language, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/${communityId}/${language}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createStep0(communityCreateStep0Model, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/create/step/0", communityCreateStep0Model, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createStep1(communityCreateStep1Model, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/create/step/1", communityCreateStep1Model, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async configExportNone(communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/config/export/none/${communityId}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async addRedactor(communityId, name, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/redactor", {
            communityId: communityId,
            name: name
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async deleteRedactor(communityId, redactorId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/redactor/${communityId}/${redactorId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createCustomHost(communityId, customHost, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/customHost", {
            communityId: communityId,
            customHost: customHost
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async checkCustomHost(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/customHost/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findCustomHost(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/customHost/find/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async checkInternalHost(communityId, hostname, communityType, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST,
                message: "none"
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/checkInternalHost/${hostname}/${communityType}/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async manage(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SUSPENDED,
                message: (0, $5FliW.Resources).t("words.communitySuspendedDueToOfferInsufficiency")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/manage/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeManage(request.data);
        return {
            community: undefined,
            articles: [],
            categories: []
        };
    }
    static async selectPartnerBlog(communityId, remoteId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/select/partner/blog/${communityId}/${remoteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
    }
    static async getPartnerBlogColumns(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/list/partner/blog/columns/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async updatePartnerBlogColumns(communityId, columns, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/list/partner/blog/columns/${communityId}`, columns, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getLinks(communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/links`, {
            communityId: communityId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getListPartnerBlog(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/list/partner/blog/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getCommunitiesAdmin(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/admin/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async resetCommunityStatsBySiteId(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/admin/resetStats/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
    }
    /**
     * start
     */ static async start(options, communityCreateStep0Model, component) {
        let community = await this.createStep0(communityCreateStep0Model, component);
        if (community) await (0, $7AbeR.Network).router.pages.reload(`/${options.basePath}/${community.id}/content/home`);
        return community;
    }
    /**
     * links
     */ static linkCategory(category) {
        return (0, $271MM.config).domain + category.route;
    }
    static linkArticle(category, article) {
        return (0, $271MM.config).domain + category.route + article.route;
    }
    static linkLocalArticle(category, article) {
        return category.route + article.route;
    }
    /**
     * websocket
     */ static async startSocket(onRetry) {
        let retry = async ()=>{
            if (onRetry) onRetry();
            await (0, $8J94x.SedestralMachine).sleep(2500);
            if (await this.startSocket()) {
                await (0, $8J94x.SedestralMachine).sleep(7000);
                window.location.reload();
            }
        };
        let socket = await (0, $7AbeR.Network).startWebSocket((0, $kfkzw.ProductType).COMMUNITY, ()=>retry());
        if (!socket) await retry();
        return socket;
    }
    static disposeSocket() {
        (0, $7AbeR.Network).getSocket((0, $kfkzw.ProductType).COMMUNITY).disconnect(true);
    }
    static async join(id) {
        if (id != null) await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).COMMUNITY, id, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_JOIN);
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_LEAVE, id);
    }
    /**
     * store
     */ static storeManage(manage) {
        manage.categories = (0, $f48e754c50b84d29$export$dedc23250a387576).storeAll(manage.categories);
        manage.articles = (0, $5aab3284ce582eaf$export$439035f52ab89a16).storeAll(manage.articles);
        return manage;
    }
    static storeLive(live) {
        live.community = this.store(live.community);
        live.categories = (0, $f48e754c50b84d29$export$dedc23250a387576).storeAll(live.categories);
        this.live = (0, $i3Hbv.observable)(live);
        return this.live;
    }
    static storeAll(communities) {
        for(let key in communities)communities[key] = this.store(communities[key]);
        return (0, $2Y8XI.Services).storeAll(communities);
    }
    static store(community) {
        let storedCommunity = (0, $2Y8XI.Services).get("id", this.communities, community.id);
        if (storedCommunity != undefined) {
            if (!community.autopilot && storedCommunity.autopilot) community.autopilot = storedCommunity.autopilot;
            if (!community.partner && storedCommunity.partner) community.partner = storedCommunity.partner;
            if (!community.context && storedCommunity.context) community.context = storedCommunity.context;
            if (!community.writingStyles && storedCommunity.writingStyles) community.writingStyles = storedCommunity.writingStyles;
            if (!community.redactors && storedCommunity.redactors) community.redactors = storedCommunity.redactors;
        }
        if (community.text) community.text = (0, $680ec485db5e71e8$export$88eb42c4a6e30051).store(community.text);
        if (community.logoFile) community.logoFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(community.logoFile);
        if (community.footerFile) community.footerFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(community.footerFile);
        if (community.faviconFile) community.faviconFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(community.faviconFile);
        return (0, $2Y8XI.Services).store("id", this.communities, community);
    }
    static getHost(community) {
        const endpoint = community.hostCustomVerified && community.hostCustom ? community.hostCustom : community.host;
        return endpoint.startsWith("http") ? endpoint : "https://" + endpoint;
    }
    /**
     * SSR
     */ static setContextSsr(context) {
        return this.storeLive(JSON.parse(context));
    }
}
$b1e6fff8c0d9b52f$export$55b7b226f6213252.communities = (0, $i3Hbv.observable)([]);
$b1e6fff8c0d9b52f$export$55b7b226f6213252.contentSortEvents = [];



var $1b6Hd = parcelRequire("1b6Hd");


class $e31963607a73fd5e$export$d7706fd1334044f9 {
    static async init() {
        (0, $7AbeR.Network).onToken = async ()=>{
            return (0, $04dad054de4b2ddf$export$f650c34b939fcf30).hasSsr() ? true : await (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).token() != undefined;
        };
        (0, $7AbeR.Network).onLogout = async ()=>{
            return true;
        };
        (0, $7AbeR.Network).onLogin = async ()=>{
            return true;
        };
        (0, $7AbeR.Network).lostFunctions = [];
        (0, $7AbeR.Network).onNetworkLost(()=>{});
        (0, $7AbeR.Network).lostSolvedFunctions = [];
        (0, $7AbeR.Network).onNetworkLostSolved(()=>{});
        this.initServices();
    }
    static initServices() {
        (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).init();
        (0, $57a401ba8ef81077$export$d41076a259927884).init();
        (0, $1b6Hd.PreferencesService).init();
    }
}




var $1a687a6c3b5b1441$export$f32d71d2735e0373;
$1a687a6c3b5b1441$export$f32d71d2735e0373 = "_7aEym";



var $5FliW = parcelRequire("5FliW");

var $7AbeR = parcelRequire("7AbeR");

var $iSiUq = parcelRequire("iSiUq");

var $8J94x = parcelRequire("8J94x");


var $5FliW = parcelRequire("5FliW");

var $271MM = parcelRequire("271MM");

var $7AbeR = parcelRequire("7AbeR");

var $bi5k0 = parcelRequire("bi5k0");

var $kfkzw = parcelRequire("kfkzw");

var $95a10e41d83d4919$export$336fad406b62621d;
(function(CommunityPublishState) {
    CommunityPublishState[CommunityPublishState["EXTERNAL"] = 1] = "EXTERNAL";
    CommunityPublishState[CommunityPublishState["INTERNAL"] = 2] = "INTERNAL";
    CommunityPublishState[CommunityPublishState["DISABLED"] = 3] = "DISABLED";
    CommunityPublishState[CommunityPublishState["SUSPENDED"] = 4] = "SUSPENDED";
    CommunityPublishState[CommunityPublishState["ONBOARDING_STEP_1"] = 5] = "ONBOARDING_STEP_1";
})($95a10e41d83d4919$export$336fad406b62621d || ($95a10e41d83d4919$export$336fad406b62621d = {}));



var $dEtAh = parcelRequire("dEtAh");

var $8J94x = parcelRequire("8J94x");

var $iSiUq = parcelRequire("iSiUq");
class $a48cda8f32a3f861$export$6125f896890f3b30 {
    init() {
        this.currentPageDuration = 0;
    }
    setupActivityTracking() {
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "visible") this.startTracking();
            else this.stopTracking();
        });
        if (document.visibilityState === "visible") this.startTracking();
    }
    startTracking() {
        if (this.intervalId !== null) return;
        this.intervalId = setInterval(()=>{
            this.currentPageDuration++;
        }, 1000);
    }
    stopTracking() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    dispose() {
        this.stopTracking();
        this.currentPageDuration = 0;
    }
    constructor(){
        this.currentPageDuration = 0;
        this.intervalId = null;
        this.setupActivityTracking();
    }
}



var $dZIKC = parcelRequire("dZIKC");
class $705575c8fe5e66dd$export$cffcd64a3cd48b50 {
    startPage() {
        this.currentPage = {
            duration: 0,
            endTime: 0,
            startTime: Date.now(),
            route: this.pages.getPath(),
            viewedPercentage: 0,
            actions: []
        };
        //duration
        this.activity.init();
        //scroll
        this.currentPageScroll = (0, $iSiUq.SedestralInterface).main.onScroll(()=>{
            let percentage = (0, $iSiUq.SedestralInterface).main.getScrollPercent();
            if (percentage > this.currentPage.viewedPercentage) this.currentPage.viewedPercentage = percentage;
        });
        //link
        this.currentPageLink = (0, $iSiUq.SedestralInterface).main.putListener(window, "click", (e)=>{
            let target = e.target;
            while(target != null && target.nodeName !== "A")target = target.parentNode;
            if (target && target.nodeName === "A") {
                if (!target.href.startsWith(this.baseUrl)) {
                    if (this.currentPage) this.currentPage.actions.push({
                        name: target.innerText,
                        value: target.href,
                        time: Date.now(),
                        type: "link"
                    });
                }
            }
        });
    }
    endPage() {
        if (this.currentPage) {
            this.currentPage.endTime = Date.now();
            this.currentPage.duration = this.activity.currentPageDuration;
            this.activity.dispose();
            (0, $8J94x.SedestralMachine).removeListener(this.currentPageScroll);
            (0, $8J94x.SedestralMachine).removeListener(this.currentPageLink);
            this.newPageFunc.forEach((value)=>value(this, this.currentPage));
        }
    }
    close() {
        this.endPage();
        this.closePageFunc.forEach((value)=>value(this));
    }
    onNewPage(func) {
        this.newPageFunc.push(func);
    }
    onClosePage(func) {
        this.closePageFunc.push(func);
    }
    constructor(pages){
        this.newPageFunc = [];
        this.closePageFunc = [];
        this.pages = pages;
        let frontId = (0, $dEtAh.SedestralStorage).getItem("fid");
        if (frontId == null) {
            frontId = (0, $dZIKC.randomUUID)().replaceAll("-", "");
            (0, $dEtAh.SedestralStorage).setItem("fid", frontId);
        }
        this.frontId = frontId;
        this.baseUrl = window.location.origin;
        this.referrer = document.referrer.startsWith(this.baseUrl) ? undefined : document.referrer;
        this.activity = new (0, $a48cda8f32a3f861$export$6125f896890f3b30)();
        this.pages.onPopState(undefined, ()=>{
            this.endPage();
            this.startPage();
        });
        (0, $8J94x.SedestralMachine).addListener(window, "beforeunload", ()=>this.close());
    }
}



var $c1R3d = parcelRequire("c1R3d");

var $7s7Z1 = parcelRequire("7s7Z1");

var $fksB7 = parcelRequire("fksB7");
class $e26e31f7bd1822ab$export$cd5a914b394b4ddc {
    /**
     * init
     */ init() {
        this.main.clear();
        this.intAHref();
        this.initPopState();
    }
    intAHref() {
        let globalFunc = (e)=>{
            let parents = (0, $7s7Z1.elementParents)(e.target);
            let elementA = e.target.tagName == "A" ? e.target : parents.find((value)=>value.tagName == "A");
            if (elementA) {
                let href = elementA.getAttribute("href");
                let target = elementA.getAttribute("target");
                let download = elementA.getAttribute("download");
                if (target == "_blank") e.stopPropagation();
                if (target !== "_blank" && download == undefined) {
                    try {
                        let url = new URL(href);
                        let x;
                        href = href.replace(url.origin, "");
                        if (href == "") href = this.pathLogin;
                    } catch (ignored) {}
                    e.preventDefault();
                    if (elementA.getAttribute("click") == undefined && elementA.getAttribute("data-click") == undefined) this.setPath(href);
                }
            }
        };
        (0, $8J94x.SedestralMachine).addListener(document, "click", globalFunc, true);
    }
    initPopState() {
        window.onpopstate = async ()=>{
            this.isOnPopState = true;
            await this.execute(this.getPath());
        };
        this.setPath(this.getPath());
    }
    /**
     * pages
     */ async getPage(path) {
        path = path.startsWith("/") ? path.substring(1) : path;
        const segments = path.split("/");
        let page;
        for(let i = segments.length; i > 0; i--){
            const partialPath = "/" + segments.slice(0, i).join("/");
            if (this.pages[partialPath] !== undefined) {
                page = this.pagesInitialized[partialPath];
                if (page == undefined) {
                    this.pagePath = partialPath;
                    page = await this.pages[partialPath](partialPath);
                    this.pagesInitialized[partialPath] = page;
                }
                break;
            }
        }
        return page;
    }
    registerPage(name, component, componentMobile) {
        this.pages[name] = (0, $fksB7.isMobile)() && componentMobile ? componentMobile : component;
    }
    // @ts-ignore
    async getDynamicPage(path) {}
    /**
     * language
     */ pathIsLanguage(path) {
        return this.languages.includes(path);
    }
    pathHasLanguage(path) {
        let firstPath = path.split("/").filter((value)=>value != "")[0];
        return this.pathIsLanguage(firstPath);
    }
    removeLanguageFromPath(path) {
        if (this.pathHasLanguage(path)) {
            let language = this.getLanguageFromPath(path);
            if (language) path = path.replace(`/${language}`, "");
        }
        return path;
    }
    getLanguageFromPath(path) {
        let firstPath = path.split("/").filter((value)=>value != "")[0];
        return this.pathIsLanguage(firstPath) ? firstPath : undefined;
    }
    addLanguageToPath(language, path) {
        return `/${language}` + path;
    }
    getLanguage() {
        let language = this.getLanguageFromPath(this.getPath());
        if (language && this.pathIsLanguage(language)) return language;
        return this.defaultLanguage;
    }
    setLanguage(language) {
        this.setPath(`/${language}${this.getPathWithoutLanguage()}`);
        window.location.reload();
    }
    /**
     * hash
     */ /**
     * Récupérer le hash actuel, sinon le hash de login si vide
     */ getPath() {
        let path = window.location.pathname;
        if (path == "/" || this.pathIsLanguage(path.replace("/", ""))) path = this.pathHome;
        return path;
    }
    getPathWithoutLanguage() {
        return this.removeLanguageFromPath(this.getPath());
    }
    async setPath(path) {
        if (!this.pathHasLanguage(path)) path = this.addLanguageToPath(this.getLanguage(), path);
        if (path != this.getPath()) {
            if (!this.isOnPopState) {
                if (!this.bufferHistoryPath) this.bufferHistoryPath = this.getPath();
                clearTimeout(this.bufferHistory);
                history.replaceState({}, "", path);
                this.bufferHistory = setTimeout(()=>{
                    history.replaceState({}, "", this.bufferHistoryPath);
                    history.pushState({}, "", path);
                    this.bufferHistoryPath = undefined;
                }, 500);
            }
            clearTimeout(this.bufferPopState);
            this.bufferPopState = setTimeout(()=>{
                this.isOnPopState = false;
            }, 500);
        }
        await this.execute(path);
    }
    async changePath(path) {
        let p = this.removeLanguageFromPath(path).substring(1);
        p = "/" + p.split("/")[0];
        let page = this.pagesInitialized[p];
        if (!page) page = this.page;
        if (page.constructor.name == this.page.constructor.name) {
            this.change = true;
            await this.setPath(path);
        } else await this.setPath(path);
    }
    /**
     * redirection
     */ async redirect(path, newTab) {
        if (newTab) window.open(path);
        else {
            path = path == "" || path == "/" ? this.pathHome : path;
            await this.setPath(path);
            window.scroll(0, 0);
        }
    }
    async reload(path) {
        this.onReload = true;
        await this.redirect(path !== null && path !== void 0 ? path : this.getPath());
    }
    /**
     * params
     */ getParams() {
        return (this.dynamicPath ? this.dynamicPath : this.getPath()).split("/");
    }
    getParam(name) {
        let hashes = this.getParams();
        for(let i = 0; i < hashes.length; i++)if (hashes[i] == name) {
            if (typeof hashes[i + 1] !== "undefined") return hashes[i + 1];
        }
        return undefined;
    }
    getParamAtIndex(index) {
        return this.getParams()[index];
    }
    hasParam(name) {
        let hashes = this.getPath().split("/");
        for(let i = 0; i < hashes.length; i++){
            if (hashes[i] == name) return true;
        }
        return false;
    }
    removeParams(names, noHash) {
        names.forEach((value)=>this.removeParam(value, noHash));
    }
    removeParam(name, noHash, forceBase) {
        if (this.hasParam(name)) {
            this.noOnHash = noHash;
            let currentParam = this.getParam(name);
            let hash = this.getPath().replace("/" + name + "/" + currentParam, "");
            if (forceBase) hash = hash.replace("/" + name, "");
            this.changePath(hash);
        }
    }
    removeParamAfter(paramName) {
        let params = (0, $7AbeR.Network).router.pages.getParams();
        for(let i = 0; i < params.length; i++){
            let baseIndex = params.indexOf(paramName);
            if (baseIndex >= 0) {
                if (i > baseIndex) {
                    if (params[i].length > 0) (0, $7AbeR.Network).router.pages.removeParam(params[i], true);
                }
            }
        }
    }
    setParams(params, noHash) {
        let hash = this.getPath();
        if (noHash) this.noOnHash = true;
        params.forEach((param)=>{
            if (param.value) hash = this.setParamUrl(hash, param.name, param.value, true);
            else hash = this.removeParamStr(hash, param.name);
        });
        this.changePath(hash);
    }
    setParam(name, value, preserve, noHash) {
        if (noHash) this.noOnHash = true;
        this.changePath(this.setParamUrl(this.getPath(), name, value, preserve));
    }
    setParamStr(path, name, value) {
        const regex = new RegExp(`/${name}/[^/]+`);
        if (path.match(regex)) return path.replace(regex, `/${name}/${value}`);
        else return `${path}/${name}/${value}`;
    }
    removeParamStr(path, name) {
        const regex = new RegExp(`/${name}/[^/]+`);
        return path.replace(regex, "");
    }
    hasParamStr(path, name) {
        const regex = new RegExp(`/${name}/[^/]+`);
        return regex.test(path);
    }
    /**
     * funcs
     */ onPopState(component, func) {
        this.popStateFunctions.push(func);
        if (component) component.onRemove(()=>this.popStateFunctions.splice(this.popStateFunctions.indexOf(func), 1));
    }
    /**
     * run
     */ async execute(path) {
        this.dynamicPath = undefined;
        if (!this.noOnHash) {
            path = this.removeLanguageFromPath(path);
            let page = await this.getPage(path);
            if (page == undefined) {
                page = await this.getDynamicPage(path);
                if (page == undefined) return this.redirect(this.path404);
            }
            if (!page.status.open) {
                if (page.status.open != undefined && page.status.online == true && !this.isOnline()) return this.redirect(this.pathLogin);
                if (path != this.path404 && page.status.online != undefined && page.status.online == false && this.isOnline()) return this.redirect(this.pathHome);
            }
            if (!this.change) {
                if (!this.onReload && page == this.page) {
                    page.onHash();
                    this.router.static.onHash();
                } else {
                    if (this.page !== undefined) {
                        this.page.remove();
                        (0, $iSiUq.SedestralInterface).main.clear();
                    }
                    this.page = page;
                    this.renderPage(page);
                    page.onHash();
                    this.router.static.onHash();
                    this.updatePageMeta(page);
                }
            } else {
                if (this.onReload || page != this.page) {
                    if (this.page != undefined) {
                        this.page.remove();
                        (0, $iSiUq.SedestralInterface).main.clear();
                    }
                    this.page = page;
                    this.renderPage(page);
                    this.updatePageMeta(page);
                }
                page.onHash();
                this.router.static.onHash();
            }
        }
        if (!this.noOnHash) this.popStateFunctions.forEach((value)=>value());
        this.onReload = false;
        this.change = false;
        this.noOnHash = false;
    }
    renderPage(page) {
        var _SedestralDebugger_rum;
        let rum = (_SedestralDebugger_rum = (0, $c1R3d.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.pageLoad();
        (0, $iSiUq.SedestralInterface).main.render(page);
        (0, $04dad054de4b2ddf$export$f650c34b939fcf30).awaitProcessing().then(()=>{
            rum === null || rum === void 0 ? void 0 : rum.end();
        });
        window.scroll(0, 0);
    }
    /**
     * logic
     */ updatePageMeta(page) {
        document.documentElement.lang = (0, $5FliW.Resources).language;
        document.title = page.title;
        this.updateMeta("robots", this.getRobots(page));
        this.updateMeta("og:locale", (0, $5FliW.Resources).language);
        this.updateMeta("og:title", page.title);
        this.updateMeta("twitter:title", page.title);
        this.updateMeta("name", page.title);
        this.updateMeta("description", page.description);
        this.updateMeta("og:description", page.description);
        this.updateMeta("twitter:description", page.description);
        this.updateMeta("keywords", page.keywords);
        this.updateMeta("image", page.image);
        this.updateMeta("og:image", page.image);
        this.updateMeta("twitter:image", page.image);
        this.updateMeta("og:url", page.ogUrl);
        this.updateMeta("og:site_name", page.ogSiteName);
        this.updateMeta("og:type", page.ogType);
        this.updateAlternateLinks(page.alternateLang);
        this.updateFavIcon(page.favicon);
    }
    updateMetasCommunity(community, isArticle, title, description, keywords, image, alternateLang) {
        var _community_logoFile, _community_faviconFile;
        var _community_text_metaTitle;
        this.page.title = title ? title : (_community_text_metaTitle = community.text.metaTitle) !== null && _community_text_metaTitle !== void 0 ? _community_text_metaTitle : (0, $5FliW.Resources).t("words.metas.title");
        var _community_text_metaTitle1;
        this.page.ogSiteName = (_community_text_metaTitle1 = community.text.metaTitle) !== null && _community_text_metaTitle1 !== void 0 ? _community_text_metaTitle1 : (0, $5FliW.Resources).t("words.metas.title");
        this.page.description = description ? description : community.text.metaDescription;
        this.page.keywords = keywords ? keywords.join(", ") : community.text.metaKeywords.join(", ");
        var _community_logoFile_link;
        this.page.image = image ? image.link : (_community_logoFile_link = (_community_logoFile = community.logoFile) === null || _community_logoFile === void 0 ? void 0 : _community_logoFile.link) !== null && _community_logoFile_link !== void 0 ? _community_logoFile_link : undefined;
        this.page.ogUrl = this.getCurrentUrlWithLang();
        this.page.favicon = community === null || community === void 0 ? void 0 : (_community_faviconFile = community.faviconFile) === null || _community_faviconFile === void 0 ? void 0 : _community_faviconFile.link;
        this.page.ogType = isArticle ? "article" : "website";
        if (!alternateLang) {
            alternateLang = new Map();
            community.languages.forEach((lang)=>{
                alternateLang.set(lang, this.getCurrentUrlWithLang(lang));
            });
        }
        this.page.alternateLang = alternateLang;
        this.updatePageMeta(this.page);
    }
    updateMeta(name, value) {
        const metas = document.querySelectorAll(`head meta[name="${name}"], head meta[itemprop="${name}"], head meta[property="${name}"]`);
        metas.forEach((meta)=>{
            meta.setAttribute("content", value !== null && value !== void 0 ? value : "");
        });
    }
    updateFavIcon(icon = (0, $7AbeR.Network).vendor + "images/favicon.png") {
        let link = document.querySelector('link[rel="icon"]');
        if (link) link.setAttribute("href", icon);
    }
    getUrlWithLang(lang) {
        return (0, $271MM.config).domain + "/" + (lang !== null && lang !== void 0 ? lang : (0, $5FliW.Resources).language) + (0, $7AbeR.Network).router.pages.pagePath;
    }
    getCurrentUrlWithLang(lang) {
        return (0, $271MM.config).domain + "/" + (lang !== null && lang !== void 0 ? lang : (0, $5FliW.Resources).language) + location.pathname.replace(/^\/[a-z]{2}/i, "");
    }
    getUrlWithPath(path) {
        return (0, $271MM.config).domain + "/" + (0, $5FliW.Resources).language + "/" + path;
    }
    getPanelUrl(path) {
        return this.generateUrl(undefined, path);
    }
    getWebsiteUrl(path) {
        return this.generateUrl(undefined, path);
    }
    updateAlternateLinks(alternateLanguages) {
        // Supprimer tous les liens alternatifs existants
        document.querySelectorAll('link[rel="alternate"]').forEach((link)=>{
            var _link_parentNode;
            (_link_parentNode = link.parentNode) === null || _link_parentNode === void 0 ? void 0 : _link_parentNode.removeChild(link);
        });
        // Ajouter les nouveaux liens alternatifs
        alternateLanguages.forEach((url, lang)=>{
            this.updateAlternateLink(lang, url);
        });
        //Si aucun lien alternate, alors on place quand même l'url actuelle
        if (alternateLanguages.size == 0) this.updateAlternateLink((0, $5FliW.Resources).language, window.location.pathname);
    }
    /**
     * override
     */ isOnline() {
        return false;
    }
    isNoneSite() {
        return false;
    }
    setParamUrl(hash, name, value, preserve) {
        let finalHash;
        if (this.hasParam(name)) {
            let currentParam = this.getParam(name);
            let toReplace = name + (currentParam == undefined ? "" : "/" + currentParam);
            let replacement = name + "/" + value;
            finalHash = hash.replace(toReplace, replacement);
            let afters = finalHash.split(replacement);
            if (afters.length > 0) {
                if (!preserve) finalHash = finalHash.replace(afters[1], "");
            }
        } else finalHash = hash + "/" + name + "/" + value;
        return finalHash;
    }
    getRobots(page) {
        let noIndex = [
            "/helpcenter",
            "/service-client",
            "/inbox",
            "/mail",
            "/publisher",
            "/statistics",
            "/livechat"
        ];
        if (noIndex.includes(location.pathname.replace(/^\/[a-z]{2}/i, ""))) return "noindex";
        if (!(0, $271MM.config).isProd) return "noindex";
        if ((0, $7AbeR.Network).productName == (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).HELPCENTER) || (0, $7AbeR.Network).productName == (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).BLOG)) {
            var _CommunityService_live, _CommunityService_live1, _CommunityService_live2;
            const isExternalCommunity = ((0, $b1e6fff8c0d9b52f$export$55b7b226f6213252) === null || (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252) === void 0 ? void 0 : (_CommunityService_live = (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).live) === null || _CommunityService_live === void 0 ? void 0 : _CommunityService_live.community.publishState) === (0, $95a10e41d83d4919$export$336fad406b62621d).EXTERNAL;
            const isHostCustomVerified = (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252) === null || (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252) === void 0 ? void 0 : (_CommunityService_live1 = (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).live) === null || _CommunityService_live1 === void 0 ? void 0 : _CommunityService_live1.community.hostCustomVerified;
            const isHostCustomMatching = "https://" + ((0, $b1e6fff8c0d9b52f$export$55b7b226f6213252) === null || (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252) === void 0 ? void 0 : (_CommunityService_live2 = (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).live) === null || _CommunityService_live2 === void 0 ? void 0 : _CommunityService_live2.community.hostCustom) === (0, $271MM.config).domain;
            return isExternalCommunity && (!isHostCustomVerified || isHostCustomMatching) ? "index" : "noindex";
        } else if ((0, $7AbeR.Network).productName == (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).WEBSITE)) return "index";
        else return (0, $04dad054de4b2ddf$export$f650c34b939fcf30).hasSsr() || this.hasPathIndex() ? "index" : "noindex";
    }
    hasPathIndex() {
        const pathsToCheck = [
            "login",
            "signup",
            "password"
        ];
        return pathsToCheck.some((path)=>{
            var _window_location_pathname;
            return (_window_location_pathname = window.location.pathname) === null || _window_location_pathname === void 0 ? void 0 : _window_location_pathname.includes(path);
        });
    }
    updateAlternateLink(lang, url) {
        if (!url.startsWith("http")) url = (0, $271MM.config).domain + url;
        let link = document.createElement("link");
        link.rel = "alternate";
        link.hreflang = lang;
        link.href = url;
        document.head.appendChild(link);
    }
    generateUrl(url, path) {
        if (path) return url + "/" + (0, $5FliW.Resources).language + "/" + path;
        else return url + "/" + (0, $5FliW.Resources).language;
    }
    constructor(router, languages, defaultLanguage){
        this.router = router;
        this.languages = languages !== null && languages !== void 0 ? languages : [
            (0, $5FliW.Resources).getDefaultLanguage()
        ];
        this.defaultLanguage = defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : (0, $5FliW.Resources).getDefaultLanguage();
        this.main = (0, $iSiUq.SedestralInterface).main;
        this.pages = {};
        this.pagesInitialized = {};
        this.page = undefined;
        this.change = false;
        this.popStateFunctions = [];
        this.stats = new (0, $705575c8fe5e66dd$export$cffcd64a3cd48b50)(this);
    }
}


class $3a2e6a8b770a9b25$export$81033b5937b7c31e {
    /**
     * get and set
     */ get components() {
        return this._components;
    }
    set components(value) {
        this._components = value;
    }
    register(name, component) {
        this._components[name] = component;
    }
    onHash() {
        for(let key in this._components)if (this._components.hasOwnProperty(key)) {
            let component = this._components[key];
            component.onHash();
        }
    }
    constructor(router){
        this._components = {};
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $68Z0d = parcelRequire("68Z0d");

var $iSiUq = parcelRequire("iSiUq");
class $79176775f504535f$export$1a9aa230c91bad4e {
    get online() {
        return this._online;
    }
    set online(value) {
        this._online = value;
    }
    get open() {
        return this._open;
    }
    set open(value) {
        this._open = value;
    }
    constructor(){
        this._online = false;
        this._open = false;
    }
}



var $iJHeF = parcelRequire("iJHeF");

var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $47734e1c0ab90ca1$export$c4dc9eeb28e63095 extends (0, $iJHeF.Component) {
    updateMetas(pageName) {
        const { title: title, description: description, keywords: keywords } = this.getPageData(pageName);
        this.title = title;
        this.description = description;
        this.keywords = keywords;
    }
    getTemplate() {
        this.init();
        return super.getTemplate();
    }
    destroy() {
        this.nullify();
        this.committed = false;
    }
    renderNoneSite() {}
    renderNoneRole() {}
    getPageData(pageName) {
        const keyPrefix = `pagesDatas.${pageName}.`;
        return {
            title: (0, $5FliW.Resources).t(`words.${keyPrefix}title`),
            description: (0, $5FliW.Resources).t(`words.${keyPrefix}description`),
            keywords: (0, $5FliW.Resources).exist(`words.${keyPrefix}keywords`) ? (0, $5FliW.Resources).t(`words.${keyPrefix}keywords`) : undefined
        };
    }
    constructor(){
        super();
        this.image = (0, $7AbeR.Network).vendor + "images/capture-blog.webp";
        this.ogUrl = (0, $7AbeR.Network).router.pages.getUrlWithLang();
        this.ogSiteName = "Sedestral";
        this.ogType = "website";
        this.container = undefined;
        this.template = "<div>page</div>";
        this.status = new (0, $79176775f504535f$export$1a9aa230c91bad4e)();
        let alternateLanguages = new Map();
        (0, $5FliW.Resources).languages.forEach((lang)=>{
            alternateLanguages.set(lang, (0, $7AbeR.Network).router.pages.getUrlWithLang(lang));
        });
        this.alternateLang = alternateLanguages;
    }
}


class $ba3f6de36c72b39f$export$7f99477635901bdd extends (0, $47734e1c0ab90ca1$export$c4dc9eeb28e63095) {
    init() {
        //language=HTML
        console.log("finish");
        this.template = `
            <div class="ssrPageLoadReady"></div>`;
    }
    onHash() {}
    constructor(){
        super();
        this.title = "Sedestral SSR";
        this.status.online = false;
    }
}



var $dEtAh = parcelRequire("dEtAh");

var $5FliW = parcelRequire("5FliW");
class $de7de48559ba9955$export$d35034d02907e61a {
    /**
     * init
     */ init(config) {
        this.config = config;
    }
    initStarted() {
        var _this_config, _this_config1;
        this.pages = new (0, $e26e31f7bd1822ab$export$cd5a914b394b4ddc)(this, (_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.languages, (_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.defaultLanguage);
        this.static = new (0, $3a2e6a8b770a9b25$export$81033b5937b7c31e)(this);
        this.pages.isOnline = ()=>(0, $7AbeR.Network).logged;
        this.pages.isNoneSite = ()=>(0, $68Z0d.EntityService).activeSite == null;
        this.registerStatic();
        this.registerPages();
        this.registerSsr();
        this.static.components.loader.displayHide();
        this.pages.init();
        this.onStarted();
    }
    initNotStarted(errorComponent) {
        this.pages = new (0, $e26e31f7bd1822ab$export$cd5a914b394b4ddc)(this);
        this.static = new (0, $3a2e6a8b770a9b25$export$81033b5937b7c31e)(this);
        this.registerStatic();
        this.static.components.loader.displayHide();
        (0, $iSiUq.SedestralInterface).body.render(errorComponent);
    }
    /**
     * register
     */ registerStatic() {}
    registerPages() {}
    registerSsr() {
        this.pages.registerPage("/sedestral.ssr", ()=>new (0, $ba3f6de36c72b39f$export$7f99477635901bdd)());
    }
    /**
     * import
     */ async importPage(func, product) {
        let key = "panelRouter" + product; //+ Date.now();
        if (Date.now() - 3600000 < new Date(parseInt((0, $dEtAh.SedestralStorage).getItem(key))).getTime()) product = undefined;
        else (0, $dEtAh.SedestralStorage).setItem(key, "" + Date.now());
        this.static.components.pageLoader.remove();
        clearTimeout(this.pageLoaderTimeout);
        this.static.components.pageLoader.product = product;
        this.static.components.pageLoader.init();
        let module = await func();
        if (product != undefined) this.pageLoaderTimeout = setTimeout(()=>{
            this.static.components.pageLoader.animateRemove();
        }, 2500);
        else this.static.components.pageLoader.remove();
        return module;
    }
    /**
     * language
     */ language(defaultLanguage) {
        let firstPath = window.location.pathname.split("/").filter((value)=>value != "")[0];
        if (this.languages.includes(firstPath)) return firstPath;
        if (this.pages && this.pages.defaultLanguage) return this.pages.defaultLanguage;
        var _ref;
        return (_ref = defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : (0, $5FliW.Resources).getBestLanguageCandidate(this.languages)) !== null && _ref !== void 0 ? _ref : (0, $5FliW.Resources).getDefaultLanguage();
    }
    /**
     * override
     */ onLogin() {}
    onLogout() {}
    onStarted() {}
    constructor(languages){
        this.languages = languages;
    }
}



var $iJHeF = parcelRequire("iJHeF");
class $5d3cd1601b58e098$export$383cb4a7b52cc636 extends (0, $iJHeF.Component) {
    // @ts-ignore
    init() {
        this.commit();
    }
    onHash() {}
    constructor(){
        super();
        this.template = "<div>static</div>";
    }
}


class $6c4be56322fba389$export$854fe5f7a33d16c2 extends (0, $5d3cd1601b58e098$export$383cb4a7b52cc636) {
    displayShow() {
        super.displayShow();
        this.setStyle("display:flex;opacity:1;");
    }
    async displayHide() {
        await super.fade("out", 200);
        super.displayHide();
    }
    onHash() {}
    constructor(){
        super();
        this.element = document.querySelector(".globalLoaderBackground:not([globalBg])");
    }
}




var $5FliW = parcelRequire("5FliW");

var $iJHeF = parcelRequire("iJHeF");
var $9a6b2421953f7865$export$cfab8f770b16541e;
var $9a6b2421953f7865$export$63e82393dc8977bf;
var $9a6b2421953f7865$export$5c452ff88e35e47d;
var $9a6b2421953f7865$export$6f093cfa640b7166;
$9a6b2421953f7865$export$cfab8f770b16541e = "trAga";
$9a6b2421953f7865$export$63e82393dc8977bf = "JeHC0";
$9a6b2421953f7865$export$5c452ff88e35e47d = "DzgHG";
$9a6b2421953f7865$export$6f093cfa640b7166 = "DWtSk";



var $5FliW = parcelRequire("5FliW");
class $1a11a2f2074dd254$export$76735e5c95577c8e extends (0, $iJHeF.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$9a6b2421953f7865$export$cfab8f770b16541e}">
                <div>
                    <div class="${$9a6b2421953f7865$export$63e82393dc8977bf}">
                        <div class="${$9a6b2421953f7865$export$5c452ff88e35e47d}"></div>
                    </div>
                    <div class="${$9a6b2421953f7865$export$6f093cfa640b7166}">
                        ${(0, $5FliW.Resources).t("words.cantHelpYouNow")} \u{1F607}
                    </div>
                </div>
            </div>
        `;
    }
}


class $1d4a851e96ae8409$export$1844d26a3bb8e080 extends (0, $de7de48559ba9955$export$d35034d02907e61a) {
    async init(config) {
        super.init(config);
        if (config.started) super.initStarted();
        else super.initNotStarted(new (0, $1a11a2f2074dd254$export$76735e5c95577c8e)());
    }
    registerPages() {
        this.registerDynamicPage();
    }
    registerDynamicPage() {
        let loaderTimeout;
        this.pages.getDynamicPage = async (path)=>{
            loaderTimeout = setTimeout(()=>this.static.components.loader.displayShow(), 150);
            let paths = path.split("/");
            let addingToRoute = ``;
            if (paths.includes("page")) {
                let page = paths[3];
                paths.splice(2, path.length - 2);
                addingToRoute = `/page/${page}`;
            }
            if (paths.length == 2) {
                let categoryRoute = paths[1];
                path = `/category/${categoryRoute}${addingToRoute}`;
                if (categoryRoute != "home") {
                    if (!await (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).checkRoute((0, $5FliW.Resources).language, categoryRoute, undefined)) {
                        this.static.components.loader.displayHide();
                        clearTimeout(loaderTimeout);
                        return;
                    }
                }
            } else if (paths.length >= 3) {
                let categoryRoute = paths[1];
                let articleRoute = paths[2];
                path = `/article/${articleRoute}`;
                if (!await (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).checkRoute((0, $5FliW.Resources).language, categoryRoute, articleRoute)) {
                    this.static.components.loader.displayHide();
                    clearTimeout(loaderTimeout);
                    return;
                }
            }
            this.pages.dynamicPath = path;
            this.static.components.loader.displayHide();
            clearTimeout(loaderTimeout);
            return await this.pages.getPage(path);
        };
    }
    registerStatic() {
        this.static.register("loader", new (0, $6c4be56322fba389$export$854fe5f7a33d16c2)());
        this.static.register("pageLoader", new (0, $6c4be56322fba389$export$854fe5f7a33d16c2)());
    }
    onLogin() {
        this.pages.redirect(this.pages.pathHome);
    }
    onLogout() {
        setTimeout(async ()=>{
            await this.pages.redirect(this.pages.pathLogin);
        }, 3000);
    }
}



var $f8743834758328bc$export$46da19ff27de8e3d;
$f8743834758328bc$export$46da19ff27de8e3d = "pBWp-";



var $iJHeF = parcelRequire("iJHeF");
var $36f9617669facfa7$export$a35262b4ab678c65;
var $36f9617669facfa7$export$428e7c787d57587d;
var $36f9617669facfa7$export$96ff94e0adb1d772;
var $36f9617669facfa7$export$1e95b668f3b82d;
var $36f9617669facfa7$export$db3c28d99448dcff;
var $36f9617669facfa7$export$3098a4cea043ebce;
var $36f9617669facfa7$export$6d59db4903f20f7d;
var $36f9617669facfa7$export$d76128d007d19019;
var $36f9617669facfa7$export$1ca1ec8b29a4ce27;
var $36f9617669facfa7$export$b7e3ae3d7c15e42e;
var $36f9617669facfa7$export$53f1d5ea8de3d7c;
var $36f9617669facfa7$export$a7db06668cad9adb;
var $36f9617669facfa7$export$f4c5de44377d2946;
var $36f9617669facfa7$export$8837f4fc672e936d;
var $36f9617669facfa7$export$89da14300d534261;
var $36f9617669facfa7$export$657ee1858213601f;
var $36f9617669facfa7$export$a8ff84c12d48cfa6;
var $36f9617669facfa7$export$61f6990d5944375a;
var $36f9617669facfa7$export$bca14c5b3b88a9c9;
var $36f9617669facfa7$export$32180ef41b15b513;
$36f9617669facfa7$export$a35262b4ab678c65 = "VY0mt";
$36f9617669facfa7$export$428e7c787d57587d = "_4CLfN";
$36f9617669facfa7$export$96ff94e0adb1d772 = "txXZ-";
$36f9617669facfa7$export$1e95b668f3b82d = "_49Pn-";
$36f9617669facfa7$export$db3c28d99448dcff = "B1SAw";
$36f9617669facfa7$export$3098a4cea043ebce = "la-iR";
$36f9617669facfa7$export$6d59db4903f20f7d = "_8alLl";
$36f9617669facfa7$export$d76128d007d19019 = "CfRgG";
$36f9617669facfa7$export$1ca1ec8b29a4ce27 = "z-3pT";
$36f9617669facfa7$export$b7e3ae3d7c15e42e = "ZlQIu";
$36f9617669facfa7$export$53f1d5ea8de3d7c = "dlCM4";
$36f9617669facfa7$export$a7db06668cad9adb = "itHRH";
$36f9617669facfa7$export$f4c5de44377d2946 = "TApCm";
$36f9617669facfa7$export$8837f4fc672e936d = "m9iL1";
$36f9617669facfa7$export$89da14300d534261 = "Eu7vN";
$36f9617669facfa7$export$657ee1858213601f = "Li9F8";
$36f9617669facfa7$export$a8ff84c12d48cfa6 = "JleTv";
$36f9617669facfa7$export$61f6990d5944375a = "ERyEi";
$36f9617669facfa7$export$bca14c5b3b88a9c9 = "sX5qr";
$36f9617669facfa7$export$32180ef41b15b513 = "HOF90";




var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");

var $iJHeF = parcelRequire("iJHeF");

var $iSiUq = parcelRequire("iSiUq");

var $8J94x = parcelRequire("8J94x");

var $gvC7k = parcelRequire("gvC7k");
class $4da9e788b83f8711$export$ec7a7f40ea27f7a7 extends (0, $iJHeF.Component) {
    /**
     * get and set
     */ get component() {
        return this._component;
    }
    set component(value) {
        this._component = value;
    }
    /**
     * place and position
     */ place() {
        if (this.component.getOffsets().top > window.innerHeight / 2) this.setStyle(`transition-duration:0;left:${this.calcMiddle()}px;top:unset;bottom:${this.calcOutsideBottom()}px;`);
        else this.setStyle(`transition-duration:0;left:${this.calcMiddle()}px;top:${this.calcTop()}px;`);
        if (this.outsideBottom()) this.setStyle(`top:unset;bottom:${this.calcOutsideBottom()}px`);
        if (this.outsideRight()) this.setStyle(`left:unset;right:${this.calcOutsideRight()}px;`);
        if (this.outsideLeft()) this.setStyle(`right:unset;left:${this.calcOutsideLeft()}px;`);
        if (this.firstPlace) {
            this.firstPlace = false;
            (0, $8J94x.SedestralMachine).requestFrame()(()=>{
                if (this.outsideBottom() || this.outsideRight() || this.outsideLeft()) this.place();
            });
        }
    }
    placeTop() {
        this.setStyle(`top:unset;bottom:${this.calcOutsideBottom()}px`);
        if (this.outsideTop()) this.setStyle(`bottom:unset;top:${this.calcTop()}px;`);
    }
    placeRight() {
        this.setStyle(`left:unset;right:${this.calcOutsideRight()}px;`);
        if (this.outsideLeft()) this.setStyle(`right:unset;left:${this.calcOutsideLeft()}px;`);
    }
    placeOnRight() {
        this.setStyle(`left:${this.calcLeft() + this._component.getWidth() + 15};right: unset;`);
        this.setStyle(`top:${this.calcMiddleTop()}px;`);
        if (this.outsideLeft()) this.setStyle(`right:unset;left:${this.calcOutsideLeft()}px;`);
        if (this.outsideRight()) this.setStyle(`left:unset;right:${this.calcOutsideRight()}px;`);
        if (this.outsideTop()) this.setStyle(`bottom:unset;top:${this.calcOutsideTop()}px;`);
        if (this.outsideBottom()) this.setStyle(`bottom: 10px;top: unset;`);
    }
    replace() {
        let timeNow = performance.now();
        if (timeNow - 10 > this.time) {
            this.time = timeNow;
            this.setStyle(`transition-duration: 0s;`);
            this.place();
        }
    }
    /**
     * calc position
     */ //place element to middle
    calcMiddle() {
        return this._component.getOffsets().left + this._component.getWidth() / 2 - this.getWidth() / 2;
    }
    calcMiddleTop() {
        return this._component.getOffsets().top + this._component.getHeight() / 2 - this.getHeight() / 2;
    }
    // place to left element
    calcLeft() {
        return this._component.getOffsets().left;
    }
    // place if limit left
    calcOutsideLeft() {
        return 10;
    }
    calcOutsideTop() {
        return 10;
    }
    //place on bottom of element
    calcTop() {
        return this._component.getOffsets().top + this._component.getHeight() + 5;
    }
    //place on top of element if bottom is limit
    calcOutsideBottom() {
        return this.component.getOffsets().bottom + this._component.getHeight() + 4;
    }
    // place if limit right
    calcOutsideRight() {
        return 10;
    }
    /**
     * calc if element is outside screen
     */ outsideLeft() {
        return (0, $gvC7k.elementOffsets)(this.getHTMLElement()).left < 10;
    }
    outsideBottom() {
        return this.getHTMLElement().getBoundingClientRect().height + this.getOffsets().top > window.innerHeight;
    }
    outsideTop() {
        return this.getOffsets().top < 0;
    }
    outsideRight() {
        return this.getWidth() + this.getOffsets().left > window.innerWidth;
    }
    /**
     * append and remove
     */ dispose() {
        if (!this.isNull()) this.remove();
        this.onDispose();
    }
    create() {
        (0, $iSiUq.SedestralInterface).main.render(this);
        (0, $iSiUq.SedestralInterface).main.removeChildren(this);
    }
    /**
     *override
     */ onDispose() {}
    beforeDispose() {}
    constructor(component){
        super();
        this._component = component;
        this.time = performance.now();
        this.firstPlace = true;
        this.putListener(window, "resize", ()=>this.replace());
    }
}


var $02957fbd0fc41c68$export$ea5c36236b0b24c6;
var $02957fbd0fc41c68$export$1114d5e9985e6d2a;
$02957fbd0fc41c68$export$ea5c36236b0b24c6 = "eSkuV";
$02957fbd0fc41c68$export$1114d5e9985e6d2a = "p28fd";



var $8J94x = parcelRequire("8J94x");

var $iSiUq = parcelRequire("iSiUq");

var $fksB7 = parcelRequire("fksB7");
class $9c70d052672aebeb$export$2b42b674fe95a29 extends (0, $4da9e788b83f8711$export$ec7a7f40ea27f7a7) {
    get hovered() {
        return this._hovered;
    }
    get minHeight() {
        return this._minHeight;
    }
    set minHeight(value) {
        this._minHeight = value;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    get hoverDelay() {
        return this._hoverDelay;
    }
    set hoverDelay(value) {
        this._hoverDelay = value;
    }
    get leaveDelay() {
        return this._leaveDelay;
    }
    set leaveDelay(value) {
        this._leaveDelay = value;
    }
    /**
     * get set
     */ get isAnimation() {
        return this._animation;
    }
    get animationDelay() {
        return this._delay;
    }
    set animationDelay(value) {
        this._delay = value;
    }
    commit() {
        if (this._autoMaxHeight) {
            this.calcMaxHeight();
            (0, $8J94x.SedestralMachine).requestFrame()(()=>{
                this.calcMaxHeight();
                this.onChange(()=>{
                    this.calcMaxHeight();
                });
            });
        }
        this.bind();
        (0, $8J94x.SedestralMachine).requestFrame()(()=>{
            this.place();
        });
        super.commit();
    }
    /**
     * bind
     */ bind() {
        if (!(0, $fksB7.isMobile)() && !this._disableLeave) {
            this.onLeave(async ()=>{
                await this.dispose();
            });
            let listener = this.component.onLeave(async ()=>{
                if (!this._hovered) {
                    await this.dispose();
                    this.component.deleteListener(listener);
                }
            }, this._leaveDelay == undefined ? 200 : this._leaveDelay);
            this.onHover(()=>{
                if (!this._hovered) {
                    this._hovered = true;
                    this.component.deleteListener(listener);
                }
            }, this._hoverDelay == undefined ? 0 : this._hoverDelay);
        } else this.onOutsideClick(()=>this.dispose());
    }
    /**
     * init and dispose
     */ async dispose() {
        this.beforeDispose();
        if (this._animation) this._mobileStyle ? await this.closeDown(this._delay) : await this.scaleHide(this._delay);
        else {
            this.displayHide();
            this.clearAll();
        }
        if (this._disableLeave) this.component[this._keyId] = undefined;
        super.dispose();
    }
    create() {
        if (this._disableLeave) {
            if (this.component[this._keyId]) {
                (0, $iSiUq.SedestralInterface).unStore(this);
                this.clearAll();
                return;
            }
            this.component[this._keyId] = true;
        }
        super.create();
        if (this._animation) this._mobileStyle ? this.openUp(this._delay) : this.scaleShow(this._delay);
        else this.displayShow();
    }
    place() {
        if (this._mobileStyle && (0, $fksB7.isMobile)()) {
            let paddingLeft = window.getComputedStyle(this.getHTMLElement(), null).getPropertyValue("padding-left");
            let paddingRight = window.getComputedStyle(this.getHTMLElement(), null).getPropertyValue("padding-right");
            this.setStyle(`width:calc(100% - ${parseInt(paddingLeft) + parseInt(paddingRight)}px);left:unset !important;right:0 !important;top:unset !important;bottom:0;border-radius: 15px 15px 0px 0px;`);
            this.getHTMLElement().lastElementChild["style"].cssText += "padding-bottom: 20px !important;";
        } else super.place();
    }
    /**
     * template
     */ getTemplate() {
        if (this._width !== 0) return this.template = `
                <div style="min-height: ${this._minHeight}px;width:${this._width}px;" class="${$02957fbd0fc41c68$export$ea5c36236b0b24c6}">
                     ${super.getTemplate()}
                </div>
            `;
        else return this.template = `
                <div style="min-height: ${this._minHeight}px;width: calc(100% - 60px); left: 15px !important; top: 15px !important" class="${$02957fbd0fc41c68$export$ea5c36236b0b24c6}">
                     ${super.getTemplate()}
                </div>
            `;
    }
    /**
     * settings
     */ animation(value) {
        this._animation = value;
        return this;
    }
    mobileStyle(value) {
        this._mobileStyle = value;
        return this;
    }
    autoMaxHeight(value) {
        this._autoMaxHeight = value;
        return this;
    }
    /**
     * height
     */ calcMaxHeight() {
        if (!this.component.isNull() && !this.isNull()) {
            let firstElement = this.getFirstChildElement();
            if (firstElement != undefined) {
                let maxHeight;
                if (this.component.getOffsets().top > window.innerHeight / 2) {
                    let bottom = this.component.getHeight() + this.component.getOffsets().bottom + 30;
                    maxHeight = window.innerHeight - bottom;
                } else {
                    let top = this.component.getHeight() + this.component.getOffsets().top + 30;
                    maxHeight = window.innerHeight - top;
                }
                let child = firstElement;
                for(let i = 0; i < child.children.length; i++)child.children[i]["_scrollTop"] = child.children[i].scrollTop;
                child.style.cssText += `height:fit-content !important;`;
                let childHeight = child.scrollHeight;
                if (childHeight > maxHeight - 10) {
                    child.style.cssText += `height:${maxHeight - ((0, $fksB7.isMobile)() ? 40 : 0)}px !important;`;
                    this.setStyle(`height:${maxHeight}px;transition:0s;`);
                } else {
                    child.style.cssText += `height:${childHeight + 1}px !important;`;
                    this.setStyle(`height:fit-content;transition:0s;`);
                }
                for(let i = 0; i < child.children.length; i++)child.children[i]["scrollTop"] = child.children[i]["_scrollTop"];
                this.place();
            }
        }
    }
    getFirstChildElement() {
        let firstElement = this.getHTMLElement().firstElementChild;
        if (firstElement && firstElement.hasAttribute("swapBar")) return firstElement.nextElementSibling;
        return firstElement;
    }
    constructor(component, minHeight, width){
        super(component);
        this._hovered = false;
        this._minHeight = minHeight;
        this._width = width;
        this._animation = true;
        this._keyId = "tooltip-" + this.constructor.name;
    }
}



var $iSiUq = parcelRequire("iSiUq");


var $8J94x = parcelRequire("8J94x");
class $94961cd4542c3c73$export$dea594182f495d9c extends (0, $9c70d052672aebeb$export$2b42b674fe95a29) {
    /**
     * get and set
     */ get screenContainer() {
        return this._screenContainer;
    }
    get isReady() {
        return this._isReady;
    }
    bind() {
        this.addListener("contextmenu", (e)=>e.stopPropagation());
        this.onOutsideClick(async ()=>await this.dispose());
        this.onOutsideRightClick(async ()=>await this.dispose());
        this.component.onRemove(async ()=>{
            this.disposeScreen();
            await this.dispose();
        });
    }
    async create(hidden) {
        if (this.component[this._keyId]) {
            (0, $iSiUq.SedestralInterface).unStore(this);
            this.clearAll();
            return;
        }
        this.component[this._keyId] = true;
        (0, $iSiUq.SedestralInterface).main.render(this);
        if (this._screen) {
            this._screenContainer = (0, $iSiUq.SedestralInterface).body.append(`<div class="${$02957fbd0fc41c68$export$1114d5e9985e6d2a}"></div>`);
            (0, $iSiUq.SedestralInterface).body.removeChildren(this._screenContainer);
        }
        if (this._unClickable) this.unClickable();
        if (!hidden) {
            if (this.isAnimation) this._mobileStyle ? await this.openUp(this.animationDelay) : await this.scaleShow(this.animationDelay);
            else this.displayShow();
        } else this.displayHide();
        (0, $8J94x.SedestralMachine).requestFrame()(()=>{
            this._isReady = true;
        });
    }
    async dispose() {
        this.disposeScreen();
        await super.dispose();
        this._isReady = false;
        this.component[this._keyId] = undefined;
    }
    disposeScreen() {
        if (this._screen && this._screenContainer != undefined) {
            this._screenContainer.remove();
            this._screenContainer = undefined;
        }
    }
    /**
     * settings
     */ screen(value) {
        this._screen = value;
        return this;
    }
    setUnClickable(value) {
        this._unClickable = value;
        return this;
    }
    setComponentUnClickable(classValue) {
        if (!this.isNull()) this.onClick((e)=>{
            (0, $8J94x.SedestralMachine).outsideClickListeners.forEach((value)=>{
                if (!(value["component"] instanceof classValue)) value.callback(e);
            });
        }, true);
    }
    constructor(component, minHeight, width){
        super(component, minHeight, width);
        this._screen = true;
        this._unClickable = true;
        this._isReady = false;
    }
}


var $4ea4ebaa06f842d1$export$2d1cd94fb03f26e9;
var $4ea4ebaa06f842d1$export$c407db72103fecfa;
var $4ea4ebaa06f842d1$export$fb184b623420d9be;
$4ea4ebaa06f842d1$export$2d1cd94fb03f26e9 = "_7C8wI";
$4ea4ebaa06f842d1$export$c407db72103fecfa = "DSd4W";
$4ea4ebaa06f842d1$export$fb184b623420d9be = "dhlLL";



var $iJHeF = parcelRequire("iJHeF");
var $84c8b38862d16378$export$f4055a8322d74206;
var $84c8b38862d16378$export$2235f094b8d7361f;
var $84c8b38862d16378$export$bb628a54ab399bc9;
var $84c8b38862d16378$export$bb654e07daaf8c3a;
var $84c8b38862d16378$export$eb03490a10c3abc9;
$84c8b38862d16378$export$f4055a8322d74206 = "ALwdj";
$84c8b38862d16378$export$2235f094b8d7361f = "c6RsJ";
$84c8b38862d16378$export$bb628a54ab399bc9 = "s24X6";
$84c8b38862d16378$export$bb654e07daaf8c3a = "mKjxY";
$84c8b38862d16378$export$eb03490a10c3abc9 = "rRzOA";


class $7a82c95c87b35184$export$8ed40a6e8d9e757d extends (0, $iJHeF.Component) {
    constructor(p){
        super();
        this.template = `
            <div loaderLight class="${$84c8b38862d16378$export$f4055a8322d74206}">
                <div class="${$84c8b38862d16378$export$2235f094b8d7361f}">
                    <svg style="${p && p.width ? `width:${p.width}px;height:${p.width}px;` : ``}" viewBox="0 0 50 50">
                        <circle style="${p && p.strokeWidth ? `stroke-width:${p.strokeWidth}px;` : ``}${p && p.strokeColor ? `stroke:${p.strokeColor};` : ``}" class="${$84c8b38862d16378$export$bb654e07daaf8c3a}" cx="25" cy="25" r="20" fill="none" stroke-width="2"/>
                    </svg>
                </div>
            </div>
        `;
    }
}




var $5FliW = parcelRequire("5FliW");

var $iJHeF = parcelRequire("iJHeF");
var $07b0030850b83291$export$56715c470bdac314;
var $07b0030850b83291$export$f1e544e8e1c4eecb;
var $07b0030850b83291$export$f4c5de44377d2946;
var $07b0030850b83291$export$a19185d1233fc4b2;
var $07b0030850b83291$export$6f093cfa640b7166;
var $07b0030850b83291$export$dc57ddd528b7443f;
var $07b0030850b83291$export$2ba01fb71ed41cb6;
var $07b0030850b83291$export$46c1c92549715335;
$07b0030850b83291$export$56715c470bdac314 = "_5QkTb";
$07b0030850b83291$export$f1e544e8e1c4eecb = "XLEgw";
$07b0030850b83291$export$f4c5de44377d2946 = "CZP6a";
$07b0030850b83291$export$a19185d1233fc4b2 = "NwOdi";
$07b0030850b83291$export$6f093cfa640b7166 = "lSeJc";
$07b0030850b83291$export$dc57ddd528b7443f = "_6ilDe";
$07b0030850b83291$export$2ba01fb71ed41cb6 = "z63-v";
$07b0030850b83291$export$46c1c92549715335 = "ygQJR";



var $7AbeR = parcelRequire("7AbeR");

class $5297a1b0c9393fef$export$8f93841fb2480ea2 extends (0, $iJHeF.Component) {
    commit() {
        this.buttonContainer = this.el($07b0030850b83291$export$dc57ddd528b7443f);
        this.button = this.el($07b0030850b83291$export$2ba01fb71ed41cb6);
        this.textContainer = this.el($07b0030850b83291$export$6f093cfa640b7166);
        if (this.buttonContainer && !this.buttonContainer.isNull()) this.buttonContainer.onClick(()=>{
            if (!this.button.hasClass($07b0030850b83291$export$46c1c92549715335)) this.onButtonClick();
        });
        super.commit();
    }
    onButtonClick() {
        (0, $7AbeR.Network).router.pages.redirect("/general/categories");
    }
    setButtonLoading() {
        if (!this.buttonContainer.isNull()) {
            this.loading = this.button.render(new (0, $7a82c95c87b35184$export$8ed40a6e8d9e757d)());
            this.button.addClass($07b0030850b83291$export$46c1c92549715335);
        }
    }
    remButtonLoading() {
        if (!this.buttonContainer.isNull() && this.loading) {
            this.button.removeClass($07b0030850b83291$export$46c1c92549715335);
            this.loading.remove();
            this.loading = undefined;
        }
    }
    constructor(emoji, text, buttonText, loader){
        super();
        //language=HTML
        this.template = `
            <div emptyBasic class="${$07b0030850b83291$export$56715c470bdac314}">
                <div class="${$07b0030850b83291$export$f1e544e8e1c4eecb}">
                    <div emptyemoji class="${$07b0030850b83291$export$a19185d1233fc4b2}">${emoji}</div>
                    ${text == undefined ? `` : `<div emptyText class="${$07b0030850b83291$export$6f093cfa640b7166}">${text}</div>`}
                    ${buttonText == undefined ? `` : `<div class="${$07b0030850b83291$export$dc57ddd528b7443f}"><div emptyButton class="${$07b0030850b83291$export$2ba01fb71ed41cb6}">${buttonText}</div></div>`}
                    ${loader == undefined ? `` : `<div class="${$07b0030850b83291$export$f4c5de44377d2946}">${this.draw(new (0, $7a82c95c87b35184$export$8ed40a6e8d9e757d)({
            width: 50,
            strokeWidth: 3
        }))}</div>`}
                </div>
            </div>
        `;
    }
}



var $86gWV = parcelRequire("86gWV");
class $4c79d0f096d935ca$export$aaabb7c931c33bb2 extends (0, $94961cd4542c3c73$export$dea594182f495d9c) {
    commit() {
        this.swapable(()=>this.dispose());
        this.container = this.el($4ea4ebaa06f842d1$export$2d1cd94fb03f26e9);
        let firstSearchTimeout = this.timeOut(()=>this.search(), 500);
        this.component.onKeyUp(()=>clearTimeout(firstSearchTimeout));
        this.component.onKeyUp(()=>this.search(), 500);
        super.commit();
    }
    async search() {
        let searchText = this.component.getValue().trim();
        if (searchText !== undefined && searchText.length > 0) {
            let search = await (0, $5aab3284ce582eaf$export$439035f52ab89a16).search(this.community.id, (0, $5FliW.Resources).language, this.component.getValue(), this);
            this.container.clearAll();
            if (!this.isNull()) this.container.scrollable();
            if (search.articles.length > 0) search.articles.forEach((article)=>this.renderArticle(article));
            else this.renderNoResults();
        } else {
            this.container.clearAll();
            this.renderNoResults();
        }
    }
    renderNoResults() {
        this.container.append(`
                <div>
                    ${this.container.draw(new (0, $5297a1b0c9393fef$export$8f93841fb2480ea2)("\uD83D\uDD0D", (0, $5FliW.Resources).t("words.searchNotFound")))}
                </div>
            `);
    }
    renderArticle(article) {
        //language=HTML
        let component = this.container.append(`
            <div class="${$4ea4ebaa06f842d1$export$c407db72103fecfa}">
                <div class="${$4ea4ebaa06f842d1$export$fb184b623420d9be}">${(0, $86gWV.filterXSS)(article.title)}</div>
            </div>
        `);
        component.onClick(()=>this.onPick(article));
    }
    calcOutsideBottom() {
        return 0;
    }
    calcMiddle() {
        return super.calcLeft();
    }
    onPick(article) {}
    constructor(component, community, width){
        super(component, 70, width);
        this.community = community;
        this.mobileStyle(true);
        this.autoMaxHeight(true);
        //language=HTML
        this.template = `
            <div class="${$4ea4ebaa06f842d1$export$2d1cd94fb03f26e9}">
                ${this.draw(new (0, $7a82c95c87b35184$export$8ed40a6e8d9e757d)())}
            </div>
        `;
    }
}



var $iSiUq = parcelRequire("iSiUq");

var $iJHeF = parcelRequire("iJHeF");
var $5d75901583be4c68$export$b605972fbb5a633b;
var $5d75901583be4c68$export$683472f6198a076e;
var $5d75901583be4c68$export$aa5fcd1d589f5ce8;
var $5d75901583be4c68$export$542cf336a574a3f8;
$5d75901583be4c68$export$b605972fbb5a633b = "eSdgY";
$5d75901583be4c68$export$683472f6198a076e = "n4zL5";
$5d75901583be4c68$export$aa5fcd1d589f5ce8 = "VGL49";
$5d75901583be4c68$export$542cf336a574a3f8 = "FqVw9";



var $55f956226c1b6693$export$d1d55afab036cac2;
var $55f956226c1b6693$export$100aa851bad32d9d;
var $55f956226c1b6693$export$1ca1ec8b29a4ce27;
var $55f956226c1b6693$export$b7e3ae3d7c15e42e;
var $55f956226c1b6693$export$c6d40e657c4cb32e;
var $55f956226c1b6693$export$e850e66917a23e0f;
var $55f956226c1b6693$export$151a98b9b0a52b4e;
var $55f956226c1b6693$export$d90250155de6d7e7;
var $55f956226c1b6693$export$51987bb50e1f6752;
var $55f956226c1b6693$export$6d59db4903f20f7d;
$55f956226c1b6693$export$d1d55afab036cac2 = "urOy5";
$55f956226c1b6693$export$100aa851bad32d9d = "vtUSD";
$55f956226c1b6693$export$1ca1ec8b29a4ce27 = "fyn-j";
$55f956226c1b6693$export$b7e3ae3d7c15e42e = "X-B0T";
$55f956226c1b6693$export$c6d40e657c4cb32e = "hQUg8";
$55f956226c1b6693$export$e850e66917a23e0f = "cvRoC";
$55f956226c1b6693$export$151a98b9b0a52b4e = "Xh1u1";
$55f956226c1b6693$export$d90250155de6d7e7 = "F--Ac";
$55f956226c1b6693$export$51987bb50e1f6752 = "Kx9kb";
$55f956226c1b6693$export$6d59db4903f20f7d = "Dfg6z";



var $5FliW = parcelRequire("5FliW");
function $98f5d61780d1ceb0$export$bd9d5a37ac9dc911(txt) {
    txt = txt.trim().toLowerCase();
    txt = txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return txt;
}


/**
 * Transforme le HTML en plain text
 */ function $62cb28e89147ef4f$export$20bf31df4b15cdec(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\n/g, "");
}


class $6b275fd2bf2f1b1a$export$76cac35af4870249 extends (0, $94961cd4542c3c73$export$dea594182f495d9c) {
    commit() {
        this.casesContainer = this.el($55f956226c1b6693$export$151a98b9b0a52b4e);
        this.casesScrollable = this.el($55f956226c1b6693$export$c6d40e657c4cb32e);
        if (this.settings.search) this.casesScrollable.setStyle(`height:calc(100% - 32px);`);
        this.casesScrollable.scrollable();
        this.init();
        this.swapable(()=>this.dispose());
        super.commit();
    }
    init() {
        this.setStyle(`padding:5px;`);
        if (this.settings.search) {
            //language=HTML
            this.el($55f956226c1b6693$export$d1d55afab036cac2).prepend(`
                <div class="${$55f956226c1b6693$export$100aa851bad32d9d}">
                    <div class="${$55f956226c1b6693$export$1ca1ec8b29a4ce27}"></div>
                    <input placeholder="${(0, $5FliW.Resources).t("words.search")}" class="${$55f956226c1b6693$export$b7e3ae3d7c15e42e}"/>
                </div>
            `);
            let input = this.el($55f956226c1b6693$export$b7e3ae3d7c15e42e);
            input.onKeyUp(()=>this.renderButtons(input.getValue()));
            input.focus();
        }
        this.renderButtons();
    }
    renderButtons(search) {
        this.casesContainer.clearAll();
        this.settings.entries.filter((value)=>{
            let searchValue = this.settings.searchDescription ? value.description : value.label;
            return search == undefined || (this.settings.searchInclude ? (0, $62cb28e89147ef4f$export$20bf31df4b15cdec)((0, $98f5d61780d1ceb0$export$bd9d5a37ac9dc911)(searchValue)).includes((0, $98f5d61780d1ceb0$export$bd9d5a37ac9dc911)(search)) : (0, $62cb28e89147ef4f$export$20bf31df4b15cdec)((0, $98f5d61780d1ceb0$export$bd9d5a37ac9dc911)(searchValue)).startsWith((0, $98f5d61780d1ceb0$export$bd9d5a37ac9dc911)(search)));
        }).forEach((entry)=>{
            //language=HTML
            let button = this.casesContainer.append(`
                <div class="${$55f956226c1b6693$export$e850e66917a23e0f} ${(this.settings.multiple ? this.selectedValue.includes("" + entry.value) : this.selectedValue == entry.value) ? $55f956226c1b6693$export$d90250155de6d7e7 : ``}">
                    ${entry.label ? entry.label : ``}
                </div>
            `);
            button["entry"] = entry;
            button.onClick(async ()=>{
                this.selectedValue = entry.value;
                if (!this.settings.multiple) {
                    if (this.settings.selectedValueNullable) {
                        if (this.selectedButton && this.selectedButton != button) this.selectedButton.removeClass($55f956226c1b6693$export$d90250155de6d7e7);
                        if (button.hasClass($55f956226c1b6693$export$d90250155de6d7e7)) {
                            this.selectedButton = undefined;
                            button.removeClass($55f956226c1b6693$export$d90250155de6d7e7);
                        } else {
                            this.selectedButton = button;
                            button.addClass($55f956226c1b6693$export$d90250155de6d7e7);
                            await this.dispose();
                        }
                    } else await this.dispose();
                } else if (button.hasClass($55f956226c1b6693$export$d90250155de6d7e7)) button.removeClass($55f956226c1b6693$export$d90250155de6d7e7);
                else button.addClass($55f956226c1b6693$export$d90250155de6d7e7);
                this.onSelect(entry);
            }, true);
            if (entry.description) {
                button.addClass($55f956226c1b6693$export$51987bb50e1f6752);
                //language=HTML
                button.append(`
                    <div class="${$55f956226c1b6693$export$6d59db4903f20f7d}">
                        ${entry.description}
                    </div>
                `);
            }
            this.buttonsComponents.push(button);
        });
    }
    calcMiddle() {
        return this.component.getOffsets().left;
    }
    /**
     * override
     */ onSelect(entry) {}
    constructor(component, settings, selectedValue){
        super(component, 0, settings.width ? settings.width : component.getWidth());
        this.settings = settings;
        this.buttonsComponents = [];
        this.typedWord = "";
        if (this.settings.entries.length > 0) this.selectedValue = selectedValue;
        //language=HTML
        this.template = `
            <div class="${$55f956226c1b6693$export$d1d55afab036cac2}">
                <div class="${$55f956226c1b6693$export$c6d40e657c4cb32e}">
                    <div class="${$55f956226c1b6693$export$151a98b9b0a52b4e}"></div>
                </div>
            </div>
        `;
        this.mobileStyle(true);
        this.autoMaxHeight(true);
    }
}



var $5FliW = parcelRequire("5FliW");
class $950fe7ab294abf98$export$32ca16bda187b168 extends (0, $iJHeF.Component) {
    commit() {
        this.selectIcon = this.el($5d75901583be4c68$export$aa5fcd1d589f5ce8);
        this.selectedContainer = this.el($5d75901583be4c68$export$542cf336a574a3f8);
        this.onClick(()=>this.renderPicker());
        this.onRemove(()=>{
            if (this.pickerComponent != undefined && !this.pickerComponent.isNull()) this.pickerComponent.remove();
        });
        this.renderSelection();
        super.commit();
    }
    select(value) {
        if (this.settings.entries.length > 0) {
            let entry = this.settings.entries.filter((entry)=>entry.value == value)[0];
            if (entry != undefined) {
                if (!this.settings.multiple) {
                    if (this.settings.selectedValueNullable && this.selectedValue == entry.value) this.selectedValue = undefined;
                    else this.selectedValue = entry.value;
                } else {
                    let values = this.selectedValue;
                    let v = entry.value;
                    if (values.indexOf(v) >= 0) values.splice(values.indexOf(v), 1);
                    else this.selectedValue.push("" + entry.value);
                }
                this.renderSelection();
            }
        }
    }
    renderSelection() {
        if (!this.settings.multiple) this.selectedContainer.setHtml(this.settings.previewIsValue ? this.getSelection().value : this.getSelection().label);
        else if (this.getSelections().length > 0) this.selectedContainer.setHtml(this.getSelections().map((value)=>value.label).join(", "));
        else this.selectedContainer.setHtml(this.settings.noneText ? this.settings.noneText : (0, $5FliW.Resources).t("words.none"));
    }
    renderPicker() {
        if (this.pickerComponent != undefined && !this.pickerComponent.isNull()) this.pickerComponent.dispose();
        else {
            this.pickerComponent = new (0, $6b275fd2bf2f1b1a$export$76cac35af4870249)(this.selectedContainer, this.settings, this.selectedValue);
            this.pickerComponent.screen(false);
            this.pickerComponent.onOutsideClick(()=>this.pickerComponent.dispose());
            this.pickerComponent.create();
            this.pickerComponent.onSelect = (entry)=>{
                if (this.beforeSelect(entry)) {
                    this.select("" + entry.value);
                    this.onSelect(entry);
                }
            };
        }
    }
    getSelection() {
        if (this.settings.multiple) {
            let selectedValues = this.selectedValue;
            if (this.settings.entries.length == 0 || (!selectedValues || selectedValues.length == 0) && this.settings.selectedValueNullable != undefined && this.settings.selectedValueNullable == true) // @ts-ignore
            return [
                {
                    value: undefined,
                    label: this.settings.noneText ? this.settings.noneText : (0, $5FliW.Resources).t("words.none")
                }
            ];
            else {
                if (!selectedValues) return [
                    this.settings.entries[0]
                ];
                else // @ts-ignore
                return selectedValues.map((value)=>{
                    return this.settings.entries.find((entry)=>entry.value == value);
                });
            }
        } else {
            let selectedValue = this.selectedValue;
            if (this.settings.entries.length == 0 || !selectedValue && this.settings.selectedValueNullable != undefined && this.settings.selectedValueNullable == true) return {
                value: undefined,
                label: this.settings.noneText ? this.settings.noneText : (0, $5FliW.Resources).t("words.none")
            };
            else {
                var _this_settings_entries_find;
                if (!selectedValue) return this.settings.entries[0];
                else return (_this_settings_entries_find = this.settings.entries.find((value)=>value.value == selectedValue)) !== null && _this_settings_entries_find !== void 0 ? _this_settings_entries_find : this.settings.entries[0];
            }
        }
    }
    getSelections() {
        return this.getSelection();
    }
    classDisable() {
        this.addClass($5d75901583be4c68$export$683472f6198a076e);
    }
    /**
     * override
     *
     */ beforeSelect(entry) {
        return true;
    }
    onSelect(entry) {}
    constructor(settings){
        var _this_settings;
        super();
        this.settings = settings;
        this.selectedValue = !this.settings.selectedValue && this.settings.multiple ? [] : this.settings.selectedValue;
        //language=HTML
        this.template = `
            <div ${this.settings.maxHeight ? 'style="height: calc(100% - 8px);"' : ""} data-selectbox="true"
                 class="${$5d75901583be4c68$export$b605972fbb5a633b}">
                <div data-selectIcon class="${$5d75901583be4c68$export$aa5fcd1d589f5ce8}"></div>
                <div style="font-size: ${(_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.fontSize}px;" class="${$5d75901583be4c68$export$542cf336a574a3f8}"></div>
            </div>
        `;
    }
}


var $555e162d861907eb$export$5c4be2d186faaedb;
var $555e162d861907eb$export$1ca1ec8b29a4ce27;
$555e162d861907eb$export$5c4be2d186faaedb = "_4nSsG";
$555e162d861907eb$export$1ca1ec8b29a4ce27 = "djvFN";



var $276sx = parcelRequire("276sx");

var $5FliW = parcelRequire("5FliW");
class $18516e6a73ac18c4$export$ea9d0843b07d2ce5 extends (0, $950fe7ab294abf98$export$32ca16bda187b168) {
    commit() {
        this.addClass($555e162d861907eb$export$5c4be2d186faaedb);
        this.iconComponent = this.append(`<div class="${$555e162d861907eb$export$1ca1ec8b29a4ce27}"></div>`);
        super.commit();
    }
    constructor(selectedValue){
        super({
            entries: [
                {
                    label: (0, $5FliW.Resources).t("words.themeLight"),
                    value: (0, $276sx.AppearanceTheme).LIGHT
                },
                {
                    label: (0, $5FliW.Resources).t("words.themeDark"),
                    value: (0, $276sx.AppearanceTheme).DARK
                },
                {
                    label: (0, $5FliW.Resources).t("words.themeAuto"),
                    value: (0, $276sx.AppearanceTheme).AUTO
                }
            ],
            selectedValue: selectedValue
        });
    }
}



var $5FliW = parcelRequire("5FliW");
class $2910a9f0f5d83e6d$export$4b82c21f3cbc0045 {
    toString() {
        return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(this.b)})`;
    }
    set(r, g, b) {
        this.r = this.clamp(r);
        this.g = this.clamp(g);
        this.b = this.clamp(b);
    }
    hueRotate(angle = 0) {
        angle = angle / 180 * Math.PI;
        const sin = Math.sin(angle);
        const cos = Math.cos(angle);
        this.multiply([
            0.213 + cos * 0.787 - sin * 0.213,
            0.715 - cos * 0.715 - sin * 0.715,
            0.072 - cos * 0.072 + sin * 0.928,
            0.213 - cos * 0.213 + sin * 0.143,
            0.715 + cos * 0.285 + sin * 0.140,
            0.072 - cos * 0.072 - sin * 0.283,
            0.213 - cos * 0.213 - sin * 0.787,
            0.715 - cos * 0.715 + sin * 0.715,
            0.072 + cos * 0.928 + sin * 0.072
        ]);
    }
    grayscale(value = 1) {
        this.multiply([
            0.2126 + 0.7874 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 + 0.2848 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 + 0.9278 * (1 - value)
        ]);
    }
    sepia(value = 1) {
        this.multiply([
            0.393 + 0.607 * (1 - value),
            0.769 - 0.769 * (1 - value),
            0.189 - 0.189 * (1 - value),
            0.349 - 0.349 * (1 - value),
            0.686 + 0.314 * (1 - value),
            0.168 - 0.168 * (1 - value),
            0.272 - 0.272 * (1 - value),
            0.534 - 0.534 * (1 - value),
            0.131 + 0.869 * (1 - value)
        ]);
    }
    saturate(value = 1) {
        this.multiply([
            0.213 + 0.787 * value,
            0.715 - 0.715 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 + 0.285 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 - 0.715 * value,
            0.072 + 0.928 * value
        ]);
    }
    multiply(matrix) {
        const newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
        const newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
        const newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
        this.r = newR;
        this.g = newG;
        this.b = newB;
    }
    brightness(value = 1) {
        this.linear(value);
    }
    contrast(value = 1) {
        this.linear(value, -(0.5 * value) + 0.5);
    }
    linear(slope = 1, intercept = 0) {
        this.r = this.clamp(this.r * slope + intercept * 255);
        this.g = this.clamp(this.g * slope + intercept * 255);
        this.b = this.clamp(this.b * slope + intercept * 255);
    }
    invert(value = 1) {
        this.r = this.clamp((value + this.r / 255 * (1 - 2 * value)) * 255);
        this.g = this.clamp((value + this.g / 255 * (1 - 2 * value)) * 255);
        this.b = this.clamp((value + this.b / 255 * (1 - 2 * value)) * 255);
    }
    hsl() {
        const r = this.r / 255;
        const g = this.g / 255;
        const b = this.b / 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h * 100,
            s: s * 100,
            l: l * 100
        };
    }
    clamp(value) {
        if (value > 255) value = 255;
        else if (value < 0) value = 0;
        return value;
    }
    constructor(r, g, b){
        this.r = r;
        this.g = g;
        this.b = b;
    }
}



class $9c77b4bfa680d552$export$d8abd748736a2520 {
    solve() {
        const result = this.solveNarrow(this.solveWide());
        return {
            values: result.values,
            loss: result.loss,
            filter: this.css(result.values)
        };
    }
    solveWide() {
        const A = 5;
        const c = 15;
        const a = [
            60,
            180,
            18000,
            600,
            1.2,
            1.2
        ];
        let best = {
            loss: Infinity
        };
        for(let i = 0; best.loss > 25 && i < 3; i++){
            const initial = [
                50,
                20,
                3750,
                50,
                100,
                100
            ];
            const result = this.spsa(A, a, c, initial, 1000);
            if (result.loss < best.loss) best = result;
        }
        return best;
    }
    solveNarrow(wide) {
        const A = wide.loss;
        const c = 2;
        const A1 = A + 1;
        const a = [
            0.25 * A1,
            0.25 * A1,
            A1,
            0.25 * A1,
            0.2 * A1,
            0.2 * A1
        ];
        return this.spsa(A, a, c, wide.values, 500);
    }
    spsa(A, a, c, values, iters) {
        const alpha = 1;
        const gamma = 0.16666666666666666;
        let best = null;
        let bestLoss = Infinity;
        const deltas = new Array(6);
        const highArgs = new Array(6);
        const lowArgs = new Array(6);
        for(let k = 0; k < iters; k++){
            const ck = c / Math.pow(k + 1, gamma);
            for(let i = 0; i < 6; i++){
                deltas[i] = Math.random() > 0.5 ? 1 : -1;
                highArgs[i] = values[i] + ck * deltas[i];
                lowArgs[i] = values[i] - ck * deltas[i];
            }
            const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
            for(let i = 0; i < 6; i++){
                const g = lossDiff / (2 * ck) * deltas[i];
                const ak = a[i] / Math.pow(A + k + 1, alpha);
                values[i] = fix(values[i] - ak * g, i);
            }
            const loss = this.loss(values);
            if (loss < bestLoss) {
                best = values.slice(0);
                bestLoss = loss;
            }
        }
        return {
            values: best,
            loss: bestLoss
        };
        function fix(value, idx) {
            let max = 100;
            if (idx === 2 /* saturate */ ) max = 7500;
            else if (idx === 4 /* brightness */  || idx === 5 /* contrast */ ) max = 200;
            if (idx === 3 /* hue-rotate */ ) {
                if (value > max) value %= max;
                else if (value < 0) value = max + value % max;
            } else if (value < 0) value = 0;
            else if (value > max) value = max;
            return value;
        }
    }
    loss(filters) {
        // Argument is array of percentages.
        const color = this.reusedColor;
        color.set(0, 0, 0);
        color.invert(filters[0] / 100);
        color.sepia(filters[1] / 100);
        color.saturate(filters[2] / 100);
        color.hueRotate(filters[3] * 3.6);
        color.brightness(filters[4] / 100);
        color.contrast(filters[5] / 100);
        const colorHSL = color.hsl();
        return Math.abs(color.r - this.target.r) + Math.abs(color.g - this.target.g) + Math.abs(color.b - this.target.b) + Math.abs(colorHSL.h - this.targetHSL.h) + Math.abs(colorHSL.s - this.targetHSL.s) + Math.abs(colorHSL.l - this.targetHSL.l);
    }
    css(filters) {
        function fmt(idx, multiplier = 1) {
            return Math.round(filters[idx] * multiplier);
        }
        return `filter: invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(2)}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(5)}%);`;
    }
    constructor(target){
        this.target = target;
        this.targetHSL = target.hsl();
        this.reusedColor = new (0, $2910a9f0f5d83e6d$export$4b82c21f3cbc0045)(0, 0, 0);
    }
}


class $7b82b3bb65b07ef6$export$4c27d57389bdce00 {
    static hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b)=>{
            return r + r + g + g + b + b;
        });
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16)
        ] : null;
    }
    static convert(hex) {
        const rgb = this.hexToRgb(hex);
        const color = new (0, $2910a9f0f5d83e6d$export$4b82c21f3cbc0045)(rgb[0], rgb[1], rgb[2]);
        const solver = new (0, $9c77b4bfa680d552$export$d8abd748736a2520)(color);
        const result = solver.solve();
        return result.filter;
    }
}



var $5FliW = parcelRequire("5FliW");
class $40f535b3d9ce652e$export$4af15bfc58f76d46 {
    static change(community, theme, productType, silent) {
        (0, $5FliW.Resources).setTheme(productType, theme, silent);
        let invertTheme = (0, $5FliW.Resources).invertTheme(productType);
        Object.keys(community.appearances[invertTheme]).forEach((value)=>{
            let saved = community.appearances[invertTheme][value];
            community.appearances[invertTheme][value] = undefined;
            community.appearances[invertTheme][value] = saved;
        });
    }
}



var $kfkzw = parcelRequire("kfkzw");
class $b375bc111bfce9a3$export$b8b8b62b00c5b490 extends (0, $18516e6a73ac18c4$export$ea9d0843b07d2ce5) {
    commit() {
        super.commit();
        this.onReactiveObserve(()=>{
            this.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor};`);
            this.iconComponent.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor));
            this.selectIcon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor));
        });
    }
    onSelect(entry) {
        (0, $40f535b3d9ce652e$export$4af15bfc58f76d46).change(this.live.community, entry.value, (0, $kfkzw.ProductType).BLOG);
    }
    constructor(live, selectedValue){
        super(selectedValue);
        this.live = live;
    }
}



var $kfkzw = parcelRequire("kfkzw");
class $f9578ec5510db8f5$export$a927fe293ce3e5a4 extends (0, $iJHeF.Component) {
    commit() {
        this.renderNavigation();
        this.renderBody();
        this.onReactiveObserve(()=>(0, $iSiUq.SedestralInterface).main.setStyle(`background:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].backgroundColor};`));
        super.commit();
    }
    /**
     * render
     */ renderNavigation() {
        //language=HTML
        this.navigationContainer = this.append(`
            <div class="${$36f9617669facfa7$export$428e7c787d57587d}"></div>`);
        var _this_live_community_text_searchInput;
        //language=HTML
        this.navigationBrandContainer = this.navigationContainer.append(`
            <div itemprop="publisher" itemscope itemtype="https://schema.org/Organization" class="${$36f9617669facfa7$export$96ff94e0adb1d772}">
                <meta itemprop="name" content="${this.live.community.text.name}">
                <link itemprop="url" href="${this.live.community.text.websiteUrl}">
                <div class="${$36f9617669facfa7$export$1e95b668f3b82d}">
                    <div class="${$36f9617669facfa7$export$db3c28d99448dcff}"></div>
                    ${this.live.community.text.websiteUrl != null ? `<a href="${this.live.community.text.websiteUrl}" target="_blank" class="${$36f9617669facfa7$export$3098a4cea043ebce}">${this.live.community.text.backWebsite}</a>` : ""}
                </div>
                <meta itemprop="name" content="${this.live.community.text.metaTitle}">
                <p itemprop="description" class="${$36f9617669facfa7$export$6d59db4903f20f7d}">
                    ${this.reactive(()=>this.live.community.text.welcome)}
                </p>
                <div class="${$36f9617669facfa7$export$d76128d007d19019}">
                    <div class="${$36f9617669facfa7$export$1ca1ec8b29a4ce27}"></div>
                    <input class="${$36f9617669facfa7$export$b7e3ae3d7c15e42e}"
                           placeholder="${(_this_live_community_text_searchInput = this.live.community.text.searchInput) !== null && _this_live_community_text_searchInput !== void 0 ? _this_live_community_text_searchInput : (0, $5FliW.Resources).t("words.search")}"/>
                </div>
                <div class="${$36f9617669facfa7$export$53f1d5ea8de3d7c}"></div>
            </div>
        `);
        this.navigationBrandInput = this.el($36f9617669facfa7$export$b7e3ae3d7c15e42e);
        this.navigationBrandLogoContainer = this.navigationBrandContainer.el($36f9617669facfa7$export$db3c28d99448dcff);
        this.navigationBrandInput.onClick(()=>this.renderSearch(), true);
        this.navigationBrandInput.onKeyUp(()=>this.renderSearch());
        this.navigationBrandContainer.onReactiveObserve(()=>{
            var _this_live_community_logoFile, _this_live_community_text;
            this.navigationBrandLogoContainer.clearAll();
            let link = (_this_live_community_logoFile = this.live.community.logoFile) === null || _this_live_community_logoFile === void 0 ? void 0 : _this_live_community_logoFile.link;
            if (link) //language=HTML
            this.navigationBrandLogoContainer.append(`
                    <a aria-label="${(0, $5FliW.Resources).t("words.backHome")}" href="/home">
                        <img height="62" width="unset" itemprop="logo"
                             alt="${(0, $5FliW.Resources).t("words.logo")} ${(_this_live_community_text = this.live.community.text) === null || _this_live_community_text === void 0 ? void 0 : _this_live_community_text.metaTitle}"
                             src="${link}"/>
                    </a>
                `, "a");
        });
        //language=HTML
        let theme = this.navigationContainer.append(`
            <div class="${$36f9617669facfa7$export$bca14c5b3b88a9c9}">
                ${this.navigationContainer.draw(new (0, $b375bc111bfce9a3$export$b8b8b62b00c5b490)(this.live, (0, $5FliW.Resources).realTheme((0, $kfkzw.ProductType).BLOG)))}
            </div>
        `);
        if (this.live.community.text.websiteUrl != null) {
            //language=HTML
            let website = this.navigationContainer.append(`
            <a href="${this.live.community.text.websiteUrl}" target="_blank" class="${$36f9617669facfa7$export$61f6990d5944375a}">
                ${this.reactive(()=>this.live.community.text.backWebsite)}
            </a>
        `);
            this.onReactiveObserve(()=>website.setStyle(`background:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor};`));
        }
        let mobileWebsite = this.navigationContainer.el($36f9617669facfa7$export$3098a4cea043ebce);
        this.onReactiveObserve(()=>mobileWebsite.setStyle(`background:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor};`));
        let description = this.navigationBrandContainer.el($36f9617669facfa7$export$6d59db4903f20f7d);
        this.onReactiveObserve(()=>description.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondTextColor};`));
    }
    renderBody() {
        //language=HTML
        this.bodyContainer = this.append(`
            <section aria-label="${(0, $5FliW.Resources).t("words.lastNews")}" class="${$36f9617669facfa7$export$32180ef41b15b513}"></>`);
    }
    renderSearch() {
        let value = this.navigationBrandInput.getValue();
        if (value.length > 0) {
            if (!this.searchTooltip || this.searchTooltip.isNull()) {
                this.searchTooltip = new (0, $4c79d0f096d935ca$export$aaabb7c931c33bb2)(this.navigationBrandInput, this.live.community, 500);
                this.searchTooltip.onPick = (article)=>{
                    let category = this.live.categories.find((value)=>value.id == article.categoryId);
                    (0, $7AbeR.Network).router.pages.reload((0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).linkLocalArticle(category, article));
                };
                this.searchTooltip.screen(false);
                this.searchTooltip.create();
            }
        } else if (this.searchTooltip) {
            this.searchTooltip.dispose();
            this.searchTooltip = undefined;
        }
    }
    /**
     * get
     */ getBasePath() {
        return `/${(0, $5FliW.Resources).language}/${(0, $7AbeR.Network).router.pages.getParamAtIndex(2)}`;
    }
    getBaseCategory() {
        return this.live.categories.find((value)=>value.route == this.getBasePath());
    }
    constructor(live){
        super();
        this.live = live ? live : (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).live;
        //language=HTML
        this.template = `
            <div class="${$36f9617669facfa7$export$a35262b4ab678c65}"></div>`;
    }
}



var $iJHeF = parcelRequire("iJHeF");
var $c24cbf495e85afd8$export$131b63270a89f2e6;
var $c24cbf495e85afd8$export$2adb16ac204af30e;
var $c24cbf495e85afd8$export$657ee1858213601f;
var $c24cbf495e85afd8$export$a8ff84c12d48cfa6;
var $c24cbf495e85afd8$export$6d59db4903f20f7d;
var $c24cbf495e85afd8$export$7f5e6e4a87406c9c;
var $c24cbf495e85afd8$export$bba2aacf8566461b;
var $c24cbf495e85afd8$export$e973a13a69c1c71d;
var $c24cbf495e85afd8$export$f4c5de44377d2946;
$c24cbf495e85afd8$export$131b63270a89f2e6 = "MXQAZ";
$c24cbf495e85afd8$export$2adb16ac204af30e = "ADtDL";
$c24cbf495e85afd8$export$657ee1858213601f = "ajmvS";
$c24cbf495e85afd8$export$a8ff84c12d48cfa6 = "_6CKqK";
$c24cbf495e85afd8$export$6d59db4903f20f7d = "tIKmq";
$c24cbf495e85afd8$export$7f5e6e4a87406c9c = "kSPYS";
$c24cbf495e85afd8$export$bba2aacf8566461b = "kjLwW";
$c24cbf495e85afd8$export$e973a13a69c1c71d = "jFuq-";
$c24cbf495e85afd8$export$f4c5de44377d2946 = "iK9KF";



var $iJHeF = parcelRequire("iJHeF");
var $0165dd0a42bf7d76$export$a201a284497a2e61;
var $0165dd0a42bf7d76$export$a7db06668cad9adb;
var $0165dd0a42bf7d76$export$fb184b623420d9be;
var $0165dd0a42bf7d76$export$5c452ff88e35e47d;
var $0165dd0a42bf7d76$export$6e22c362a0406a2c;
var $0165dd0a42bf7d76$export$6f093cfa640b7166;
var $0165dd0a42bf7d76$export$41ee12f6f6f05843;
var $0165dd0a42bf7d76$export$40e543e69a8b3fbb;
var $0165dd0a42bf7d76$export$3dc937ad060d9bcc;
$0165dd0a42bf7d76$export$a201a284497a2e61 = "_9LD0z";
$0165dd0a42bf7d76$export$a7db06668cad9adb = "t8vgP";
$0165dd0a42bf7d76$export$fb184b623420d9be = "_7F38E";
$0165dd0a42bf7d76$export$5c452ff88e35e47d = "ASPj0";
$0165dd0a42bf7d76$export$6e22c362a0406a2c = "-vlDw";
$0165dd0a42bf7d76$export$6f093cfa640b7166 = "ufUNQ";
$0165dd0a42bf7d76$export$41ee12f6f6f05843 = "iSwtT";
$0165dd0a42bf7d76$export$40e543e69a8b3fbb = "Hapun";
$0165dd0a42bf7d76$export$3dc937ad060d9bcc = "C1aB9";



var $iJHeF = parcelRequire("iJHeF");
var $0ad1deef5c5f77e0$export$6e109a9f92b7ed91;
var $0ad1deef5c5f77e0$export$e4b2ac9215619f8d;
var $0ad1deef5c5f77e0$export$d66076e79486cd64;
$0ad1deef5c5f77e0$export$6e109a9f92b7ed91 = "_8kPsT";
$0ad1deef5c5f77e0$export$e4b2ac9215619f8d = "_9WqY4";
$0ad1deef5c5f77e0$export$d66076e79486cd64 = "_8hOSL";



var $5FliW = parcelRequire("5FliW");

var $86gWV = parcelRequire("86gWV");

var $kfkzw = parcelRequire("kfkzw");

var $5FliW = parcelRequire("5FliW");
function $fc6aadf4022c3c2b$export$f7e2c8231c57a8bd(strings) {
    const filteredStrings = strings.filter((str)=>str);
    if (filteredStrings.length > 1) {
        const allButLast = filteredStrings.slice(0, -1).join(", ");
        const lastAuthor = filteredStrings[filteredStrings.length - 1];
        return `${allButLast} ${(0, $5FliW.Resources).t("words.coWriteAnd")} ${lastAuthor}`;
    } else return filteredStrings[0] || "";
}


class $32189638f5e2b85e$export$501f8eb9ce5cc0d1 extends (0, $iJHeF.Component) {
    commit() {
        this.names = this.el($0ad1deef5c5f77e0$export$e4b2ac9215619f8d);
        this.onReactiveObserve(()=>{
            this.names.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor};`);
        });
        super.commit();
    }
    constructor(live, article, writers){
        super();
        this.live = live;
        this.writers = writers;
        this.article = article;
        //language=HTML
        this.template = `
            <div class="${$0ad1deef5c5f77e0$export$6e109a9f92b7ed91}">
                <div itemprop="author" class="${$0ad1deef5c5f77e0$export$e4b2ac9215619f8d}">
                    <div itemprop="name" class="${$0ad1deef5c5f77e0$export$d66076e79486cd64}">
                        ${(0, $fc6aadf4022c3c2b$export$f7e2c8231c57a8bd)(writers.map((value)=>(0, $86gWV.filterXSS)(value.name)))}
                    </div>
                </div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
/**
 * retourne la date pour les metas
 */ function $bedd4934a490c664$export$9863893cf6a97125(date) {
    const isoDate = date.toISOString();
    const offset = -date.getTimezoneOffset();
    const offsetSign = offset >= 0 ? "+" : "-";
    const offsetHours = Math.abs(Math.floor(offset / 60)).toString().padStart(2, "0");
    const offsetMinutes = Math.abs(offset % 60).toString().padStart(2, "0");
    const timezoneFormat = `${offsetSign}${offsetHours}:${offsetMinutes}`;
    const localISODate = `${isoDate.substring(0, isoDate.length - 1)}${timezoneFormat}`;
    return localISODate;
}



var $86gWV = parcelRequire("86gWV");

var $5FliW = parcelRequire("5FliW");
function $707d95bde0aa2db5$export$4d4ebea86394cbb3(date) {
    return new Intl.DateTimeFormat((0, $5FliW.Resources).language, {
        day: "numeric",
        month: "long",
        year: "numeric"
    }).format(new Date(date));
}


var $5a8b1089e7aa6fcb$exports = {};
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if (0, $5a8b1089e7aa6fcb$exports) $5a8b1089e7aa6fcb$exports = lazySizes;
})(typeof window != "undefined" ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    "use strict";
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = "addEventListener";
    var _getAttribute = "getAttribute";
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        "load",
        "error",
        "lazyincluded",
        "_lazyloaded"
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : "removeEventListener";
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent("Event");
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]("srcset")) el.setAttribute("srcset", full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = "onscroll" in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, "visibility") == "hidden";
            return isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden");
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, "opacity") || 1) > 0;
                if (visible && getCSS(parent, "overflow") != "visible") {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto"))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) source.setAttribute("media", customMedia);
            if (sourceSrcset) source.setAttribute("srcset", sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute("sizes", sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || "");
                }
                firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName("source"), handleSources);
                if (srcset) elem.setAttribute("srcset", srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ("_lazyCache" in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == "lazy") isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, "lazyunveilread").detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener("scroll", altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);
                addEventListener("scroll", throttledCheckElements, true);
                addEventListener("resize", throttledCheckElements, true);
                addEventListener("pageshow", function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll("." + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
                    docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener("hashchange", throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend"
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener("load", onload);
                    document[_addEventListener]("DOMContentLoaded", throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";
            elem.setAttribute("sizes", width);
            if (regPicture.test(parent.nodeName || "")) {
                sources = parent.getElementsByTagName("source");
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute("sizes", width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, "lazybeforesizes", {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});



var $hEeUt = parcelRequire("hEeUt");


var $kfkzw = parcelRequire("kfkzw");
class $f8405ceb85b0cc24$export$6f61eb4b492d800b extends (0, $iJHeF.Component) {
    commit() {
        this.imageContainer = this.el($0165dd0a42bf7d76$export$5c452ff88e35e47d);
        let title = this.el($0165dd0a42bf7d76$export$fb184b623420d9be);
        let text = this.el($0165dd0a42bf7d76$export$6f093cfa640b7166);
        let details = this.el($0165dd0a42bf7d76$export$41ee12f6f6f05843);
        this.onReactiveObserve(()=>{
            title.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].titleColor};`);
            text.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor};`);
            details.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondTextColor};`);
        });
        this.renderImage();
        super.commit();
    }
    renderImage() {
        if (this.article.imageFile) {
            var _this_article_imageFile, _this_article_imageFile1;
            //language=HTML
            this.imageContainer.append(`
                <img class="lazyload" itemprop="image" alt="${this.article.title}"
                     src="${(0, $hEeUt.IMG_EMPTY)}"
                     data-src="${(_this_article_imageFile = this.article.imageFile) === null || _this_article_imageFile === void 0 ? void 0 : _this_article_imageFile.link}" 
                     data-sizes="auto"
                     width="auto"
                     height="auto"
                />
            `);
            //language=HTML
            this.imageContainer.append(`
                <noscript>
                    <img itemprop="image" src="${(_this_article_imageFile1 = this.article.imageFile) === null || _this_article_imageFile1 === void 0 ? void 0 : _this_article_imageFile1.link}" alt="${this.article.title}" width="auto" height="auto"/>
                </noscript>
            `);
        } else {
            var _this_live_community;
            this.imageContainer.addClass($0165dd0a42bf7d76$export$6e22c362a0406a2c);
            if ((_this_live_community = this.live.community) === null || _this_live_community === void 0 ? void 0 : _this_live_community.logoFile) //language=HTML
            this.imageContainer.append(`
                    <img itemprop="image" alt="${this.live.community.text.metaTitle}"
                         src="${this.live.community.logoFile.link}"
                         width="auto"
                         height="auto"
                    />
                `);
        }
    }
    constructor(live, article, category){
        super();
        this.live = live;
        this.article = article;
        let writers = article.writersRedactors.concat(article.writersAccounts);
        this.owner = new (0, $32189638f5e2b85e$export$501f8eb9ce5cc0d1)(live, article, writers);
        //language=HTML
        this.template = `
            <article itemprop="blogPosts" itemscope itemtype="https://schema.org/BlogPosting"
                     class="${$0165dd0a42bf7d76$export$a201a284497a2e61}">
                <meta itemprop="url" content="${(0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).linkArticle(category, article)}">
                <meta itemprop="inLanguage" content="${category.language}">
                <meta itemprop="articleSection" content="${(0, $86gWV.filterXSS)(category.title)}">
                <div class="${$0165dd0a42bf7d76$export$5c452ff88e35e47d}"></div>
                <div class="${$0165dd0a42bf7d76$export$a7db06668cad9adb}">
                    <h2 itemprop="headline" class="${$0165dd0a42bf7d76$export$fb184b623420d9be}">
                        ${(0, $86gWV.filterXSS)(this.article.title)}
                    </h2>
                    <p itemprop="description" class="${$0165dd0a42bf7d76$export$6f093cfa640b7166}">
                        ${(0, $86gWV.filterXSS)(this.article.snippet)}
                    </p>
                </div>

                <div class="${$0165dd0a42bf7d76$export$41ee12f6f6f05843}">
                    ${(0, $707d95bde0aa2db5$export$4d4ebea86394cbb3)(new Date(this.article.time))} | ${(0, $86gWV.filterXSS)(category.title)} |
                    ${Math.round(this.article.readingSeconds / 60)} ${(0, $5FliW.Resources).t("words.timeToRead")}
                </div>

                ${writers.length > 0 ? `
                    <div class="${$0165dd0a42bf7d76$export$40e543e69a8b3fbb}">
                        <div class="${$0165dd0a42bf7d76$export$3dc937ad060d9bcc}">
                            ${this.draw(this.owner)}
                        </div>
                    </div>` : ""}

                ${this.article.keywords.length > 0 ? `<meta itemprop="keywords" content="${(0, $86gWV.filterXSS)(this.article.keywords.join(", "))}">` : ``}
                <meta itemprop="datePublished" content="${(0, $bedd4934a490c664$export$9863893cf6a97125)(new Date(this.article.time))}">
                ${this.article.lastEditTime > 0 ? `<meta itemprop="dateModified" content="${(0, $bedd4934a490c664$export$9863893cf6a97125)(new Date(this.article.lastEditTime))}">` : ``}
                <div itemprop="publisher" itemscope itemtype="https://schema.org/Organization">
                    <meta itemprop="name" content="${this.live.community.name}">
                    ${this.live.community.logoFile ? `<link itemprop="logo" href="${this.live.community.logoFile.link}">` : ``}
                </div>
            </article>
        `;
    }
}



var $iJHeF = parcelRequire("iJHeF");
var $c56ea8ea12d4bc8c$export$e1afdb76bd8cfa22;
var $c56ea8ea12d4bc8c$export$2077e0241d6afd3c;
var $c56ea8ea12d4bc8c$export$d90250155de6d7e7;
var $c56ea8ea12d4bc8c$export$eabcd2c8791e7bf4;
var $c56ea8ea12d4bc8c$export$1ca1ec8b29a4ce27;
var $c56ea8ea12d4bc8c$export$79ffe56a765070d2;
$c56ea8ea12d4bc8c$export$e1afdb76bd8cfa22 = "KHVLM";
$c56ea8ea12d4bc8c$export$2077e0241d6afd3c = "-N69w";
$c56ea8ea12d4bc8c$export$d90250155de6d7e7 = "waFEM";
$c56ea8ea12d4bc8c$export$eabcd2c8791e7bf4 = "S3hje";
$c56ea8ea12d4bc8c$export$1ca1ec8b29a4ce27 = "kudOA";
$c56ea8ea12d4bc8c$export$79ffe56a765070d2 = "eg911";



var $7AbeR = parcelRequire("7AbeR");
class $7c568c430c504b93$export$a930e4e670143502 extends (0, $iJHeF.Component) {
    commit() {
        super.commit();
    }
    /**
     * count
     */ getLimit() {
        return 10;
    }
    getOffsetLimit() {
        let page = this.getPageParam();
        if (!page) return 0;
        else return (page - 1 > 0 ? page - 1 : 0) * this.getLimit();
    }
    getCurrentPage() {
        return this.getOffsetLimit() / this.getLimit() + 1;
    }
    getPageParam() {
        return parseInt((0, $7AbeR.Network).router.pages.getParam(this.paramId));
    }
    /**
     * render
     */ renderPages(findCount) {
        let pages = Math.ceil(findCount / this.getLimit());
        let currentPage = this.getCurrentPage();
        let startPage = currentPage - 2;
        let endPage = currentPage + 2;
        if (startPage < 1) {
            startPage = 1;
            endPage = pages >= 5 ? 5 : pages;
        }
        if (endPage > pages) {
            endPage = pages;
            startPage = pages - 4 > 0 ? pages - 4 : 1;
        }
        if (currentPage - 1 > 0) //language=HTML
        this.append(`
                <a href="${this.pageUrl(currentPage - 1)}" class="${$c56ea8ea12d4bc8c$export$2077e0241d6afd3c} ${$c56ea8ea12d4bc8c$export$eabcd2c8791e7bf4}">
                    <div class="${$c56ea8ea12d4bc8c$export$1ca1ec8b29a4ce27}"></div>
                </a>
            `);
        for(let i = startPage; i <= endPage; i++)this.renderPage(i);
        if (currentPage + 1 <= pages) //language=HTML
        this.append(`
                <a href="${this.pageUrl(currentPage + 1)}" class="${$c56ea8ea12d4bc8c$export$2077e0241d6afd3c} ${$c56ea8ea12d4bc8c$export$79ffe56a765070d2}">
                    <div class="${$c56ea8ea12d4bc8c$export$1ca1ec8b29a4ce27}"></div>
                </a>
            `);
    }
    renderPage(number) {
        //language=HTML
        let page = this.append(`
            <a href="${this.pageUrl(number)}" class="${$c56ea8ea12d4bc8c$export$2077e0241d6afd3c} ${number == this.getCurrentPage() ? $c56ea8ea12d4bc8c$export$d90250155de6d7e7 : ""}">
                ${number}
            </a>
        `);
    }
    setPage(number) {
        (0, $7AbeR.Network).router.pages.setParam(this.paramId, number, true, this.noHash);
        this.onPick();
    }
    pageUrl(number) {
        let path = (0, $7AbeR.Network).router.pages.getPath();
        path = (0, $7AbeR.Network).router.pages.setParamStr(path, "page", number);
        return path;
    }
    /**
     * get
     */ getPagesRounds() {
        return this.els($c56ea8ea12d4bc8c$export$2077e0241d6afd3c);
    }
    /**
     * override
     */ onPick() {}
    constructor(noHash){
        super();
        this.paramId = "page";
        this.noHash = noHash;
        //language=HTML
        this.template = `
            <div class="${$c56ea8ea12d4bc8c$export$e1afdb76bd8cfa22}"></div>`;
    }
}



var $iJHeF = parcelRequire("iJHeF");
var $b7395dfd82302ade$export$cb83d1eb3f194a53;
var $b7395dfd82302ade$export$8a5e915bd1d05fe0;
var $b7395dfd82302ade$export$e850e66917a23e0f;
var $b7395dfd82302ade$export$1158a42d67788fdd;
var $b7395dfd82302ade$export$3931a0da49df8dc0;
$b7395dfd82302ade$export$cb83d1eb3f194a53 = "_1iuv6";
$b7395dfd82302ade$export$8a5e915bd1d05fe0 = "KugNv";
$b7395dfd82302ade$export$e850e66917a23e0f = "XLbL4";
$b7395dfd82302ade$export$1158a42d67788fdd = "subyq";
$b7395dfd82302ade$export$3931a0da49df8dc0 = "OuN5k";


class $cdef7ab7d9b673c6$export$2971787bd99e2dee extends (0, $iJHeF.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$b7395dfd82302ade$export$cb83d1eb3f194a53} ${$b7395dfd82302ade$export$8a5e915bd1d05fe0}">
                <div class="${$b7395dfd82302ade$export$3931a0da49df8dc0}">
                    <div class="${$b7395dfd82302ade$export$e850e66917a23e0f}"></div>
                    <div class="${$b7395dfd82302ade$export$e850e66917a23e0f}"></div>
                    <div class="${$b7395dfd82302ade$export$e850e66917a23e0f}"></div>
                    <div class="${$b7395dfd82302ade$export$e850e66917a23e0f}"></div>
                </div>
            </div>
        `;
    }
}





var $5FliW = parcelRequire("5FliW");


var $iSiUq = parcelRequire("iSiUq");


var $86gWV = parcelRequire("86gWV");

var $kfkzw = parcelRequire("kfkzw");
class $16e6139046b2ca2c$export$e87b8cd8cae8dcf2 extends (0, $iJHeF.Component) {
    commit() {
        this.pagingComponent = new (0, $7c568c430c504b93$export$a930e4e670143502)(false);
        super.commit();
    }
    async renderAll(category) {
        this.category = category;
        this.pagingComponent = new (0, $7c568c430c504b93$export$a930e4e670143502)(false);
        let loaderTimeout = this.timeOut(()=>this.renderLoader(), 100);
        this.articles = await (0, $5aab3284ce582eaf$export$439035f52ab89a16).findAll(this.live.community.id, this.pagingComponent.getOffsetLimit(), this.pagingComponent.getLimit(), category ? category.route : undefined);
        clearTimeout(loaderTimeout);
        this.removeLoader();
        if (category) {
            //language=HTML
            let categoryComponent = this.append(`
                <div itemscope itemtype="https://schema.org/CollectionPage" class="${$c24cbf495e85afd8$export$657ee1858213601f}">
                    <div itemprop="name" class="${$c24cbf495e85afd8$export$a8ff84c12d48cfa6}">${(0, $86gWV.filterXSS)(category.title)}</div>
                    <div itemprop="description" class="${$c24cbf495e85afd8$export$6d59db4903f20f7d}">${(0, $86gWV.filterXSS)(category.description)}</div>
                </div>
            `);
            if (category.imageFile) {
                let categoryIcon = categoryComponent.prepend(`<img itemprop="image" alt="${category.title}" src="${category.imageFile.link}"/>`);
                this.onReactiveObserve(()=>categoryIcon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].titleColor)));
            }
            let description = categoryComponent.el($c24cbf495e85afd8$export$6d59db4903f20f7d);
            let name = categoryComponent.el($c24cbf495e85afd8$export$a8ff84c12d48cfa6);
            this.onReactiveObserve(()=>{
                name.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].titleColor};`);
                description.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].titleColor};`);
            });
        }
        if (this.articles && this.articles.articles.length > 0) {
            if (this.category) this.articles.articles.sort((a, b)=>a.indexOrder > b.indexOrder ? 1 : -1);
            else this.articles.articles.sort((a, b)=>a.time < b.time ? 1 : -1);
            this.articlesContainer = this.append(`<div class="${$c24cbf495e85afd8$export$7f5e6e4a87406c9c}"></div>`);
            this.articles.articles.forEach((article)=>this.renderArticle(article));
            this.renderPaging();
        } else this.renderEmpty();
        (0, $iSiUq.SedestralInterface).main.scrollTop(0, 250);
    }
    renderPaging() {
        //language=HTML
        this.append(`
            <div class="${$c24cbf495e85afd8$export$e973a13a69c1c71d}">
                ${this.draw(this.pagingComponent)}
            </div>
        `);
        this.pagingComponent.renderPages(this.articles.totalArticlesCount);
        this.onReactiveObserve(()=>this.pagingComponent.getPagesRounds().forEach((value)=>value.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor};`)));
    }
    renderArticle(article) {
        let category = this.live.categories.find((value)=>value.id == article.categoryId);
        //language=HTML
        this.articlesContainer.append(`
            <a href="${(0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).linkArticle(category, article)}" class="${$c24cbf495e85afd8$export$bba2aacf8566461b}">
                ${this.articlesContainer.draw(new (0, $f8405ceb85b0cc24$export$6f61eb4b492d800b)(this.live, article, this.live.categories.find((value)=>value.id == article.categoryId)))}
            </a>
        `);
    }
    renderEmpty() {
        this.addClass($c24cbf495e85afd8$export$2adb16ac204af30e);
        let emptyComponent = new (0, $5297a1b0c9393fef$export$8f93841fb2480ea2)("\uD83E\uDDD0", (0, $5FliW.Resources).t("words.noNews"));
        //language=HTML
        this.append(`
            <div class="${$c24cbf495e85afd8$export$f4c5de44377d2946}">
                ${this.draw(emptyComponent)}
            </div>
        `);
        this.onReactiveObserve(()=>{
            emptyComponent.textContainer.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor};`);
        });
    }
    renderLoader() {
        this.clearAll();
        this.addClass($c24cbf495e85afd8$export$2adb16ac204af30e);
        this.render(new (0, $cdef7ab7d9b673c6$export$2971787bd99e2dee)());
    }
    removeLoader() {
        this.removeClass($c24cbf495e85afd8$export$2adb16ac204af30e);
        this.clearAll();
    }
    constructor(live){
        super();
        this.live = live;
        //language=HTML
        this.template = `
            <div class="${$c24cbf495e85afd8$export$131b63270a89f2e6}"></div>`;
    }
}



var $5FliW = parcelRequire("5FliW");



var $7AbeR = parcelRequire("7AbeR");


var $86gWV = parcelRequire("86gWV");

var $kfkzw = parcelRequire("kfkzw");
class $3da5dda3c5f04e17$export$542b5577df419247 extends (0, $f9578ec5510db8f5$export$a927fe293ce3e5a4) {
    commit() {
        super.commit();
        (0, $7AbeR.Network).router.pages.onPopState(this, ()=>this.renderBodyContent());
    }
    /**
     * render
     */ renderNavigation() {
        super.renderNavigation();
        //language=HTML
        this.navigationContentContainer = this.navigationContainer.append(`
            <nav aria-label="${(0, $5FliW.Resources).t("words.menu")}" class="${$36f9617669facfa7$export$a7db06668cad9adb}">
                <ul class="${$36f9617669facfa7$export$8837f4fc672e936d}" itemscope itemtype="https://schema.org/ItemList"></ul>
            </nav>`);
        this.navigationContentContainer.pendAfter(this.navigationBrandContainer);
        this.categoriesContainer = this.navigationContentContainer.el($36f9617669facfa7$export$8837f4fc672e936d);
        this.renderNavigationCategories();
    }
    renderBody() {
        super.renderBody();
    }
    renderNavigationCategories() {
        this.navigationCategoryIndex = 1;
        this.renderNavigationCategory({
            title: (0, $5FliW.Resources).t("words.lastArticles"),
            route: `/${(0, $5FliW.Resources).language}/home`
        });
        this.live.categories.forEach((category)=>this.renderNavigationCategory(category));
    }
    renderNavigationCategory(category) {
        let path = (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).linkCategory(category);
        //language=HTML
        let li = this.categoriesContainer.append(`
            <li class="${category.route == this.getBasePath() ? $36f9617669facfa7$export$89da14300d534261 : ``}" itemprop="itemListElement" itemscope
                itemtype="https://schema.org/ListItem">
                <a href="${path}" itemprop="item">
                    <div class="${$36f9617669facfa7$export$657ee1858213601f}">
                        <div class="${$36f9617669facfa7$export$1ca1ec8b29a4ce27}"></div>
                        <div class="${$36f9617669facfa7$export$a8ff84c12d48cfa6}" itemprop="name">
                            ${(0, $86gWV.filterXSS)(category.title)}
                        </div>
                    </div>
                </a>
                <meta itemprop="position" content="${this.navigationCategoryIndex}">
            </li>
        `);
        this.categoriesComponents.push({
            category: category,
            component: li
        });
        let categoryComponent = li.el($36f9617669facfa7$export$657ee1858213601f);
        let icon = li.el($36f9617669facfa7$export$1ca1ec8b29a4ce27);
        icon.clearAll();
        if (category.imageFile) icon.append(`<img alt="${(0, $5FliW.Resources).t("words.category")} ${category.title}" src="${category.imageFile.link}"/>`);
        let updateTheme = ()=>{
            if (li.hasClass($36f9617669facfa7$export$89da14300d534261)) {
                categoryComponent.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor};border-color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor}`);
                if (category.imageFile) icon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].mainColor));
            } else {
                categoryComponent.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor};`);
                if (category.imageFile) icon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor));
            }
        };
        this.onReactiveObserve(()=>updateTheme());
        li.onChange(()=>updateTheme());
        this.navigationCategoryIndex++;
    }
    async renderBodyContent() {
        this.updateNavigationCategories();
        if (!this.articlesComponent) {
            this.articlesComponent = new (0, $16e6139046b2ca2c$export$e87b8cd8cae8dcf2)(this.live);
            this.bodyContainer.render(this.articlesComponent);
        }
        this.updateMetas();
        await this.articlesComponent.renderAll(this.getBaseCategory());
    }
    visualizer() {
        this.renderBodyContent();
    }
    /**
     * update
     */ updateMetas() {
        var _this_articlesComponent;
        let pageCount = (_this_articlesComponent = this.articlesComponent) === null || _this_articlesComponent === void 0 ? void 0 : _this_articlesComponent.pagingComponent.getPageParam();
        let pageMetaData = pageCount ? ` ${(0, $5FliW.Resources).t("words.page")} ${pageCount}` : ``;
        let category = this.getBaseCategory();
        let title = (category ? category.title : this.live.community.text.metaTitle) + (pageMetaData ? ` -${pageMetaData}` : "");
        let description = category ? category.description : this.live.community.text.metaDescription + pageMetaData;
        let alternateLang = category ? new Map(Object.entries(category.alternateLanguages)) : undefined;
        (0, $7AbeR.Network).router.pages.updateMetasCommunity(this.live.community, false, title, description, undefined, category === null || category === void 0 ? void 0 : category.imageFile, alternateLang);
    }
    updateNavigationCategories() {
        let path = this.getBasePath();
        this.categoriesComponents.forEach((value)=>{
            if (value.category.route == path) value.component.addClass($36f9617669facfa7$export$89da14300d534261);
            else value.component.removeClass($36f9617669facfa7$export$89da14300d534261);
        });
    }
    constructor(live){
        super(live);
        this.categoriesComponents = [];
    }
}


class $5dde90783f5e5816$export$a9f121ca8122b59e extends (0, $47734e1c0ab90ca1$export$c4dc9eeb28e63095) {
    init() {
        //language=HTML
        this.template = `
            <div class="${$f8743834758328bc$export$46da19ff27de8e3d}">
                ${this.draw(new (0, $3da5dda3c5f04e17$export$542b5577df419247)())}
            </div>
        `;
    }
    onHash() {}
    constructor(){
        super();
        this.title = "Blog";
        this.status.online = undefined;
    }
}







var $iJHeF = parcelRequire("iJHeF");
var $b9e6238ad3dfde4e$export$44f2e4bb6fd0af57;
var $b9e6238ad3dfde4e$export$f4c5de44377d2946;
var $b9e6238ad3dfde4e$export$fb184b623420d9be;
var $b9e6238ad3dfde4e$export$a7db06668cad9adb;
var $b9e6238ad3dfde4e$export$2da9be4cfdb689b1;
var $b9e6238ad3dfde4e$export$722fbec263ad908a;
var $b9e6238ad3dfde4e$export$ed80d9de1d9df928;
$b9e6238ad3dfde4e$export$44f2e4bb6fd0af57 = "nbBuo";
$b9e6238ad3dfde4e$export$f4c5de44377d2946 = "f6tu2";
$b9e6238ad3dfde4e$export$fb184b623420d9be = "ZuCOg";
$b9e6238ad3dfde4e$export$a7db06668cad9adb = "GCjx-";
$b9e6238ad3dfde4e$export$2da9be4cfdb689b1 = "GaukA";
$b9e6238ad3dfde4e$export$722fbec263ad908a = "BLpWm";
$b9e6238ad3dfde4e$export$ed80d9de1d9df928 = "TxPhl";




var $iJHeF = parcelRequire("iJHeF");
var $dd99ddfbd53d1483$export$1866c60c130e130;
var $dd99ddfbd53d1483$export$1e95b668f3b82d;
var $dd99ddfbd53d1483$export$40e543e69a8b3fbb;
$dd99ddfbd53d1483$export$1866c60c130e130 = "RkNx2";
$dd99ddfbd53d1483$export$1e95b668f3b82d = "AwIK5";
$dd99ddfbd53d1483$export$40e543e69a8b3fbb = "kAZAW";



var $iJHeF = parcelRequire("iJHeF");
var $48cb704b5249e843$export$5533f3fa6fce9810;
var $48cb704b5249e843$export$8a5e915bd1d05fe0;
var $48cb704b5249e843$export$1158a42d67788fdd;
$48cb704b5249e843$export$5533f3fa6fce9810 = "ts9Ct";
$48cb704b5249e843$export$8a5e915bd1d05fe0 = "UNkWR";
$48cb704b5249e843$export$1158a42d67788fdd = "_6u5eI";


class $53e251dc5b374a09$export$225d33e6c7e4852d extends (0, $iJHeF.Component) {
    constructor(shine){
        super();
        //language=HTML
        this.template = `
            <div loaderBlock class="${$48cb704b5249e843$export$5533f3fa6fce9810} ${shine ? $48cb704b5249e843$export$8a5e915bd1d05fe0 : ``}">
            </div>
        `;
    }
}



var $iJHeF = parcelRequire("iJHeF");
var $c359cfade8f1a66f$export$8cb904089a919076;
var $c359cfade8f1a66f$export$8a5e915bd1d05fe0;
var $c359cfade8f1a66f$export$1158a42d67788fdd;
var $c359cfade8f1a66f$export$be5493f9613cbbe;
$c359cfade8f1a66f$export$8cb904089a919076 = "sH3ID";
$c359cfade8f1a66f$export$8a5e915bd1d05fe0 = "fvZUp";
$c359cfade8f1a66f$export$1158a42d67788fdd = "o8s08";
$c359cfade8f1a66f$export$be5493f9613cbbe = "u-IXp";



var $bIule = parcelRequire("bIule");
class $959c95ac7ac79747$export$766a040f1f31f2a9 extends (0, $iJHeF.Component) {
    object() {
        let height = (0, $bIule.randomInteger)(this.minHeight == undefined ? 60 : this.minHeight, this.maxHeight ? this.maxHeight : 120);
        return `<div style="height: ${height}px;" class="${$c359cfade8f1a66f$export$be5493f9613cbbe}"></div>`;
    }
    constructor(shine, size, minHeight, maxHeight){
        super();
        this.minHeight = minHeight;
        this.maxHeight = maxHeight;
        if (typeof size == "undefined") size = 16;
        let objects = this.object();
        for(let i = 0; i < size; i++)objects += this.object();
        this.template = `
            <div loaderObjectList class="${$c359cfade8f1a66f$export$8cb904089a919076} ${shine ? $c359cfade8f1a66f$export$8a5e915bd1d05fe0 : ``}">
                ${objects}
            </div>
        `;
    }
}


class $0d3f38900cffe8cf$export$700833bf6caddd53 extends (0, $iJHeF.Component) {
    constructor(shine){
        super();
        //language=HTML
        this.template = `
            <div class="${$dd99ddfbd53d1483$export$1866c60c130e130}">
                <div class="${$dd99ddfbd53d1483$export$1e95b668f3b82d}">
                    ${this.draw(new (0, $959c95ac7ac79747$export$766a040f1f31f2a9)(shine, 1, 40, 40))}
                </div>
                <div class="${$dd99ddfbd53d1483$export$40e543e69a8b3fbb}">
                    ${this.draw(new (0, $53e251dc5b374a09$export$225d33e6c7e4852d)(shine))}
                </div>
            </div>
        `;
    }
}




var $7AbeR = parcelRequire("7AbeR");

var $iJHeF = parcelRequire("iJHeF");
var $17086f1340a04623$export$5a27b0a7c09e91d6;
var $17086f1340a04623$export$fb184b623420d9be;
var $17086f1340a04623$export$f09b1917886389c3;
var $17086f1340a04623$export$c407db72103fecfa;
var $17086f1340a04623$export$c9ba4d494a4ef84c;
var $17086f1340a04623$export$1ca1ec8b29a4ce27;
var $17086f1340a04623$export$87453108c2dd3831;
var $17086f1340a04623$export$e98652cea9b09aa;
var $17086f1340a04623$export$b602b78110e4ab1e;
$17086f1340a04623$export$5a27b0a7c09e91d6 = "qfWjG";
$17086f1340a04623$export$fb184b623420d9be = "R-uQX";
$17086f1340a04623$export$f09b1917886389c3 = "_5Yx8v";
$17086f1340a04623$export$c407db72103fecfa = "_86FCv";
$17086f1340a04623$export$c9ba4d494a4ef84c = "_2zf96";
$17086f1340a04623$export$1ca1ec8b29a4ce27 = "vFnYD";
$17086f1340a04623$export$87453108c2dd3831 = "bdTDg";
$17086f1340a04623$export$e98652cea9b09aa = "_-8gpX";
$17086f1340a04623$export$b602b78110e4ab1e = "YUuRt";



var $5FliW = parcelRequire("5FliW");
class $41a47f8d375d5219$export$9eaf349bcfd8f562 extends (0, $iJHeF.Component) {
    commit() {
        super.commit();
        this.networkIcons = this.els($17086f1340a04623$export$1ca1ec8b29a4ce27);
    }
    constructor(name, url){
        super();
        //language=HTML
        this.template = `
            <div class="${$17086f1340a04623$export$5a27b0a7c09e91d6}">
                <div class="${$17086f1340a04623$export$fb184b623420d9be}">${(0, $5FliW.Resources).t("words.share")}</div>
                <div class="${$17086f1340a04623$export$f09b1917886389c3}">
                    <a aria-label="${(0, $5FliW.Resources).t("words.shareTo")} LinkedIn"
                       href="https://www.linkedin.com/sharing/share-offsite/?url=${url}"
                       target="_blank">
                        <div class="${$17086f1340a04623$export$c407db72103fecfa} ${$17086f1340a04623$export$c9ba4d494a4ef84c}">
                            <div class="${$17086f1340a04623$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                    <a aria-label="${(0, $5FliW.Resources).t("words.shareTo")} Twitter"
                       href="https://twitter.com/share?text=${name}&url=${url}"
                       target="_blank"
                       rel="noopener">
                        <div class="${$17086f1340a04623$export$c407db72103fecfa} ${$17086f1340a04623$export$87453108c2dd3831}">
                            <div class="${$17086f1340a04623$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                    <a aria-label="${(0, $5FliW.Resources).t("words.shareTo")} Facebook"
                       href="https://www.facebook.com/sharer/sharer.php?u=${url}&t=${name}"
                       target="_blank">
                        <div class="${$17086f1340a04623$export$c407db72103fecfa} ${$17086f1340a04623$export$e98652cea9b09aa}">
                            <div class="${$17086f1340a04623$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                    <a aria-label="${(0, $5FliW.Resources).t("words.shareTo")} Mail"
                       href="mailto:?body=${name}%0A${url}&subject=${name}"
                       target="_blank">
                        <div class="${$17086f1340a04623$export$c407db72103fecfa} ${$17086f1340a04623$export$b602b78110e4ab1e}">
                            <div class="${$17086f1340a04623$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                </div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");

var $271MM = parcelRequire("271MM");



var $86gWV = parcelRequire("86gWV");


var $kfkzw = parcelRequire("kfkzw");
class $9ecfa8fb0fead00e$export$6f6cf3b69af87d57 extends (0, $iJHeF.Component) {
    commit() {
        super.commit();
        this.renderAll();
    }
    async renderAll() {
        var _view_article_imageFile;
        let view = await (0, $5aab3284ce582eaf$export$439035f52ab89a16).view(this.live.community.id, (0, $7AbeR.Network).router.pages.getParamAtIndex(2), this);
        let share = new (0, $41a47f8d375d5219$export$9eaf349bcfd8f562)(view.article.title, document.URL);
        this.onReady(view);
        this.clearAll();
        //language=HTML
        this.append(`
            <article itemscope itemtype="https://schema.org/BlogPosting">
                <header>
                    <h1 class="${$b9e6238ad3dfde4e$export$fb184b623420d9be}" itemprop="headline">${(0, $86gWV.filterXSS)(view.article.title)}</h1>
                    <p class="${$b9e6238ad3dfde4e$export$2da9be4cfdb689b1}">
                        ${(0, $5FliW.Resources).t("words.publishedDate")}
                        <time itemprop="datePublished" datetime="${(0, $bedd4934a490c664$export$9863893cf6a97125)(new Date(view.article.time))}">
                            ${(0, $707d95bde0aa2db5$export$4d4ebea86394cbb3)(new Date(view.article.time))}
                        </time>
                        ${(0, $5FliW.Resources).t("words.publishedIn")}
                        <meta itemprop="inLanguage" content="${view.category.language}">
                        <a itemprop="articleSection"
                           href="${(0, $271MM.config).domain + view.category.route}">${(0, $86gWV.filterXSS)(view.category.title)}</a>
                    </p>
                    ${view.article.writersAccounts.length > 0 ? this.draw(new (0, $32189638f5e2b85e$export$501f8eb9ce5cc0d1)(this.live, view.article, view.article.writersRedactors.concat(view.article.writersAccounts))) : ""}
                </header>
                <link itemprop="image" href="${(_view_article_imageFile = view.article.imageFile) === null || _view_article_imageFile === void 0 ? void 0 : _view_article_imageFile.link}">
                <div class="${$b9e6238ad3dfde4e$export$a7db06668cad9adb}" itemprop="articleBody">
                    ${view.article.html}
                </div>
                <footer>
                    ${view.article.lastEditTime > 0 ? `<p class="${$b9e6238ad3dfde4e$export$722fbec263ad908a}">
                        ${(0, $5FliW.Resources).t("words.lastEdit")}
                        <time itemprop="dateModified" datetime="${(0, $bedd4934a490c664$export$9863893cf6a97125)(new Date(view.article.lastEditTime))}">${(0, $707d95bde0aa2db5$export$4d4ebea86394cbb3)(new Date(view.article.lastEditTime))}</time>
                    </p>` : ``}
                </footer>
                ${view.article.keywords.length > 0 ? `<meta itemprop="keywords" content="${(0, $86gWV.filterXSS)(view.article.keywords.join(", "))}">` : ``}
                <div class="${$b9e6238ad3dfde4e$export$ed80d9de1d9df928}">
                    ${this.draw(share)}
                </div>
                <div itemprop="publisher" itemscope itemtype="https://schema.org/Organization">
                    <meta itemprop="name" content="${this.live.community.name}">
                    ${this.live.community.logoFile ? `<link itemprop="logo" href="${this.live.community.logoFile.link}">` : ``}
                </div>
            </article>
        `);
        let title = this.el($b9e6238ad3dfde4e$export$fb184b623420d9be);
        let content = this.el($b9e6238ad3dfde4e$export$a7db06668cad9adb);
        let time = this.el($b9e6238ad3dfde4e$export$2da9be4cfdb689b1);
        let update = this.el($b9e6238ad3dfde4e$export$722fbec263ad908a);
        this.onReactiveObserve(()=>{
            title.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].titleColor};`);
            content.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].textColor};`);
            time.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondTextColor};`);
            share.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].textColor};`);
            share.networkIcons.forEach((icon)=>{
                icon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].textColor));
            });
            if (!update.isNull()) update.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondTextColor};`);
        });
    }
    onReady(view) {}
    constructor(live){
        super();
        this.live = live;
        //language=HTML
        this.template = `
            <div class="${$b9e6238ad3dfde4e$export$44f2e4bb6fd0af57}">
                <div class="${$b9e6238ad3dfde4e$export$f4c5de44377d2946}">
                    ${this.draw(new (0, $0d3f38900cffe8cf$export$700833bf6caddd53)(true))}
                </div>
            </div>
        `;
    }
}




var $iJHeF = parcelRequire("iJHeF");
var $6cd823d9b7da1b20$export$517a635500dbb8ba;
var $6cd823d9b7da1b20$export$c407db72103fecfa;
var $6cd823d9b7da1b20$export$60d5655c6babb2a0;
var $6cd823d9b7da1b20$export$1ca1ec8b29a4ce27;
var $6cd823d9b7da1b20$export$aafa59e2e03f2942;
var $6cd823d9b7da1b20$export$7c341cb16fc91138;
$6cd823d9b7da1b20$export$517a635500dbb8ba = "_4qp2g";
$6cd823d9b7da1b20$export$c407db72103fecfa = "v-Zrf";
$6cd823d9b7da1b20$export$60d5655c6babb2a0 = "KFONN";
$6cd823d9b7da1b20$export$1ca1ec8b29a4ce27 = "o9-NJ";
$6cd823d9b7da1b20$export$aafa59e2e03f2942 = "oY1Ll";
$6cd823d9b7da1b20$export$7c341cb16fc91138 = "CFLLo";




var $5FliW = parcelRequire("5FliW");

function $cb3926a73c123df1$export$e69b0af0a4b13014(durationInSeconds) {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor(durationInSeconds % 3600 / 60);
    const seconds = durationInSeconds % 60;
    let iso8601Duration = "PT";
    if (hours > 0) iso8601Duration += `${hours}H`;
    if (minutes > 0 || hours > 0 && seconds > 0) iso8601Duration += `${minutes}M`;
    if (seconds > 0 && hours === 0) iso8601Duration += `${seconds}S`;
    return iso8601Duration;
}



var $kfkzw = parcelRequire("kfkzw");
class $b623f29ab2230209$export$b833e4a843da0ff8 extends (0, $iJHeF.Component) {
    commit() {
        super.commit();
        let readIcon = this.el($6cd823d9b7da1b20$export$aafa59e2e03f2942);
        let backIcon = this.el($6cd823d9b7da1b20$export$7c341cb16fc91138);
        this.onReactiveObserve(()=>{
            this.setStyle(`color:${this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor};`);
            backIcon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor));
            readIcon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor));
            this.shareComponent.networkIcons.forEach((icon)=>{
                icon.setStyle((0, $7b82b3bb65b07ef6$export$4c27d57389bdce00).convert(this.live.community.appearances[(0, $5FliW.Resources).theme((0, $kfkzw.ProductType).BLOG)].secondColor));
            });
        });
    }
    constructor(live, article){
        super();
        this.live = live;
        this.shareComponent = new (0, $41a47f8d375d5219$export$9eaf349bcfd8f562)(article.title, document.URL);
        //language=HTML
        this.template = `
            <div class="${$6cd823d9b7da1b20$export$517a635500dbb8ba}">
                <a aria-label="${(0, $5FliW.Resources).t("words.backHome")}" href="/home">
                    <div class="${$6cd823d9b7da1b20$export$c407db72103fecfa} ${$6cd823d9b7da1b20$export$60d5655c6babb2a0}">
                        <div class="${$6cd823d9b7da1b20$export$1ca1ec8b29a4ce27} ${$6cd823d9b7da1b20$export$7c341cb16fc91138}"></div>
                        <div>${(0, $5FliW.Resources).t("words.allArticles")}</div>
                    </div>
                </a>
                <div class="${$6cd823d9b7da1b20$export$c407db72103fecfa}">
                    <div class="${$6cd823d9b7da1b20$export$1ca1ec8b29a4ce27} ${$6cd823d9b7da1b20$export$aafa59e2e03f2942}"></div>
                    <div>${Math.round(article.readingSeconds / 60)} ${(0, $5FliW.Resources).t("words.timeToRead")}</div>
                    <meta itemprop="timeRequired" content="${(0, $cb3926a73c123df1$export$e69b0af0a4b13014)(article.readingSeconds)}">
                </div>
                <div class="${$6cd823d9b7da1b20$export$c407db72103fecfa}">
                    ${this.draw(this.shareComponent)}
                </div>
            </div>
        `;
    }
}



var $7AbeR = parcelRequire("7AbeR");
class $bbae8d6ffac47c7b$export$882c92cb8664ebd extends (0, $f9578ec5510db8f5$export$a927fe293ce3e5a4) {
    /**
     * render
     */ renderBody() {
        //language=HTML
        this.bodyContainer = this.append(`
            <div class="${$36f9617669facfa7$export$32180ef41b15b513}"></>`);
        let blogComponent = new (0, $9ecfa8fb0fead00e$export$6f6cf3b69af87d57)(this.live);
        this.bodyContainer.render(blogComponent);
        blogComponent.onReady = (view)=>{
            this.navigationContentContainer.clearAll();
            this.navigationContentContainer.render(new (0, $b623f29ab2230209$export$b833e4a843da0ff8)(this.live, view.article));
            (0, $7AbeR.Network).router.pages.updateMetasCommunity(this.live.community, true, view.article.title, view.article.snippet, view.article.keywords, view.article.imageFile, new Map(Object.entries(view.article.alternateLanguages)));
        };
    }
    renderNavigation() {
        super.renderNavigation();
        //language=HTML
        let content = this.navigationContainer.append(`
            <div class="${$36f9617669facfa7$export$a7db06668cad9adb}">
                <div class="${$36f9617669facfa7$export$f4c5de44377d2946}">
                    ${this.navigationContainer.draw(new (0, $959c95ac7ac79747$export$766a040f1f31f2a9)(true, 2, 60, 50))}
                </div>
            </div>`);
        this.navigationContentContainer = content.el($36f9617669facfa7$export$a7db06668cad9adb);
        content.pendAfter(this.navigationBrandContainer);
    }
    constructor(live){
        super(live);
    }
}


class $8e633116d8b69e51$export$342df85f6679df0e extends (0, $47734e1c0ab90ca1$export$c4dc9eeb28e63095) {
    init() {
        //language=HTML
        this.template = `
            <div class="${$f8743834758328bc$export$46da19ff27de8e3d}">
                ${this.draw(new (0, $bbae8d6ffac47c7b$export$882c92cb8664ebd)())}
            </div>
        `;
    }
    onHash() {}
    constructor(){
        super();
        this.title = "Blog";
        this.status.online = undefined;
    }
}







var $5FliW = parcelRequire("5FliW");
class $e4707e993912365b$export$c119d9d54b9ab9 extends (0, $3da5dda3c5f04e17$export$542b5577df419247) {
    /**
     * render
     */ async renderBodyContent() {
        this.bodyContainer.render(new (0, $5297a1b0c9393fef$export$8f93841fb2480ea2)("\uD83D\uDC40", (0, $5FliW.Resources).t("words.theRequestedPageDoesNotExistOrHasBeenRemoved")));
    }
    constructor(){
        super();
    }
}


class $395ea1be583d943f$export$43da7815743519 extends (0, $47734e1c0ab90ca1$export$c4dc9eeb28e63095) {
    init() {
        //language=HTML
        this.template = `
            <div class="${$f8743834758328bc$export$46da19ff27de8e3d}">
                ${this.draw(new (0, $e4707e993912365b$export$c119d9d54b9ab9)())}
            </div>
        `;
    }
    onHash() {}
    constructor(){
        super();
        this.title = "404";
        this.status.online = undefined;
    }
}


class $d6515d30d6df40d2$export$2172d880ce970b8f extends (0, $1d4a851e96ae8409$export$1844d26a3bb8e080) {
    async init(config) {
        await super.init(config);
    }
    registerPages() {
        this.pages.registerPage("/category", ()=>new (0, $5dde90783f5e5816$export$a9f121ca8122b59e)());
        this.pages.registerPage("/article", ()=>new (0, $8e633116d8b69e51$export$342df85f6679df0e)());
        this.pages.registerPage("/404", ()=>new (0, $395ea1be583d943f$export$43da7815743519)());
        this.pages.path404 = "/404";
        this.pages.pathHome = "/home";
        this.pages.pathLogin = "/home";
        super.registerPages();
    }
}




class $605c97b8166a54f7$export$b25f5cc1eb7681bd {
}
$605c97b8166a54f7$export$b25f5cc1eb7681bd.panel = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.blog = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.helpCenter = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.livechat = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.website = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];


class $77e4404715e7ccaa$export$b68be92453dfc5b6 {
    static async init() {
        this.router = new (0, $d6515d30d6df40d2$export$2172d880ce970b8f)((0, $605c97b8166a54f7$export$b25f5cc1eb7681bd).blog);
        let started = await (0, $7AbeR.Network).start(this.router);
        await (0, $5FliW.Resources).init([
            this.router.language()
        ], this.router.languages);
        try {
            await Promise.all([
                await (0, $5FliW.Resources).loadI18n("blog")
            ]);
        } catch (e) {}
        await this.router.init({
            started: started,
            defaultLanguage: (0, $5FliW.Resources).language,
            languages: (0, $5FliW.Resources).languages
        });
    }
}


(0, $271MM.config).import((0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).BLOG));
(0, $ae3682a3319cdf37$export$d1af847c14d84dee).ready(async ()=>{
    await (0, $ae3682a3319cdf37$export$d1af847c14d84dee).init();
    await (0, $e31963607a73fd5e$export$d7706fd1334044f9).init();
    await (0, $7AbeR.Network).init((0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).BLOG));
    await (0, $77e4404715e7ccaa$export$b68be92453dfc5b6).init();
});


//# sourceMappingURL=blog.5be0b714.js.map
 }());